import Re, { useReducer as xr, useCallback as ie, useEffect as Q, memo as it, useMemo as ee, useState as J, useRef as Ae, useContext as Le, useLayoutEffect as Pp, createContext as Xn, forwardRef as jp, cloneElement as Lp, useId as kp } from "react";
import { ModalContext as gn, useSimpleImport as Mp, useGenerate as Vp, useAvailableModels as Up, useFilterOptions as Fp, getOverlayHistoryCount as jo, pushOverlayHistoryState as Bp, useEntityNew as $p, useExport as Gp, useRequest as zp, DialogContext as Wp, useAiEventsApi as Yp, useSections as Gc } from "@prometheus/hooks";
import { EntityIconNames as zc, CriteriaTypes as D, AttributeTypes as x, DropdownAttributesIds as E, LimitEvents as Ht, IntervalValue as Te, AttributeDetailsTypes as F, IntervalInclude as mn, DateEdge as Ls, EventPersistence as Lo, CountEvents as er, OccurrenceCriteria as ks, TypesOfContainer as he, NameConflictResolution as ze, StandardConceptTypes as Hp, FileExtension as Jr, ImportAtlasAsset as Va, DateFormat as Gt, mapStandardConceptTypes as qp, CollapseType as Xp, ValidationMessageType as Bi, EntityTypes as ki, DefinitionKeys as Ms, CountEventsChar as Dn, TypesOfIncluded as tr, TypesOfCreationBlock as zn, typesOfCreationBlock as Jp, containerTypes as Kp, IntervalIncludeChar as Qp, IntervalValueChars as Vs, IntervalValueDateChars as Us } from "@prometheus/enums";
import { NameWithAliasCell as Zp, ActionCell as Fs, EntityImport as eh, ICON_COLUMN as th, ID_COLUMN as nh, NAME_COLUMN as Wc, CREATED_COLUMN as rh, UPDATED_COLUMN as ih, AUTHOR_COLUMN as oh, EntityTypeCell as ah, TabWithCounter as $t, EntityMessagesTab as sh, ImportMultipleSource as Yc, SpinnerWidgetContainer as Qt, TitleWithCount as Kr, FormElement as qe, FormActionsContainer as co, Section as Ua, PageList as Hc, EntityMessages as lh, CodeEditor as qc, Statistics as ch, TabsNavigationNew as Xc, useEntityMessages as uh, useIsLibraryDataSteward as dh, useArchiveLibraryMember as ph, SecondaryContentWrapper as Ti, ErrorPage as hh, NestedInfoWrapper as fh, CohortBaseInfo as mh, SpinnerContainer as Jc, Versions as Eh, MetaAttributes as Bs, PublishEntity as xh, ExportMultipleSource as Ch, ConfirmationDialog as gh, SubModuleDescriptionBlock as yh } from "@prometheus/features";
import { Box as Y, IconButton as Qr, transparentize as $s, Icon as ge, Tooltip as Xe, Input as Je, useNotifications as Nn, Grid as R, Typography as fe, Radio as $i, AnalysisIcon as Th, ContentBlock as nr, Table as Sh, Button as We, Select as Rt, DatePicker as rr, Spinner as Ct, OutlinedChip as Ih, IconActionButton as Cr, useTheme as Ah, CriteriaIcon as bh, DropDownMenu as vn, AutocompleteInput as Gi, Checkbox as hr, Block as gr, Autocomplete as zi, SEARCH_PRECISION_OPTIONS as Wi, useWindowSize as Rh, SearchPrecision as Oh, Dialog as vh, DialogTitle as Dh, DialogContent as _h, DialogActions as Nh, AISpinner as Kc, tooltipClasses as Gs, Paper as wh, Divider as Fa, NewTable as Ph, CheckboxCell as Si, StatusTag as jh, Skeleton as zs } from "@prometheus/components";
import me from "@emotion/styled";
import { useNavigate as yr, useParams as Qc, useLocation as Lh, useSearchParams as kh, Routes as Zc, Route as ln, Navigate as Ws } from "react-router-dom";
import { getReducerWithProduce as ui, api as Se, getSortDirection as di, axiosInstance as Mh, getUUID as Yt, createFiltersPanelListConfig as Vh, createCrudMethodsListConfig as Uh, createHeadersFromMetadataAttributes as Fh, createSortingMethodListConfig as Bh, createBreadcrumbsEntityConfig as $h, sortBy as Gh, isEqual as ke, getFormatDate as Ys, formatDate as ir, getConceptSetById as Yi, isObject as ko, unionBy as zh, convertAttributeListDTOToObjectAttributeList as Wh, getFilteredDropdownAttributeList as eu, convertObjectAttributeListToAttributeListDTO as Yh, getSortAttributesByCriteria as Hh, getFilteredDropdownCriteriaList as wn, isEmpty as En, isAiGeneratedMetadata as tu, isAiStatusMetadata as qh, getCodeLanguageByFileExtension as nu, convertCriteriaListDTOToObjectCriteriaList as ru, convertObjectCriteriaListToCriteriaListDTO as iu, pickBy as Xh, identity as Jh, formatFilterListNoFiql as Kh, parseStatistics as Qh, getStandartConceptType as Hs, getPublishOriginBreadcrumb as Zh, getDerivedObjectsCount as ef, pick as tf, mapExcludedToIsExcluded as qs, mapIsExcludedToExcluded as nf, convertExtendedToLegacyConcepts as ou, getNumberUUID as sa } from "@prometheus/utils";
import { Status as ce, EntityActions as Xs } from "@prometheus/types";
import { unstable_batchedUpdates as Ii, createPortal as rf } from "react-dom";
import { getSummary as of, setBreadcrumbs as af } from "@prometheus/redux";
import { useSelector as Ba, useDispatch as au } from "react-redux";
var Hi = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function su(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var la = { exports: {} }, _r = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Js;
function sf() {
  if (Js) return _r;
  Js = 1;
  var e = Symbol.for("react.transitional.element"), t = Symbol.for("react.fragment");
  function n(r, i, o) {
    var s = null;
    if (o !== void 0 && (s = "" + o), i.key !== void 0 && (s = "" + i.key), "key" in i) {
      o = {};
      for (var l in i)
        l !== "key" && (o[l] = i[l]);
    } else o = i;
    return i = o.ref, {
      $$typeof: e,
      type: r,
      key: s,
      ref: i !== void 0 ? i : null,
      props: o
    };
  }
  return _r.Fragment = t, _r.jsx = n, _r.jsxs = n, _r;
}
var Nr = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ks;
function lf() {
  return Ks || (Ks = 1, process.env.NODE_ENV !== "production" && function() {
    function e(m) {
      if (m == null) return null;
      if (typeof m == "function")
        return m.$$typeof === L ? null : m.displayName || m.name || null;
      if (typeof m == "string") return m;
      switch (m) {
        case C:
          return "Fragment";
        case I:
          return "Profiler";
        case T:
          return "StrictMode";
        case v:
          return "Suspense";
        case O:
          return "SuspenseList";
        case w:
          return "Activity";
      }
      if (typeof m == "object")
        switch (typeof m.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), m.$$typeof) {
          case g:
            return "Portal";
          case S:
            return (m.displayName || "Context") + ".Provider";
          case A:
            return (m._context.displayName || "Context") + ".Consumer";
          case _:
            var W = m.render;
            return m = m.displayName, m || (m = W.displayName || W.name || "", m = m !== "" ? "ForwardRef(" + m + ")" : "ForwardRef"), m;
          case j:
            return W = m.displayName || null, W !== null ? W : e(m.type) || "Memo";
          case M:
            W = m._payload, m = m._init;
            try {
              return e(m(W));
            } catch {
            }
        }
      return null;
    }
    function t(m) {
      return "" + m;
    }
    function n(m) {
      try {
        t(m);
        var W = !1;
      } catch {
        W = !0;
      }
      if (W) {
        W = console;
        var H = W.error, y = typeof Symbol == "function" && Symbol.toStringTag && m[Symbol.toStringTag] || m.constructor.name || "Object";
        return H.call(
          W,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          y
        ), t(m);
      }
    }
    function r(m) {
      if (m === C) return "<>";
      if (typeof m == "object" && m !== null && m.$$typeof === M)
        return "<...>";
      try {
        var W = e(m);
        return W ? "<" + W + ">" : "<...>";
      } catch {
        return "<...>";
      }
    }
    function i() {
      var m = P.A;
      return m === null ? null : m.getOwner();
    }
    function o() {
      return Error("react-stack-top-frame");
    }
    function s(m) {
      if (k.call(m, "key")) {
        var W = Object.getOwnPropertyDescriptor(m, "key").get;
        if (W && W.isReactWarning) return !1;
      }
      return m.key !== void 0;
    }
    function l(m, W) {
      function H() {
        q || (q = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          W
        ));
      }
      H.isReactWarning = !0, Object.defineProperty(m, "key", {
        get: H,
        configurable: !0
      });
    }
    function c() {
      var m = e(this.type);
      return N[m] || (N[m] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), m = this.props.ref, m !== void 0 ? m : null;
    }
    function u(m, W, H, y, X, V, $, le) {
      return H = V.ref, m = {
        $$typeof: h,
        type: m,
        key: W,
        props: V,
        _owner: X
      }, (H !== void 0 ? H : null) !== null ? Object.defineProperty(m, "ref", {
        enumerable: !1,
        get: c
      }) : Object.defineProperty(m, "ref", { enumerable: !1, value: null }), m._store = {}, Object.defineProperty(m._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(m, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.defineProperty(m, "_debugStack", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: $
      }), Object.defineProperty(m, "_debugTask", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: le
      }), Object.freeze && (Object.freeze(m.props), Object.freeze(m)), m;
    }
    function p(m, W, H, y, X, V, $, le) {
      var b = W.children;
      if (b !== void 0)
        if (y)
          if (z(b)) {
            for (y = 0; y < b.length; y++)
              d(b[y]);
            Object.freeze && Object.freeze(b);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else d(b);
      if (k.call(W, "key")) {
        b = e(m);
        var oe = Object.keys(W).filter(function(ye) {
          return ye !== "key";
        });
        y = 0 < oe.length ? "{key: someKey, " + oe.join(": ..., ") + ": ...}" : "{key: someKey}", te[b + y] || (oe = 0 < oe.length ? "{" + oe.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          y,
          b,
          oe,
          b
        ), te[b + y] = !0);
      }
      if (b = null, H !== void 0 && (n(H), b = "" + H), s(W) && (n(W.key), b = "" + W.key), "key" in W) {
        H = {};
        for (var re in W)
          re !== "key" && (H[re] = W[re]);
      } else H = W;
      return b && l(
        H,
        typeof m == "function" ? m.displayName || m.name || "Unknown" : m
      ), u(
        m,
        b,
        V,
        X,
        i(),
        H,
        $,
        le
      );
    }
    function d(m) {
      typeof m == "object" && m !== null && m.$$typeof === h && m._store && (m._store.validated = 1);
    }
    var f = Re, h = Symbol.for("react.transitional.element"), g = Symbol.for("react.portal"), C = Symbol.for("react.fragment"), T = Symbol.for("react.strict_mode"), I = Symbol.for("react.profiler"), A = Symbol.for("react.consumer"), S = Symbol.for("react.context"), _ = Symbol.for("react.forward_ref"), v = Symbol.for("react.suspense"), O = Symbol.for("react.suspense_list"), j = Symbol.for("react.memo"), M = Symbol.for("react.lazy"), w = Symbol.for("react.activity"), L = Symbol.for("react.client.reference"), P = f.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, k = Object.prototype.hasOwnProperty, z = Array.isArray, B = console.createTask ? console.createTask : function() {
      return null;
    };
    f = {
      react_stack_bottom_frame: function(m) {
        return m();
      }
    };
    var q, N = {}, ne = f.react_stack_bottom_frame.bind(
      f,
      o
    )(), ue = B(r(o)), te = {};
    Nr.Fragment = C, Nr.jsx = function(m, W, H, y, X) {
      var V = 1e4 > P.recentlyCreatedOwnerStacks++;
      return p(
        m,
        W,
        H,
        !1,
        y,
        X,
        V ? Error("react-stack-top-frame") : ne,
        V ? B(r(m)) : ue
      );
    }, Nr.jsxs = function(m, W, H, y, X) {
      var V = 1e4 > P.recentlyCreatedOwnerStacks++;
      return p(
        m,
        W,
        H,
        !0,
        y,
        X,
        V ? Error("react-stack-top-frame") : ne,
        V ? B(r(m)) : ue
      );
    };
  }()), Nr;
}
process.env.NODE_ENV === "production" ? la.exports = sf() : la.exports = lf();
var a = la.exports;
const cf = me.div`
  box-sizing: border-box;
  display: inline-block;
  font-weight: 700;
  font-size: 12px;
  line-height: 12px;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  border: 2px solid
    ${({ theme: e }) => e.palette.warning.main};
  margin-right: 8px;
  ::after {
    content: 'i';
    display: inline-block;
    line-height: 12px;
    color: ${({ theme: e }) => e.palette.warning.main};
  }
`, uf = ({
  value: e,
  viewMode: t,
  onRefresh: n,
  row: r
}) => {
  const { versionId: i, currentVersionId: o, terminated: s } = r.original;
  return /* @__PURE__ */ a.jsx(a.Fragment, { children: s ? /* @__PURE__ */ a.jsx(Y, { display: "flex", children: /* @__PURE__ */ a.jsx(
    Qr,
    {
      color: "warning",
      onClick: () => {
      },
      sx: (l) => ({
        backgroundColor: $s(0.8, l.palette.grey[500]),
        p: 0,
        my: -1,
        minWidth: 110,
        height: 26,
        fontSize: 14,
        borderRadius: 1,
        pointerEvents: "none",
        color: l.palette.grey[600],
        cursor: "default"
      }),
      children: /* @__PURE__ */ a.jsxs(
        Y,
        {
          className: "archived-icon",
          display: "flex",
          justifyContent: "space-around",
          alignItems: "center",
          flexWrap: "nowrap",
          children: [
            /* @__PURE__ */ a.jsx(
              ge,
              {
                iconName: "terminated",
                sx: (l) => ({
                  color: l.palette.grey[500],
                  fontSize: 18,
                  mr: 1
                })
              }
            ),
            /* @__PURE__ */ a.jsx("div", { children: "Archived" })
          ]
        }
      )
    }
  ) }) : !!(e && i && o) && /* @__PURE__ */ a.jsx(Y, { display: "flex", children: /* @__PURE__ */ a.jsx(
    Xe,
    {
      text: /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
        "Newer version exists,",
        /* @__PURE__ */ a.jsx("br", {}),
        " would you like to REFRESH it?"
      ] }),
      children: /* @__PURE__ */ a.jsxs(
        Qr,
        {
          color: "warning",
          onClick: () => {
            i && o && n(r.original);
          },
          sx: (l) => ({
            backgroundColor: "#ffead5",
            p: 0,
            my: -1,
            minWidth: 110,
            height: 26,
            fontSize: 14,
            borderRadius: 1,
            pointerEvents: t ? "none" : "all",
            ".refresh-icon": {
              display: "none"
            },
            "&:hover": {
              backgroundColor: $s(
                0.8,
                l.palette.info.main
              ),
              ".warning-icon": {
                display: "none"
              },
              ".refresh-icon": {
                display: "flex",
                color: l.palette.info.main
              }
            }
          }),
          children: [
            /* @__PURE__ */ a.jsxs(
              Y,
              {
                className: "warning-icon",
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
                flexWrap: "nowrap",
                children: [
                  /* @__PURE__ */ a.jsx(cf, {}),
                  /* @__PURE__ */ a.jsx("div", { children: "Outdated" })
                ]
              }
            ),
            /* @__PURE__ */ a.jsxs(
              Y,
              {
                className: "refresh-icon",
                display: "flex",
                alignItems: "center",
                flexWrap: "nowrap",
                justifyContent: "space-around",
                children: [
                  /* @__PURE__ */ a.jsx(
                    ge,
                    {
                      iconName: "reload",
                      color: "info",
                      sx: { fontSize: 16, mr: 1 }
                    }
                  ),
                  /* @__PURE__ */ a.jsx("div", { children: "Refresh" })
                ]
              }
            )
          ]
        }
      )
    }
  ) }) });
}, df = {
  createCols: (e, t, n = !1, r = []) => [
    {
      Header: "Name",
      accessor: "name",
      id: "name",
      isCropped: !0,
      width: "100%",
      minWidth: 250,
      maxWidth: 400,
      Cell: (i) => /* @__PURE__ */ a.jsx(
        Zp,
        {
          ...i,
          hasAlias: n,
          onChange: e.onUpdate,
          aliases: r,
          entityType: zc.COHORT
        }
      )
    },
    {
      Header: "",
      id: "outdatedVersion",
      width: "3%",
      minWidth: 70,
      accessor: (i) => i.currentVersionId && i.currentVersionId !== i.versionId,
      Cell: (i) => /* @__PURE__ */ a.jsx(
        uf,
        {
          ...i,
          viewMode: t,
          onRefresh: e.onRefresh
        }
      )
    },
    {
      Header: "",
      accessor: "actions",
      isCropped: !0,
      maxWidth: 100,
      width: "7%",
      disableSortBy: !0,
      // Read-only still gets a way into the cohort — the same navigation the edit
      // button performs, the target just renders read-only for these users.
      Cell: (i) => t ? /* @__PURE__ */ a.jsx(Fs, { onView: () => e.onView(i.row.original.value) }) : /* @__PURE__ */ a.jsx(
        Fs,
        {
          onEdit: () => e.onEdit(i.row.original.value),
          onRemove: () => e.onRemove(i.row.original.versionId)
        }
      )
    }
  ]
}, pf = [
  {
    Component: Je,
    name: "name",
    label: "Name",
    type: "text"
  },
  {
    Component: Je,
    name: "description",
    label: "Description",
    type: "text",
    multiline: !0,
    minRows: 2,
    maxRows: 10
  }
], yn = [
  {
    id: D.DEMOGRAPHIC,
    name: "Demographic",
    desc: "",
    value: "Demographic"
  },
  {
    id: D.CONDITION_ERA,
    name: "Condition Era",
    desc: "",
    value: "ConditionEra"
  },
  {
    id: D.CONDITION_OCCURRENCE,
    name: "Condition Occurrence",
    desc: "",
    value: "ConditionOccurrence"
  },
  {
    id: D.DEATH,
    name: "Death",
    desc: "",
    value: "Death"
  },
  {
    id: D.DEVICE_EXPOSURE,
    name: "Device Exposure",
    desc: "",
    value: "DeviceExposure"
  },
  {
    id: D.DOSE_ERA,
    name: "Dose Era",
    desc: "",
    value: "DoseEra"
  },
  {
    id: D.DRUG_ERA,
    name: "Drug Era",
    desc: "",
    value: "DrugEra"
  },
  {
    id: D.DRUG_EXPOSURE,
    name: "Drug Exposure",
    desc: "",
    value: "DrugExposure"
  },
  {
    id: D.LOCATION_REGION,
    name: "Location Region",
    desc: "",
    value: "LocationRegion"
  },
  {
    id: D.MEASUREMENT,
    name: "Measurement",
    desc: "",
    value: "Measurement"
  },
  {
    id: D.OBSERVATION,
    name: "Observation",
    desc: "",
    value: "Observation"
  },
  {
    id: D.OBSERVATION_PERIOD,
    name: "Observation Period",
    desc: "",
    value: "ObservationPeriod"
  },
  {
    id: D.PAYER_PLAN_PERIOD,
    name: "Payer Plan Period",
    desc: "",
    value: "PayerPlanPeriod"
  },
  {
    id: D.PROCEDURE_OCCURRENCE,
    name: "Procedure Occurrence",
    desc: "",
    value: "ProcedureOccurrence"
  },
  {
    id: D.SPECIMEN,
    name: "Specimen",
    desc: "",
    value: "Specimen"
  },
  {
    id: D.VISIT,
    name: "Visit",
    desc: "",
    value: "VisitOccurrence"
  },
  {
    id: D.VISIT_DETAILS,
    name: "Visit detail",
    desc: "",
    value: "VisitDetail"
  },
  {
    id: D.GROUP,
    name: "Group",
    desc: "",
    value: "Group"
  }
], lu = [
  {
    id: E.FIRST_DIAGNOSIS,
    name: "First diagnosis",
    desc: "",
    value: x.FIRST
  },
  {
    id: E.AGE_AT_ERA_START,
    name: "Age at era start",
    desc: "",
    value: x.AGE_START
  },
  {
    id: E.AGE_AT_ERA_END,
    name: "Age at era end",
    desc: "",
    value: x.AGE_END
  },
  {
    id: E.GENDER,
    name: "Gender",
    desc: "",
    value: x.GENDER
  },
  {
    id: E.LOC_START_DATE,
    name: "Start date",
    desc: "",
    value: x.START_DATE
  },
  {
    id: E.LOC_END_DATE,
    name: "End date",
    desc: "",
    value: x.END_DATE
  },
  {
    id: E.START_DATE,
    name: "Start date",
    desc: "",
    value: x.ERA_START_DATE
  },
  {
    id: E.END_DATE,
    name: "End date",
    desc: "",
    value: x.ERA_END_DATE
  },
  {
    id: E.ERA_CONDITION_COUNT,
    name: "Era condition count",
    desc: "",
    value: x.OCCURRENCE_COUNT
  },
  {
    id: E.ERA_LENGTH,
    name: "Era length",
    desc: "",
    value: x.ERA_LENGTH
  },
  {
    id: E.NESTED,
    name: "Nested",
    desc: "",
    value: x.CORRETALED_CRITERIA
  },
  {
    id: E.AGE_OCCURRENCE,
    name: "Age at occurrence",
    desc: "",
    value: x.AGE
  },
  {
    id: E.CONDITION_STATUS,
    name: "Condition status",
    desc: "",
    value: x.CONDITION_STATUS
  },
  {
    id: E.CONDITION_STATUS_CS,
    name: "Condition status concept set",
    desc: "",
    value: x.CONDITION_STATUS_CS
  },
  {
    id: E.CONDITION_START_DATE,
    name: "Start date",
    desc: "",
    value: x.OCCURRENCE_START_DATE
  },
  {
    id: E.CONDITION_END_DATE,
    name: "End date",
    desc: "",
    value: x.OCCURRENCE_END_DATE
  },
  {
    id: E.CONDITION_TYPE,
    name: "Condition type",
    desc: "",
    value: x.CONDITION_TYPE
  },
  {
    id: E.CONDITION_TYPE_CS,
    name: "Condition type concept set",
    desc: "",
    value: x.CONDITION_TYPE_CS
  },
  {
    id: E.VISIT,
    name: "Visit",
    desc: "",
    value: x.VISIT_TYPE
  },
  {
    id: E.VISIT_CS,
    name: "Visit concept set",
    desc: "",
    value: x.VISIT_TYPE_CS
  },
  {
    id: E.STOP_REASON,
    name: "Stop reason",
    desc: "",
    value: x.STOP_REASON
  },
  {
    id: E.CONDITION_SOURCE_CONCEPT,
    name: "Condition source concept",
    desc: "",
    value: x.CONDITION_SOURCE_CONCEPT
  },
  {
    id: E.PROVIDER_SPECIALTY,
    name: "Provider specialty",
    desc: "",
    value: x.PROVIDER_SPECIALTY
  },
  {
    id: E.DEATH_DATE,
    name: "Death date",
    desc: "",
    value: x.OCCURRENCE_START_DATE
  },
  {
    id: E.DEATH_TYPE,
    name: "Death type",
    desc: "",
    value: x.DEATH_TYPE
  },
  {
    id: E.DEATH_TYPE_CS,
    name: "Death type concept set",
    desc: "",
    value: x.DEATH_TYPE_CS
  },
  {
    id: E.CAUSE_DEATH_SOURCE_CONCEPT,
    name: "Cause of death source concept",
    desc: "",
    value: x.DEATH_SOURCE_CONCEPT
  },
  {
    id: E.FIRST_EXPOSURE,
    name: "First exposure",
    desc: "",
    value: x.FIRST
  },
  {
    id: E.DEVICE_TYPE,
    name: "Device type",
    desc: "",
    value: x.DEVICE_TYPE
  },
  {
    id: E.DEVICE_TYPE_CS,
    name: "Device type concept set",
    desc: "",
    value: x.DEVICE_TYPE_CS
  },
  {
    id: E.UNIQUE_ID,
    name: "Unique ID",
    desc: "",
    value: x.UNIQUE_DEVICE_ID
  },
  {
    id: E.QUANTITY,
    name: "Quantity",
    desc: "",
    value: x.QUANTITY
  },
  {
    id: E.DEVICE_SOURCE_CONCEPT,
    name: "Device source concept",
    desc: "",
    value: x.DEVICE_SOURCE_CONCEPT
  },
  {
    id: E.FIRST_MEASURE,
    name: "First measure",
    desc: "",
    value: x.FIRST
  },
  {
    id: E.MEASUREMENT_DATE,
    name: "Measurement date",
    desc: "",
    value: x.OCCURRENCE_START_DATE
  },
  {
    id: E.MEASUREMENT_TYPE,
    name: "Measurement type",
    desc: "",
    value: x.MEASUREMENT_TYPE
  },
  {
    id: E.MEASUREMENT_TYPE_CS,
    name: "Measurement type concept set",
    desc: "",
    value: x.MEASUREMENT_TYPE_CS
  },
  {
    id: E.OPERATOR,
    name: "Operator",
    desc: "",
    value: x.OPERATOR
  },
  {
    id: E.OPERATOR_CS,
    name: "Operator concept set",
    desc: "",
    value: x.OPERATOR_CS
  },
  {
    id: E.VALUE_AS_CONCEPT,
    name: "Value as concept",
    desc: "",
    value: x.VALUE_AS_CONCEPT
  },
  {
    id: E.VALUE_AS_CONCEPT_CS,
    name: "Value as concept set",
    desc: "",
    value: x.VALUE_AS_CONCEPT_CS
  },
  {
    id: E.VALUE_AS_NUMBER,
    name: "Value as number",
    desc: "",
    value: x.VALUE_AS_NUMBER
  },
  {
    id: E.VALUE_AS_STRING,
    name: "Value as string",
    desc: "",
    value: x.VALUE_AS_STRING
  },
  {
    id: E.UNIT,
    name: "Unit",
    desc: "",
    value: x.UNIT
  },
  {
    id: E.UNIT_CS,
    name: "Unit concept set",
    desc: "",
    value: x.UNIT_CS
  },
  {
    id: E.ABNORMAL_RESULT,
    name: "Abnormal result",
    desc: "",
    value: x.ABNORMAL
  },
  {
    id: E.LOW_RANGE_RATIO,
    name: "Low range ratio",
    desc: "",
    value: x.RANGE_LOW_RATIO
  },
  {
    id: E.HIGH_RANGE_RATIO,
    name: "High range ratio",
    desc: "",
    value: x.RANGE_HIGH_RATIO
  },
  {
    id: E.LOW_RANGE,
    name: "Low range",
    desc: "",
    value: x.RANGE_LOW
  },
  {
    id: E.HIGH_RANGE,
    name: "High range",
    desc: "",
    value: x.RANGE_HIGH
  },
  {
    id: E.MEASUREMENT_SOURCE_CONCEPT,
    name: "Measurement source concept",
    desc: "",
    value: x.MEASUREMENT_SOURCE_CONCEPT
  },
  {
    id: E.FIRST_OBSERVATION,
    name: "First observation",
    desc: "",
    value: x.FIRST
  },
  {
    id: E.OBSERVATION_DATE,
    name: "Observation date",
    desc: "",
    value: x.OCCURRENCE_START_DATE
  },
  {
    id: E.OBSERVATION_TYPE,
    name: "Observation type",
    desc: "",
    value: x.OBSERVATION_TYPE
  },
  {
    id: E.OBSERVATION_TYPE_CS,
    name: "Observation type concept set",
    desc: "",
    value: x.OBSERVATION_TYPE_CS
  },
  {
    id: E.OBSERVATION_SOURCE_CONCEPT,
    name: "Observation source concept",
    desc: "",
    value: x.OBSERVATION_SOURCE_CONCEPT
  },
  {
    id: E.QUALIFIER,
    name: "Qualifier",
    desc: "",
    value: x.QUALIFIER
  },
  {
    id: E.QUALIFIER_CS,
    name: "Qualifier concept set",
    desc: "",
    value: x.QUALIFIER_CS
  },
  {
    id: E.SPECIFY_START_AND_DATE,
    name: "Specific start and end dates",
    desc: "",
    value: x.USER_DEFINED_PERIOD
  },
  {
    id: E.FIRST_OBSERVATION_PERIOD,
    name: "First observation period",
    desc: "",
    value: x.FIRST
  },
  {
    id: E.AGE_AT_START,
    name: "Age at start",
    desc: "",
    value: x.AGE_START
  },
  {
    id: E.AGE_AT_END,
    name: "Age at end",
    desc: "",
    value: x.AGE_END
  },
  {
    id: E.PERIOD_TYPE,
    name: "Period type",
    desc: "",
    value: x.PERIOD_TYPE
  },
  {
    id: E.PERIOD_TYPE_CS,
    name: "Period type concept set",
    desc: "",
    value: x.PERIOD_TYPE_CS
  },
  {
    id: E.PERIOD_START_DATE,
    name: "Period start date",
    desc: "",
    value: x.PERIOD_START_DATE
  },
  {
    id: E.PERIOD_END_DATE,
    name: "Period end date",
    desc: "",
    value: x.PERIOD_END_DATE
  },
  {
    id: E.PERIOD_LENGTH,
    name: "Period length",
    desc: "",
    value: x.PERIOD_LENGTH
  },
  {
    id: E.FIRST_PAYER_PLAN_PERIOD,
    name: "First payer plan period",
    desc: "",
    value: x.FIRST
  },
  {
    id: E.STOP_REASON_SOURCE_CONCEPT,
    name: "Stop reason source concept",
    desc: "",
    value: x.STOP_REASON_SOURCE_CONCEPT
  },
  {
    id: E.SPONSOR_SOURCE_CONCEPT,
    name: "Sponsor source concept",
    desc: "",
    value: x.SPONSOR_SOURCE_CONCEPT
  },
  {
    id: E.PLAN_SOURCE_CONCEPT,
    name: "Plan source concept",
    desc: "",
    value: x.PLAN_SOURCE_CONCEPT
  },
  {
    id: E.PAYER_SOURCE_CONCEPT,
    name: "Payer source concept",
    desc: "",
    value: x.PAYER_SOURCE_CONCEPT
  },
  {
    id: E.STOP_REASON_CONCEPT,
    name: "Stop reason concept",
    desc: "",
    value: x.STOP_REASON_CONCEPT
  },
  {
    id: E.SPONSOR_CONCEPT,
    name: "Sponsor concept",
    desc: "",
    value: x.SPONSOR_CONCEPT
  },
  {
    id: E.PLAN_CONCEPT,
    name: "Plan concept",
    desc: "",
    value: x.PLAN_CONCEPT
  },
  {
    id: E.PAYER_CONCEPT,
    name: "Payer concept",
    desc: "",
    value: x.PAYER_CONCEPT
  },
  {
    id: E.FIRST_PROCEDURE,
    name: "First procedure",
    desc: "",
    value: x.FIRST
  },
  {
    id: E.FIRST_OCCURRENCE,
    name: "First occurrence",
    desc: "",
    value: x.FIRST
  },
  {
    id: E.PROCEDURE_SOURCE_CONCEPT,
    name: "Procedure source concept",
    desc: "",
    value: x.PROCEDURE_SOURCE_CONCEPT
  },
  {
    id: E.MODIFIER,
    name: "Modifier",
    desc: "",
    value: x.MODIFIER
  },
  {
    id: E.MODIFIER_CS,
    name: "Modifier concept set",
    desc: "",
    value: x.MODIFIER_CS
  },
  {
    id: E.PROCEDURE_TYPE,
    name: "Procedure type",
    desc: "",
    value: x.PROCEDURE_TYPE
  },
  {
    id: E.PROCEDURE_TYPE_CS,
    name: "Procedure type concept set",
    desc: "",
    value: x.PROCEDURE_TYPE_CS
  },
  {
    id: E.DOSE_VALUE,
    name: "Dose value",
    desc: "",
    value: x.DOSE_VALUE
  },
  {
    id: E.ERA_EXPOSURE_COUNT,
    name: "Era exposure count",
    desc: "",
    value: x.OCCURRENCE_COUNT
  },
  {
    id: E.DAYS_SUPPLY,
    name: "Days supply",
    desc: "",
    value: x.DAYS_SUPPLY
  },
  {
    id: E.REFILLS,
    name: "Refills",
    desc: "",
    value: x.REFILLS
  },
  {
    id: E.DRUG_TYPE,
    name: "Drug type",
    desc: "",
    value: x.DRUG_TYPE
  },
  {
    id: E.DRUG_TYPE_CS,
    name: "Drug type concept set",
    desc: "",
    value: x.DRUG_TYPE_CS
  },
  {
    id: E.EFFECTIVE_DOSE,
    name: "Effective dose",
    desc: "",
    value: x.EFFECTIVE_DRUG_DOSE
  },
  {
    id: E.ROUTE,
    name: "Route",
    desc: "",
    value: x.ROUTE_CONCEPT
  },
  {
    id: E.ROUTE_CS,
    name: "Route concept set",
    desc: "",
    value: x.ROUTE_CONCEPT_CS
  },
  {
    id: E.RACE,
    name: "Race",
    desc: "",
    value: x.RACE
  },
  {
    id: E.ETHNICITY,
    name: "Ethnicity",
    desc: "",
    value: x.ETHNICITY
  },
  {
    id: E.DRUG_SOURCE_CONCEPT,
    name: "Drug source concept",
    desc: "",
    value: x.DRUG_SOURCE_CONCEPT
  },
  {
    id: E.LOT_NUMBER,
    name: "Lot number",
    desc: "",
    value: x.LOT_NUMBER
  },
  {
    id: E.DOSE_UNIT,
    name: "Dose unit",
    desc: "",
    value: x.DOSE_UNIT
  },
  {
    id: E.DOSE_UNIT_CS,
    name: "Dose unit concept set",
    desc: "",
    value: x.DOSE_UNIT_CS
  },
  {
    id: E.SOURCE_ID,
    name: "Source ID",
    desc: "",
    value: x.SOURCE_ID
  },
  {
    id: E.DISEASE_STATUS,
    name: "Disease status",
    desc: "",
    value: x.DISEASE_STATUS
  },
  {
    id: E.DISEASE_STATUS_CS,
    name: "Disease status concept set",
    desc: "",
    value: x.DISEASE_STATUS_CS
  },
  {
    id: E.ANATOMIC_SITE,
    name: "Anatomic site",
    desc: "",
    value: x.ANATOMIC_SITE
  },
  {
    id: E.ANATOMIC_SITE_CS,
    name: "Anatomic site concept set",
    desc: "",
    value: x.ANATOMIC_SITE_CS
  },
  {
    id: E.SPECIMEN_TYPE,
    name: "Specimen type",
    desc: "",
    value: x.SPECIMEN_TYPE
  },
  {
    id: E.SPECIMEN_TYPE_CS,
    name: "Specimen type concept set",
    desc: "",
    value: x.SPECIMEN_TYPE_CS
  },
  {
    id: E.SPECIMEN_DATE,
    name: "Specimen date",
    desc: "",
    value: x.OCCURRENCE_START_DATE
  },
  {
    id: E.GAP_DAYS,
    name: "Gap days",
    desc: "",
    value: x.GAP_DAYS
  },
  {
    id: E.PLACE_SERVICE_LOCATION,
    name: "Place of service location",
    desc: "",
    value: x.PLACE_SERVICE_LOCATION
  },
  {
    id: E.PLACE_SERVICE_DISTANCE,
    name: "Place of service distance",
    desc: "",
    value: x.PLACE_SERVICE_DISTANCE
  },
  {
    id: E.PLACE_SERVICE,
    name: "Place of service",
    desc: "",
    value: x.PLACE_SERVICE
  },
  {
    id: E.VISIT_SOURCE_CONCEPT,
    name: "Visit source concept",
    desc: "",
    value: x.VISIT_SOURCE_CONCEPT
  },
  {
    id: E.VISIT_LENGTH,
    name: "Visit length",
    desc: "",
    value: x.VISIT_LENGTH
  },
  {
    id: E.VISIT_TYPE,
    name: "Visit type",
    desc: "",
    value: x.VISIT_TYPE
  },
  {
    id: E.VISIT_TYPE_CS,
    name: "Visit type concept set",
    desc: "",
    value: x.VISIT_TYPE_CS
  },
  {
    id: E.FIRST_VISIT,
    name: "First visit",
    desc: "",
    value: x.FIRST
  },
  {
    id: E.FIRST_VISIT_DETAIL,
    name: "First visit detail",
    desc: "",
    value: x.FIRST
  },
  {
    id: E.AGE_AT_VISIT_DETAIL,
    name: "Age at visit detail",
    desc: "",
    value: x.AGE
  },
  {
    id: E.GENDER_CS,
    name: "Gender Concept Set",
    desc: "",
    value: x.GENDER_CS
  },
  {
    id: E.RACE_CS,
    name: "Race Concept Set",
    desc: "",
    value: x.RACE_CS
  },
  {
    id: E.ETHNICITY_CS,
    name: "Ethnicity Concept Set",
    desc: "",
    value: x.ETHNICITY_CS
  },
  {
    id: E.VISIT_DETAIL_START_DATE,
    name: "Start date",
    desc: "",
    value: x.VISIT_DETAIL_START_DATE
  },
  {
    id: E.VISIT_DETAIL_END_DATE,
    name: "End date",
    desc: "",
    value: x.VISIT_DETAIL_END_DATE
  },
  {
    id: E.MODIFY_EVENT_START_END,
    name: "Modify event start/end",
    desc: "",
    value: x.DATE_ADJUSTMENT
  },
  {
    id: E.VISIT_DETAIL_TYPE,
    name: "Visit detail type concept set",
    desc: "",
    value: x.VISIT_DETAIL_TYPE_CS
  },
  {
    id: E.VISIT_DETAIL_LENGTH,
    name: "Visit detail length",
    desc: "",
    value: x.VISIT_DETAIL_LENGTH
  },
  {
    id: E.VISIT_DETAIL_SOURCE_CONCEPT,
    name: "Visit detail Source Concept",
    desc: "",
    value: x.VISIT_DETAIL_SOURCE_CONCEPT
  },
  {
    id: E.PROVIDER_SPECIALTY_CS,
    name: "Provider specialty concept set",
    desc: "",
    value: x.PROVIDER_SPECIALTY_CS
  },
  {
    id: E.PLACE_SERVICE_CS,
    name: "Place of service concept set",
    desc: "",
    value: x.PLACE_SERVICE_CS
  }
], fr = [
  {
    name: "all events",
    value: Ht.ALL
  },
  {
    name: "earliest event",
    value: Ht.FIRST
  },
  {
    name: "latest event",
    value: Ht.LAST
  }
], Wn = [
  {
    value: 0,
    name: "0"
  },
  {
    value: 1,
    name: "1"
  },
  {
    value: 7,
    name: "7"
  },
  {
    value: 14,
    name: "14"
  },
  {
    value: 21,
    name: "21"
  },
  {
    value: 30,
    name: "30"
  },
  {
    value: 60,
    name: "60"
  },
  {
    value: 90,
    name: "90"
  },
  {
    value: 120,
    name: "120"
  },
  {
    value: 180,
    name: "180"
  },
  {
    value: 365,
    name: "365"
  },
  {
    value: 548,
    name: "548"
  },
  {
    value: 730,
    name: "730"
  },
  {
    value: 1095,
    name: "1095"
  }
], Ai = [
  {
    value: "undefined",
    name: "all"
  },
  {
    value: 0,
    name: "0"
  },
  {
    value: 1,
    name: "1"
  },
  {
    value: 7,
    name: "7"
  },
  {
    value: 14,
    name: "14"
  },
  {
    value: 21,
    name: "21"
  },
  {
    value: 30,
    name: "30"
  },
  {
    value: 60,
    name: "60"
  },
  {
    value: 90,
    name: "90"
  },
  {
    value: 120,
    name: "120"
  },
  {
    value: 180,
    name: "180"
  },
  {
    value: 365,
    name: "365"
  },
  {
    value: 548,
    name: "548"
  },
  {
    value: 730,
    name: "730"
  },
  {
    value: 1095,
    name: "1095"
  }
], uo = {
  Demographic: {
    titleText: "Demographic:",
    baseText: "with the following event criteria",
    baseTextViewMode: "with the following event criteria",
    defaultValue: "",
    attributes: [
      E.MODIFY_EVENT_START_END,
      E.AGE_OCCURRENCE,
      E.GENDER,
      E.GENDER_CS,
      E.CONDITION_START_DATE,
      E.CONDITION_END_DATE,
      E.RACE,
      E.RACE_CS,
      E.ETHNICITY,
      E.ETHNICITY_CS
    ],
    attributesSort: [
      x.DATE_ADJUSTMENT,
      x.AGE,
      x.GENDER,
      x.GENDER_CS,
      x.OCCURRENCE_START_DATE,
      x.OCCURRENCE_END_DATE,
      x.RACE,
      x.RACE_CS,
      x.ETHNICITY,
      x.ETHNICITY_CS
    ],
    extendOptions: {
      textBlock1: {
        startText: "Limit qualifying events to",
        control: "select",
        optionsControl: fr,
        endText: "per person"
      }
    }
  },
  ConditionEra: {
    titleText: "Condition Era:",
    baseText: "a condition era of",
    baseTextViewMode: "condition eras of",
    defaultValue: "Any condition",
    attributes: [
      E.MODIFY_EVENT_START_END,
      E.FIRST_DIAGNOSIS,
      E.AGE_AT_ERA_START,
      E.AGE_AT_ERA_END,
      E.GENDER,
      E.GENDER_CS,
      E.START_DATE,
      E.END_DATE,
      E.ERA_CONDITION_COUNT,
      E.ERA_LENGTH,
      E.NESTED
    ],
    attributesSort: [
      x.DATE_ADJUSTMENT,
      x.FIRST,
      x.GENDER,
      x.GENDER_CS,
      x.AGE_START,
      x.AGE_END,
      x.ERA_START_DATE,
      x.ERA_END_DATE,
      x.ERA_LENGTH,
      x.OCCURRENCE_COUNT,
      x.CORRETALED_CRITERIA
    ],
    extend: !0,
    extendOptions: {
      textBlock1: {
        startText: "Limit qualifying events to",
        control: "select",
        optionsControl: fr,
        endText: "per person"
      }
    }
  },
  ConditionOccurrence: {
    titleText: "Condition Occurrence:",
    baseText: "a condition occurrence of",
    baseTextViewMode: "condition occurrence of",
    defaultValue: "Any condition",
    extend: !0,
    attributes: [
      E.MODIFY_EVENT_START_END,
      E.FIRST_DIAGNOSIS,
      E.AGE_OCCURRENCE,
      E.GENDER,
      E.GENDER_CS,
      E.CONDITION_STATUS,
      E.CONDITION_STATUS_CS,
      E.CONDITION_START_DATE,
      E.CONDITION_END_DATE,
      E.CONDITION_TYPE,
      E.CONDITION_TYPE_CS,
      E.VISIT,
      E.VISIT_CS,
      E.STOP_REASON,
      E.CONDITION_SOURCE_CONCEPT,
      E.PROVIDER_SPECIALTY,
      E.PROVIDER_SPECIALTY_CS,
      E.NESTED
    ],
    attributesSort: [
      x.DATE_ADJUSTMENT,
      x.FIRST,
      x.GENDER,
      x.GENDER_CS,
      x.AGE,
      x.OCCURRENCE_START_DATE,
      x.OCCURRENCE_END_DATE,
      x.CONDITION_TYPE,
      x.CONDITION_TYPE_CS,
      x.STOP_REASON,
      x.PROVIDER_SPECIALTY,
      x.PROVIDER_SPECIALTY_CS,
      x.CONDITION_STATUS,
      x.CONDITION_STATUS_CS,
      x.VISIT_TYPE,
      x.VISIT_TYPE_CS,
      x.CONDITION_SOURCE_CONCEPT,
      x.CORRETALED_CRITERIA
    ]
  },
  Death: {
    titleText: "Death:",
    baseText: "a death occurrence from",
    baseTextViewMode: "death occurrence of",
    defaultValue: "Any death",
    extend: !0,
    attributes: [
      E.MODIFY_EVENT_START_END,
      E.AGE_OCCURRENCE,
      E.GENDER,
      E.GENDER_CS,
      E.DEATH_DATE,
      E.DEATH_TYPE,
      E.DEATH_TYPE_CS,
      E.CAUSE_DEATH_SOURCE_CONCEPT,
      E.NESTED
    ],
    attributesSort: [
      x.DATE_ADJUSTMENT,
      x.GENDER,
      x.GENDER_CS,
      x.AGE,
      x.OCCURRENCE_START_DATE,
      x.DEATH_TYPE,
      x.DEATH_TYPE_CS,
      x.DEATH_SOURCE_CONCEPT,
      x.CORRETALED_CRITERIA
    ]
  },
  DeviceExposure: {
    titleText: "Device Exposure:",
    baseText: "a device exposure of",
    baseTextViewMode: "device exposure of",
    defaultValue: "Any device",
    extend: !0,
    attributes: [
      E.MODIFY_EVENT_START_END,
      E.FIRST_DIAGNOSIS,
      E.AGE_OCCURRENCE,
      E.GENDER,
      E.GENDER_CS,
      E.CONDITION_START_DATE,
      E.CONDITION_END_DATE,
      E.DEVICE_TYPE,
      E.DEVICE_TYPE_CS,
      E.VISIT,
      E.VISIT_CS,
      E.UNIQUE_ID,
      E.QUANTITY,
      E.DEVICE_SOURCE_CONCEPT,
      E.PROVIDER_SPECIALTY,
      E.PROVIDER_SPECIALTY_CS,
      E.NESTED
    ],
    attributesSort: [
      x.DATE_ADJUSTMENT,
      x.FIRST,
      x.GENDER,
      x.GENDER_CS,
      x.AGE,
      x.OCCURRENCE_START_DATE,
      x.OCCURRENCE_END_DATE,
      x.DEVICE_TYPE,
      x.DEVICE_TYPE_CS,
      x.UNIQUE_DEVICE_ID,
      x.PROVIDER_SPECIALTY,
      x.PROVIDER_SPECIALTY_CS,
      x.VISIT_TYPE,
      x.VISIT_TYPE_CS,
      x.QUANTITY,
      x.DEVICE_SOURCE_CONCEPT,
      x.CORRETALED_CRITERIA
    ]
  },
  Group: {
    baseText: "",
    attributes: [],
    wrapCriteria: !0
  },
  DoseEra: {
    titleText: "Dose Era:",
    baseText: "a dose era of",
    baseTextViewMode: "dose eras of",
    defaultValue: "Any drug",
    extend: !0,
    attributes: [
      E.MODIFY_EVENT_START_END,
      E.FIRST_EXPOSURE,
      E.GENDER,
      E.GENDER_CS,
      E.AGE_AT_ERA_START,
      E.AGE_AT_ERA_END,
      E.START_DATE,
      E.END_DATE,
      E.UNIT,
      E.UNIT_CS,
      E.DOSE_VALUE,
      E.ERA_LENGTH,
      E.NESTED
    ],
    attributesSort: [
      x.DATE_ADJUSTMENT,
      x.FIRST,
      x.GENDER,
      x.GENDER_CS,
      x.AGE_START,
      x.AGE_END,
      x.ERA_START_DATE,
      x.ERA_END_DATE,
      x.UNIT,
      x.UNIT_CS,
      x.DOSE_VALUE,
      x.ERA_LENGTH,
      x.CORRETALED_CRITERIA
    ]
  },
  DrugEra: {
    titleText: "Drug Era:",
    baseText: "a drug era of",
    baseTextViewMode: "drug era of",
    defaultValue: "Any drug",
    extend: !0,
    attributes: [
      E.MODIFY_EVENT_START_END,
      E.FIRST_EXPOSURE,
      E.GENDER,
      E.GENDER_CS,
      E.AGE_AT_ERA_START,
      E.AGE_AT_ERA_END,
      E.START_DATE,
      E.END_DATE,
      E.ERA_LENGTH,
      E.ERA_EXPOSURE_COUNT,
      E.NESTED
    ],
    attributesSort: [
      x.DATE_ADJUSTMENT,
      x.FIRST,
      x.GENDER,
      x.GENDER_CS,
      x.AGE_START,
      x.AGE_END,
      x.ERA_START_DATE,
      x.ERA_END_DATE,
      x.ERA_LENGTH,
      x.OCCURRENCE_COUNT,
      x.CORRETALED_CRITERIA
    ]
  },
  DrugExposure: {
    titleText: "Drug Exposure:",
    baseText: "a drug exposure of",
    baseTextViewMode: "drug exposure of",
    defaultValue: "Any drug",
    extend: !0,
    attributes: [
      E.MODIFY_EVENT_START_END,
      E.FIRST_EXPOSURE,
      E.AGE_OCCURRENCE,
      E.GENDER,
      E.GENDER_CS,
      E.CONDITION_START_DATE,
      E.CONDITION_END_DATE,
      E.DRUG_TYPE,
      E.DRUG_TYPE_CS,
      E.VISIT,
      E.VISIT_CS,
      E.REFILLS,
      E.QUANTITY,
      E.DAYS_SUPPLY,
      E.ROUTE,
      E.ROUTE_CS,
      E.DOSE_UNIT,
      E.DOSE_UNIT_CS,
      E.LOT_NUMBER,
      E.DRUG_SOURCE_CONCEPT,
      E.PROVIDER_SPECIALTY,
      E.PROVIDER_SPECIALTY_CS,
      E.NESTED
    ],
    attributesSort: [
      x.DATE_ADJUSTMENT,
      x.FIRST,
      x.AGE,
      x.GENDER,
      x.GENDER_CS,
      x.OCCURRENCE_START_DATE,
      x.OCCURRENCE_END_DATE,
      x.DRUG_TYPE,
      x.DRUG_TYPE_CS,
      x.VISIT_TYPE,
      x.VISIT_TYPE_CS,
      x.REFILLS,
      x.QUANTITY,
      x.DAYS_SUPPLY,
      x.ROUTE_CONCEPT,
      x.ROUTE_CONCEPT_CS,
      x.DOSE_UNIT,
      x.DOSE_UNIT_CS,
      x.LOT_NUMBER,
      x.DRUG_SOURCE_CONCEPT,
      x.PROVIDER_SPECIALTY,
      x.PROVIDER_SPECIALTY_CS,
      x.CORRETALED_CRITERIA
    ]
  },
  Measurement: {
    titleText: "Measurement:",
    baseText: "a measurement of",
    baseTextViewMode: "measurement of",
    defaultValue: "Any Measurement",
    extend: !0,
    attributes: [
      E.MODIFY_EVENT_START_END,
      E.FIRST_MEASURE,
      E.AGE_OCCURRENCE,
      E.GENDER,
      E.GENDER_CS,
      E.MEASUREMENT_DATE,
      E.MEASUREMENT_TYPE,
      E.MEASUREMENT_TYPE_CS,
      E.VISIT,
      E.VISIT_CS,
      E.OPERATOR,
      E.OPERATOR_CS,
      E.VALUE_AS_NUMBER,
      E.VALUE_AS_CONCEPT,
      E.VALUE_AS_CONCEPT_CS,
      E.UNIT,
      E.UNIT_CS,
      E.ABNORMAL_RESULT,
      E.LOW_RANGE,
      E.HIGH_RANGE,
      E.LOW_RANGE_RATIO,
      E.HIGH_RANGE_RATIO,
      E.PROVIDER_SPECIALTY,
      E.PROVIDER_SPECIALTY_CS,
      E.MEASUREMENT_SOURCE_CONCEPT,
      E.NESTED
    ],
    attributesSort: [
      x.DATE_ADJUSTMENT,
      x.FIRST,
      x.AGE,
      x.GENDER,
      x.GENDER_CS,
      x.OCCURRENCE_START_DATE,
      x.MEASUREMENT_TYPE,
      x.MEASUREMENT_TYPE_CS,
      x.VISIT_TYPE,
      x.VISIT_TYPE_CS,
      x.OPERATOR,
      x.OPERATOR_CS,
      x.VALUE_AS_NUMBER,
      x.VALUE_AS_CONCEPT,
      x.VALUE_AS_CONCEPT_CS,
      x.UNIT,
      x.UNIT_CS,
      x.ABNORMAL,
      x.RANGE_LOW,
      x.RANGE_HIGH,
      x.RANGE_LOW_RATIO,
      x.RANGE_HIGH_RATIO,
      x.PROVIDER_SPECIALTY,
      x.PROVIDER_SPECIALTY_CS,
      x.MEASUREMENT_SOURCE_CONCEPT,
      x.CORRETALED_CRITERIA
    ]
  },
  Observation: {
    titleText: "Observation:",
    baseText: "an observation of",
    baseTextViewMode: "observation of",
    defaultValue: "Any Observation",
    extend: !0,
    attributes: [
      E.MODIFY_EVENT_START_END,
      E.FIRST_OBSERVATION,
      E.AGE_OCCURRENCE,
      E.GENDER,
      E.GENDER_CS,
      E.OBSERVATION_DATE,
      E.OBSERVATION_TYPE,
      E.OBSERVATION_TYPE_CS,
      E.VISIT,
      E.VISIT_CS,
      E.VALUE_AS_NUMBER,
      E.VALUE_AS_STRING,
      E.VALUE_AS_CONCEPT,
      E.VALUE_AS_CONCEPT_CS,
      E.QUALIFIER,
      E.QUALIFIER_CS,
      E.UNIT,
      E.UNIT_CS,
      E.OBSERVATION_SOURCE_CONCEPT,
      E.PROVIDER_SPECIALTY,
      E.PROVIDER_SPECIALTY_CS,
      E.NESTED
    ],
    attributesSort: [
      x.DATE_ADJUSTMENT,
      x.FIRST,
      x.AGE,
      x.GENDER,
      x.GENDER_CS,
      x.OCCURRENCE_START_DATE,
      x.OBSERVATION_TYPE,
      x.OBSERVATION_TYPE_CS,
      x.VISIT_TYPE,
      x.VISIT_TYPE_CS,
      x.VALUE_AS_NUMBER,
      x.VALUE_AS_STRING,
      x.VALUE_AS_CONCEPT,
      x.VALUE_AS_CONCEPT_CS,
      x.QUALIFIER,
      x.QUALIFIER_CS,
      x.UNIT,
      x.UNIT_CS,
      x.OBSERVATION_SOURCE_CONCEPT,
      x.PROVIDER_SPECIALTY,
      x.PROVIDER_SPECIALTY_CS,
      x.CORRETALED_CRITERIA
    ]
  },
  ObservationPeriod: {
    titleText: "Observation period:",
    baseText: "observation periods with the following criteria",
    baseTextViewMode: "observation period",
    defaultValue: "",
    attributes: [
      E.MODIFY_EVENT_START_END,
      E.FIRST_OBSERVATION_PERIOD,
      E.SPECIFY_START_AND_DATE,
      E.AGE_AT_START,
      E.AGE_AT_END,
      E.PERIOD_START_DATE,
      E.PERIOD_END_DATE,
      E.PERIOD_TYPE,
      E.PERIOD_TYPE_CS,
      E.PERIOD_LENGTH,
      E.NESTED
    ],
    attributesSort: [
      x.DATE_ADJUSTMENT,
      x.FIRST,
      x.AGE_START,
      x.AGE_END,
      x.USER_DEFINED_PERIOD,
      x.PERIOD_START_DATE,
      x.PERIOD_END_DATE,
      x.PERIOD_TYPE,
      x.PERIOD_TYPE_CS,
      x.PERIOD_LENGTH,
      x.CORRETALED_CRITERIA
    ],
    extend: !0
  },
  PayerPlanPeriod: {
    titleText: "Payer plan period:",
    baseText: "payer plan periods with the following criteria",
    baseTextViewMode: "payer plan period",
    defaultValue: "",
    extend: !0,
    attributes: [
      E.MODIFY_EVENT_START_END,
      E.FIRST_PAYER_PLAN_PERIOD,
      E.GENDER,
      E.GENDER_CS,
      E.AGE_AT_START,
      E.AGE_AT_END,
      E.PERIOD_START_DATE,
      E.PERIOD_END_DATE,
      E.PERIOD_LENGTH,
      E.PAYER_CONCEPT,
      E.PLAN_CONCEPT,
      E.SPONSOR_CONCEPT,
      E.STOP_REASON_CONCEPT,
      E.PAYER_SOURCE_CONCEPT,
      E.PLAN_SOURCE_CONCEPT,
      E.SPONSOR_SOURCE_CONCEPT,
      E.STOP_REASON_SOURCE_CONCEPT,
      E.NESTED
    ],
    attributesSort: [
      x.DATE_ADJUSTMENT,
      x.FIRST,
      x.GENDER,
      x.GENDER_CS,
      x.AGE_START,
      x.AGE_END,
      x.PERIOD_START_DATE,
      x.PERIOD_END_DATE,
      x.PERIOD_LENGTH,
      x.PAYER_CONCEPT,
      x.PLAN_CONCEPT,
      x.SPONSOR_CONCEPT,
      x.STOP_REASON_CONCEPT,
      x.PAYER_SOURCE_CONCEPT,
      x.PLAN_SOURCE_CONCEPT,
      x.SPONSOR_SOURCE_CONCEPT,
      x.STOP_REASON_SOURCE_CONCEPT,
      x.CORRETALED_CRITERIA
    ]
  },
  ProcedureOccurrence: {
    titleText: "Procedure occurrence:",
    baseText: "a procedure occurrence of",
    baseTextViewMode: "procedure occurrence of",
    defaultValue: "Any Procedure",
    extend: !0,
    attributes: [
      E.MODIFY_EVENT_START_END,
      E.FIRST_PROCEDURE,
      E.AGE_OCCURRENCE,
      E.GENDER,
      E.GENDER_CS,
      E.CONDITION_START_DATE,
      E.PROCEDURE_TYPE,
      E.PROCEDURE_TYPE_CS,
      E.VISIT,
      E.VISIT_CS,
      E.MODIFIER,
      E.MODIFIER_CS,
      E.QUANTITY,
      E.PROCEDURE_SOURCE_CONCEPT,
      E.PROVIDER_SPECIALTY,
      E.PROVIDER_SPECIALTY_CS,
      E.NESTED
    ],
    attributesSort: [
      x.DATE_ADJUSTMENT,
      x.FIRST,
      x.AGE,
      x.GENDER,
      x.GENDER_CS,
      x.OCCURRENCE_START_DATE,
      x.PROCEDURE_TYPE,
      x.PROCEDURE_TYPE_CS,
      x.VISIT_TYPE,
      x.VISIT_TYPE_CS,
      x.MODIFIER,
      x.MODIFIER_CS,
      x.QUANTITY,
      x.PROCEDURE_SOURCE_CONCEPT,
      x.PROVIDER_SPECIALTY,
      x.PROVIDER_SPECIALTY_CS,
      x.CORRETALED_CRITERIA
    ]
  },
  LocationRegion: {
    titleText: "Location region:",
    baseText: "a location region of",
    baseTextViewMode: "location region of",
    defaultValue: "Any Location region",
    extend: !0,
    attributes: [
      E.LOC_START_DATE,
      E.LOC_END_DATE,
      E.NESTED
    ],
    attributesSort: [
      x.START_DATE,
      x.END_DATE,
      x.CORRETALED_CRITERIA
    ]
  },
  Specimen: {
    titleText: "Specimen:",
    baseText: "a specimen of",
    baseTextViewMode: "specimen of",
    defaultValue: "Any Specimen",
    extend: !0,
    attributes: [
      E.MODIFY_EVENT_START_END,
      E.FIRST_OCCURRENCE,
      E.AGE_OCCURRENCE,
      E.GENDER,
      E.GENDER_CS,
      E.SPECIMEN_DATE,
      E.SPECIMEN_TYPE,
      E.SPECIMEN_TYPE_CS,
      E.QUANTITY,
      E.UNIT,
      E.UNIT_CS,
      E.ANATOMIC_SITE,
      E.ANATOMIC_SITE_CS,
      E.DISEASE_STATUS,
      E.DISEASE_STATUS_CS,
      E.SOURCE_ID,
      E.NESTED
    ],
    attributesSort: [
      x.DATE_ADJUSTMENT,
      x.FIRST,
      x.AGE,
      x.GENDER,
      x.GENDER_CS,
      x.OCCURRENCE_START_DATE,
      x.SPECIMEN_TYPE,
      x.SPECIMEN_TYPE_CS,
      x.QUANTITY,
      x.UNIT,
      x.UNIT_CS,
      x.ANATOMIC_SITE,
      x.ANATOMIC_SITE_CS,
      x.DISEASE_STATUS,
      x.DISEASE_STATUS_CS,
      x.SOURCE_ID,
      x.CORRETALED_CRITERIA
    ]
  },
  VisitOccurrence: {
    titleText: "Visit:",
    baseText: "a visit occurrence of",
    baseTextViewMode: "visit occurrence of",
    defaultValue: "Any Visit",
    extend: !0,
    attributes: [
      E.MODIFY_EVENT_START_END,
      E.FIRST_VISIT,
      E.AGE_OCCURRENCE,
      E.GENDER,
      E.GENDER_CS,
      E.CONDITION_START_DATE,
      E.CONDITION_END_DATE,
      E.VISIT_TYPE,
      E.VISIT_TYPE_CS,
      E.VISIT_LENGTH,
      E.VISIT_SOURCE_CONCEPT,
      E.PROVIDER_SPECIALTY,
      E.PROVIDER_SPECIALTY_CS,
      E.PLACE_SERVICE,
      E.PLACE_SERVICE_CS,
      E.PLACE_SERVICE_LOCATION,
      E.PLACE_SERVICE_DISTANCE,
      E.NESTED
    ],
    attributesSort: [
      x.DATE_ADJUSTMENT,
      x.FIRST,
      x.AGE,
      x.GENDER,
      x.GENDER_CS,
      x.OCCURRENCE_START_DATE,
      x.OCCURRENCE_END_DATE,
      x.VISIT_TYPE,
      x.VISIT_TYPE_CS,
      x.VISIT_LENGTH,
      x.VISIT_SOURCE_CONCEPT,
      x.PROVIDER_SPECIALTY,
      x.PROVIDER_SPECIALTY_CS,
      x.PLACE_SERVICE,
      x.PLACE_SERVICE_CS,
      x.PLACE_SERVICE_LOCATION,
      x.PLACE_SERVICE_DISTANCE,
      x.CORRETALED_CRITERIA
    ]
  },
  VisitDetail: {
    titleText: "Visit Detail:",
    baseText: "a visit detail of",
    baseTextViewMode: "visit occurrence of",
    defaultValue: "Any Visit Detail",
    extend: !0,
    attributes: [
      E.MODIFY_EVENT_START_END,
      E.FIRST_VISIT_DETAIL,
      E.AGE_AT_VISIT_DETAIL,
      E.GENDER_CS,
      E.VISIT_DETAIL_START_DATE,
      E.VISIT_DETAIL_END_DATE,
      E.MODIFY_EVENT_START_END,
      E.VISIT_DETAIL_TYPE,
      E.VISIT_DETAIL_LENGTH,
      E.VISIT_DETAIL_SOURCE_CONCEPT,
      E.PROVIDER_SPECIALTY_CS,
      E.PLACE_SERVICE_CS,
      E.PLACE_SERVICE_LOCATION,
      E.NESTED
    ],
    attributesSort: [
      x.DATE_ADJUSTMENT,
      x.FIRST,
      x.AGE,
      x.GENDER_CS,
      x.VISIT_DETAIL_START_DATE,
      x.VISIT_DETAIL_END_DATE,
      x.DATE_ADJUSTMENT,
      x.VISIT_DETAIL_TYPE_CS,
      x.VISIT_DETAIL_SOURCE_CONCEPT,
      x.VISIT_DETAIL_LENGTH,
      x.PROVIDER_SPECIALTY_CS,
      x.PLACE_SERVICE_CS,
      x.PLACE_SERVICE_LOCATION,
      x.CORRETALED_CRITERIA
    ]
  }
}, Qs = [
  {
    value: Te.LESS_THAN,
    name: "before"
  },
  {
    value: Te.LESS_OR_EQUAL_TO,
    name: "on or before"
  },
  {
    value: Te.EQUAL_TO,
    name: "on"
  },
  {
    value: Te.GREATER_THAN,
    name: "after"
  },
  {
    value: Te.GREATER_OR_EQUAL_TO,
    name: "on or after"
  },
  {
    value: Te.BETWEEN,
    name: "between"
  },
  {
    value: Te.NOT_BETWEEN,
    name: "not between"
  }
], et = (e, t, n, r) => ({
  startText: t,
  type: F.DROPDOWN,
  defaultParam: {
    value: r,
    name: n
  },
  isExclusion: !0,
  subModule: "concept-sets",
  value: e
}), mr = {
  First: {
    startText: "for the first time in the person's history",
    altStartText: "limited to the patients first observation period",
    type: F.BOOL,
    value: "First"
  },
  AgeAtStart: {
    startText: "with age in years at era start",
    altStartText: "with age in years at period start",
    viewModeTextEnd: "years old at era start",
    type: F.VALUE,
    value: "AgeAtStart"
  },
  AgeAtEnd: {
    startText: "with age in years at era end",
    altStartText: "with age in years at period end",
    viewModeTextEnd: "years old at era end",
    type: F.VALUE,
    value: "AgeAtEnd"
  },
  Gender: {
    startText: "with a gender of",
    type: F.VOCABULARY,
    value: "Gender",
    domainId: "Gender"
  },
  EraStartDate: {
    startText: "start is",
    type: F.DATE,
    viewModeTextStart: "starting",
    value: "EraStartDate"
  },
  EraEndDate: {
    startText: "end is",
    type: F.DATE,
    viewModeTextStart: "ending",
    value: "EraEndDate"
  },
  StartDate: {
    startText: "start is",
    viewModeTextStart: "starting",
    type: F.DATE,
    value: "StartDate"
  },
  EndDate: {
    startText: "end is",
    type: F.DATE,
    viewModeTextStart: "ending",
    value: "EndDate"
  },
  OccurrenceCount: {
    startText: "with occurrence count",
    viewModeTextStart: "containing",
    viewModeTextEnd: "occurrences",
    type: F.VALUE,
    value: "OccurrenceCount"
  },
  EraLength: {
    startText: "with era length",
    viewModeTextStart: "era length is",
    viewModeTextEnd: "days",
    type: F.VALUE,
    value: "EraLength",
    endText: "days"
  },
  Age: {
    startText: "with age",
    viewModeTextEnd: "years old",
    type: F.VALUE,
    value: "Age"
  },
  ConditionStatus: {
    startText: "with a condition status of",
    type: F.VOCABULARY,
    viewModeTextStart: "a condition status that is:",
    value: "ConditionStatus",
    domainId: "Condition Status"
  },
  ConditionStatusCS: et(
    "ConditionStatusCS",
    "with a condition status",
    "Any condition status",
    "ANY_CONDITION_STATUS"
  ),
  OccurrenceStartDate: {
    startText: "occurrence start is",
    viewModeTextStart: "starting",
    type: F.DATE,
    value: "OccurrenceStartDate"
  },
  OccurrenceEndDate: {
    startText: "occurrence end is",
    viewModeTextStart: "ending",
    type: F.DATE,
    value: "OccurrenceEndDate"
  },
  ConditionType: {
    startText: "condition type",
    extend: !0,
    type: F.VOCABULARY,
    viewModeTextStart: "a condition type that is:",
    value: "ConditionType",
    secondValue: "ConditionTypeExclude",
    domainId: "Type Concept"
  },
  ConditionTypeCS: et(
    "ConditionTypeCS",
    "condition type",
    "Any condition type",
    "ANY_CONDITION_TYPE"
  ),
  VisitType: {
    startText: "visit type",
    altStartText: "with a visit occurrence of:",
    viewModeTextStart: "a visit occurrence that is:",
    type: F.VOCABULARY,
    value: "VisitType",
    secondValue: "VisitTypeExclude",
    domainId: "Visit",
    standardConcept: "Standard",
    extend: !0
    // secondValue: 'VisitTypeExclude',
  },
  VisitTypeCS: et(
    "VisitTypeCS",
    "visit type",
    "Any visit type",
    "ANY_VISIT_TYPE"
  ),
  StopReason: {
    startText: "with a stop reason",
    viewModeTextStart: "with a stop reason",
    type: F.TEXT,
    dropdownType: "intervalValue",
    value: "StopReason"
  },
  ConditionSourceConcept: {
    startText: "condition source concept is",
    type: F.DROPDOWN,
    defaultParam: {
      value: "ANY_CONDITION",
      name: "Any Condition"
    },
    subModule: "concept-sets",
    value: "ConditionSourceConcept"
  },
  ProviderSpecialty: {
    startText: "with a provider specialty of",
    viewModeTextStart: "a provider specialty that is:",
    type: F.VOCABULARY,
    subModule: "concept-sets",
    value: "ProviderSpecialty",
    domainId: "Provider"
  },
  DeathType: {
    startText: "death type",
    viewModeTextStart: "a death type that is:",
    type: F.VOCABULARY,
    extend: !0,
    value: "DeathType",
    secondValue: "DeathTypeExclude",
    domainId: "Type Concept",
    permamentSecondValue: !0
  },
  DeathTypeCS: et(
    "DeathTypeCS",
    "death type",
    "Any death type",
    "ANY_DEATH_TYPE"
  ),
  DeathDate: {
    startText: "occurrence start is",
    viewModeTextStart: "starting",
    type: F.DATE,
    dropdownType: "intervalDate",
    value: "OccurrenceStartDate"
  },
  DeathSourceConcept: {
    startText: "death source concept is",
    type: F.DROPDOWN,
    defaultParam: {
      value: "ANY_DEATH",
      name: "Any Death"
    },
    subModule: "concept-sets",
    value: "DeathSourceConcept"
  },
  DeviceType: {
    startText: "device type",
    type: F.VOCABULARY,
    extend: !0,
    viewModeTextStart: "a device type that is:",
    subModule: "concept-sets",
    value: "DeviceType",
    secondValue: "DeviceTypeExclude",
    domainId: "Type Concept"
  },
  DeviceTypeCS: et(
    "DeviceTypeCS",
    "device type",
    "Any device type",
    "ANY_DEVICE_TYPE"
  ),
  UniqueDeviceId: {
    startText: "with unique device ID",
    viewModeTextStart: "unique device ID",
    type: F.TEXT,
    dropdownType: "intervalInclude",
    value: "UniqueDeviceId"
  },
  Quantity: {
    startText: "with quantity",
    type: F.VALUE,
    dropdownType: "intervalValue",
    defaultOp: Te.LESS_THAN,
    value: "Quantity"
  },
  DeviceSourceConcept: {
    startText: "device source concept is",
    type: F.DROPDOWN,
    defaultParam: {
      value: "ANY_DEVICE",
      name: "Any Device"
    },
    subModule: "concept-sets",
    value: "DeviceSourceConcept"
  },
  Unit: {
    startText: "with unit",
    type: F.VOCABULARY,
    subModule: "concept-sets",
    value: "Unit",
    domainId: "Unit"
  },
  UnitCS: et("UnitCS", "with unit", "Any unit", "ANY_UNIT"),
  DoseUnit: {
    startText: "dose unit is",
    type: F.VOCABULARY,
    subModule: "concept-sets",
    value: "DoseUnit",
    domainId: "Unit"
  },
  DoseUnitCS: et(
    "DoseUnitCS",
    "dose unit is",
    "Any dose unit",
    "ANY_DOSE_UNIT"
  ),
  DoseValue: {
    startText: "with dose value",
    type: F.VALUE,
    dropdownType: "intervalValue",
    value: "DoseValue"
  },
  ERA_EXPOSURE_COUNT: {
    startText: "with exposure count",
    type: F.VALUE,
    dropdownType: "intervalValue",
    value: "OccurrenceCount"
  },
  DrugType: {
    startText: "drug type",
    type: F.VOCABULARY,
    extend: !0,
    subModule: "concept-sets",
    value: "DrugType",
    secondValue: "DrugTypeExclude",
    domainId: "Type Concept"
  },
  DrugTypeCS: et(
    "DrugTypeCS",
    "drug type",
    "Any drug type",
    "ANY_DRUG_TYPE"
  ),
  Refills: {
    startText: "with refills",
    type: F.VALUE,
    dropdownType: "intervalValue",
    value: "Refills"
  },
  DaysSupply: {
    startText: "with days supply",
    type: F.VALUE,
    dropdownType: "intervalValue",
    value: "DaysSupply"
  },
  RouteConcept: {
    startText: "route concept is",
    type: F.VOCABULARY,
    subModule: "concept-sets",
    value: "RouteConcept",
    domainId: "Route"
  },
  RouteConceptCS: et(
    "RouteConceptCS",
    "route concept is",
    "Any route",
    "ANY_ROUTE"
  ),
  EffectiveDrugDose: {
    startText: "with effective drug dose",
    type: F.VALUE,
    dropdownType: "intervalValue",
    value: "EffectiveDrugDose"
  },
  LotNumber: {
    startText: "with a lot number",
    type: F.TEXT,
    dropdownType: "intervalValue",
    value: "LotNumber"
  },
  DrugSourceConcept: {
    startText: "drug source concept is",
    type: F.DROPDOWN,
    defaultParam: {
      value: "ANY_DRUG",
      name: "Any Drug"
    },
    subModule: "concept-sets",
    value: "DrugSourceConcept"
  },
  MeasurementType: {
    startText: "measurement type",
    type: F.VOCABULARY,
    extend: !0,
    subModule: "concept-sets",
    value: "MeasurementType",
    secondValue: "MeasurementTypeExclude",
    domainId: "Type Concept"
  },
  MeasurementTypeCS: et(
    "MeasurementTypeCS",
    "measurement type",
    "Any measurement type",
    "ANY_MEASUREMENT_TYPE"
  ),
  Operator: {
    startText: "measurement value operator is",
    type: F.VOCABULARY,
    subModule: "concept-sets",
    value: "Operator",
    domainId: "Meas Value Operator"
  },
  OperatorCS: et(
    "OperatorCS",
    "measurement value operator is",
    "Any operator",
    "ANY_OPERATOR"
  ),
  ValueAsNumber: {
    startText: "with value as number",
    type: F.VALUE,
    dropdownType: "intervalValue",
    defaultOp: Te.LESS_THAN,
    value: "ValueAsNumber"
  },
  ValueAsString: {
    startText: "with value as string",
    type: F.TEXT,
    dropdownType: "intervalValue",
    value: "ValueAsString",
    defaultOp: mn.CONTAINING
  },
  ValueAsConcept: {
    startText: "with value as concept",
    type: F.VOCABULARY,
    subModule: "concept-sets",
    value: "ValueAsConcept",
    domainId: "Meas Value"
  },
  ValueAsConceptCS: et(
    "ValueAsConceptCS",
    "with value as concept",
    "Any value as concept",
    "ANY_VALUE_AS_CONCEPT"
  ),
  Abnormal: {
    startText: "with an abnormal result",
    type: F.BOOL,
    value: "Abnormal"
  },
  RangeLow: {
    startText: "with range low",
    type: F.VALUE,
    dropdownType: "intervalValue",
    value: "RangeLow"
  },
  RangeHigh: {
    startText: "with range high",
    type: F.VALUE,
    dropdownType: "intervalValue",
    value: "RangeHigh"
  },
  RangeLowRatio: {
    startText: "with range low ratio",
    type: F.VALUE,
    dropdownType: "intervalValue",
    value: "RangeLowRatio"
  },
  RangeHighRatio: {
    startText: "with range high ratio",
    type: F.VALUE,
    dropdownType: "intervalValue",
    value: "RangeHighRatio"
  },
  MeasurementSourceConcept: {
    startText: "measurement source concept is",
    type: F.DROPDOWN,
    defaultParam: {
      value: "ANY_MEASUREMENT",
      name: "Any Measurement"
    },
    subModule: "concept-sets",
    value: "MeasurementSourceConcept"
  },
  ObservationType: {
    startText: "observation type",
    type: F.VOCABULARY,
    extend: !0,
    subModule: "concept-sets",
    value: "ObservationType",
    secondValue: "ObservationTypeExclude",
    domainId: "Type Concept"
  },
  ObservationTypeCS: et(
    "ObservationTypeCS",
    "observation type",
    "Any observation type",
    "ANY_OBSERVATION_TYPE"
  ),
  Qualifier: {
    startText: "with qualifier",
    type: F.VOCABULARY,
    subModule: "concept-sets",
    value: "Qualifier",
    domainId: "Condition"
  },
  QualifierCS: et(
    "QualifierCS",
    "with qualifier",
    "Any qualifier",
    "ANY_QUALIFIER"
  ),
  ObservationSourceConcept: {
    startText: "observation source concept is",
    type: F.DROPDOWN,
    defaultParam: {
      value: "ANY_OBSERVATION",
      name: "Any Observation"
    },
    subModule: "concept-sets",
    value: "ObservationSourceConcept"
  },
  PeriodLength: {
    startText: "with period duration",
    type: F.VALUE,
    dropdownType: "intervalValue",
    value: "PeriodLength",
    endText: "days"
  },
  UserDefinedPeriod: {
    startText: "using specified period",
    range: !0,
    type: F.DATE,
    dropdownType: "intervalDate",
    value: "UserDefinedPeriod"
  },
  PeriodStartDate: {
    startText: "payer plan period start is",
    altStartText: "observation period start is",
    type: F.DATE,
    dropdownType: "intervalDate",
    value: "PeriodStartDate"
  },
  PeriodEndDate: {
    startText: "payer plan period end is",
    altStartText: "observation period end is",
    type: F.DATE,
    dropdownType: "intervalDate",
    value: "PeriodEndDate"
  },
  PayerConcept: {
    startText: "payer concept is",
    type: F.DROPDOWN,
    defaultParam: {
      value: "ANY_PAYER",
      name: "Any Payer"
    },
    subModule: "concept-sets",
    value: "PayerConcept"
  },
  PlanConcept: {
    startText: "plan concept is",
    type: F.DROPDOWN,
    defaultParam: {
      value: "ANY_PLAN",
      name: "Any Plan"
    },
    subModule: "concept-sets",
    value: "PlanConcept"
  },
  SponsorConcept: {
    startText: "sponsor concept is",
    type: F.DROPDOWN,
    defaultParam: {
      value: "ANY_SPONSOR",
      name: "Any Sponsor"
    },
    subModule: "concept-sets",
    value: "SponsorConcept"
  },
  StopReasonConcept: {
    startText: "stop reason concept is",
    type: F.DROPDOWN,
    defaultParam: {
      value: "ANY_STOP_REASON",
      name: "Any Stop Reason"
    },
    subModule: "concept-sets",
    value: "StopReasonConcept"
  },
  PayerSourceConcept: {
    startText: "payer source concept is",
    type: F.DROPDOWN,
    defaultParam: {
      value: "ANY_PAYER_SOURCE",
      name: "Any Payer Source"
    },
    subModule: "concept-sets",
    value: "PayerSourceConcept"
  },
  PlanSourceConcept: {
    startText: "plan source concept is",
    type: F.DROPDOWN,
    defaultParam: {
      value: "ANY_PLAN_SOURCE",
      name: "Any Plan Source"
    },
    subModule: "concept-sets",
    value: "PlanSourceConcept"
  },
  SponsorSourceConcept: {
    startText: "sponsor source concept is",
    type: F.DROPDOWN,
    defaultParam: {
      value: "ANY_SPONSOR_SOURCE",
      name: "Any Sponsor Source"
    },
    subModule: "concept-sets",
    value: "SponsorSourceConcept"
  },
  StopReasonSourceConcept: {
    startText: "stop reason source concept is",
    type: F.DROPDOWN,
    defaultParam: {
      value: "ANY_STOP_REASON_SOURCE",
      name: "Any Stop Reason Source"
    },
    subModule: "concept-sets",
    value: "StopReasonSourceConcept"
  },
  PeriodType: {
    startText: "period type is",
    type: F.VOCABULARY,
    subModule: "concept-sets",
    value: "PeriodType",
    domainId: "Type Concept"
  },
  PeriodTypeCS: et(
    "PeriodTypeCS",
    "period type is",
    "Any period type",
    "ANY_PERIOD_TYPE"
  ),
  ProcedureType: {
    startText: "procedure type",
    type: F.VOCABULARY,
    extend: !0,
    subModule: "concept-sets",
    value: "ProcedureType",
    secondValue: "ProcedureTypeExclude",
    domainId: "Type Concept"
  },
  ProcedureTypeCS: et(
    "ProcedureTypeCS",
    "procedure type",
    "Any procedure type",
    "ANY_PROCEDURE_TYPE"
  ),
  Modifier: {
    startText: "modifier is",
    type: F.VOCABULARY,
    subModule: "concept-sets",
    value: "Modifier",
    domainId: "Spec Anatomic Site"
  },
  ModifierCS: et(
    "ModifierCS",
    "modifier is",
    "Any modifier",
    "ANY_MODIFIER"
  ),
  ProcedureSourceConcept: {
    startText: "procedure source concept is",
    type: F.DROPDOWN,
    defaultParam: {
      value: "ANY_PROCEDURE",
      name: "Any Procedure"
    },
    subModule: "concept-sets",
    value: "ProcedureSourceConcept"
  },
  SpecimenType: {
    startText: "specimen type",
    type: F.VOCABULARY,
    extend: !0,
    subModule: "concept-sets",
    value: "SpecimenType",
    secondValue: "SpecimenTypeExclude",
    domainId: "Type Concept"
  },
  SpecimenTypeCS: et(
    "SpecimenTypeCS",
    "specimen type",
    "Any specimen type",
    "ANY_SPECIMEN_TYPE"
  ),
  SPECIMEN_DATE: {
    startText: "occurrence start is",
    type: F.DATE,
    dropdownType: "intervalDate",
    value: "OccurrenceStartDate"
  },
  AnatomicSite: {
    startText: "with anatomic site",
    type: F.VOCABULARY,
    subModule: "concept-sets",
    value: "AnatomicSite",
    domainId: "Spec Anatomic Site"
  },
  AnatomicSiteCS: et(
    "AnatomicSiteCS",
    "with anatomic site",
    "Any anatomic site",
    "ANY_ANATOMIC_SITE"
  ),
  PlaceOfServiceLocation: {
    startText: "with a place of service located in",
    type: F.DROPDOWN,
    defaultParam: {
      value: "ANY_LOCATION",
      name: "Any Location"
    },
    subModule: "concept-sets",
    value: "PlaceOfServiceLocation"
  },
  PlaceOfService: {
    startText: "with a place of service of",
    type: F.VOCABULARY,
    subModule: "concept-sets",
    value: "PlaceOfService",
    domainId: "Place of Service"
  },
  VisitSourceConcept: {
    startText: "visit source concept is",
    type: F.DROPDOWN,
    defaultParam: {
      value: "ANY_VISIT",
      name: "Any Visit"
    },
    subModule: "concept-sets",
    value: "VisitSourceConcept"
  },
  VisitLength: {
    startText: "with visit duration",
    type: F.VALUE,
    dropdownType: "intervalValue",
    value: "VisitLength"
  },
  PlaceOfServiceDistance: {
    startText: "with distance from a Place of Service to Patient",
    type: F.VALUE,
    dropdownType: "intervalValue",
    value: "PlaceOfServiceDistance"
  },
  DiseaseStatus: {
    startText: "with disease status",
    type: F.VOCABULARY,
    subModule: "concept-sets",
    value: "DiseaseStatus",
    domainId: "Spec Disease Status"
  },
  DiseaseStatusCS: et(
    "DiseaseStatusCS",
    "with disease status",
    "Any disease status",
    "ANY_DISEASE_STATUS"
  ),
  SourceId: {
    startText: "with source ID",
    type: F.TEXT,
    dropdownType: "intervalInclude",
    value: "SourceId"
  },
  Race: {
    startText: "with a race of",
    type: F.VOCABULARY,
    subModule: "concept-sets",
    value: "Race",
    domainId: "Race"
  },
  Ethnicity: {
    startText: "with a ethnicity of",
    type: F.VOCABULARY,
    subModule: "concept-sets",
    value: "Ethnicity",
    domainId: "Ethnicity"
  },
  DateAdjustment: {
    startText: "with date adjustment:",
    type: F.RANGE,
    value: "DateAdjustment",
    domainId: "DateAdjustment"
  },
  VisitDetailStartDate: {
    startText: "visit detail start is",
    type: F.DATE,
    viewModeTextStart: "starting",
    value: "VisitDetailStartDate"
  },
  VisitDetailEndDate: {
    startText: "visit detail end is",
    type: F.DATE,
    viewModeTextStart: "ending",
    value: "VisitDetailEndDate"
  },
  VisitDetailTypeCS: {
    startText: "visit detail type",
    type: F.DROPDOWN,
    defaultParam: {
      value: "ANY_VISIT_DETAIL_TYPE",
      name: "Any visit detail type"
    },
    isExclusion: !0,
    subModule: "concept-sets",
    value: "VisitDetailTypeCS"
  },
  VisitDetailLength: {
    startText: "with visit detail duration",
    type: F.VALUE,
    dropdownType: "intervalValue",
    value: "VisitDetailLength"
  },
  VisitDetailSourceConcept: {
    startText: "visit detail source soncept is",
    type: F.DROPDOWN,
    defaultParam: {
      value: "ANY_VISIT_DETAIL_SOURCE_CONCEPT",
      name: "Any visit detail cource concept"
    },
    subModule: "concept-sets",
    value: "VisitDetailSourceConcept"
  },
  GenderCS: {
    startText: "with a gender",
    type: F.DROPDOWN,
    defaultParam: {
      value: "ANY_GENDER",
      name: "Any gender"
    },
    isExclusion: !0,
    subModule: "concept-sets",
    value: "GenderCS"
  },
  RaceCS: {
    startText: "with a race",
    type: F.DROPDOWN,
    defaultParam: {
      value: "ANY_RACE",
      name: "Any race"
    },
    isExclusion: !0,
    subModule: "concept-sets",
    value: "RaceCS"
  },
  EthnicityCS: {
    startText: "with a ethnicity",
    type: F.DROPDOWN,
    defaultParam: {
      value: "ANY_ETHNICITY",
      name: "Any ethnicity"
    },
    isExclusion: !0,
    subModule: "concept-sets",
    value: "EthnicityCS"
  },
  ProviderSpecialtyCS: {
    startText: "with a provider specialty",
    type: F.DROPDOWN,
    defaultParam: {
      value: "ANY_PROVIDER",
      name: "Any provider specialty"
    },
    isExclusion: !0,
    subModule: "concept-sets",
    value: "ProviderSpecialtyCS"
  },
  PlaceOfServiceCS: {
    startText: "with place of service",
    type: F.DROPDOWN,
    defaultParam: {
      value: "ANY_LOCATION",
      name: "Any location"
    },
    isExclusion: !0,
    subModule: "concept-sets",
    value: "PlaceOfServiceCS"
  },
  CorrelatedCriteria: {
    type: F.GROUP,
    value: "CorrelatedCriteria"
  },
  Group: {
    type: F.GROUP,
    value: "Group"
  },
  default: {
    startText: "default",
    type: F.BOOL,
    value: "Default"
  }
}, Zs = [
  {
    value: Te.LESS_THAN,
    name: "less than"
  },
  {
    value: Te.LESS_OR_EQUAL_TO,
    name: "less or equal to"
  },
  {
    value: Te.EQUAL_TO,
    name: "equal to"
  },
  {
    value: Te.GREATER_THAN,
    name: "greater than"
  },
  {
    value: Te.GREATER_OR_EQUAL_TO,
    name: "greater or equal to"
  },
  {
    value: Te.BETWEEN,
    name: "between"
  },
  {
    value: Te.NOT_BETWEEN,
    name: "not between"
  }
], el = [
  {
    value: mn.STARTING_WITH,
    name: "starting with"
  },
  {
    value: mn.CONTAINING,
    name: "containing"
  },
  {
    value: mn.ENDING_WITH,
    name: "ending with"
  },
  {
    value: mn.NOT_STARTING_WITH,
    name: "not starting with"
  },
  {
    value: mn.NOT_CONTAINING,
    name: "not containing"
  },
  {
    value: mn.NOT_ENDING_WITH,
    name: "not ending with"
  }
], cu = [
  {
    value: Ls.START_DATE,
    name: "start date"
  },
  {
    value: Ls.END_DATE,
    name: "end date"
  }
], tl = [
  {
    value: "START_DATE",
    name: "start date"
  },
  {
    value: "END_DATE",
    name: "end date"
  }
], hf = [
  {
    value: Lo.END,
    name: "end of continuous observation"
  },
  {
    value: Lo.FIXED,
    name: "fixed duration relative to initial event"
  },
  {
    value: Lo.EXPOSURE,
    name: "end of a continuous drug exposure"
  }
], or = [
  {
    name: "after",
    value: 1
  },
  {
    name: "before",
    value: -1
  }
], ff = [
  {
    name: "all",
    value: er.ALL
  },
  {
    name: "any",
    value: er.ANY
  },
  {
    name: "at Least",
    value: er.AT_LEAST
  },
  {
    name: "at most",
    value: er.AT_MOST
  }
], ca = [
  {
    name: "exactly",
    value: 0
  },
  {
    name: "at most",
    value: 1
  },
  {
    name: "at least",
    value: 2
  }
], ua = [
  {
    name: "standard concept",
    value: ks.STANDARD_CONCEPT
  },
  {
    name: "start date",
    value: ks.START_DATE
  }
], mf = [
  {
    value: 0,
    name: "0"
  },
  {
    value: 1,
    name: "1"
  },
  {
    value: 2,
    name: "2"
  },
  {
    value: 3,
    name: "3"
  },
  {
    value: 4,
    name: "4"
  },
  {
    value: 5,
    name: "5"
  },
  {
    value: 6,
    name: "6"
  },
  {
    value: 7,
    name: "7"
  },
  {
    value: 8,
    name: "8"
  },
  {
    value: 9,
    name: "9"
  },
  {
    value: 10,
    name: "10"
  },
  {
    value: 20,
    name: "20"
  },
  {
    value: 50,
    name: "50"
  },
  {
    value: 100,
    name: "100"
  }
];
er.ALL;
const Ef = {
  CriteriaList: [],
  ObservationWindow: {
    PriorDays: 0,
    PostDays: 0
  },
  PrimaryCriteriaLimit: {
    Type: Ht.FIRST
  }
}, uu = {
  IsDistinct: !1,
  Type: 2,
  Count: 1,
  CountColumn: void 0
}, ar = {
  Start: {
    Coeff: -1
  },
  End: {
    Coeff: 1
  },
  UseIndexEnd: !1,
  UseEventEnd: !1
}, xf = /* @__PURE__ */ new Set([
  D.CONDITION_OCCURRENCE,
  D.DEVICE_EXPOSURE,
  D.DRUG_EXPOSURE,
  D.MEASUREMENT,
  D.OBSERVATION,
  D.PAYER_PLAN_PERIOD,
  D.PROCEDURE_OCCURRENCE,
  D.VISIT,
  D.VISIT_DETAILS
]), Cf = /* @__PURE__ */ new Set([
  D.CONDITION_ERA,
  D.CONDITION_OCCURRENCE,
  D.DEATH,
  D.DEVICE_EXPOSURE,
  D.DOSE_ERA,
  D.DRUG_ERA,
  D.DRUG_EXPOSURE,
  D.LOCATION_REGION,
  D.MEASUREMENT,
  D.OBSERVATION,
  D.OBSERVATION_PERIOD,
  D.PAYER_PLAN_PERIOD,
  D.PROCEDURE_OCCURRENCE,
  D.SPECIMEN,
  D.VISIT,
  D.VISIT_DETAILS
]), du = (e) => !1, da = (e) => !!(e && xf.has(e)), pu = (e) => e === D.LOCATION_REGION, hu = (e) => !!(e && Cf.has(e));
er.ALL;
const gf = "&filter.metadata.subject=COHORT";
var xn = /* @__PURE__ */ ((e) => (e.INIT = "INIT", e.ADD_ATTRIBUTE = "ADD_ATTRIBUTE", e.UPDATE_ATTRIBUTE = "UPDATE_ATTRIBUTE", e.REMOVE_ATTRIBUTE = "REMOVE_ATTRIBUTE", e))(xn || {});
const yf = (e, t) => ui(e, (n) => {
  switch (t.type) {
    case xn.INIT:
      n.isStartHook = !0, n.attributes = t.payload;
      break;
    case xn.ADD_ATTRIBUTE:
      n.attributes[t.payload.id] = t.payload;
      break;
    case xn.UPDATE_ATTRIBUTE:
      n.attributes[t.payload.id].value = t.payload.values;
      break;
    case xn.REMOVE_ATTRIBUTE:
      delete n.attributes[t.payload];
      break;
  }
}), Tf = {
  attributes: {},
  isStartHook: !1,
  isLoading: !1
}, fu = (e, t) => {
  switch (e) {
    case F.BOOL:
      return !0;
    case F.VALUE:
      return {
        Op: t || Te.GREATER_THAN,
        Value: null
      };
    case F.DATE:
      return {
        Op: Te.LESS_THAN,
        Value: null
      };
    case F.TEXT:
      return {
        Op: mn.CONTAINING,
        Text: null
      };
    case F.DROPDOWN:
      return null;
    case F.VOCABULARY:
      return [];
    default:
      return {};
  }
}, Sf = (e) => {
  const [t, n] = xr(
    yf,
    Tf
  ), r = ie(
    (l) => {
      const c = mr[l.value], u = {
        id: l.value,
        name: l.name,
        value: fu(c.type, c.defaultOp),
        permamentSecondValue: c.permamentSecondValue
      };
      n({
        type: xn.ADD_ATTRIBUTE,
        payload: u
      });
    },
    []
  ), i = ie(
    (l, c) => {
      n({
        type: xn.UPDATE_ATTRIBUTE,
        payload: {
          id: l,
          values: c
        }
      });
    },
    []
  ), o = ie((l) => {
    n({
      type: xn.REMOVE_ATTRIBUTE,
      payload: l
    });
  }, []), s = ie(() => {
    n({
      type: xn.INIT,
      payload: e
    });
  }, []);
  return Q(() => {
    e && s();
  }, []), {
    ...t,
    addAttribute: r,
    removeAttribute: o,
    updateAttribute: i
  };
};
var Mt = /* @__PURE__ */ ((e) => (e.GET_COHORTS = "GET_COHORTS", e.SET_COHORTS = "SET_COHORTS", e.REMOVE_COHORT = "REMOVE_COHORT", e.CREATE_COHORT_REQUEST = "CREATE_COHORTS_REQUEST", e.CREATE_COHORT_REQUEST_DONE = "CREATE_COHORTS_REQUEST_DONE", e.CLEAR = "CLEAR", e))(Mt || {});
const If = {
  isCreated: !1,
  isUpdate: !1,
  isLoading: !1,
  cohorts: {},
  cohort: null
}, Af = (e, t) => ui(e, (n) => {
  switch (t.type) {
    case Mt.GET_COHORTS:
      n.cohorts = t.payload;
      break;
    case Mt.CREATE_COHORT_REQUEST:
      n.isCreated = !1, n.isUpdate = !1, n.isLoading = !0;
      break;
    case Mt.CREATE_COHORT_REQUEST_DONE:
      n.isCreated = !0, n.isLoading = !1, n.cohort = t.payload;
      break;
    case Mt.CLEAR:
      n.cohorts = {};
      break;
    case Mt.SET_COHORTS:
      t.payload.multi ? n.cohorts = {
        ...n.cohorts,
        ...t.payload.newItems
      } : n.cohorts = t.payload.newItems;
      break;
    case Mt.REMOVE_COHORT:
      delete n.cohorts[t.payload];
      break;
  }
}), nl = (e, t = ze.CREATE_NEW_OBJECT) => `${e}?resolution=${encodeURIComponent(t)}`, Mo = {}, bf = (e) => e.includes("/copy/") ? "copy" : e.includes("/import") ? "import" : "default", Rf = (e) => {
  switch (e) {
    case ze.COPY:
      return Array.from(/* @__PURE__ */ new Set([e, "COPY"]));
    case ze.CREATE_NEW_VERSION:
      return Array.from(
        /* @__PURE__ */ new Set([
          "NEW_VERSION",
          e,
          "CREATE_NEW_VERSION",
          "create_new_version",
          "create-new-version"
        ])
      );
    case ze.CREATE_NEW_OBJECT:
    default:
      return Array.from(
        /* @__PURE__ */ new Set([
          "NEW_OBJECT",
          e,
          "CREATE_NEW_OBJECT",
          "CREATE_NEW",
          "create_new",
          "create-new"
        ])
      );
  }
}, pi = (e, t, n = ze.CREATE_NEW_OBJECT) => {
  const r = bf(e), i = Mo[r];
  if (i === null)
    return Se.post(e, t);
  if (typeof i == "string")
    return Se.post(nl(e, i), t).catch((l) => {
      var c;
      if (((c = l == null ? void 0 : l.response) == null ? void 0 : c.status) === 400)
        return delete Mo[r], pi(e, t, n);
      throw l;
    });
  const o = [
    ...Rf(n),
    void 0
  ], s = (l) => {
    const c = o[l], u = c ? nl(e, c) : e;
    return Se.post(u, t).then((p) => (Mo[r] = c ?? null, p)).catch((p) => {
      var d;
      if (((d = p == null ? void 0 : p.response) == null ? void 0 : d.status) === 400 && l < o.length - 1)
        return s(l + 1);
      throw p;
    });
  };
  return s(0);
}, po = (e, t) => {
  const n = encodeURIComponent(e), r = t ? `&entityId=${encodeURIComponent(t)}` : "";
  return `name=${n}${r}`;
}, mu = (e) => {
  const { pageNumber: t, pageSize: n, sortBy: r, query: i } = e, o = di(r), s = `/cohortdefinition/list?size=${n || ""}&page=${t || ""}&sort=${o}&${i || ""}`;
  return Se.get(s);
}, Eu = (e) => {
  const { pageNumber: t, pageSize: n, sortBy: r, query: i } = e, o = di(r), s = `/workspace/cohorts/list?size=${n || ""}&page=${t || 0}&sort=${o}&${i || ""}`;
  return Se.get(s);
}, Of = () => Se.get("/cohortdefinition/sorts"), vf = () => Se.get("/workspace/cohorts/sorts"), xu = (e, t) => {
  if (!e)
    throw new Error("Study must be selected in order to get study cohorts");
  const { pageNumber: n, pageSize: r, sortBy: i, query: o } = t, s = di(i), l = `/studies/${e}/cohorts/list?size=${r || ""}&page=${n || 0}&sort=${s}&${o || ""}`;
  return Se.get(l);
}, Df = (e) => {
  const { pageNumber: t, pageSize: n, sortBy: r, query: i } = e, o = di(r), s = `/library/cohorts/list?size=${n || ""}&page=${t || 0}&sort=${o}&${i || ""}`;
  return Se.get(s);
}, _f = (e) => {
  const t = `/cohortdefinition/filter?${e}`;
  return Se.get(t);
}, Nf = (e) => {
  const t = `/workspace/cohorts/filter?${e}`;
  return Se.get(t);
}, wf = (e, t) => {
  const n = `/studies/${t}/cohorts/filter?${e}`;
  return Se.get(n);
}, Pf = (e) => {
  const t = `/library/cohorts/filter?${e}`;
  return Se.get(t);
}, qi = (e) => Se.get(`/cohortdefinition/${e}?timestanp=${(/* @__PURE__ */ new Date()).toISOString()}`), Cu = (e) => Se.delete(`/cohortdefinition/${e}`), ho = (e, t) => Se.put(`/cohortdefinition/${e}`, t), jf = (e) => Se.post("/cohortdefinition", e), fo = (e) => Se.post("/workspace/cohorts", e), gu = (e, t, n = ze.COPY) => pi(
  `/workspace/cohorts/copy/${e}`,
  t ? { name: t } : {},
  n
), $a = (e, t) => Se.post(`/studies/${e}/cohorts`, t), Lf = (e, t) => {
  const { pageNumber: n, pageSize: r, sortBy: i, query: o } = t, s = di(i), l = `/cohortdefinition/${e}/usage/list?size=${r || ""}&page=${n || 0}&sort=${s}&${o || ""}`;
  return Se.get(l);
}, kf = (e, t) => {
  const n = `/cohortdefinition/${t}/usage/filter?${e}`;
  return Se.get(n);
}, yu = (e, t, n, r = ze.COPY) => pi(
  `/studies/${e}/cohorts/copy/${t}`,
  n ? { name: n } : {},
  r
), Mf = (e, t = ze.CREATE_NEW_OBJECT) => pi("/workspace/cohorts/import", e, t), Vf = (e, t, n = ze.CREATE_NEW_OBJECT) => pi(
  `/studies/${e}/cohorts/import`,
  t,
  n
), Uf = (e, t) => Se.get(
  `/workspace/cohorts/check-name?${po(e, t)}`
), Ff = (e, t, n) => Se.get(
  `/studies/${e}/cohorts/check-name?${po(
    t,
    n
  )}`
), Bf = (e, t) => Se.get(
  `/workspace/concept-sets/check-name?${po(e, t)}`
), $f = (e, t, n) => Se.get(
  `/studies/${e}/concept-sets/check-name?${po(
    t,
    n
  )}`
), Tu = (e, t, n, r) => {
  switch (e) {
    case he.STUDY:
      if (!n)
        throw new Error("Study parentId is required for name check.");
      return Ff(n, t, r);
    case he.WORKSPACE:
    default:
      return Uf(t, r);
  }
}, Gf = (e, t, n, r) => {
  switch (e) {
    case he.STUDY:
      if (!n)
        throw new Error("Study parentId is required for name check.");
      return $f(n, t, r);
    case he.WORKSPACE:
    default:
      return Bf(t, r);
  }
}, zf = (e, t) => t !== "new" ? ho(t, e) : fo(e), Wf = (e, t, n) => t !== "new" ? ho(t, e) : $a(n, e), Yf = (e) => Se.get(`/cohortdefinition/${e}/versions?size=10000`), Su = (e) => Se.get(`/cohortdefinition/version/${e}`), Iu = (e) => Se.get(`/conceptset/version/${e}`), Hf = (e) => Se.post("/cohortdefinition/validation", e), qf = (e) => Se.post("/library/cohort/invites", e), Xi = (e, t) => {
  let n = "";
  e && t && (n += `?size=1000000&page=0&${e}=${t}`);
  const r = `/cohortdefinition/metadata-value/list${n}`;
  return Se.get(r);
}, pa = (e) => Se.post("/cohortdefinition/metadata-value", e), ha = (e, t) => {
  const n = `/cohortdefinition/metadata-value/${t}`;
  return Se.put(n, e);
}, rl = (e) => {
  const t = `/cohortdefinition/metadata-value/${e}`;
  return Se.delete(t);
}, il = (e, t) => {
  const n = `/cohortdefinition/metadata-value/${e}/copy`;
  return Se.post(n, t);
}, Xf = (e, t, n, r) => Se.post(`/atlas/${e}/assets/${t}/export?id=${n}&name=${r}`, {}), Jf = (e) => Se.get(`/cohortdefinition/${e}/summary`), Kf = (e, t) => Se.patch(`/cohortdefinition/${e}`, t), Qf = (e = "", t) => {
  {
    const n = e.replace(/^&/, ""), r = `/admin/metadata-attribute/list${n ? `?${n}` : ""}`;
    return Se.get(r);
  }
}, Zf = (e) => Mh.get(
  `https://clinicaltrials.gov/api/v2/studies/${e}`,
  {
    headers: {
      accept: "text/csv"
    }
  }
), Ji = (e) => typeof e == "object" && e !== null, em = (e) => {
  if (typeof e == "string" && e.trim())
    return e;
  if (typeof e == "number")
    return String(e);
}, ol = (e, t) => {
  for (const n of t) {
    const r = em(e[n]);
    if (r)
      return r;
  }
}, tm = (e) => {
  if (!Ji(e) || !Ji(e.response))
    return !1;
  const t = e.response.status;
  return t === 400 || t === 404 || t === 405;
}, nm = (e) => {
  if (typeof e == "string")
    return e;
  if (!Ji(e))
    return null;
  const t = ol(e, [
    "sql",
    "templateSql",
    "renderedSql",
    "value",
    "content"
  ]);
  return t || Ji(e.result) && ol(e.result, [
    "sql",
    "templateSql",
    "renderedSql",
    "value"
  ]) || null;
}, rm = async (e, t, n = !1) => {
  const r = t.flatMap((s) => [
    `/cohortdefinition/${e}/export/sql?dialect=${encodeURIComponent(
      s
    )}`,
    `/cohortdefinition/${e}/export/sql/${encodeURIComponent(s)}`,
    `/cohortdefinition/${e}/sql?dialect=${encodeURIComponent(s)}`,
    `/cohortdefinition/${e}/sql/${encodeURIComponent(s)}`
  ]), i = n ? [`/cohortdefinition/${e}/export/sql`, ...r] : [...r, `/cohortdefinition/${e}/export/sql`];
  let o = null;
  for (const s of new Set(i))
    try {
      const l = await Se.get(s), c = nm(l);
      if (c)
        return c;
    } catch (l) {
      if (o = l, !tm(l))
        throw l;
    }
  throw o || new Error("SQL export is unavailable for selected dialect");
}, Au = (e) => Se.get(`/cohortdefinition/${e}/derived-stats`), im = (e, t) => {
  switch (e) {
    case he.WORKSPACE:
      return {
        fetch: (n) => Eu(n),
        create: (n) => fo(n)
      };
    case he.STUDY:
      return {
        fetch: (n) => xu(t, n),
        create: (n) => $a(t, n)
      };
    default:
      return {
        fetch: (n) => mu(n),
        create: (n) => jf(n)
      };
  }
}, om = (e, t, n) => {
  const [r, i] = xr(
    Af,
    If
  ), { fetch: o, create: s } = im(e, t), l = async (h, g, C) => {
    i({
      type: Mt.CREATE_COHORT_REQUEST
    });
    try {
      const T = await s({
        name: h,
        description: g,
        expression: C
      });
      i({
        type: Mt.CREATE_COHORT_REQUEST_DONE,
        payload: T
      });
    } catch {
    }
  }, c = async () => {
    try {
      const h = await o({
        pageNumber: 0,
        pageSize: 1e5
      });
    } catch {
    }
  }, u = ie(
    async (h) => {
      try {
        const g = h.map(
          (I) => Su(I.versionId).then((A) => ({
            ...A,
            data: {
              ...A.data,
              currentVersionId: I.currentVersionId
            }
          }))
        ), C = await Promise.all(g), T = {};
        return C.forEach((I) => {
          T[I.data.versionId] = {
            value: I.data.id,
            name: I.data.name,
            versionId: I.data.versionId,
            currentVersionId: I.data.currentVersionId
          };
        }), i({
          type: Mt.GET_COHORTS,
          payload: T
        }), T;
      } catch {
      }
    },
    [r.cohorts]
  ), p = ie((h, g) => {
    const C = {};
    h.forEach((T) => {
      C[T.versionId] = {
        value: T.id,
        name: T.name,
        versionId: T.versionId
      };
    }), i({
      type: Mt.SET_COHORTS,
      payload: {
        newItems: C,
        multi: g
      }
    });
  }, []), d = ie(async (h) => {
    i({
      type: Mt.REMOVE_COHORT,
      payload: h
    });
  }, []), f = ie(() => {
    i({
      type: Mt.CLEAR
    });
  }, []);
  return {
    ...r,
    getExistCohort: c,
    createCohortExpression: l,
    getExistCohortsById: u,
    clearCohortData: f,
    setCohortByImport: p,
    removeCohort: d
  };
};
var It = /* @__PURE__ */ ((e) => (e.INIT = "INIT", e.ADD_CRITERIA = "ADD_CRITERIA", e.UPDATE_CRITERIA_ATTRIBUTES = "UPDATE_CRITERIA_ATTRIBUTES", e.UPDATE_CRITERIA_CODESETID = "UPDATE_CRITERIA_CODESETID", e.UPDATE_CRITERIA_EXTEND_OPTIONS = "UPDATE_CRITERIA_EXTEND_OPTIONS", e.UPDATE_CRITERIA_GROUP = "UPDATE_CRITERIA_EXTEND_GROUP", e.REMOVE_CRITERIA = "REMOVE_CRITERIA", e))(It || {});
const am = {
  criteries: {},
  isStartHook: !1,
  isLoading: !1
}, sm = (e, t) => ui(e, (n) => {
  switch (t.type) {
    case It.INIT:
      n.isStartHook = !0, n.criteries = t.payload;
      break;
    case It.ADD_CRITERIA:
      n.criteries[t.payload.id] = t.payload;
      break;
    case It.UPDATE_CRITERIA_ATTRIBUTES:
      n.criteries[t.payload.id].attributes = t.payload.values;
      break;
    case It.UPDATE_CRITERIA_CODESETID:
      n.criteries[t.payload.id].codesetId = t.payload.value;
      break;
    case It.UPDATE_CRITERIA_EXTEND_OPTIONS:
      n.criteries[t.payload.id].extendOptions = t.payload.value;
      break;
    case It.UPDATE_CRITERIA_GROUP:
      n.criteries[t.payload.id].group = t.payload.value;
      break;
    case It.REMOVE_CRITERIA:
      delete n.criteries[t.payload];
      break;
  }
}), lm = (e, t = {}) => {
  var i;
  if (!t.extend || !((i = uo[e]) != null && i.extend))
    return;
  const n = {
    StartWindow: {
      Start: { ...ar.Start },
      End: { ...ar.End },
      UseIndexEnd: ar.UseIndexEnd,
      UseEventEnd: ar.UseEventEnd
    }
  };
  t.hideOccurrence || (n.Occurrence = { ...uu });
  const r = !t.hideIgnoreObservationPeriod && hu(e);
  return (r || t.hiddenIgnoreObservationPeriodValue !== void 0) && (n.IgnoreObservationPeriod = r ? pu(e) : t.hiddenIgnoreObservationPeriodValue), (t.showRestrictToSameVisitForAllCriteria || da(e)) && (n.RestrictVisit = da(e) && du()), n;
}, cm = (e, t = {}) => {
  const [n, r] = xr(
    sm,
    am
  ), i = ie(
    (d) => {
      const f = {
        id: Yt(),
        name: d.id,
        codesetId: void 0,
        attributes: d.predefinedAttribute ? d.predefinedAttribute : {},
        extendOptions: lm(d.id, t),
        group: void 0
      };
      r({
        type: It.ADD_CRITERIA,
        payload: f
      });
    },
    [
      t.extend,
      t.hideIgnoreObservationPeriod,
      t.hiddenIgnoreObservationPeriodValue,
      t.hideOccurrence,
      t.showRestrictToSameVisitForAllCriteria
    ]
  ), o = ie(
    (d, f) => {
      r({
        type: It.UPDATE_CRITERIA_ATTRIBUTES,
        payload: {
          id: d,
          values: f
        }
      });
    },
    []
  ), s = ie((d, f) => {
    r({
      type: It.UPDATE_CRITERIA_CODESETID,
      payload: {
        id: d,
        value: f
      }
    });
  }, []), l = ie(
    (d, f) => {
      r({
        type: It.UPDATE_CRITERIA_EXTEND_OPTIONS,
        payload: {
          id: f,
          value: d
        }
      });
    },
    []
  ), c = ie(
    (d, f) => {
      r({
        type: It.UPDATE_CRITERIA_GROUP,
        payload: {
          id: d,
          value: f
        }
      });
    },
    []
  ), u = ie((d) => {
    r({
      type: It.REMOVE_CRITERIA,
      payload: d
    });
  }, []), p = ie((d) => {
    r({
      type: It.INIT,
      payload: d ?? e
    });
  }, []);
  return Q(() => {
    e && p();
  }, []), {
    ...n,
    init: p,
    addCriteria: i,
    updateCriteriaAttributes: o,
    updateCriteriaCodeSetId: s,
    removeCriteria: u,
    updateExtendOptionsCriteria: l,
    updateGroupCriteria: c
  };
}, Vr = "Criteria", Vo = "CorrelatedCriteria", um = /* @__PURE__ */ new Set([
  Vr,
  "Occurrence",
  "StartWindow",
  "EndWindow",
  "IgnoreObservationPeriod",
  "RestrictVisit"
]), At = (e) => typeof e == "object" && e !== null && !Array.isArray(e), Un = (e) => e === void 0 ? e : JSON.parse(JSON.stringify(e)), al = (e, t) => t && At(e[t]) ? t : Object.keys(e).find(
  (n) => !um.has(n) && At(e[n])
), bu = (e, t) => {
  let n = !1;
  return Array.isArray(t.CriteriaList) && t.CriteriaList.length > 0 && (!Array.isArray(e.CriteriaList) || e.CriteriaList.length === 0 ? (e.CriteriaList = Un(t.CriteriaList), n = !0) : t.CriteriaList.forEach((r, i) => {
    const o = e.CriteriaList[i];
    At(o) && At(r) ? n = Ga(
      o,
      r
    ) || n : o === void 0 && (e.CriteriaList[i] = Un(r), n = !0);
  })), Array.isArray(t.DemographicCriteriaList) && t.DemographicCriteriaList.length > 0 && (!Array.isArray(e.DemographicCriteriaList) || e.DemographicCriteriaList.length === 0) && (e.DemographicCriteriaList = Un(
    t.DemographicCriteriaList
  ), n = !0), Array.isArray(t.Groups) && t.Groups.length > 0 && (!Array.isArray(e.Groups) || e.Groups.length === 0 ? (e.Groups = Un(t.Groups), n = !0) : t.Groups.forEach((r, i) => {
    const o = e.Groups[i];
    At(o) && At(r) ? n = bu(o, r) || n : o === void 0 && (e.Groups[i] = Un(r), n = !0);
  })), n;
}, Ga = (e, t) => {
  if (At(e[Vr]) && At(t[Vr]))
    return Ga(
      e[Vr],
      t[Vr]
    );
  const n = al(e), r = al(t, n);
  if (!n || !r)
    return !1;
  const i = e[n], o = t[r];
  if (!At(i) || !At(o))
    return !1;
  const s = o[Vo];
  if (!At(s))
    return !1;
  const l = i[Vo];
  return At(l) ? bu(
    l,
    s
  ) : (i[Vo] = Un(s), !0);
}, dm = (e, t) => {
  var c, u;
  const n = e == null ? void 0 : e.expression, r = (c = t == null ? void 0 : t.PrimaryCriteria) == null ? void 0 : c.CriteriaList, i = (u = n == null ? void 0 : n.PrimaryCriteria) == null ? void 0 : u.CriteriaList;
  if (!At(n) || !Array.isArray(r) || !Array.isArray(i))
    return { cohort: e, changed: !1 };
  const o = Un(e), s = o.expression.PrimaryCriteria.CriteriaList;
  let l = !1;
  return r.forEach((p, d) => {
    const f = s[d];
    At(f) && At(p) && (l = Ga(f, p) || l);
  }), l ? { cohort: o, changed: l } : { cohort: e, changed: !1 };
}, pm = "atlas", hm = "Error! Name is already used by another object.", fm = "Unable to validate name uniqueness. Please try again.", Fr = (e) => typeof e == "object" && e !== null, mm = (e) => {
  if (Fr(e))
    return typeof e.message == "string" ? e.message : void 0;
}, Em = (e) => {
  if (!(!Fr(e) || !Fr(e.response) || !Fr(e.response.data)))
    return typeof e.response.data.message == "string" ? e.response.data.message : void 0;
}, xm = (e) => typeof e == "boolean" ? e : Fr(e) ? typeof e.available == "boolean" ? e.available : typeof e.isAvailable == "boolean" ? e.isAvailable : typeof e.success == "boolean" ? e.success : typeof e.result == "boolean" ? e.result : typeof e.unique == "boolean" ? e.unique : typeof e.isUnique == "boolean" ? e.isUnique : typeof e.valid == "boolean" ? e.valid : typeof e.isValid == "boolean" ? e.isValid : typeof e.exists == "boolean" ? !e.exists : typeof e.duplicate == "boolean" ? !e.duplicate : typeof e.conflict == "boolean" ? !e.conflict : typeof e.used == "boolean" ? !e.used : !0 : !0, Ru = it(
  (e) => {
    const {
      onChange: t,
      typeContainer: n,
      parentId: r,
      importMethod: i,
      resolution: o = ze.CREATE_NEW_OBJECT,
      onResolutionChange: s
    } = e, { enqueueSnackbar: l } = Nn(), c = ee(() => pf, []), [u, p] = J(!1), [d, f] = J(""), [h, g] = J(""), C = Ae(o), T = !!s, I = s || ((P) => {
    }), A = "Fully identical cohort(s) will not be created, instead existing ones will be reused. Cohort(s) with the same name, but different content will create a new version of the existing ones.", S = "New cohort(s) will be created, even if identical cohort(s) exist.", _ = o === ze.CREATE_NEW_OBJECT, { cohort: v, createCohortExpression: O, isLoading: j } = om(
      n,
      r
    );
    Q(() => {
      v && v.id && t(v);
    }, [v, t]);
    const M = ie(() => {
      f("");
    }, []);
    Q(() => {
      C.current = o, _ || M();
    }, [_, M]);
    const w = ie(
      (P) => {
        C.current = P, P !== ze.CREATE_NEW_OBJECT && M(), I(P);
      },
      [I, M]
    ), L = ie(
      async (P) => {
        p(!0);
        const { expression: k, name: z, description: B } = P, q = (z == null ? void 0 : z.trim()) || "", N = P.format ?? pm, ne = C.current, ue = ne === ze.CREATE_NEW_OBJECT;
        let te;
        try {
          te = JSON.parse(k);
        } catch {
          p(!1), l("Cohort Definition is not valid JSON!", {
            variant: "error"
          });
          return;
        }
        const m = "expression" in te ? te.expression : te;
        let W = m;
        if (N === "atlas") {
          if (!Array.isArray(m.ConceptSets)) {
            p(!1), l("Atlas cohort definition is not valid!", {
              variant: "error"
            });
            return;
          }
          const H = m.ConceptSets.map((V) => {
            const le = V.expression.items.map((b) => {
              const oe = { ...b };
              return "isExcluded" in oe && oe.isExcluded && (oe.excluded = oe.isExcluded, delete oe.isExcluded), oe.concept.STANDARD_CONCEPT === Hp.NON_STANDARD && (oe.hierarchy = oe.includeDescendants, delete oe.includeMapped, delete oe.includeDescendants), oe;
            });
            return {
              ...V,
              expression: {
                items: le
              }
            };
          }), y = /* @__PURE__ */ new Map();
          for (const V of H) {
            const $ = V.id, le = V.name, b = y.get($) ?? [];
            b.push(le), y.set($, b);
          }
          const X = Array.from(y.entries()).filter(([V, $]) => $.length > 1).map(([V, $]) => ({ id: V, names: $ }));
          if (X.length > 0) {
            const V = X.map(($) => `ID ${$.id}: ${$.names.join(", ")}`).join(`
`);
            p(!1), l(
              `Duplicate ConceptSet IDs found:
${V}
Please use unique IDs.`,
              {
                variant: "error"
              }
            );
            return;
          }
          W = {
            ...m,
            ConceptSets: H
          };
        }
        if (ue)
          try {
            const H = await Tu(
              n,
              q,
              r
            );
            if (!xm(H)) {
              f(
                mm(H) || hm
              ), p(!1);
              return;
            }
            M();
          } catch (H) {
            f(
              Em(H) || fm
            ), p(!1);
            return;
          }
        try {
          if (i) {
            const H = await i(
              {
                name: q,
                description: B,
                expression: W,
                format: N
              },
              ne
            ), { cohort: y, changed: X } = dm(H, W);
            let V = y;
            if (X && y.id)
              try {
                V = await ho(
                  String(y.id),
                  y
                );
              } catch {
                l(
                  "Cohort imported, but nested criteria could not be restored.",
                  {
                    variant: "error"
                  }
                );
              }
            p(!1), t(V);
          } else
            await O(q, B, W), p(!1);
        } catch {
          p(!1), l("Cohort is not valid!", {
            variant: "error"
          });
          return;
        }
      },
      [
        O,
        l,
        i,
        t,
        r,
        M,
        n
      ]
    );
    return /* @__PURE__ */ a.jsx(R, { container: !0, children: /* @__PURE__ */ a.jsx(R, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsx(
      eh,
      {
        onSubmit: L,
        codeKey: "expression",
        nameKey: "name",
        editorTitle: "Cohort Definition",
        fields: c,
        isLoading: j || u,
        fileExtension: Jr.JSON,
        submitButtonText: "Import",
        isSubmitDisabled: _ && !!d && h.trim().length > 0,
        onFieldValueChange: (P, k) => {
          P === "name" && (g(k), M());
        },
        fieldErrors: {
          name: d
        },
        footerStart: T ? /* @__PURE__ */ a.jsxs(
          Y,
          {
            display: "flex",
            alignItems: "center",
            columnGap: 1.5,
            flexWrap: "nowrap",
            sx: { maxWidth: "100%", overflowX: "auto", py: 0.5 },
            children: [
              /* @__PURE__ */ a.jsx(fe, { variant: "caption", sx: { whiteSpace: "nowrap" }, children: "Select conflict resolution method:" }),
              /* @__PURE__ */ a.jsxs(
                Y,
                {
                  display: "flex",
                  alignItems: "center",
                  columnGap: 1.5,
                  sx: { whiteSpace: "nowrap" },
                  children: [
                    /* @__PURE__ */ a.jsxs(Y, { display: "flex", alignItems: "center", columnGap: 0.75, children: [
                      /* @__PURE__ */ a.jsx(
                        $i,
                        {
                          checked: o === ze.CREATE_NEW_VERSION,
                          onChange: () => w(
                            ze.CREATE_NEW_VERSION
                          ),
                          name: "import-resolution-manual",
                          size: "small",
                          sx: { p: 0.25, "& .MuiSvgIcon-root": { fontSize: 16 } }
                        }
                      ),
                      /* @__PURE__ */ a.jsx(fe, { variant: "caption", children: "Overwrite existing cohorts" }),
                      /* @__PURE__ */ a.jsx(Xe, { text: A, children: /* @__PURE__ */ a.jsx(
                        ge,
                        {
                          iconName: "info",
                          sx: { fontSize: 12, color: "text.secondary" }
                        }
                      ) })
                    ] }),
                    /* @__PURE__ */ a.jsxs(Y, { display: "flex", alignItems: "center", columnGap: 0.75, children: [
                      /* @__PURE__ */ a.jsx(
                        $i,
                        {
                          checked: o === ze.CREATE_NEW_OBJECT,
                          onChange: () => w(
                            ze.CREATE_NEW_OBJECT
                          ),
                          name: "import-resolution-manual",
                          size: "small",
                          sx: { p: 0.25, "& .MuiSvgIcon-root": { fontSize: 16 } }
                        }
                      ),
                      /* @__PURE__ */ a.jsx(fe, { variant: "caption", children: "Create new cohorts" }),
                      /* @__PURE__ */ a.jsx(Xe, { text: S, children: /* @__PURE__ */ a.jsx(
                        ge,
                        {
                          iconName: "info",
                          sx: { fontSize: 12, color: "text.secondary" }
                        }
                      ) })
                    ] })
                  ]
                }
              )
            ]
          }
        ) : null
      }
    ) }) });
  }
), Ki = (e, t) => Uh(
  e,
  t,
  mu,
  Cu,
  xu,
  Eu,
  Df
), fa = (e, t) => Vh(
  e,
  t,
  _f,
  wf,
  Nf,
  Pf
), Ou = (e) => Bh(e, {
  getSorting: Of,
  getSortingWorkspace: vf
}), Zr = (e, t) => {
  switch (e) {
    case he.WORKSPACE:
      return (n, r) => fo(n);
    case he.STUDY:
      return (n, r) => $a(t, n);
  }
}, vu = (e, t) => {
  switch (e) {
    case he.WORKSPACE:
      return (n, r = ze.CREATE_NEW_OBJECT) => Mf(n, r);
    case he.STUDY:
      return (n, r = ze.CREATE_NEW_OBJECT) => Vf(t, n, r);
  }
}, Cm = (e, t, n, r) => {
  const i = n === he.WORKSPACE ? "/workspace" : `/study-manager/${r}`, o = (() => {
    switch (t) {
      case "ANALYSIS":
        return "analyses";
      case "COHORT":
        return "cohorts";
      case "CONCEPT_SET":
        return "concept-sets";
    }
  })();
  return `${i}/${o}/${e}`;
}, za = [
  th({
    id: "typeIcon",
    cell: ah,
    accessorFn: (e) => e.type || zc.COHORT
  }),
  nh(),
  Wc({
    size: 350
  }),
  rh(),
  ih(),
  oh()
], gm = ({ metaAttributes: e }) => [
  ...za,
  ...Fh(e, !0)
], ym = [
  {
    header: "",
    accessorKey: "type",
    id: "type",
    cell: Th,
    size: 40,
    enableResizing: !1,
    meta: {
      columnType: "action"
    }
  },
  Wc()
], Tm = (e, t) => ({
  get: (n) => qi(n),
  delete: (n) => Cu(n),
  update: (n, r) => {
    switch (e) {
      case he.STUDY:
        return Wf(n, r, t);
      case he.WORKSPACE:
        return zf(n, r);
      case he.LIBRARY:
        return Kf(r, {
          name: n.name,
          description: n.description
        });
    }
  },
  copy: (n, r, i = ze.COPY) => {
    switch (e) {
      case he.STUDY:
        return yu(t, n, r, i);
      case he.WORKSPACE:
        return gu(n, r, i);
    }
  }
}), Sm = (e, t, n) => $h(
  "New Cohort Definition",
  e,
  t,
  n
), Im = (e, t, n = {}, r, i, o, s, l, c) => {
  const u = s === he.LIBRARY, p = s !== he.LIBRARY;
  let d = [
    {
      id: "definition",
      title: "Definition",
      value: "",
      end: !0
    },
    {
      id: "conceptSets",
      title: /* @__PURE__ */ a.jsx(
        $t,
        {
          title: "Concept Sets",
          count: r.conceptSets || 0,
          status: ce.SUCCESS,
          dense: !0
        }
      ),
      value: "concept-sets"
    }
  ];
  return t !== "new" && (i ? (d = [
    ...d,
    ...p ? [
      {
        id: "versioning",
        align: "right",
        iconOnly: !0,
        iconName: "reload",
        title: /* @__PURE__ */ a.jsx(
          $t,
          {
            title: "Versions",
            count: r.versions || 0,
            status: ce.SUCCESS,
            dense: !0
          }
        ),
        value: "versions"
      }
    ] : [],
    {
      id: "meta-attributes",
      align: "right",
      iconOnly: !0,
      iconName: "bookmark",
      title: /* @__PURE__ */ a.jsx(
        $t,
        {
          title: "Metadata",
          count: r.metadata || 0,
          status: ce.SUCCESS,
          dense: !0
        }
      ),
      value: "meta-attributes"
    }
  ], l && d.push({
    id: "ai-meta-attributes",
    align: "right",
    iconOnly: !0,
    iconName: "stars",
    title: /* @__PURE__ */ a.jsx(
      $t,
      {
        title: "Generative AI",
        count: r["metadata-ai"] || 0,
        status: ce.SUCCESS,
        dense: !0
      }
    ),
    value: "ai-meta-attributes"
  }), u && !c ? d.push({
    id: "statistics",
    align: "right",
    iconOnly: !0,
    iconName: "chart",
    title: /* @__PURE__ */ a.jsx(
      $t,
      {
        title: "Utilization Statistics",
        count: r.usedIn || 0,
        status: ce.SUCCESS,
        dense: !0
      }
    ),
    value: "statistics"
  }) : r.usedIn > 0 && d.push({
    id: "usage",
    align: "right",
    iconOnly: !0,
    iconName: "users",
    title: /* @__PURE__ */ a.jsx(
      $t,
      {
        title: "Used In",
        count: r.usedIn || 0,
        status: ce.SUCCESS,
        dense: !0
      }
    ),
    value: "usage"
  })) : (d = [
    ...d,
    ...p ? [
      {
        id: "versioning",
        align: "right",
        iconOnly: !0,
        iconName: "reload",
        title: /* @__PURE__ */ a.jsx(
          $t,
          {
            title: "Versions",
            count: r.versions || 0,
            status: ce.SUCCESS,
            dense: !0
          }
        ),
        value: "versions"
      }
    ] : [],
    {
      id: "messages",
      align: "right",
      iconOnly: !0,
      iconName: "message",
      title: /* @__PURE__ */ a.jsx(sh, { ...n.messages }),
      value: "messages"
    },
    {
      id: "meta-attributes",
      align: "right",
      iconOnly: !0,
      iconName: "bookmark",
      title: /* @__PURE__ */ a.jsx(
        $t,
        {
          title: "Metadata",
          count: r.metadata || 0,
          status: ce.SUCCESS,
          dense: !0
        }
      ),
      value: "meta-attributes"
    }
  ], l && d.push({
    id: "ai-meta-attributes",
    align: "right",
    iconOnly: !0,
    iconName: "stars",
    title: /* @__PURE__ */ a.jsx(
      $t,
      {
        title: "Generative AI",
        count: r["metadata-ai"] || 0,
        status: ce.SUCCESS,
        dense: !0
      }
    ),
    value: "ai-meta-attributes"
  }), r.usedIn > 0 && d.push({
    id: "usage",
    align: "right",
    iconOnly: !0,
    iconName: "users",
    title: /* @__PURE__ */ a.jsx(
      $t,
      {
        title: "Used In",
        count: r.usedIn || 0,
        status: ce.SUCCESS,
        dense: !0
      }
    ),
    value: "usage"
  }))), d;
}, Am = {
  getList: Yf,
  getCurrent: Su
}, bm = (e) => {
  var ne, ue, te;
  const {
    returnEntityText: t,
    typeContainer: n,
    parentId: r,
    path: i,
    onChange: o,
    initialData: s,
    multiple: l = !1,
    //isSelect,
    subModules: c,
    withAlias: u,
    containerProps: {
      titleText: p,
      buttonText: d,
      viewMode: f,
      collapsible: h = !1,
      description: g = "",
      defaultState: C = !1,
      classNameContainer: T = "cohort-import-button"
    }
  } = e, I = yr(), { createCols: A } = df, { openModal: S, closeModal: _ } = Le(gn), v = ee(() => vu(n, r), [n, r]), {
    state: O,
    updateList: j,
    refreshVersion: M,
    removeItem: w,
    updateItem: L
  } = Mp(s, l, o, u, "versionId", qi), P = (m) => {
    switch (n) {
      case he.WORKSPACE:
        return `/workspace/cohorts/${m}?returnPath=${i}&returnEntityText=${t}`;
      case he.STUDY:
        return `/study-manager/${r}/cohorts/${m}?returnPath=${i}&returnEntityText=${t}`;
      case he.LIBRARY:
        return `/library/cohorts/${m}?returnPath=${i}&returnEntityText=${t}`;
    }
  }, k = (m) => {
    I(P(m));
  }, z = ee(() => A(
    {
      onEdit: k,
      onView: k,
      onRefresh: M,
      onRemove: w,
      onUpdate: L
    },
    f,
    u,
    Object.values(O).map((m) => m.alias || null)
  ), [O, f, u]), B = (m) => {
    j(m, _);
  }, q = (m) => {
    m.stopPropagation(), S(
      () => /* @__PURE__ */ a.jsx(
        Yc,
        {
          name: "cohorts",
          currentContainer: n,
          parentId: r,
          defaultResolution: ze.CREATE_NEW_OBJECT,
          hideConflictResolutionMethod: !0,
          hideConflictResolutionControls: !0,
          onChange: B,
          createListMethods: Ki,
          cols: za,
          createListFiltersMethod: fa,
          createMethodCreate: Zr,
          subModules: c,
          analysisMode: !0,
          isSelect: l,
          successMessage: "Cohort(s) successfully imported.",
          atlasEntity: [Va.COHORT],
          getEntity: qi,
          manualImport: !0,
          manualImportComponent: /* @__PURE__ */ a.jsx(
            Ru,
            {
              typeContainer: n,
              parentId: r,
              importMethod: v,
              fullEntity: !0,
              onChange: B
            }
          )
        }
      ),
      "Import cohort",
      {
        onClose: _,
        closeOnClickOutside: !0
      }
    );
  }, N = Gh(Object.values(O), "id");
  return ((ne = Object.keys(O)) == null ? void 0 : ne.length) === 0 && f ? /* @__PURE__ */ a.jsx(a.Fragment, {}) : /* @__PURE__ */ a.jsxs(
    nr,
    {
      collapsible: h,
      title: p,
      defaultState: h ? C : !0,
      actions: f ? /* @__PURE__ */ a.jsx(a.Fragment, {}) : /* @__PURE__ */ a.jsx(
        We,
        {
          onClick: q,
          variant: "contained",
          color: "info",
          startIcon: /* @__PURE__ */ a.jsx(ge, { iconName: "add" }),
          name: `button-${T}`,
          sx: { px: 3 },
          children: d
        }
      ),
      outlined: !0,
      elevated: !0,
      children: [
        /* @__PURE__ */ a.jsx(
          R,
          {
            item: !0,
            xs: 12,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            children: g && /* @__PURE__ */ a.jsx(fe, { variant: "subtitle2", children: g })
          }
        ),
        Object.keys(O).length > 0 ? /* @__PURE__ */ a.jsx(R, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsx(R, { container: !0, children: /* @__PURE__ */ a.jsx(R, { item: !0, xs: 12, className: `table-${T}`, children: /* @__PURE__ */ a.jsx(
          Sh,
          {
            columns: z,
            data: N,
            totalElements: (ue = Object.keys(O)) == null ? void 0 : ue.length,
            pageSize: (te = Object.keys(O)) == null ? void 0 : te.length,
            loadingMessage: "",
            enableSorting: l,
            tileView: !0
          }
        ) }) }) }) : /* @__PURE__ */ a.jsx(
          R,
          {
            item: !0,
            xs: 12,
            sx: {
              backgroundColor: "backgroundColor.main",
              textAlign: "center",
              p: 1
            },
            children: /* @__PURE__ */ a.jsx(fe, { variant: "subtitle2", color: "borderColor.main", children: "No cohorts" })
          }
        )
      ]
    }
  );
};
function Rm() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return ee(
    () => (r) => {
      t.forEach((i) => i(r));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t
  );
}
const mo = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u";
function Tr(e) {
  const t = Object.prototype.toString.call(e);
  return t === "[object Window]" || // In Electron context the Window object serializes to [object global]
  t === "[object global]";
}
function Wa(e) {
  return "nodeType" in e;
}
function Ot(e) {
  var t, n;
  return e ? Tr(e) ? e : Wa(e) && (t = (n = e.ownerDocument) == null ? void 0 : n.defaultView) != null ? t : window : window;
}
function Ya(e) {
  const {
    Document: t
  } = Ot(e);
  return e instanceof t;
}
function hi(e) {
  return Tr(e) ? !1 : e instanceof Ot(e).HTMLElement;
}
function Du(e) {
  return e instanceof Ot(e).SVGElement;
}
function Sr(e) {
  return e ? Tr(e) ? e.document : Wa(e) ? Ya(e) ? e : hi(e) || Du(e) ? e.ownerDocument : document : document : document;
}
const Zt = mo ? Pp : Q;
function Eo(e) {
  const t = Ae(e);
  return Zt(() => {
    t.current = e;
  }), ie(function() {
    for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
      r[i] = arguments[i];
    return t.current == null ? void 0 : t.current(...r);
  }, []);
}
function Om() {
  const e = Ae(null), t = ie((r, i) => {
    e.current = setInterval(r, i);
  }, []), n = ie(() => {
    e.current !== null && (clearInterval(e.current), e.current = null);
  }, []);
  return [t, n];
}
function ei(e, t) {
  t === void 0 && (t = [e]);
  const n = Ae(e);
  return Zt(() => {
    n.current !== e && (n.current = e);
  }, t), n;
}
function fi(e, t) {
  const n = Ae();
  return ee(
    () => {
      const r = e(n.current);
      return n.current = r, r;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [...t]
  );
}
function Qi(e) {
  const t = Eo(e), n = Ae(null), r = ie(
    (i) => {
      i !== n.current && (t == null || t(i, n.current)), n.current = i;
    },
    //eslint-disable-next-line
    []
  );
  return [n, r];
}
function Zi(e) {
  const t = Ae();
  return Q(() => {
    t.current = e;
  }, [e]), t.current;
}
let Uo = {};
function mi(e, t) {
  return ee(() => {
    if (t)
      return t;
    const n = Uo[e] == null ? 0 : Uo[e] + 1;
    return Uo[e] = n, e + "-" + n;
  }, [e, t]);
}
function _u(e) {
  return function(t) {
    for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
      r[i - 1] = arguments[i];
    return r.reduce((o, s) => {
      const l = Object.entries(s);
      for (const [c, u] of l) {
        const p = o[c];
        p != null && (o[c] = p + e * u);
      }
      return o;
    }, {
      ...t
    });
  };
}
const cr = /* @__PURE__ */ _u(1), eo = /* @__PURE__ */ _u(-1);
function vm(e) {
  return "clientX" in e && "clientY" in e;
}
function xo(e) {
  if (!e)
    return !1;
  const {
    KeyboardEvent: t
  } = Ot(e.target);
  return t && e instanceof t;
}
function Dm(e) {
  if (!e)
    return !1;
  const {
    TouchEvent: t
  } = Ot(e.target);
  return t && e instanceof t;
}
function to(e) {
  if (Dm(e)) {
    if (e.touches && e.touches.length) {
      const {
        clientX: t,
        clientY: n
      } = e.touches[0];
      return {
        x: t,
        y: n
      };
    } else if (e.changedTouches && e.changedTouches.length) {
      const {
        clientX: t,
        clientY: n
      } = e.changedTouches[0];
      return {
        x: t,
        y: n
      };
    }
  }
  return vm(e) ? {
    x: e.clientX,
    y: e.clientY
  } : null;
}
const Cn = /* @__PURE__ */ Object.freeze({
  Translate: {
    toString(e) {
      if (!e)
        return;
      const {
        x: t,
        y: n
      } = e;
      return "translate3d(" + (t ? Math.round(t) : 0) + "px, " + (n ? Math.round(n) : 0) + "px, 0)";
    }
  },
  Scale: {
    toString(e) {
      if (!e)
        return;
      const {
        scaleX: t,
        scaleY: n
      } = e;
      return "scaleX(" + t + ") scaleY(" + n + ")";
    }
  },
  Transform: {
    toString(e) {
      if (e)
        return [Cn.Translate.toString(e), Cn.Scale.toString(e)].join(" ");
    }
  },
  Transition: {
    toString(e) {
      let {
        property: t,
        duration: n,
        easing: r
      } = e;
      return t + " " + n + "ms " + r;
    }
  }
}), sl = "a,frame,iframe,input:not([type=hidden]):not(:disabled),select:not(:disabled),textarea:not(:disabled),button:not(:disabled),*[tabindex]";
function _m(e) {
  return e.matches(sl) ? e : e.querySelector(sl);
}
const Nm = {
  display: "none"
};
function wm(e) {
  let {
    id: t,
    value: n
  } = e;
  return Re.createElement("div", {
    id: t,
    style: Nm
  }, n);
}
function Pm(e) {
  let {
    id: t,
    announcement: n,
    ariaLiveType: r = "assertive"
  } = e;
  const i = {
    position: "fixed",
    top: 0,
    left: 0,
    width: 1,
    height: 1,
    margin: -1,
    border: 0,
    padding: 0,
    overflow: "hidden",
    clip: "rect(0 0 0 0)",
    clipPath: "inset(100%)",
    whiteSpace: "nowrap"
  };
  return Re.createElement("div", {
    id: t,
    style: i,
    role: "status",
    "aria-live": r,
    "aria-atomic": !0
  }, n);
}
function jm() {
  const [e, t] = J("");
  return {
    announce: ie((r) => {
      r != null && t(r);
    }, []),
    announcement: e
  };
}
const Nu = /* @__PURE__ */ Xn(null);
function Lm(e) {
  const t = Le(Nu);
  Q(() => {
    if (!t)
      throw new Error("useDndMonitor must be used within a children of <DndContext>");
    return t(e);
  }, [e, t]);
}
function km() {
  const [e] = J(() => /* @__PURE__ */ new Set()), t = ie((r) => (e.add(r), () => e.delete(r)), [e]);
  return [ie((r) => {
    let {
      type: i,
      event: o
    } = r;
    e.forEach((s) => {
      var l;
      return (l = s[i]) == null ? void 0 : l.call(s, o);
    });
  }, [e]), t];
}
const Mm = {
  draggable: `
    To pick up a draggable item, press the space bar.
    While dragging, use the arrow keys to move the item.
    Press space again to drop the item in its new position, or press escape to cancel.
  `
}, Vm = {
  onDragStart(e) {
    let {
      active: t
    } = e;
    return "Picked up draggable item " + t.id + ".";
  },
  onDragOver(e) {
    let {
      active: t,
      over: n
    } = e;
    return n ? "Draggable item " + t.id + " was moved over droppable area " + n.id + "." : "Draggable item " + t.id + " is no longer over a droppable area.";
  },
  onDragEnd(e) {
    let {
      active: t,
      over: n
    } = e;
    return n ? "Draggable item " + t.id + " was dropped over droppable area " + n.id : "Draggable item " + t.id + " was dropped.";
  },
  onDragCancel(e) {
    let {
      active: t
    } = e;
    return "Dragging was cancelled. Draggable item " + t.id + " was dropped.";
  }
};
function Um(e) {
  let {
    announcements: t = Vm,
    container: n,
    hiddenTextDescribedById: r,
    screenReaderInstructions: i = Mm
  } = e;
  const {
    announce: o,
    announcement: s
  } = jm(), l = mi("DndLiveRegion"), [c, u] = J(!1);
  if (Q(() => {
    u(!0);
  }, []), Lm(ee(() => ({
    onDragStart(d) {
      let {
        active: f
      } = d;
      o(t.onDragStart({
        active: f
      }));
    },
    onDragMove(d) {
      let {
        active: f,
        over: h
      } = d;
      t.onDragMove && o(t.onDragMove({
        active: f,
        over: h
      }));
    },
    onDragOver(d) {
      let {
        active: f,
        over: h
      } = d;
      o(t.onDragOver({
        active: f,
        over: h
      }));
    },
    onDragEnd(d) {
      let {
        active: f,
        over: h
      } = d;
      o(t.onDragEnd({
        active: f,
        over: h
      }));
    },
    onDragCancel(d) {
      let {
        active: f,
        over: h
      } = d;
      o(t.onDragCancel({
        active: f,
        over: h
      }));
    }
  }), [o, t])), !c)
    return null;
  const p = Re.createElement(Re.Fragment, null, Re.createElement(wm, {
    id: r,
    value: i.draggable
  }), Re.createElement(Pm, {
    id: l,
    announcement: s
  }));
  return n ? rf(p, n) : p;
}
var lt;
(function(e) {
  e.DragStart = "dragStart", e.DragMove = "dragMove", e.DragEnd = "dragEnd", e.DragCancel = "dragCancel", e.DragOver = "dragOver", e.RegisterDroppable = "registerDroppable", e.SetDroppableDisabled = "setDroppableDisabled", e.UnregisterDroppable = "unregisterDroppable";
})(lt || (lt = {}));
function no() {
}
function wu(e, t) {
  return ee(
    () => ({
      sensor: e,
      options: t ?? {}
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [e, t]
  );
}
function Pu() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return ee(
    () => [...t].filter((r) => r != null),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [...t]
  );
}
const en = /* @__PURE__ */ Object.freeze({
  x: 0,
  y: 0
});
function Fm(e, t) {
  return Math.sqrt(Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2));
}
function Bm(e, t) {
  const n = to(e);
  if (!n)
    return "0 0";
  const r = {
    x: (n.x - t.left) / t.width * 100,
    y: (n.y - t.top) / t.height * 100
  };
  return r.x + "% " + r.y + "%";
}
function $m(e, t) {
  let {
    data: {
      value: n
    }
  } = e, {
    data: {
      value: r
    }
  } = t;
  return n - r;
}
function Gm(e, t) {
  let {
    data: {
      value: n
    }
  } = e, {
    data: {
      value: r
    }
  } = t;
  return r - n;
}
function zm(e, t) {
  if (!e || e.length === 0)
    return null;
  const [n] = e;
  return n[t];
}
function ll(e, t, n) {
  return t === void 0 && (t = e.left), n === void 0 && (n = e.top), {
    x: t + e.width * 0.5,
    y: n + e.height * 0.5
  };
}
const ju = (e) => {
  let {
    collisionRect: t,
    droppableRects: n,
    droppableContainers: r
  } = e;
  const i = ll(t, t.left, t.top), o = [];
  for (const s of r) {
    const {
      id: l
    } = s, c = n.get(l);
    if (c) {
      const u = Fm(ll(c), i);
      o.push({
        id: l,
        data: {
          droppableContainer: s,
          value: u
        }
      });
    }
  }
  return o.sort($m);
};
function Wm(e, t) {
  const n = Math.max(t.top, e.top), r = Math.max(t.left, e.left), i = Math.min(t.left + t.width, e.left + e.width), o = Math.min(t.top + t.height, e.top + e.height), s = i - r, l = o - n;
  if (r < i && n < o) {
    const c = t.width * t.height, u = e.width * e.height, p = s * l, d = p / (c + u - p);
    return Number(d.toFixed(4));
  }
  return 0;
}
const Ym = (e) => {
  let {
    collisionRect: t,
    droppableRects: n,
    droppableContainers: r
  } = e;
  const i = [];
  for (const o of r) {
    const {
      id: s
    } = o, l = n.get(s);
    if (l) {
      const c = Wm(l, t);
      c > 0 && i.push({
        id: s,
        data: {
          droppableContainer: o,
          value: c
        }
      });
    }
  }
  return i.sort(Gm);
};
function Hm(e, t, n) {
  return {
    ...e,
    scaleX: t && n ? t.width / n.width : 1,
    scaleY: t && n ? t.height / n.height : 1
  };
}
function Lu(e, t) {
  return e && t ? {
    x: e.left - t.left,
    y: e.top - t.top
  } : en;
}
function qm(e) {
  return function(n) {
    for (var r = arguments.length, i = new Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++)
      i[o - 1] = arguments[o];
    return i.reduce((s, l) => ({
      ...s,
      top: s.top + e * l.y,
      bottom: s.bottom + e * l.y,
      left: s.left + e * l.x,
      right: s.right + e * l.x
    }), {
      ...n
    });
  };
}
const Xm = /* @__PURE__ */ qm(1);
function ku(e) {
  if (e.startsWith("matrix3d(")) {
    const t = e.slice(9, -1).split(/, /);
    return {
      x: +t[12],
      y: +t[13],
      scaleX: +t[0],
      scaleY: +t[5]
    };
  } else if (e.startsWith("matrix(")) {
    const t = e.slice(7, -1).split(/, /);
    return {
      x: +t[4],
      y: +t[5],
      scaleX: +t[0],
      scaleY: +t[3]
    };
  }
  return null;
}
function Jm(e, t, n) {
  const r = ku(t);
  if (!r)
    return e;
  const {
    scaleX: i,
    scaleY: o,
    x: s,
    y: l
  } = r, c = e.left - s - (1 - i) * parseFloat(n), u = e.top - l - (1 - o) * parseFloat(n.slice(n.indexOf(" ") + 1)), p = i ? e.width / i : e.width, d = o ? e.height / o : e.height;
  return {
    width: p,
    height: d,
    top: u,
    right: c + p,
    bottom: u + d,
    left: c
  };
}
const Km = {
  ignoreTransform: !1
};
function Ir(e, t) {
  t === void 0 && (t = Km);
  let n = e.getBoundingClientRect();
  if (t.ignoreTransform) {
    const {
      transform: u,
      transformOrigin: p
    } = Ot(e).getComputedStyle(e);
    u && (n = Jm(n, u, p));
  }
  const {
    top: r,
    left: i,
    width: o,
    height: s,
    bottom: l,
    right: c
  } = n;
  return {
    top: r,
    left: i,
    width: o,
    height: s,
    bottom: l,
    right: c
  };
}
function cl(e) {
  return Ir(e, {
    ignoreTransform: !0
  });
}
function Qm(e) {
  const t = e.innerWidth, n = e.innerHeight;
  return {
    top: 0,
    left: 0,
    right: t,
    bottom: n,
    width: t,
    height: n
  };
}
function Zm(e, t) {
  return t === void 0 && (t = Ot(e).getComputedStyle(e)), t.position === "fixed";
}
function eE(e, t) {
  t === void 0 && (t = Ot(e).getComputedStyle(e));
  const n = /(auto|scroll|overlay)/;
  return ["overflow", "overflowX", "overflowY"].some((i) => {
    const o = t[i];
    return typeof o == "string" ? n.test(o) : !1;
  });
}
function Ha(e, t) {
  const n = [];
  function r(i) {
    if (t != null && n.length >= t || !i)
      return n;
    if (Ya(i) && i.scrollingElement != null && !n.includes(i.scrollingElement))
      return n.push(i.scrollingElement), n;
    if (!hi(i) || Du(i) || n.includes(i))
      return n;
    const o = Ot(e).getComputedStyle(i);
    return i !== e && eE(i, o) && n.push(i), Zm(i, o) ? n : r(i.parentNode);
  }
  return e ? r(e) : n;
}
function Mu(e) {
  const [t] = Ha(e, 1);
  return t ?? null;
}
function Fo(e) {
  return !mo || !e ? null : Tr(e) ? e : Wa(e) ? Ya(e) || e === Sr(e).scrollingElement ? window : hi(e) ? e : null : null;
}
function Vu(e) {
  return Tr(e) ? e.scrollX : e.scrollLeft;
}
function Uu(e) {
  return Tr(e) ? e.scrollY : e.scrollTop;
}
function ma(e) {
  return {
    x: Vu(e),
    y: Uu(e)
  };
}
var dt;
(function(e) {
  e[e.Forward = 1] = "Forward", e[e.Backward = -1] = "Backward";
})(dt || (dt = {}));
function Fu(e) {
  return !mo || !e ? !1 : e === document.scrollingElement;
}
function Bu(e) {
  const t = {
    x: 0,
    y: 0
  }, n = Fu(e) ? {
    height: window.innerHeight,
    width: window.innerWidth
  } : {
    height: e.clientHeight,
    width: e.clientWidth
  }, r = {
    x: e.scrollWidth - n.width,
    y: e.scrollHeight - n.height
  }, i = e.scrollTop <= t.y, o = e.scrollLeft <= t.x, s = e.scrollTop >= r.y, l = e.scrollLeft >= r.x;
  return {
    isTop: i,
    isLeft: o,
    isBottom: s,
    isRight: l,
    maxScroll: r,
    minScroll: t
  };
}
const tE = {
  x: 0.2,
  y: 0.2
};
function nE(e, t, n, r, i) {
  let {
    top: o,
    left: s,
    right: l,
    bottom: c
  } = n;
  r === void 0 && (r = 10), i === void 0 && (i = tE);
  const {
    isTop: u,
    isBottom: p,
    isLeft: d,
    isRight: f
  } = Bu(e), h = {
    x: 0,
    y: 0
  }, g = {
    x: 0,
    y: 0
  }, C = {
    height: t.height * i.y,
    width: t.width * i.x
  };
  return !u && o <= t.top + C.height ? (h.y = dt.Backward, g.y = r * Math.abs((t.top + C.height - o) / C.height)) : !p && c >= t.bottom - C.height && (h.y = dt.Forward, g.y = r * Math.abs((t.bottom - C.height - c) / C.height)), !f && l >= t.right - C.width ? (h.x = dt.Forward, g.x = r * Math.abs((t.right - C.width - l) / C.width)) : !d && s <= t.left + C.width && (h.x = dt.Backward, g.x = r * Math.abs((t.left + C.width - s) / C.width)), {
    direction: h,
    speed: g
  };
}
function rE(e) {
  if (e === document.scrollingElement) {
    const {
      innerWidth: o,
      innerHeight: s
    } = window;
    return {
      top: 0,
      left: 0,
      right: o,
      bottom: s,
      width: o,
      height: s
    };
  }
  const {
    top: t,
    left: n,
    right: r,
    bottom: i
  } = e.getBoundingClientRect();
  return {
    top: t,
    left: n,
    right: r,
    bottom: i,
    width: e.clientWidth,
    height: e.clientHeight
  };
}
function $u(e) {
  return e.reduce((t, n) => cr(t, ma(n)), en);
}
function iE(e) {
  return e.reduce((t, n) => t + Vu(n), 0);
}
function oE(e) {
  return e.reduce((t, n) => t + Uu(n), 0);
}
function Gu(e, t) {
  if (t === void 0 && (t = Ir), !e)
    return;
  const {
    top: n,
    left: r,
    bottom: i,
    right: o
  } = t(e);
  Mu(e) && (i <= 0 || o <= 0 || n >= window.innerHeight || r >= window.innerWidth) && e.scrollIntoView({
    block: "center",
    inline: "center"
  });
}
const aE = [["x", ["left", "right"], iE], ["y", ["top", "bottom"], oE]];
class qa {
  constructor(t, n) {
    this.rect = void 0, this.width = void 0, this.height = void 0, this.top = void 0, this.bottom = void 0, this.right = void 0, this.left = void 0;
    const r = Ha(n), i = $u(r);
    this.rect = {
      ...t
    }, this.width = t.width, this.height = t.height;
    for (const [o, s, l] of aE)
      for (const c of s)
        Object.defineProperty(this, c, {
          get: () => {
            const u = l(r), p = i[o] - u;
            return this.rect[c] + p;
          },
          enumerable: !0
        });
    Object.defineProperty(this, "rect", {
      enumerable: !1
    });
  }
}
class Br {
  constructor(t) {
    this.target = void 0, this.listeners = [], this.removeAll = () => {
      this.listeners.forEach((n) => {
        var r;
        return (r = this.target) == null ? void 0 : r.removeEventListener(...n);
      });
    }, this.target = t;
  }
  add(t, n, r) {
    var i;
    (i = this.target) == null || i.addEventListener(t, n, r), this.listeners.push([t, n, r]);
  }
}
function sE(e) {
  const {
    EventTarget: t
  } = Ot(e);
  return e instanceof t ? e : Sr(e);
}
function Bo(e, t) {
  const n = Math.abs(e.x), r = Math.abs(e.y);
  return typeof t == "number" ? Math.sqrt(n ** 2 + r ** 2) > t : "x" in t && "y" in t ? n > t.x && r > t.y : "x" in t ? n > t.x : "y" in t ? r > t.y : !1;
}
var zt;
(function(e) {
  e.Click = "click", e.DragStart = "dragstart", e.Keydown = "keydown", e.ContextMenu = "contextmenu", e.Resize = "resize", e.SelectionChange = "selectionchange", e.VisibilityChange = "visibilitychange";
})(zt || (zt = {}));
function ul(e) {
  e.preventDefault();
}
function lE(e) {
  e.stopPropagation();
}
var Ne;
(function(e) {
  e.Space = "Space", e.Down = "ArrowDown", e.Right = "ArrowRight", e.Left = "ArrowLeft", e.Up = "ArrowUp", e.Esc = "Escape", e.Enter = "Enter", e.Tab = "Tab";
})(Ne || (Ne = {}));
const zu = {
  start: [Ne.Space, Ne.Enter],
  cancel: [Ne.Esc],
  end: [Ne.Space, Ne.Enter, Ne.Tab]
}, cE = (e, t) => {
  let {
    currentCoordinates: n
  } = t;
  switch (e.code) {
    case Ne.Right:
      return {
        ...n,
        x: n.x + 25
      };
    case Ne.Left:
      return {
        ...n,
        x: n.x - 25
      };
    case Ne.Down:
      return {
        ...n,
        y: n.y + 25
      };
    case Ne.Up:
      return {
        ...n,
        y: n.y - 25
      };
  }
};
class Wu {
  constructor(t) {
    this.props = void 0, this.autoScrollEnabled = !1, this.referenceCoordinates = void 0, this.listeners = void 0, this.windowListeners = void 0, this.props = t;
    const {
      event: {
        target: n
      }
    } = t;
    this.props = t, this.listeners = new Br(Sr(n)), this.windowListeners = new Br(Ot(n)), this.handleKeyDown = this.handleKeyDown.bind(this), this.handleCancel = this.handleCancel.bind(this), this.attach();
  }
  attach() {
    this.handleStart(), this.windowListeners.add(zt.Resize, this.handleCancel), this.windowListeners.add(zt.VisibilityChange, this.handleCancel), setTimeout(() => this.listeners.add(zt.Keydown, this.handleKeyDown));
  }
  handleStart() {
    const {
      activeNode: t,
      onStart: n
    } = this.props, r = t.node.current;
    r && Gu(r), n(en);
  }
  handleKeyDown(t) {
    if (xo(t)) {
      const {
        active: n,
        context: r,
        options: i
      } = this.props, {
        keyboardCodes: o = zu,
        coordinateGetter: s = cE,
        scrollBehavior: l = "smooth"
      } = i, {
        code: c
      } = t;
      if (o.end.includes(c)) {
        this.handleEnd(t);
        return;
      }
      if (o.cancel.includes(c)) {
        this.handleCancel(t);
        return;
      }
      const {
        collisionRect: u
      } = r.current, p = u ? {
        x: u.left,
        y: u.top
      } : en;
      this.referenceCoordinates || (this.referenceCoordinates = p);
      const d = s(t, {
        active: n,
        context: r.current,
        currentCoordinates: p
      });
      if (d) {
        const f = eo(d, p), h = {
          x: 0,
          y: 0
        }, {
          scrollableAncestors: g
        } = r.current;
        for (const C of g) {
          const T = t.code, {
            isTop: I,
            isRight: A,
            isLeft: S,
            isBottom: _,
            maxScroll: v,
            minScroll: O
          } = Bu(C), j = rE(C), M = {
            x: Math.min(T === Ne.Right ? j.right - j.width / 2 : j.right, Math.max(T === Ne.Right ? j.left : j.left + j.width / 2, d.x)),
            y: Math.min(T === Ne.Down ? j.bottom - j.height / 2 : j.bottom, Math.max(T === Ne.Down ? j.top : j.top + j.height / 2, d.y))
          }, w = T === Ne.Right && !A || T === Ne.Left && !S, L = T === Ne.Down && !_ || T === Ne.Up && !I;
          if (w && M.x !== d.x) {
            const P = C.scrollLeft + f.x, k = T === Ne.Right && P <= v.x || T === Ne.Left && P >= O.x;
            if (k && !f.y) {
              C.scrollTo({
                left: P,
                behavior: l
              });
              return;
            }
            k ? h.x = C.scrollLeft - P : h.x = T === Ne.Right ? C.scrollLeft - v.x : C.scrollLeft - O.x, h.x && C.scrollBy({
              left: -h.x,
              behavior: l
            });
            break;
          } else if (L && M.y !== d.y) {
            const P = C.scrollTop + f.y, k = T === Ne.Down && P <= v.y || T === Ne.Up && P >= O.y;
            if (k && !f.x) {
              C.scrollTo({
                top: P,
                behavior: l
              });
              return;
            }
            k ? h.y = C.scrollTop - P : h.y = T === Ne.Down ? C.scrollTop - v.y : C.scrollTop - O.y, h.y && C.scrollBy({
              top: -h.y,
              behavior: l
            });
            break;
          }
        }
        this.handleMove(t, cr(eo(d, this.referenceCoordinates), h));
      }
    }
  }
  handleMove(t, n) {
    const {
      onMove: r
    } = this.props;
    t.preventDefault(), r(n);
  }
  handleEnd(t) {
    const {
      onEnd: n
    } = this.props;
    t.preventDefault(), this.detach(), n();
  }
  handleCancel(t) {
    const {
      onCancel: n
    } = this.props;
    t.preventDefault(), this.detach(), n();
  }
  detach() {
    this.listeners.removeAll(), this.windowListeners.removeAll();
  }
}
Wu.activators = [{
  eventName: "onKeyDown",
  handler: (e, t, n) => {
    let {
      keyboardCodes: r = zu,
      onActivation: i
    } = t, {
      active: o
    } = n;
    const {
      code: s
    } = e.nativeEvent;
    if (r.start.includes(s)) {
      const l = o.activatorNode.current;
      return l && e.target !== l ? !1 : (e.preventDefault(), i == null || i({
        event: e.nativeEvent
      }), !0);
    }
    return !1;
  }
}];
function dl(e) {
  return !!(e && "distance" in e);
}
function pl(e) {
  return !!(e && "delay" in e);
}
class Xa {
  constructor(t, n, r) {
    var i;
    r === void 0 && (r = sE(t.event.target)), this.props = void 0, this.events = void 0, this.autoScrollEnabled = !0, this.document = void 0, this.activated = !1, this.initialCoordinates = void 0, this.timeoutId = null, this.listeners = void 0, this.documentListeners = void 0, this.windowListeners = void 0, this.props = t, this.events = n;
    const {
      event: o
    } = t, {
      target: s
    } = o;
    this.props = t, this.events = n, this.document = Sr(s), this.documentListeners = new Br(this.document), this.listeners = new Br(r), this.windowListeners = new Br(Ot(s)), this.initialCoordinates = (i = to(o)) != null ? i : en, this.handleStart = this.handleStart.bind(this), this.handleMove = this.handleMove.bind(this), this.handleEnd = this.handleEnd.bind(this), this.handleCancel = this.handleCancel.bind(this), this.handleKeydown = this.handleKeydown.bind(this), this.removeTextSelection = this.removeTextSelection.bind(this), this.attach();
  }
  attach() {
    const {
      events: t,
      props: {
        options: {
          activationConstraint: n,
          bypassActivationConstraint: r
        }
      }
    } = this;
    if (this.listeners.add(t.move.name, this.handleMove, {
      passive: !1
    }), this.listeners.add(t.end.name, this.handleEnd), t.cancel && this.listeners.add(t.cancel.name, this.handleCancel), this.windowListeners.add(zt.Resize, this.handleCancel), this.windowListeners.add(zt.DragStart, ul), this.windowListeners.add(zt.VisibilityChange, this.handleCancel), this.windowListeners.add(zt.ContextMenu, ul), this.documentListeners.add(zt.Keydown, this.handleKeydown), n) {
      if (r != null && r({
        event: this.props.event,
        activeNode: this.props.activeNode,
        options: this.props.options
      }))
        return this.handleStart();
      if (pl(n)) {
        this.timeoutId = setTimeout(this.handleStart, n.delay), this.handlePending(n);
        return;
      }
      if (dl(n)) {
        this.handlePending(n);
        return;
      }
    }
    this.handleStart();
  }
  detach() {
    this.listeners.removeAll(), this.windowListeners.removeAll(), setTimeout(this.documentListeners.removeAll, 50), this.timeoutId !== null && (clearTimeout(this.timeoutId), this.timeoutId = null);
  }
  handlePending(t, n) {
    const {
      active: r,
      onPending: i
    } = this.props;
    i(r, t, this.initialCoordinates, n);
  }
  handleStart() {
    const {
      initialCoordinates: t
    } = this, {
      onStart: n
    } = this.props;
    t && (this.activated = !0, this.documentListeners.add(zt.Click, lE, {
      capture: !0
    }), this.removeTextSelection(), this.documentListeners.add(zt.SelectionChange, this.removeTextSelection), n(t));
  }
  handleMove(t) {
    var n;
    const {
      activated: r,
      initialCoordinates: i,
      props: o
    } = this, {
      onMove: s,
      options: {
        activationConstraint: l
      }
    } = o;
    if (!i)
      return;
    const c = (n = to(t)) != null ? n : en, u = eo(i, c);
    if (!r && l) {
      if (dl(l)) {
        if (l.tolerance != null && Bo(u, l.tolerance))
          return this.handleCancel();
        if (Bo(u, l.distance))
          return this.handleStart();
      }
      if (pl(l) && Bo(u, l.tolerance))
        return this.handleCancel();
      this.handlePending(l, u);
      return;
    }
    t.cancelable && t.preventDefault(), s(c);
  }
  handleEnd() {
    const {
      onAbort: t,
      onEnd: n
    } = this.props;
    this.detach(), this.activated || t(this.props.active), n();
  }
  handleCancel() {
    const {
      onAbort: t,
      onCancel: n
    } = this.props;
    this.detach(), this.activated || t(this.props.active), n();
  }
  handleKeydown(t) {
    t.code === Ne.Esc && this.handleCancel();
  }
  removeTextSelection() {
    var t;
    (t = this.document.getSelection()) == null || t.removeAllRanges();
  }
}
const uE = {
  cancel: {
    name: "pointercancel"
  },
  move: {
    name: "pointermove"
  },
  end: {
    name: "pointerup"
  }
};
class Co extends Xa {
  constructor(t) {
    const {
      event: n
    } = t, r = Sr(n.target);
    super(t, uE, r);
  }
}
Co.activators = [{
  eventName: "onPointerDown",
  handler: (e, t) => {
    let {
      nativeEvent: n
    } = e, {
      onActivation: r
    } = t;
    return !n.isPrimary || n.button !== 0 ? !1 : (r == null || r({
      event: n
    }), !0);
  }
}];
const dE = {
  move: {
    name: "mousemove"
  },
  end: {
    name: "mouseup"
  }
};
var Ea;
(function(e) {
  e[e.RightClick = 2] = "RightClick";
})(Ea || (Ea = {}));
class pE extends Xa {
  constructor(t) {
    super(t, dE, Sr(t.event.target));
  }
}
pE.activators = [{
  eventName: "onMouseDown",
  handler: (e, t) => {
    let {
      nativeEvent: n
    } = e, {
      onActivation: r
    } = t;
    return n.button === Ea.RightClick ? !1 : (r == null || r({
      event: n
    }), !0);
  }
}];
const $o = {
  cancel: {
    name: "touchcancel"
  },
  move: {
    name: "touchmove"
  },
  end: {
    name: "touchend"
  }
};
class hE extends Xa {
  constructor(t) {
    super(t, $o);
  }
  static setup() {
    return window.addEventListener($o.move.name, t, {
      capture: !1,
      passive: !1
    }), function() {
      window.removeEventListener($o.move.name, t);
    };
    function t() {
    }
  }
}
hE.activators = [{
  eventName: "onTouchStart",
  handler: (e, t) => {
    let {
      nativeEvent: n
    } = e, {
      onActivation: r
    } = t;
    const {
      touches: i
    } = n;
    return i.length > 1 ? !1 : (r == null || r({
      event: n
    }), !0);
  }
}];
var $r;
(function(e) {
  e[e.Pointer = 0] = "Pointer", e[e.DraggableRect = 1] = "DraggableRect";
})($r || ($r = {}));
var ro;
(function(e) {
  e[e.TreeOrder = 0] = "TreeOrder", e[e.ReversedTreeOrder = 1] = "ReversedTreeOrder";
})(ro || (ro = {}));
function fE(e) {
  let {
    acceleration: t,
    activator: n = $r.Pointer,
    canScroll: r,
    draggingRect: i,
    enabled: o,
    interval: s = 5,
    order: l = ro.TreeOrder,
    pointerCoordinates: c,
    scrollableAncestors: u,
    scrollableAncestorRects: p,
    delta: d,
    threshold: f
  } = e;
  const h = EE({
    delta: d,
    disabled: !o
  }), [g, C] = Om(), T = Ae({
    x: 0,
    y: 0
  }), I = Ae({
    x: 0,
    y: 0
  }), A = ee(() => {
    switch (n) {
      case $r.Pointer:
        return c ? {
          top: c.y,
          bottom: c.y,
          left: c.x,
          right: c.x
        } : null;
      case $r.DraggableRect:
        return i;
    }
  }, [n, i, c]), S = Ae(null), _ = ie(() => {
    const O = S.current;
    if (!O)
      return;
    const j = T.current.x * I.current.x, M = T.current.y * I.current.y;
    O.scrollBy(j, M);
  }, []), v = ee(() => l === ro.TreeOrder ? [...u].reverse() : u, [l, u]);
  Q(
    () => {
      if (!o || !u.length || !A) {
        C();
        return;
      }
      for (const O of v) {
        if ((r == null ? void 0 : r(O)) === !1)
          continue;
        const j = u.indexOf(O), M = p[j];
        if (!M)
          continue;
        const {
          direction: w,
          speed: L
        } = nE(O, M, A, t, f);
        for (const P of ["x", "y"])
          h[P][w[P]] || (L[P] = 0, w[P] = 0);
        if (L.x > 0 || L.y > 0) {
          C(), S.current = O, g(_, s), T.current = L, I.current = w;
          return;
        }
      }
      T.current = {
        x: 0,
        y: 0
      }, I.current = {
        x: 0,
        y: 0
      }, C();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      t,
      _,
      r,
      C,
      o,
      s,
      // eslint-disable-next-line react-hooks/exhaustive-deps
      JSON.stringify(A),
      // eslint-disable-next-line react-hooks/exhaustive-deps
      JSON.stringify(h),
      g,
      u,
      v,
      p,
      // eslint-disable-next-line react-hooks/exhaustive-deps
      JSON.stringify(f)
    ]
  );
}
const mE = {
  x: {
    [dt.Backward]: !1,
    [dt.Forward]: !1
  },
  y: {
    [dt.Backward]: !1,
    [dt.Forward]: !1
  }
};
function EE(e) {
  let {
    delta: t,
    disabled: n
  } = e;
  const r = Zi(t);
  return fi((i) => {
    if (n || !r || !i)
      return mE;
    const o = {
      x: Math.sign(t.x - r.x),
      y: Math.sign(t.y - r.y)
    };
    return {
      x: {
        [dt.Backward]: i.x[dt.Backward] || o.x === -1,
        [dt.Forward]: i.x[dt.Forward] || o.x === 1
      },
      y: {
        [dt.Backward]: i.y[dt.Backward] || o.y === -1,
        [dt.Forward]: i.y[dt.Forward] || o.y === 1
      }
    };
  }, [n, t, r]);
}
function xE(e, t) {
  const n = t != null ? e.get(t) : void 0, r = n ? n.node.current : null;
  return fi((i) => {
    var o;
    return t == null ? null : (o = r ?? i) != null ? o : null;
  }, [r, t]);
}
function CE(e, t) {
  return ee(() => e.reduce((n, r) => {
    const {
      sensor: i
    } = r, o = i.activators.map((s) => ({
      eventName: s.eventName,
      handler: t(s.handler, r)
    }));
    return [...n, ...o];
  }, []), [e, t]);
}
var ti;
(function(e) {
  e[e.Always = 0] = "Always", e[e.BeforeDragging = 1] = "BeforeDragging", e[e.WhileDragging = 2] = "WhileDragging";
})(ti || (ti = {}));
var xa;
(function(e) {
  e.Optimized = "optimized";
})(xa || (xa = {}));
const hl = /* @__PURE__ */ new Map();
function gE(e, t) {
  let {
    dragging: n,
    dependencies: r,
    config: i
  } = t;
  const [o, s] = J(null), {
    frequency: l,
    measure: c,
    strategy: u
  } = i, p = Ae(e), d = T(), f = ei(d), h = ie(function(I) {
    I === void 0 && (I = []), !f.current && s((A) => A === null ? I : A.concat(I.filter((S) => !A.includes(S))));
  }, [f]), g = Ae(null), C = fi((I) => {
    if (d && !n)
      return hl;
    if (!I || I === hl || p.current !== e || o != null) {
      const A = /* @__PURE__ */ new Map();
      for (let S of e) {
        if (!S)
          continue;
        if (o && o.length > 0 && !o.includes(S.id) && S.rect.current) {
          A.set(S.id, S.rect.current);
          continue;
        }
        const _ = S.node.current, v = _ ? new qa(c(_), _) : null;
        S.rect.current = v, v && A.set(S.id, v);
      }
      return A;
    }
    return I;
  }, [e, o, n, d, c]);
  return Q(() => {
    p.current = e;
  }, [e]), Q(
    () => {
      d || h();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [n, d]
  ), Q(
    () => {
      o && o.length > 0 && s(null);
    },
    //eslint-disable-next-line react-hooks/exhaustive-deps
    [JSON.stringify(o)]
  ), Q(
    () => {
      d || typeof l != "number" || g.current !== null || (g.current = setTimeout(() => {
        h(), g.current = null;
      }, l));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [l, d, h, ...r]
  ), {
    droppableRects: C,
    measureDroppableContainers: h,
    measuringScheduled: o != null
  };
  function T() {
    switch (u) {
      case ti.Always:
        return !1;
      case ti.BeforeDragging:
        return n;
      default:
        return !n;
    }
  }
}
function Ja(e, t) {
  return fi((n) => e ? n || (typeof t == "function" ? t(e) : e) : null, [t, e]);
}
function yE(e, t) {
  return Ja(e, t);
}
function TE(e) {
  let {
    callback: t,
    disabled: n
  } = e;
  const r = Eo(t), i = ee(() => {
    if (n || typeof window > "u" || typeof window.MutationObserver > "u")
      return;
    const {
      MutationObserver: o
    } = window;
    return new o(r);
  }, [r, n]);
  return Q(() => () => i == null ? void 0 : i.disconnect(), [i]), i;
}
function go(e) {
  let {
    callback: t,
    disabled: n
  } = e;
  const r = Eo(t), i = ee(
    () => {
      if (n || typeof window > "u" || typeof window.ResizeObserver > "u")
        return;
      const {
        ResizeObserver: o
      } = window;
      return new o(r);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [n]
  );
  return Q(() => () => i == null ? void 0 : i.disconnect(), [i]), i;
}
function SE(e) {
  return new qa(Ir(e), e);
}
function fl(e, t, n) {
  t === void 0 && (t = SE);
  const [r, i] = J(null);
  function o() {
    i((c) => {
      if (!e)
        return null;
      if (e.isConnected === !1) {
        var u;
        return (u = c ?? n) != null ? u : null;
      }
      const p = t(e);
      return JSON.stringify(c) === JSON.stringify(p) ? c : p;
    });
  }
  const s = TE({
    callback(c) {
      if (e)
        for (const u of c) {
          const {
            type: p,
            target: d
          } = u;
          if (p === "childList" && d instanceof HTMLElement && d.contains(e)) {
            o();
            break;
          }
        }
    }
  }), l = go({
    callback: o
  });
  return Zt(() => {
    o(), e ? (l == null || l.observe(e), s == null || s.observe(document.body, {
      childList: !0,
      subtree: !0
    })) : (l == null || l.disconnect(), s == null || s.disconnect());
  }, [e]), r;
}
function IE(e) {
  const t = Ja(e);
  return Lu(e, t);
}
const ml = [];
function AE(e) {
  const t = Ae(e), n = fi((r) => e ? r && r !== ml && e && t.current && e.parentNode === t.current.parentNode ? r : Ha(e) : ml, [e]);
  return Q(() => {
    t.current = e;
  }, [e]), n;
}
function bE(e) {
  const [t, n] = J(null), r = Ae(e), i = ie((o) => {
    const s = Fo(o.target);
    s && n((l) => l ? (l.set(s, ma(s)), new Map(l)) : null);
  }, []);
  return Q(() => {
    const o = r.current;
    if (e !== o) {
      s(o);
      const l = e.map((c) => {
        const u = Fo(c);
        return u ? (u.addEventListener("scroll", i, {
          passive: !0
        }), [u, ma(u)]) : null;
      }).filter((c) => c != null);
      n(l.length ? new Map(l) : null), r.current = e;
    }
    return () => {
      s(e), s(o);
    };
    function s(l) {
      l.forEach((c) => {
        const u = Fo(c);
        u == null || u.removeEventListener("scroll", i);
      });
    }
  }, [i, e]), ee(() => e.length ? t ? Array.from(t.values()).reduce((o, s) => cr(o, s), en) : $u(e) : en, [e, t]);
}
function El(e, t) {
  t === void 0 && (t = []);
  const n = Ae(null);
  return Q(
    () => {
      n.current = null;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t
  ), Q(() => {
    const r = e !== en;
    r && !n.current && (n.current = e), !r && n.current && (n.current = null);
  }, [e]), n.current ? eo(e, n.current) : en;
}
function RE(e) {
  Q(
    () => {
      if (!mo)
        return;
      const t = e.map((n) => {
        let {
          sensor: r
        } = n;
        return r.setup == null ? void 0 : r.setup();
      });
      return () => {
        for (const n of t)
          n == null || n();
      };
    },
    // TO-DO: Sensors length could theoretically change which would not be a valid dependency
    // eslint-disable-next-line react-hooks/exhaustive-deps
    e.map((t) => {
      let {
        sensor: n
      } = t;
      return n;
    })
  );
}
function OE(e, t) {
  return ee(() => e.reduce((n, r) => {
    let {
      eventName: i,
      handler: o
    } = r;
    return n[i] = (s) => {
      o(s, t);
    }, n;
  }, {}), [e, t]);
}
function Yu(e) {
  return ee(() => e ? Qm(e) : null, [e]);
}
const xl = [];
function vE(e, t) {
  t === void 0 && (t = Ir);
  const [n] = e, r = Yu(n ? Ot(n) : null), [i, o] = J(xl);
  function s() {
    o(() => e.length ? e.map((c) => Fu(c) ? r : new qa(t(c), c)) : xl);
  }
  const l = go({
    callback: s
  });
  return Zt(() => {
    l == null || l.disconnect(), s(), e.forEach((c) => l == null ? void 0 : l.observe(c));
  }, [e]), i;
}
function Hu(e) {
  if (!e)
    return null;
  if (e.children.length > 1)
    return e;
  const t = e.children[0];
  return hi(t) ? t : e;
}
function DE(e) {
  let {
    measure: t
  } = e;
  const [n, r] = J(null), i = ie((u) => {
    for (const {
      target: p
    } of u)
      if (hi(p)) {
        r((d) => {
          const f = t(p);
          return d ? {
            ...d,
            width: f.width,
            height: f.height
          } : f;
        });
        break;
      }
  }, [t]), o = go({
    callback: i
  }), s = ie((u) => {
    const p = Hu(u);
    o == null || o.disconnect(), p && (o == null || o.observe(p)), r(p ? t(p) : null);
  }, [t, o]), [l, c] = Qi(s);
  return ee(() => ({
    nodeRef: l,
    rect: n,
    setRef: c
  }), [n, l, c]);
}
const _E = [{
  sensor: Co,
  options: {}
}, {
  sensor: Wu,
  options: {}
}], NE = {
  current: {}
}, Mi = {
  draggable: {
    measure: cl
  },
  droppable: {
    measure: cl,
    strategy: ti.WhileDragging,
    frequency: xa.Optimized
  },
  dragOverlay: {
    measure: Ir
  }
};
class Gr extends Map {
  get(t) {
    var n;
    return t != null && (n = super.get(t)) != null ? n : void 0;
  }
  toArray() {
    return Array.from(this.values());
  }
  getEnabled() {
    return this.toArray().filter((t) => {
      let {
        disabled: n
      } = t;
      return !n;
    });
  }
  getNodeFor(t) {
    var n, r;
    return (n = (r = this.get(t)) == null ? void 0 : r.node.current) != null ? n : void 0;
  }
}
const wE = {
  activatorEvent: null,
  active: null,
  activeNode: null,
  activeNodeRect: null,
  collisions: null,
  containerNodeRect: null,
  draggableNodes: /* @__PURE__ */ new Map(),
  droppableRects: /* @__PURE__ */ new Map(),
  droppableContainers: /* @__PURE__ */ new Gr(),
  over: null,
  dragOverlay: {
    nodeRef: {
      current: null
    },
    rect: null,
    setRef: no
  },
  scrollableAncestors: [],
  scrollableAncestorRects: [],
  measuringConfiguration: Mi,
  measureDroppableContainers: no,
  windowRect: null,
  measuringScheduled: !1
}, qu = {
  activatorEvent: null,
  activators: [],
  active: null,
  activeNodeRect: null,
  ariaDescribedById: {
    draggable: ""
  },
  dispatch: no,
  draggableNodes: /* @__PURE__ */ new Map(),
  over: null,
  measureDroppableContainers: no
}, Ei = /* @__PURE__ */ Xn(qu), Xu = /* @__PURE__ */ Xn(wE);
function PE() {
  return {
    draggable: {
      active: null,
      initialCoordinates: {
        x: 0,
        y: 0
      },
      nodes: /* @__PURE__ */ new Map(),
      translate: {
        x: 0,
        y: 0
      }
    },
    droppable: {
      containers: new Gr()
    }
  };
}
function jE(e, t) {
  switch (t.type) {
    case lt.DragStart:
      return {
        ...e,
        draggable: {
          ...e.draggable,
          initialCoordinates: t.initialCoordinates,
          active: t.active
        }
      };
    case lt.DragMove:
      return e.draggable.active == null ? e : {
        ...e,
        draggable: {
          ...e.draggable,
          translate: {
            x: t.coordinates.x - e.draggable.initialCoordinates.x,
            y: t.coordinates.y - e.draggable.initialCoordinates.y
          }
        }
      };
    case lt.DragEnd:
    case lt.DragCancel:
      return {
        ...e,
        draggable: {
          ...e.draggable,
          active: null,
          initialCoordinates: {
            x: 0,
            y: 0
          },
          translate: {
            x: 0,
            y: 0
          }
        }
      };
    case lt.RegisterDroppable: {
      const {
        element: n
      } = t, {
        id: r
      } = n, i = new Gr(e.droppable.containers);
      return i.set(r, n), {
        ...e,
        droppable: {
          ...e.droppable,
          containers: i
        }
      };
    }
    case lt.SetDroppableDisabled: {
      const {
        id: n,
        key: r,
        disabled: i
      } = t, o = e.droppable.containers.get(n);
      if (!o || r !== o.key)
        return e;
      const s = new Gr(e.droppable.containers);
      return s.set(n, {
        ...o,
        disabled: i
      }), {
        ...e,
        droppable: {
          ...e.droppable,
          containers: s
        }
      };
    }
    case lt.UnregisterDroppable: {
      const {
        id: n,
        key: r
      } = t, i = e.droppable.containers.get(n);
      if (!i || r !== i.key)
        return e;
      const o = new Gr(e.droppable.containers);
      return o.delete(n), {
        ...e,
        droppable: {
          ...e.droppable,
          containers: o
        }
      };
    }
    default:
      return e;
  }
}
function LE(e) {
  let {
    disabled: t
  } = e;
  const {
    active: n,
    activatorEvent: r,
    draggableNodes: i
  } = Le(Ei), o = Zi(r), s = Zi(n == null ? void 0 : n.id);
  return Q(() => {
    if (!t && !r && o && s != null) {
      if (!xo(o) || document.activeElement === o.target)
        return;
      const l = i.get(s);
      if (!l)
        return;
      const {
        activatorNode: c,
        node: u
      } = l;
      if (!c.current && !u.current)
        return;
      requestAnimationFrame(() => {
        for (const p of [c.current, u.current]) {
          if (!p)
            continue;
          const d = _m(p);
          if (d) {
            d.focus();
            break;
          }
        }
      });
    }
  }, [r, t, i, s, o]), null;
}
function Ju(e, t) {
  let {
    transform: n,
    ...r
  } = t;
  return e != null && e.length ? e.reduce((i, o) => o({
    transform: i,
    ...r
  }), n) : n;
}
function kE(e) {
  return ee(
    () => ({
      draggable: {
        ...Mi.draggable,
        ...e == null ? void 0 : e.draggable
      },
      droppable: {
        ...Mi.droppable,
        ...e == null ? void 0 : e.droppable
      },
      dragOverlay: {
        ...Mi.dragOverlay,
        ...e == null ? void 0 : e.dragOverlay
      }
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [e == null ? void 0 : e.draggable, e == null ? void 0 : e.droppable, e == null ? void 0 : e.dragOverlay]
  );
}
function ME(e) {
  let {
    activeNode: t,
    measure: n,
    initialRect: r,
    config: i = !0
  } = e;
  const o = Ae(!1), {
    x: s,
    y: l
  } = typeof i == "boolean" ? {
    x: i,
    y: i
  } : i;
  Zt(() => {
    if (!s && !l || !t) {
      o.current = !1;
      return;
    }
    if (o.current || !r)
      return;
    const u = t == null ? void 0 : t.node.current;
    if (!u || u.isConnected === !1)
      return;
    const p = n(u), d = Lu(p, r);
    if (s || (d.x = 0), l || (d.y = 0), o.current = !0, Math.abs(d.x) > 0 || Math.abs(d.y) > 0) {
      const f = Mu(u);
      f && f.scrollBy({
        top: d.y,
        left: d.x
      });
    }
  }, [t, s, l, r, n]);
}
const yo = /* @__PURE__ */ Xn({
  ...en,
  scaleX: 1,
  scaleY: 1
});
var Rn;
(function(e) {
  e[e.Uninitialized = 0] = "Uninitialized", e[e.Initializing = 1] = "Initializing", e[e.Initialized = 2] = "Initialized";
})(Rn || (Rn = {}));
const Ku = /* @__PURE__ */ it(function(t) {
  var n, r, i, o;
  let {
    id: s,
    accessibility: l,
    autoScroll: c = !0,
    children: u,
    sensors: p = _E,
    collisionDetection: d = Ym,
    measuring: f,
    modifiers: h,
    ...g
  } = t;
  const C = xr(jE, void 0, PE), [T, I] = C, [A, S] = km(), [_, v] = J(Rn.Uninitialized), O = _ === Rn.Initialized, {
    draggable: {
      active: j,
      nodes: M,
      translate: w
    },
    droppable: {
      containers: L
    }
  } = T, P = j != null ? M.get(j) : null, k = Ae({
    initial: null,
    translated: null
  }), z = ee(() => {
    var ct;
    return j != null ? {
      id: j,
      // It's possible for the active node to unmount while dragging
      data: (ct = P == null ? void 0 : P.data) != null ? ct : NE,
      rect: k
    } : null;
  }, [j, P]), B = Ae(null), [q, N] = J(null), [ne, ue] = J(null), te = ei(g, Object.values(g)), m = mi("DndDescribedBy", s), W = ee(() => L.getEnabled(), [L]), H = kE(f), {
    droppableRects: y,
    measureDroppableContainers: X,
    measuringScheduled: V
  } = gE(W, {
    dragging: O,
    dependencies: [w.x, w.y],
    config: H.droppable
  }), $ = xE(M, j), le = ee(() => ne ? to(ne) : null, [ne]), b = wo(), oe = yE($, H.draggable.measure);
  ME({
    activeNode: j != null ? M.get(j) : null,
    config: b.layoutShiftCompensation,
    initialRect: oe,
    measure: H.draggable.measure
  });
  const re = fl($, H.draggable.measure, oe), ye = fl($ ? $.parentElement : null), Me = Ae({
    activatorEvent: null,
    active: null,
    activeNode: $,
    collisionRect: null,
    collisions: null,
    droppableRects: y,
    draggableNodes: M,
    draggingNode: null,
    draggingNodeRect: null,
    droppableContainers: L,
    over: null,
    scrollableAncestors: [],
    scrollAdjustedTranslate: null
  }), ot = L.getNodeFor((n = Me.current.over) == null ? void 0 : n.id), Ue = DE({
    measure: H.dragOverlay.measure
  }), Ve = (r = Ue.nodeRef.current) != null ? r : $, Qe = O ? (i = Ue.rect) != null ? i : re : null, pt = !!(Ue.nodeRef.current && Ue.rect), qt = IE(pt ? null : re), de = Yu(Ve ? Ot(Ve) : null), ae = AE(O ? ot ?? $ : null), Fe = vE(ae), vt = Ju(h, {
    transform: {
      x: w.x - qt.x,
      y: w.y - qt.y,
      scaleX: 1,
      scaleY: 1
    },
    activatorEvent: ne,
    active: z,
    activeNodeRect: re,
    containerNodeRect: ye,
    draggingNodeRect: Qe,
    over: Me.current.over,
    overlayNodeRect: Ue.rect,
    scrollableAncestors: ae,
    scrollableAncestorRects: Fe,
    windowRect: de
  }), Ye = le ? cr(le, w) : null, Tt = bE(ae), at = El(Tt), U = El(Tt, [re]), K = cr(vt, at), pe = Qe ? Xm(Qe, vt) : null, Ce = z && pe ? d({
    active: z,
    collisionRect: pe,
    droppableRects: y,
    droppableContainers: W,
    pointerCoordinates: Ye
  }) : null, ve = zm(Ce, "id"), [He, Pt] = J(null), Pe = pt ? vt : cr(vt, U), hn = Hm(Pe, (o = He == null ? void 0 : He.rect) != null ? o : null, re), Xt = Ae(null), Ze = ie(
    (ct, ht) => {
      let {
        sensor: ft,
        options: jt
      } = ht;
      if (B.current == null)
        return;
      const mt = M.get(B.current);
      if (!mt)
        return;
      const Et = ct.nativeEvent, Ft = new ft({
        active: B.current,
        activeNode: mt,
        event: Et,
        options: jt,
        // Sensors need to be instantiated with refs for arguments that change over time
        // otherwise they are frozen in time with the stale arguments
        context: Me,
        onAbort(st) {
          if (!M.get(st))
            return;
          const {
            onDragAbort: Bt
          } = te.current, Jt = {
            id: st
          };
          Bt == null || Bt(Jt), A({
            type: "onDragAbort",
            event: Jt
          });
        },
        onPending(st, nn, Bt, Jt) {
          if (!M.get(st))
            return;
          const {
            onDragPending: Ln
          } = te.current, rn = {
            id: st,
            constraint: nn,
            initialCoordinates: Bt,
            offset: Jt
          };
          Ln == null || Ln(rn), A({
            type: "onDragPending",
            event: rn
          });
        },
        onStart(st) {
          const nn = B.current;
          if (nn == null)
            return;
          const Bt = M.get(nn);
          if (!Bt)
            return;
          const {
            onDragStart: Jt
          } = te.current, jn = {
            activatorEvent: Et,
            active: {
              id: nn,
              data: Bt.data,
              rect: k
            }
          };
          Ii(() => {
            Jt == null || Jt(jn), v(Rn.Initializing), I({
              type: lt.DragStart,
              initialCoordinates: st,
              active: nn
            }), A({
              type: "onDragStart",
              event: jn
            }), N(Xt.current), ue(Et);
          });
        },
        onMove(st) {
          I({
            type: lt.DragMove,
            coordinates: st
          });
        },
        onEnd: In(lt.DragEnd),
        onCancel: In(lt.DragCancel)
      });
      Xt.current = Ft;
      function In(st) {
        return async function() {
          const {
            active: Bt,
            collisions: Jt,
            over: jn,
            scrollAdjustedTranslate: Ln
          } = Me.current;
          let rn = null;
          if (Bt && Ln) {
            const {
              cancelDrop: An
            } = te.current;
            rn = {
              activatorEvent: Et,
              active: Bt,
              collisions: Jt,
              delta: Ln,
              over: jn
            }, st === lt.DragEnd && typeof An == "function" && await Promise.resolve(An(rn)) && (st = lt.DragCancel);
          }
          B.current = null, Ii(() => {
            I({
              type: st
            }), v(Rn.Uninitialized), Pt(null), N(null), ue(null), Xt.current = null;
            const An = st === lt.DragEnd ? "onDragEnd" : "onDragCancel";
            if (rn) {
              const fn = te.current[An];
              fn == null || fn(rn), A({
                type: An,
                event: rn
              });
            }
          });
        };
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [M]
  ), tn = ie((ct, ht) => (ft, jt) => {
    const mt = ft.nativeEvent, Et = M.get(jt);
    if (
      // Another sensor is already instantiating
      B.current !== null || // No active draggable
      !Et || // Event has already been captured
      mt.dndKit || mt.defaultPrevented
    )
      return;
    const Ft = {
      active: Et
    };
    ct(ft, ht.options, Ft) === !0 && (mt.dndKit = {
      capturedBy: ht.sensor
    }, B.current = jt, Ze(ft, ht));
  }, [M, Ze]), Dt = CE(p, tn);
  RE(p), Zt(() => {
    re && _ === Rn.Initializing && v(Rn.Initialized);
  }, [re, _]), Q(
    () => {
      const {
        onDragMove: ct
      } = te.current, {
        active: ht,
        activatorEvent: ft,
        collisions: jt,
        over: mt
      } = Me.current;
      if (!ht || !ft)
        return;
      const Et = {
        active: ht,
        activatorEvent: ft,
        collisions: jt,
        delta: {
          x: K.x,
          y: K.y
        },
        over: mt
      };
      Ii(() => {
        ct == null || ct(Et), A({
          type: "onDragMove",
          event: Et
        });
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [K.x, K.y]
  ), Q(
    () => {
      const {
        active: ct,
        activatorEvent: ht,
        collisions: ft,
        droppableContainers: jt,
        scrollAdjustedTranslate: mt
      } = Me.current;
      if (!ct || B.current == null || !ht || !mt)
        return;
      const {
        onDragOver: Et
      } = te.current, Ft = jt.get(ve), In = Ft && Ft.rect.current ? {
        id: Ft.id,
        rect: Ft.rect.current,
        data: Ft.data,
        disabled: Ft.disabled
      } : null, st = {
        active: ct,
        activatorEvent: ht,
        collisions: ft,
        delta: {
          x: mt.x,
          y: mt.y
        },
        over: In
      };
      Ii(() => {
        Pt(In), Et == null || Et(st), A({
          type: "onDragOver",
          event: st
        });
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [ve]
  ), Zt(() => {
    Me.current = {
      activatorEvent: ne,
      active: z,
      activeNode: $,
      collisionRect: pe,
      collisions: Ce,
      droppableRects: y,
      draggableNodes: M,
      draggingNode: Ve,
      draggingNodeRect: Qe,
      droppableContainers: L,
      over: He,
      scrollableAncestors: ae,
      scrollAdjustedTranslate: K
    }, k.current = {
      initial: Qe,
      translated: pe
    };
  }, [z, $, Ce, pe, M, Ve, Qe, y, L, He, ae, K]), fE({
    ...b,
    delta: w,
    draggingRect: pe,
    pointerCoordinates: Ye,
    scrollableAncestors: ae,
    scrollableAncestorRects: Fe
  });
  const _o = ee(() => ({
    active: z,
    activeNode: $,
    activeNodeRect: re,
    activatorEvent: ne,
    collisions: Ce,
    containerNodeRect: ye,
    dragOverlay: Ue,
    draggableNodes: M,
    droppableContainers: L,
    droppableRects: y,
    over: He,
    measureDroppableContainers: X,
    scrollableAncestors: ae,
    scrollableAncestorRects: Fe,
    measuringConfiguration: H,
    measuringScheduled: V,
    windowRect: de
  }), [z, $, re, ne, Ce, ye, Ue, M, L, y, He, X, ae, Fe, H, V, de]), No = ee(() => ({
    activatorEvent: ne,
    activators: Dt,
    active: z,
    activeNodeRect: re,
    ariaDescribedById: {
      draggable: m
    },
    dispatch: I,
    draggableNodes: M,
    over: He,
    measureDroppableContainers: X
  }), [ne, Dt, z, re, I, m, M, He, X]);
  return Re.createElement(Nu.Provider, {
    value: S
  }, Re.createElement(Ei.Provider, {
    value: No
  }, Re.createElement(Xu.Provider, {
    value: _o
  }, Re.createElement(yo.Provider, {
    value: hn
  }, u)), Re.createElement(LE, {
    disabled: (l == null ? void 0 : l.restoreFocus) === !1
  })), Re.createElement(Um, {
    ...l,
    hiddenTextDescribedById: m
  }));
  function wo() {
    const ct = (q == null ? void 0 : q.autoScrollEnabled) === !1, ht = typeof c == "object" ? c.enabled === !1 : c === !1, ft = O && !ct && !ht;
    return typeof c == "object" ? {
      ...c,
      enabled: ft
    } : {
      enabled: ft
    };
  }
}), VE = /* @__PURE__ */ Xn(null), Cl = "button", UE = "Draggable";
function FE(e) {
  let {
    id: t,
    data: n,
    disabled: r = !1,
    attributes: i
  } = e;
  const o = mi(UE), {
    activators: s,
    activatorEvent: l,
    active: c,
    activeNodeRect: u,
    ariaDescribedById: p,
    draggableNodes: d,
    over: f
  } = Le(Ei), {
    role: h = Cl,
    roleDescription: g = "draggable",
    tabIndex: C = 0
  } = i ?? {}, T = (c == null ? void 0 : c.id) === t, I = Le(T ? yo : VE), [A, S] = Qi(), [_, v] = Qi(), O = OE(s, t), j = ei(n);
  Zt(
    () => (d.set(t, {
      id: t,
      key: o,
      node: A,
      activatorNode: _,
      data: j
    }), () => {
      const w = d.get(t);
      w && w.key === o && d.delete(t);
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [d, t]
  );
  const M = ee(() => ({
    role: h,
    tabIndex: C,
    "aria-disabled": r,
    "aria-pressed": T && h === Cl ? !0 : void 0,
    "aria-roledescription": g,
    "aria-describedby": p.draggable
  }), [r, h, C, T, g, p.draggable]);
  return {
    active: c,
    activatorEvent: l,
    activeNodeRect: u,
    attributes: M,
    isDragging: T,
    listeners: r ? void 0 : O,
    node: A,
    over: f,
    setNodeRef: S,
    setActivatorNodeRef: v,
    transform: I
  };
}
function Qu() {
  return Le(Xu);
}
const BE = "Droppable", $E = {
  timeout: 25
};
function GE(e) {
  let {
    data: t,
    disabled: n = !1,
    id: r,
    resizeObserverConfig: i
  } = e;
  const o = mi(BE), {
    active: s,
    dispatch: l,
    over: c,
    measureDroppableContainers: u
  } = Le(Ei), p = Ae({
    disabled: n
  }), d = Ae(!1), f = Ae(null), h = Ae(null), {
    disabled: g,
    updateMeasurementsFor: C,
    timeout: T
  } = {
    ...$E,
    ...i
  }, I = ei(C ?? r), A = ie(
    () => {
      if (!d.current) {
        d.current = !0;
        return;
      }
      h.current != null && clearTimeout(h.current), h.current = setTimeout(() => {
        u(Array.isArray(I.current) ? I.current : [I.current]), h.current = null;
      }, T);
    },
    //eslint-disable-next-line react-hooks/exhaustive-deps
    [T]
  ), S = go({
    callback: A,
    disabled: g || !s
  }), _ = ie((M, w) => {
    S && (w && (S.unobserve(w), d.current = !1), M && S.observe(M));
  }, [S]), [v, O] = Qi(_), j = ei(t);
  return Q(() => {
    !S || !v.current || (S.disconnect(), d.current = !1, S.observe(v.current));
  }, [v, S]), Q(
    () => (l({
      type: lt.RegisterDroppable,
      element: {
        id: r,
        key: o,
        disabled: n,
        node: v,
        rect: f,
        data: j
      }
    }), () => l({
      type: lt.UnregisterDroppable,
      key: o,
      id: r
    })),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [r]
  ), Q(() => {
    n !== p.current.disabled && (l({
      type: lt.SetDroppableDisabled,
      id: r,
      key: o,
      disabled: n
    }), p.current.disabled = n);
  }, [r, o, n, l]), {
    active: s,
    rect: f,
    isOver: (c == null ? void 0 : c.id) === r,
    node: v,
    over: c,
    setNodeRef: O
  };
}
function zE(e) {
  let {
    animation: t,
    children: n
  } = e;
  const [r, i] = J(null), [o, s] = J(null), l = Zi(n);
  return !n && !r && l && i(l), Zt(() => {
    if (!o)
      return;
    const c = r == null ? void 0 : r.key, u = r == null ? void 0 : r.props.id;
    if (c == null || u == null) {
      i(null);
      return;
    }
    Promise.resolve(t(u, o)).then(() => {
      i(null);
    });
  }, [t, r, o]), Re.createElement(Re.Fragment, null, n, r ? Lp(r, {
    ref: s
  }) : null);
}
const WE = {
  x: 0,
  y: 0,
  scaleX: 1,
  scaleY: 1
};
function YE(e) {
  let {
    children: t
  } = e;
  return Re.createElement(Ei.Provider, {
    value: qu
  }, Re.createElement(yo.Provider, {
    value: WE
  }, t));
}
const HE = {
  position: "fixed",
  touchAction: "none"
}, qE = (e) => xo(e) ? "transform 250ms ease" : void 0, XE = /* @__PURE__ */ jp((e, t) => {
  let {
    as: n,
    activatorEvent: r,
    adjustScale: i,
    children: o,
    className: s,
    rect: l,
    style: c,
    transform: u,
    transition: p = qE
  } = e;
  if (!l)
    return null;
  const d = i ? u : {
    ...u,
    scaleX: 1,
    scaleY: 1
  }, f = {
    ...HE,
    width: l.width,
    height: l.height,
    top: l.top,
    left: l.left,
    transform: Cn.Transform.toString(d),
    transformOrigin: i && r ? Bm(r, l) : void 0,
    transition: typeof p == "function" ? p(r) : p,
    ...c
  };
  return Re.createElement(n, {
    className: s,
    style: f,
    ref: t
  }, o);
}), JE = (e) => (t) => {
  let {
    active: n,
    dragOverlay: r
  } = t;
  const i = {}, {
    styles: o,
    className: s
  } = e;
  if (o != null && o.active)
    for (const [l, c] of Object.entries(o.active))
      c !== void 0 && (i[l] = n.node.style.getPropertyValue(l), n.node.style.setProperty(l, c));
  if (o != null && o.dragOverlay)
    for (const [l, c] of Object.entries(o.dragOverlay))
      c !== void 0 && r.node.style.setProperty(l, c);
  return s != null && s.active && n.node.classList.add(s.active), s != null && s.dragOverlay && r.node.classList.add(s.dragOverlay), function() {
    for (const [c, u] of Object.entries(i))
      n.node.style.setProperty(c, u);
    s != null && s.active && n.node.classList.remove(s.active);
  };
}, KE = (e) => {
  let {
    transform: {
      initial: t,
      final: n
    }
  } = e;
  return [{
    transform: Cn.Transform.toString(t)
  }, {
    transform: Cn.Transform.toString(n)
  }];
}, QE = {
  duration: 250,
  easing: "ease",
  keyframes: KE,
  sideEffects: /* @__PURE__ */ JE({
    styles: {
      active: {
        opacity: "0"
      }
    }
  })
};
function ZE(e) {
  let {
    config: t,
    draggableNodes: n,
    droppableContainers: r,
    measuringConfiguration: i
  } = e;
  return Eo((o, s) => {
    if (t === null)
      return;
    const l = n.get(o);
    if (!l)
      return;
    const c = l.node.current;
    if (!c)
      return;
    const u = Hu(s);
    if (!u)
      return;
    const {
      transform: p
    } = Ot(s).getComputedStyle(s), d = ku(p);
    if (!d)
      return;
    const f = typeof t == "function" ? t : ex(t);
    return Gu(c, i.draggable.measure), f({
      active: {
        id: o,
        data: l.data,
        node: c,
        rect: i.draggable.measure(c)
      },
      draggableNodes: n,
      dragOverlay: {
        node: s,
        rect: i.dragOverlay.measure(u)
      },
      droppableContainers: r,
      measuringConfiguration: i,
      transform: d
    });
  });
}
function ex(e) {
  const {
    duration: t,
    easing: n,
    sideEffects: r,
    keyframes: i
  } = {
    ...QE,
    ...e
  };
  return (o) => {
    let {
      active: s,
      dragOverlay: l,
      transform: c,
      ...u
    } = o;
    if (!t)
      return;
    const p = {
      x: l.rect.left - s.rect.left,
      y: l.rect.top - s.rect.top
    }, d = {
      scaleX: c.scaleX !== 1 ? s.rect.width * c.scaleX / l.rect.width : 1,
      scaleY: c.scaleY !== 1 ? s.rect.height * c.scaleY / l.rect.height : 1
    }, f = {
      x: c.x - p.x,
      y: c.y - p.y,
      ...d
    }, h = i({
      ...u,
      active: s,
      dragOverlay: l,
      transform: {
        initial: c,
        final: f
      }
    }), [g] = h, C = h[h.length - 1];
    if (JSON.stringify(g) === JSON.stringify(C))
      return;
    const T = r == null ? void 0 : r({
      active: s,
      dragOverlay: l,
      ...u
    }), I = l.node.animate(h, {
      duration: t,
      easing: n,
      fill: "forwards"
    });
    return new Promise((A) => {
      I.onfinish = () => {
        T == null || T(), A();
      };
    });
  };
}
let gl = 0;
function tx(e) {
  return ee(() => {
    if (e != null)
      return gl++, gl;
  }, [e]);
}
const Zu = /* @__PURE__ */ Re.memo((e) => {
  let {
    adjustScale: t = !1,
    children: n,
    dropAnimation: r,
    style: i,
    transition: o,
    modifiers: s,
    wrapperElement: l = "div",
    className: c,
    zIndex: u = 999
  } = e;
  const {
    activatorEvent: p,
    active: d,
    activeNodeRect: f,
    containerNodeRect: h,
    draggableNodes: g,
    droppableContainers: C,
    dragOverlay: T,
    over: I,
    measuringConfiguration: A,
    scrollableAncestors: S,
    scrollableAncestorRects: _,
    windowRect: v
  } = Qu(), O = Le(yo), j = tx(d == null ? void 0 : d.id), M = Ju(s, {
    activatorEvent: p,
    active: d,
    activeNodeRect: f,
    containerNodeRect: h,
    draggingNodeRect: T.rect,
    over: I,
    overlayNodeRect: T.rect,
    scrollableAncestors: S,
    scrollableAncestorRects: _,
    transform: O,
    windowRect: v
  }), w = Ja(f), L = ZE({
    config: r,
    draggableNodes: g,
    droppableContainers: C,
    measuringConfiguration: A
  }), P = w ? T.setRef : void 0;
  return Re.createElement(YE, null, Re.createElement(zE, {
    animation: L
  }, d && j ? Re.createElement(XE, {
    key: j,
    id: d.id,
    ref: P,
    as: l,
    activatorEvent: p,
    adjustScale: t,
    className: c,
    transition: o,
    rect: w,
    style: {
      zIndex: u,
      ...i
    },
    transform: M
  }, n) : null));
});
function Ka(e, t, n) {
  const r = e.slice();
  return r.splice(n < 0 ? r.length + n : n, 0, r.splice(t, 1)[0]), r;
}
function nx(e, t) {
  return e.reduce((n, r, i) => {
    const o = t.get(r);
    return o && (n[i] = o), n;
  }, Array(e.length));
}
function bi(e) {
  return e !== null && e >= 0;
}
function rx(e, t) {
  if (e === t)
    return !0;
  if (e.length !== t.length)
    return !1;
  for (let n = 0; n < e.length; n++)
    if (e[n] !== t[n])
      return !1;
  return !0;
}
function ix(e) {
  return typeof e == "boolean" ? {
    draggable: e,
    droppable: e
  } : e;
}
const ed = (e) => {
  let {
    rects: t,
    activeIndex: n,
    overIndex: r,
    index: i
  } = e;
  const o = Ka(t, r, n), s = t[i], l = o[i];
  return !l || !s ? null : {
    x: l.left - s.left,
    y: l.top - s.top,
    scaleX: l.width / s.width,
    scaleY: l.height / s.height
  };
}, Ri = {
  scaleX: 1,
  scaleY: 1
}, td = (e) => {
  var t;
  let {
    activeIndex: n,
    activeNodeRect: r,
    index: i,
    rects: o,
    overIndex: s
  } = e;
  const l = (t = o[n]) != null ? t : r;
  if (!l)
    return null;
  if (i === n) {
    const u = o[s];
    return u ? {
      x: 0,
      y: n < s ? u.top + u.height - (l.top + l.height) : u.top - l.top,
      ...Ri
    } : null;
  }
  const c = ox(o, i, n);
  return i > n && i <= s ? {
    x: 0,
    y: -l.height - c,
    ...Ri
  } : i < n && i >= s ? {
    x: 0,
    y: l.height + c,
    ...Ri
  } : {
    x: 0,
    y: 0,
    ...Ri
  };
};
function ox(e, t, n) {
  const r = e[t], i = e[t - 1], o = e[t + 1];
  return r ? n < t ? i ? r.top - (i.top + i.height) : o ? o.top - (r.top + r.height) : 0 : o ? o.top - (r.top + r.height) : i ? r.top - (i.top + i.height) : 0 : 0;
}
const nd = "Sortable", rd = /* @__PURE__ */ Re.createContext({
  activeIndex: -1,
  containerId: nd,
  disableTransforms: !1,
  items: [],
  overIndex: -1,
  useDragOverlay: !1,
  sortedRects: [],
  strategy: ed,
  disabled: {
    draggable: !1,
    droppable: !1
  }
});
function id(e) {
  let {
    children: t,
    id: n,
    items: r,
    strategy: i = ed,
    disabled: o = !1
  } = e;
  const {
    active: s,
    dragOverlay: l,
    droppableRects: c,
    over: u,
    measureDroppableContainers: p
  } = Qu(), d = mi(nd, n), f = l.rect !== null, h = ee(() => r.map((O) => typeof O == "object" && "id" in O ? O.id : O), [r]), g = s != null, C = s ? h.indexOf(s.id) : -1, T = u ? h.indexOf(u.id) : -1, I = Ae(h), A = !rx(h, I.current), S = T !== -1 && C === -1 || A, _ = ix(o);
  Zt(() => {
    A && g && p(h);
  }, [A, h, g, p]), Q(() => {
    I.current = h;
  }, [h]);
  const v = ee(
    () => ({
      activeIndex: C,
      containerId: d,
      disabled: _,
      disableTransforms: S,
      items: h,
      overIndex: T,
      useDragOverlay: f,
      sortedRects: nx(h, c),
      strategy: i
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [C, d, _.draggable, _.droppable, S, h, T, c, f, i]
  );
  return Re.createElement(rd.Provider, {
    value: v
  }, t);
}
const ax = (e) => {
  let {
    id: t,
    items: n,
    activeIndex: r,
    overIndex: i
  } = e;
  return Ka(n, r, i).indexOf(t);
}, sx = (e) => {
  let {
    containerId: t,
    isSorting: n,
    wasDragging: r,
    index: i,
    items: o,
    newIndex: s,
    previousItems: l,
    previousContainerId: c,
    transition: u
  } = e;
  return !u || !r || l !== o && i === s ? !1 : n ? !0 : s !== i && t === c;
}, lx = {
  duration: 200,
  easing: "ease"
}, od = "transform", cx = /* @__PURE__ */ Cn.Transition.toString({
  property: od,
  duration: 0,
  easing: "linear"
}), ux = {
  roleDescription: "sortable"
};
function dx(e) {
  let {
    disabled: t,
    index: n,
    node: r,
    rect: i
  } = e;
  const [o, s] = J(null), l = Ae(n);
  return Zt(() => {
    if (!t && n !== l.current && r.current) {
      const c = i.current;
      if (c) {
        const u = Ir(r.current, {
          ignoreTransform: !0
        }), p = {
          x: c.left - u.left,
          y: c.top - u.top,
          scaleX: c.width / u.width,
          scaleY: c.height / u.height
        };
        (p.x || p.y) && s(p);
      }
    }
    n !== l.current && (l.current = n);
  }, [t, n, r, i]), Q(() => {
    o && s(null);
  }, [o]), o;
}
function ad(e) {
  let {
    animateLayoutChanges: t = sx,
    attributes: n,
    disabled: r,
    data: i,
    getNewIndex: o = ax,
    id: s,
    strategy: l,
    resizeObserverConfig: c,
    transition: u = lx
  } = e;
  const {
    items: p,
    containerId: d,
    activeIndex: f,
    disabled: h,
    disableTransforms: g,
    sortedRects: C,
    overIndex: T,
    useDragOverlay: I,
    strategy: A
  } = Le(rd), S = px(r, h), _ = p.indexOf(s), v = ee(() => ({
    sortable: {
      containerId: d,
      index: _,
      items: p
    },
    ...i
  }), [d, i, _, p]), O = ee(() => p.slice(p.indexOf(s)), [p, s]), {
    rect: j,
    node: M,
    isOver: w,
    setNodeRef: L
  } = GE({
    id: s,
    data: v,
    disabled: S.droppable,
    resizeObserverConfig: {
      updateMeasurementsFor: O,
      ...c
    }
  }), {
    active: P,
    activatorEvent: k,
    activeNodeRect: z,
    attributes: B,
    setNodeRef: q,
    listeners: N,
    isDragging: ne,
    over: ue,
    setActivatorNodeRef: te,
    transform: m
  } = FE({
    id: s,
    data: v,
    attributes: {
      ...ux,
      ...n
    },
    disabled: S.draggable
  }), W = Rm(L, q), H = !!P, y = H && !g && bi(f) && bi(T), X = !I && ne, V = X && y ? m : null, le = y ? V ?? (l ?? A)({
    rects: C,
    activeNodeRect: z,
    activeIndex: f,
    overIndex: T,
    index: _
  }) : null, b = bi(f) && bi(T) ? o({
    id: s,
    items: p,
    activeIndex: f,
    overIndex: T
  }) : _, oe = P == null ? void 0 : P.id, re = Ae({
    activeId: oe,
    items: p,
    newIndex: b,
    containerId: d
  }), ye = p !== re.current.items, Me = t({
    active: P,
    containerId: d,
    isDragging: ne,
    isSorting: H,
    id: s,
    index: _,
    items: p,
    newIndex: re.current.newIndex,
    previousItems: re.current.items,
    previousContainerId: re.current.containerId,
    transition: u,
    wasDragging: re.current.activeId != null
  }), ot = dx({
    disabled: !Me,
    index: _,
    node: M,
    rect: j
  });
  return Q(() => {
    H && re.current.newIndex !== b && (re.current.newIndex = b), d !== re.current.containerId && (re.current.containerId = d), p !== re.current.items && (re.current.items = p);
  }, [H, b, d, p]), Q(() => {
    if (oe === re.current.activeId)
      return;
    if (oe != null && re.current.activeId == null) {
      re.current.activeId = oe;
      return;
    }
    const Ve = setTimeout(() => {
      re.current.activeId = oe;
    }, 50);
    return () => clearTimeout(Ve);
  }, [oe]), {
    active: P,
    activeIndex: f,
    attributes: B,
    data: v,
    rect: j,
    index: _,
    newIndex: b,
    items: p,
    isOver: w,
    isSorting: H,
    isDragging: ne,
    listeners: N,
    node: M,
    overIndex: T,
    over: ue,
    setNodeRef: W,
    setActivatorNodeRef: te,
    setDroppableNodeRef: L,
    setDraggableNodeRef: q,
    transform: ot ?? le,
    transition: Ue()
  };
  function Ue() {
    if (
      // Temporarily disable transitions for a single frame to set up derived transforms
      ot || // Or to prevent items jumping to back to their "new" position when items change
      ye && re.current.newIndex === _
    )
      return cx;
    if (!(X && !xo(k) || !u) && (H || Me))
      return Cn.Transition.toString({
        ...u,
        property: od
      });
  }
}
function px(e, t) {
  var n, r;
  return typeof e == "boolean" ? {
    draggable: e,
    // Backwards compatibility
    droppable: !1
  } : {
    draggable: (n = e == null ? void 0 : e.draggable) != null ? n : t.draggable,
    droppable: (r = e == null ? void 0 : e.droppable) != null ? r : t.droppable
  };
}
Ne.Down, Ne.Right, Ne.Up, Ne.Left;
const hx = ({
  startText: e
}) => /* @__PURE__ */ a.jsx(R, { container: !0, children: /* @__PURE__ */ a.jsx(R, { item: !0, xs: 12, children: e }) }), sd = me.div`
  /* background: #ffffff; */
  display: flex;
  font-size: 14px;
  border: 0;
  min-height: 30px;
  justify-content: space-between;
  line-height: 30px;
  // margin-bottom: 10px;
`;
me(We)`
  &.button-component {
    padding-top: 0;
    padding-bottom: 0;
  }
  &.button-component-icon {
    padding: 2px;
    min-width: 0;
    height: 20px;
    width: 20px;
    margin-left: 6px;
    /* width: 26px; */
  }
`;
const fx = me.div`
  display: inline-block;
  margin-right: 6px;
  // margin-bottom: 6px;
`;
me.div`
  & > *:not(:last-of-type) {
    margin-right: -1px;
  }
  & > *:hover {
    z-index: 2;
  }
`;
const ld = me("div", {
  shouldForwardProp: (e) => e !== "isGroup"
})`
  align-items: center;
  display: flex;
  border-radius: 2px;
  flex-grow: 1;
  font-size: 14px;
  padding: ${({ isGroup: e }) => e ? "0" : "2px"};

  &:hover {
    background-color: ${({ theme: e, isGroup: t }) => t ? "#ffffff" : e.palette.backgroundColor.light};
  }
`, cd = me("div", {
  shouldForwardProp: (e) => e !== "isGroup"
})`
  align-self: flex-start;
  padding-left: 12px;
  line-height: ${({ isGroup: e }) => e ? 30 : 34}px;
`, To = me.div``, So = me.div`
  margin-left: 5px;
  span {
    margin-right: 5px;
  }
`;
me.div`
  margin-left: 5px;
  font-size: 14px;
  font-weight: 500;
  padding-top: 1px;
`;
const mx = me.div`
  font-size: 14px;
  font-weight: 700;
  margin-left: 5px;
  cursor: ${({ existConceptSet: e }) => e ? "pointer" : "default"};
`, ud = it(
  (e) => {
    const { id: t, startText: n, range: r, value: i, updateAttribute: o, viewMode: s } = e, [l, c] = J({
      Op: (i == null ? void 0 : i.Op) || Te.LESS_THAN,
      Value: (r ? i == null ? void 0 : i.StartDate : i == null ? void 0 : i.Value) || null,
      Extent: (r ? i == null ? void 0 : i.EndDate : i == null ? void 0 : i.Extent) || null
    }), { Op: u, Value: p, Extent: d } = l;
    return Q(() => {
      const f = {
        Op: l.Op,
        Value: l.Value
      };
      (u === Te.BETWEEN || u === Te.NOT_BETWEEN) && (f.Extent = l.Extent), (f.Extent === null || u !== Te.BETWEEN && u !== Te.NOT_BETWEEN) && delete f.Extent, f.Value === null && delete f.Value, r && delete f.Op, ke(f, i) || o(t, r ? {
        StartDate: p,
        EndDate: d
      } : f);
    }, [l]), /* @__PURE__ */ a.jsxs(R, { container: !0, alignItems: "center", className: "attribute-date", children: [
      /* @__PURE__ */ a.jsx(R, { item: !0, minWidth: s ? 0 : 175, mr: s ? 0 : 1, children: n }),
      /* @__PURE__ */ a.jsx(R, { item: !0, children: s ? /* @__PURE__ */ a.jsxs(So, { children: [
        /* @__PURE__ */ a.jsx("span", { children: Qs.find((f) => f.value === u).name }),
        /* @__PURE__ */ a.jsx("span", { children: Ys(p) }),
        (u === Te.BETWEEN || u === Te.NOT_BETWEEN) && /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
          /* @__PURE__ */ a.jsx("span", { children: "and" }),
          /* @__PURE__ */ a.jsx("span", { children: Ys(d) })
        ] })
      ] }) : /* @__PURE__ */ a.jsx(To, { children: r ? /* @__PURE__ */ a.jsxs(R, { container: !0, spacing: 1, alignItems: "center", children: [
        /* @__PURE__ */ a.jsx(R, { item: !0, children: "starting:" }),
        /* @__PURE__ */ a.jsx(R, { item: !0, children: /* @__PURE__ */ a.jsx(
          rr,
          {
            fullWidth: !1,
            value: p,
            format: Gt.DATEPICKER_DATE,
            onChange: (f) => {
              c({
                ...l,
                Value: ir(f, Gt.ISO_DATE)
              });
            },
            name: "dateAttrPickerStart"
          }
        ) }),
        /* @__PURE__ */ a.jsx(R, { item: !0, children: "and ending:" }),
        /* @__PURE__ */ a.jsx(R, { item: !0, children: /* @__PURE__ */ a.jsx(
          rr,
          {
            fullWidth: !1,
            value: d,
            format: Gt.DATEPICKER_DATE,
            onChange: (f) => {
              c({
                ...l,
                Extent: ir(f, Gt.ISO_DATE)
              });
            },
            name: "dateAttrPickerEnd"
          }
        ) })
      ] }) : /* @__PURE__ */ a.jsxs(R, { container: !0, spacing: 1, alignItems: "center", children: [
        /* @__PURE__ */ a.jsx(R, { item: !0, children: /* @__PURE__ */ a.jsx(
          Rt,
          {
            className: "",
            fullWidth: !1,
            options: Qs,
            value: u,
            placeholder: "Select option...",
            onChange: (f) => c({ ...l, Op: f }),
            name: "dateAttrSelect"
          }
        ) }),
        /* @__PURE__ */ a.jsx(R, { item: !0, children: /* @__PURE__ */ a.jsx(
          rr,
          {
            fullWidth: !1,
            value: p,
            format: Gt.DATEPICKER_DATE,
            onChange: (f) => {
              c({
                ...l,
                Value: ir(f, Gt.ISO_DATE)
              });
            },
            name: "dateAttrPicker"
          }
        ) }),
        (u === Te.BETWEEN || u === Te.NOT_BETWEEN) && /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
          /* @__PURE__ */ a.jsx(R, { item: !0, children: "and" }),
          /* @__PURE__ */ a.jsx(R, { item: !0, children: /* @__PURE__ */ a.jsx(
            rr,
            {
              fullWidth: !1,
              value: d,
              format: Gt.DATEPICKER_DATE,
              onChange: (f) => {
                c({
                  ...l,
                  Extent: ir(f, Gt.ISO_DATE)
                });
              },
              name: "dateAttrPickerBetween"
            }
          ) })
        ] })
      ] }) }) })
    ] });
  }
), yl = (e, t) => Object.prototype.hasOwnProperty.call(e, t), Ex = (e) => {
  if (!e)
    return "none";
  const t = !!(e.referenceId || e.versionId || e.currentVersionId);
  return !t && !e.terminated ? "none" : e.terminated || t && !e.currentVersionId ? "archived" : e.versionId && e.currentVersionId && e.currentVersionId !== e.versionId ? "outdated" : "none";
}, xx = (e) => {
  var t, n;
  return (e == null ? void 0 : e.ordinal) ?? ((t = e == null ? void 0 : e.data) == null ? void 0 : t.versionOrdinal) ?? ((n = e == null ? void 0 : e.data) == null ? void 0 : n.version) ?? (e == null ? void 0 : e.versionOrdinal) ?? (e == null ? void 0 : e.version) ?? null;
}, wr = ({ label: e, color: t, icon: n }) => {
  const r = {
    warning: {
      backgroundColor: "#fff1dd",
      color: "#f2a53a"
    },
    info: {
      backgroundColor: "#d6eafb",
      color: "#64a7df"
    },
    default: {
      backgroundColor: "#dfdfdf",
      color: "#8f8f8f"
    }
  };
  return /* @__PURE__ */ a.jsxs(
    Y,
    {
      display: "inline-flex",
      alignItems: "center",
      px: 1.25,
      height: 26,
      borderRadius: 1,
      sx: {
        ...r[t],
        lineHeight: 1
      },
      children: [
        n,
        /* @__PURE__ */ a.jsx(fe, { component: "span", fontSize: 14, sx: { lineHeight: 1 }, children: e })
      ]
    }
  );
}, Tl = /* @__PURE__ */ a.jsx(
  Y,
  {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    mr: 0.75,
    width: 16,
    height: 16,
    borderRadius: "50%",
    sx: {
      border: "2px solid currentColor"
    },
    children: /* @__PURE__ */ a.jsx(
      ge,
      {
        iconName: "info",
        sx: {
          color: "inherit",
          fontSize: 16,
          "& circle": {
            fill: "transparent",
            fillOpacity: 1
          }
        }
      }
    )
  }
), Cx = /* @__PURE__ */ a.jsx(ge, { iconName: "reload", sx: { color: "inherit", fontSize: 16, mr: 0.75 } }), gx = /* @__PURE__ */ a.jsx(Ct, { size: 16, sx: { color: "inherit", mr: 0.75 } }), qn = ({
  conceptSet: e,
  viewMode: t = !1,
  onRefresh: n,
  showRefreshOnHover: r = !0,
  marginLeft: i = 1.5
}) => {
  const o = ee(() => Ex(e), [e]), [s, l] = J(null), [c, u] = J(!1), [p, d] = J(!1);
  if (Q(() => {
    let S = !0;
    return (o === "outdated" || o === "archived") && ((e == null ? void 0 : e.versionOrdinal) === void 0 || (e == null ? void 0 : e.versionOrdinal) === null) && ((e == null ? void 0 : e.version) === void 0 || (e == null ? void 0 : e.version) === null) && (e != null && e.versionId) && Iu(e.versionId).then((_) => {
      const v = xx(_);
      S && v !== null && l(v);
    }).catch(() => {
    }), () => {
      S = !1;
    };
  }, [
    e == null ? void 0 : e.version,
    e == null ? void 0 : e.versionId,
    e == null ? void 0 : e.versionOrdinal,
    o
  ]), Q(() => {
    p && d(!1);
  }, [e == null ? void 0 : e.id, e == null ? void 0 : e.versionId, e == null ? void 0 : e.currentVersionId]), !e || o === "none" || o === "outdated" && p)
    return null;
  const f = e.versionOrdinal ?? e.version ?? s, h = f != null, g = !!(!t && o === "outdated" && n && e.currentVersionId), C = e.currentVersionOrdinal, T = /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    "Newer version exists",
    C != null ? ` (latest version: ${C})` : "",
    ",",
    /* @__PURE__ */ a.jsx("br", {}),
    " would you like to REFRESH it?"
  ] }), I = (S) => {
    S.preventDefault(), S.stopPropagation();
  }, A = async (S) => {
    if (S.preventDefault(), S.stopPropagation(), !c) {
      u(!0);
      try {
        await (n == null ? void 0 : n(e)), d(!0);
      } finally {
        u(!1);
      }
    }
  };
  return /* @__PURE__ */ a.jsxs(
    Y,
    {
      display: "inline-flex",
      alignItems: "center",
      flexWrap: "nowrap",
      ml: i,
      sx: {
        whiteSpace: "nowrap",
        alignSelf: "center",
        lineHeight: 1
      },
      children: [
        h && /* @__PURE__ */ a.jsxs(
          fe,
          {
            variant: "subtitle1",
            component: "i",
            sx: { mr: 2, fontWeight: 400, whiteSpace: "nowrap" },
            children: [
              "( Version: ",
              f,
              " )"
            ]
          }
        ),
        o === "archived" && /* @__PURE__ */ a.jsx(
          wr,
          {
            color: "default",
            label: "Archived",
            icon: /* @__PURE__ */ a.jsx(
              ge,
              {
                iconName: "terminated",
                sx: { color: "inherit", fontSize: 16, mr: 0.75 }
              }
            )
          }
        ),
        o === "outdated" && (c ? /* @__PURE__ */ a.jsx(wr, { color: "info", label: "Refreshing", icon: gx }) : g ? /* @__PURE__ */ a.jsx(Xe, { text: T, children: /* @__PURE__ */ a.jsxs(
          Y,
          {
            role: "button",
            tabIndex: 0,
            onClick: A,
            onKeyDown: (S) => {
              (S.key === "Enter" || S.key === " ") && A(S);
            },
            onMouseDown: I,
            onPointerDown: I,
            onTouchStart: I,
            sx: {
              cursor: "pointer",
              display: "inline-flex",
              alignItems: "center",
              lineHeight: 1,
              ...r ? {
                ".refresh-chip": {
                  display: "none"
                },
                "&:hover": {
                  ".outdated-chip": {
                    display: "none"
                  },
                  ".refresh-chip": {
                    display: "inline-flex"
                  }
                }
              } : {}
            },
            children: [
              /* @__PURE__ */ a.jsx(Y, { className: "outdated-chip", sx: { display: "inline-flex" }, children: /* @__PURE__ */ a.jsx(
                wr,
                {
                  color: "warning",
                  label: "Outdated",
                  icon: Tl
                }
              ) }),
              r && /* @__PURE__ */ a.jsx(Y, { className: "refresh-chip", sx: { display: "inline-flex" }, children: /* @__PURE__ */ a.jsx(
                wr,
                {
                  color: "info",
                  label: "Refresh",
                  icon: Cx
                }
              ) })
            ]
          }
        ) }) : /* @__PURE__ */ a.jsx(wr, { color: "warning", label: "Outdated", icon: Tl }))
      ]
    }
  );
}, yx = (e) => {
  const {
    startText: t,
    defaultTitle: n,
    updateAttribute: r,
    value: i,
    subModules: o,
    conceptSets: s,
    typeContainer: l,
    parentId: c,
    updateConceptSets: u,
    refreshConceptSetReference: p,
    embeddedReferenceOnly: d,
    viewMode: f,
    isExclusion: h,
    id: g
  } = e, C = d || l === he.LIBRARY, T = (B) => typeof B == "number" ? B >= 0 : B.trim() !== "" && B !== "-1", I = (B) => {
    if (!ko(B))
      return typeof B == "number" ? B >= 0 ? B : -1 : C && typeof B == "string" && B.trim() ? B : -1;
    const q = B;
    return typeof q.CodesetId == "number" ? q.CodesetId : typeof q.codesetId == "number" ? q.codesetId : C && typeof q.CodesetId == "string" ? q.CodesetId.trim() ? q.CodesetId : -1 : C && typeof q.codesetId == "string" && q.codesetId.trim() ? q.codesetId : -1;
  }, A = (B) => {
    if (!ko(B))
      return !1;
    const q = B;
    return typeof q.isExclusion == "boolean" ? q.isExclusion : typeof q.IsExclusion == "boolean" ? q.IsExclusion : !1;
  }, { openModal: S, closeModal: _ } = Le(gn), [v, O] = J(
    I(i)
  ), [j, M] = J(A(i)), w = Yi(v, s), L = () => {
    S(
      () => /* @__PURE__ */ a.jsx(a.Fragment, { children: /* @__PURE__ */ a.jsx(
        o.concept,
        {
          type: "component",
          name: "view-concept-set-button",
          subModules: o,
          config: {
            conceptSets: s,
            conceptSetId: v
          }
        }
      ) }),
      "View concept set",
      {
        closeOnClickOutside: !0,
        onClose: _,
        width: "1000px"
      }
    );
  };
  Q(() => {
    const B = I(i), q = A(i);
    if (h) {
      if (!T(v)) {
        i !== null && r(g, null);
        return;
      }
      (B !== v || q !== j || !ko(i)) && r(g, {
        CodesetId: v,
        IsExclusion: !!j
      });
    } else
      B !== v && r(g, v);
  }, [v, j]);
  const P = () => {
    O(-1);
  }, k = (B, q) => {
    O(B.id ?? -1), q && u([...s, B]);
  }, z = () => {
    M(!j);
  };
  return /* @__PURE__ */ a.jsxs(R, { container: !0, alignItems: "center", className: "attribute-dropdown", children: [
    /* @__PURE__ */ a.jsx(R, { item: !0, minWidth: f ? 0 : 175, mr: f ? 0 : 1, children: t }),
    h && !f && /* @__PURE__ */ a.jsx(R, { item: !0, mr: 1, children: /* @__PURE__ */ a.jsx(
      We,
      {
        onClick: z,
        fullWidth: !1,
        variant: "outlined",
        name: "exclude",
        children: j ? "is not any of" : "is any of"
      }
    ) }),
    /* @__PURE__ */ a.jsx(R, { item: !0, children: f ? /* @__PURE__ */ a.jsxs(Y, { display: "flex", alignItems: "center", flexWrap: "nowrap", children: [
      /* @__PURE__ */ a.jsx(
        mx,
        {
          existConceptSet: T(v),
          onClick: T(v) ? L : () => {
          },
          children: T(v) ? w == null ? void 0 : w.name : n
        }
      ),
      /* @__PURE__ */ a.jsx(
        qn,
        {
          conceptSet: w,
          viewMode: f,
          onRefresh: p
        }
      )
    ] }) : /* @__PURE__ */ a.jsxs(Y, { display: "flex", alignItems: "center", flexWrap: "nowrap", children: [
      /* @__PURE__ */ a.jsx(
        o.concept,
        {
          type: "component",
          name: "widget-concept-set-choose-button",
          subModules: o,
          config: {
            conceptSets: s,
            defaultValue: n,
            conceptSetId: v,
            onUpdate: k,
            onClear: P,
            typeContainer: l,
            parentId: c,
            localImport: !0,
            embeddedReferenceOnly: d,
            dense: !1
          }
        }
      ),
      /* @__PURE__ */ a.jsx(
        qn,
        {
          conceptSet: w,
          viewMode: f,
          onRefresh: p
        }
      )
    ] }) })
  ] });
}, Tx = (e) => {
  const {
    updateAttribute: t,
    value: n,
    subModules: r,
    conceptSets: i,
    updateConceptSets: o,
    viewMode: s,
    typeContainer: l,
    parentId: c,
    id: u,
    criteriaName: p,
    conceptSetName: d,
    refreshConceptSetReference: f,
    embeddedReferenceOnly: h
  } = e, g = (C) => {
    t(u, C);
  };
  return /* @__PURE__ */ a.jsx(
    Ar,
    {
      extend: !0,
      subModules: r,
      value: n,
      conceptSets: i,
      updateConceptSets: o,
      updateModel: g,
      viewMode: s,
      typeContainer: l,
      parentId: c,
      attrGroup: !0,
      groupTitleText: `Group criteria of ${p}`,
      hasAction: !s,
      conceptSetName: d,
      refreshConceptSetReference: f,
      embeddedReferenceOnly: h
    }
  );
}, Sx = (e) => {
  const { id: t, startText: n, value: r, updateAttribute: i, viewMode: o, defaultOp: s } = e, [l, c] = J({
    Op: (r == null ? void 0 : r.Op) || s || mn.CONTAINING,
    Text: (r == null ? void 0 : r.Text) || null
  }), { Op: u, Text: p } = l;
  return Q(() => {
    const d = {
      Op: l.Op,
      Text: l.Text
    };
    d.Text === null && delete d.Text, ke(d, r) || i(t, d);
  }, [l]), /* @__PURE__ */ a.jsxs(R, { container: !0, alignItems: "center", className: "attribute-text", children: [
    /* @__PURE__ */ a.jsx(R, { item: !0, minWidth: o ? 0 : 175, mr: o ? 0 : 1, children: n }),
    /* @__PURE__ */ a.jsx(R, { item: !0, children: o ? /* @__PURE__ */ a.jsxs(So, { children: [
      /* @__PURE__ */ a.jsx("span", { children: el.find((d) => d.value === u).name }),
      /* @__PURE__ */ a.jsx("span", { children: p })
    ] }) : /* @__PURE__ */ a.jsx(To, { children: /* @__PURE__ */ a.jsxs(R, { container: !0, spacing: 1, alignItems: "center", children: [
      /* @__PURE__ */ a.jsx(R, { item: !0, children: /* @__PURE__ */ a.jsx(
        Rt,
        {
          className: "",
          options: el,
          value: u,
          placeholder: "Select option...",
          onChange: (d) => c({ ...l, Op: d }),
          fullWidth: !0,
          name: "textAttrSelect"
        }
      ) }),
      /* @__PURE__ */ a.jsx(R, { item: !0, children: /* @__PURE__ */ a.jsx(
        Je,
        {
          type: "text",
          fullWidth: !0,
          value: p,
          onChange: (d) => c({ ...l, Text: d.target.value }),
          name: "textAttrInput"
        }
      ) })
    ] }) }) })
  ] });
}, Qa = (e) => {
  const {
    id: t,
    startText: n,
    value: r,
    updateAttribute: i,
    viewMode: o,
    endText: s,
    defaultOp: l
  } = e, c = r || {}, [u, p] = J({
    Op: c.Op || l || Te.GREATER_THAN,
    Value: c.Value != null && +c.Value >= 0 ? +c.Value : null,
    Extent: c.Extent != null && +c.Extent >= 0 ? +c.Extent : null
  }), { Op: d, Value: f, Extent: h } = u;
  return Q(() => {
    const g = {
      Op: u.Op,
      Value: u.Value != null && +(u == null ? void 0 : u.Value) >= 0 ? +(u == null ? void 0 : u.Value) : null,
      Extent: (u == null ? void 0 : u.Extent) != null && +(u == null ? void 0 : u.Extent) >= 0 ? +(u == null ? void 0 : u.Extent) : null
    };
    (g.Extent === null || d !== Te.BETWEEN && d !== Te.NOT_BETWEEN) && delete g.Extent, g.Value === null && delete g.Value, ke(g, r) || i(t, g);
  }, [u]), /* @__PURE__ */ a.jsxs(R, { container: !0, alignItems: "center", className: "attribute-value", children: [
    /* @__PURE__ */ a.jsx(R, { item: !0, minWidth: o ? 0 : 175, mr: o ? 0 : 1, children: n }),
    /* @__PURE__ */ a.jsx(R, { item: !0, children: o ? /* @__PURE__ */ a.jsxs(So, { children: [
      /* @__PURE__ */ a.jsx("span", { children: Zs.find((g) => g.value === d).name }),
      /* @__PURE__ */ a.jsx("span", { children: f }),
      (d === Te.BETWEEN || d === Te.NOT_BETWEEN) && /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
        /* @__PURE__ */ a.jsx("span", { children: "and" }),
        /* @__PURE__ */ a.jsx("span", { children: h }),
        s && /* @__PURE__ */ a.jsx("span", { children: "days" })
      ] })
    ] }) : /* @__PURE__ */ a.jsx(To, { children: /* @__PURE__ */ a.jsxs(R, { container: !0, spacing: 1, alignItems: "center", children: [
      /* @__PURE__ */ a.jsx(R, { item: !0, children: /* @__PURE__ */ a.jsx(
        Rt,
        {
          className: "valueAttrSelect",
          options: Zs,
          value: d,
          placeholder: "Select option...",
          onChange: (g) => p({
            ...u,
            Op: g,
            Extent: [
              Te.BETWEEN,
              Te.NOT_BETWEEN
            ].includes(g) ? 1 : null
          }),
          name: "valueAttrSelect",
          id: "valueAttrSelect" + t
        }
      ) }),
      /* @__PURE__ */ a.jsx(R, { item: !0, children: /* @__PURE__ */ a.jsx(
        Je,
        {
          type: "text",
          value: f,
          onChange: (g) => p({ ...u, Value: g.target.value }),
          name: "valueAttrText",
          id: "valueAttrText" + t,
          className: "valueAttrText"
        }
      ) }),
      (d === Te.BETWEEN || d === Te.NOT_BETWEEN) && /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
        /* @__PURE__ */ a.jsx(R, { item: !0, children: "and" }),
        /* @__PURE__ */ a.jsx(R, { item: !0, children: /* @__PURE__ */ a.jsx(
          Je,
          {
            type: "text",
            value: h,
            onChange: (g) => p({ ...u, Extent: g.target.value }),
            name: "valueAttrExtent",
            id: "valueAttrExtent" + t,
            className: "valueAttrExtent"
          }
        ) })
      ] }),
      s && /* @__PURE__ */ a.jsx(R, { item: !0, children: "days" })
    ] }) }) })
  ] });
}, Ix = (e) => {
  const {
    name: t,
    startText: n,
    extend: r,
    domainId: i,
    standardConcept: o,
    value: s,
    updateAttribute: l,
    subModules: c,
    viewMode: u,
    id: p
  } = e, d = s || [], [f, h] = J(
    (r && d.baseValue ? d.baseValue : d) || []
  ), [g, C] = J(
    r ? d[`${p}Exclude`] || !1 : void 0
  );
  Q(() => {
    if (r) {
      const S = d.baseValue || d;
      (!ke(S, f) || g != d[`${p}Exclude`]) && l(p, {
        baseValue: f,
        [`${p}Exclude`]: g
      });
    } else
      ke(s, f) || l(p, f);
  }, [f, g]);
  const T = () => {
    C(!g);
  }, I = (S) => {
    const _ = f.filter(
      (v) => v.CONCEPT_ID !== S.CONCEPT_ID
    );
    h(_);
  }, A = (S) => {
    h((_) => zh(_, S, "CONCEPT_ID"));
  };
  return /* @__PURE__ */ a.jsxs(
    R,
    {
      container: !0,
      spacing: 1,
      alignItems: "center",
      className: "attribute-vocabulary",
      children: [
        /* @__PURE__ */ a.jsx(
          R,
          {
            item: !0,
            minWidth: u ? 0 : 175,
            mr: u ? 0 : 1,
            className: "start-text",
            children: n
          }
        ),
        r && !u && /* @__PURE__ */ a.jsx(R, { item: !0, children: /* @__PURE__ */ a.jsx(
          We,
          {
            onClick: T,
            fullWidth: !1,
            variant: "outlined",
            name: "exclude",
            children: g ? "is not any of" : "is any of"
          }
        ) }),
        u ? f.map((S, _) => /* @__PURE__ */ a.jsxs(R, { item: !0, fontWeight: "bold", children: [
          S.CONCEPT_NAME,
          _ !== f.length - 1 ? ", " : ""
        ] }, S.CONCEPT_ID)) : /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
          f.length > 0 && /* @__PURE__ */ a.jsx(R, { item: !0, children: f.map((S) => /* @__PURE__ */ a.jsx(fx, { children: /* @__PURE__ */ a.jsx(
            Ih,
            {
              label: S.CONCEPT_NAME,
              variant: "outlined",
              color: "primary",
              classes: {
                root: "chip",
                outlined: "chip-outlined",
                deleteIcon: "chip-delete-outlined"
              },
              deleteIcon: /* @__PURE__ */ a.jsx(ge, { iconName: "close", sx: { fontSize: 14 } }),
              onDelete: u ? void 0 : () => I(S)
            }
          ) }, S.CONCEPT_ID)) }),
          /* @__PURE__ */ a.jsx(R, { item: !0, children: /* @__PURE__ */ a.jsx(
            c.vocabulary,
            {
              type: "component",
              name: "add-import-concepts-widget",
              subModules: c,
              config: {
                domainId: i,
                standardConcept: o,
                onAddConcepts: A
              }
            }
          ) })
        ] })
      ]
    }
  );
}, Ax = (e) => {
  const { id: t, startText: n, value: r, updateAttribute: i, viewMode: o } = e, [s, l] = J({
    EndOffset: (r == null ? void 0 : r.EndOffset) || 0,
    EndWith: (r == null ? void 0 : r.EndWith) || "END_DATE",
    StartOffset: (r == null ? void 0 : r.StartOffset) || 0,
    StartWith: (r == null ? void 0 : r.StartWith) || "START_DATE"
  });
  return Q(() => {
    ke(s, r) || i(t, s);
  }, [s]), /* @__PURE__ */ a.jsxs(R, { container: !0, alignItems: "center", className: "attribute-range", children: [
    /* @__PURE__ */ a.jsx(R, { item: !0, minWidth: o ? 0 : 175, mr: o ? 0 : 1, children: n }),
    /* @__PURE__ */ a.jsx(R, { item: !0, children: o ? /* @__PURE__ */ a.jsx(So, {}) : /* @__PURE__ */ a.jsx(To, { children: /* @__PURE__ */ a.jsxs(R, { container: !0, spacing: 1, alignItems: "center", children: [
      /* @__PURE__ */ a.jsx(R, { item: !0, children: "starting with" }),
      /* @__PURE__ */ a.jsx(R, { item: !0, children: /* @__PURE__ */ a.jsx(
        Rt,
        {
          className: "StartWith",
          options: tl,
          value: s.StartWith,
          placeholder: "Select option...",
          onChange: (c) => l({ ...s, StartWith: c }),
          name: "StartWith",
          id: "StartWith" + t
        }
      ) }),
      /* @__PURE__ */ a.jsx(R, { item: !0, children: "+" }),
      /* @__PURE__ */ a.jsx(R, { item: !0, xs: 2, children: /* @__PURE__ */ a.jsx(
        Je,
        {
          type: "text",
          value: s.StartOffset,
          onChange: (c) => l({ ...s, StartOffset: +c.target.value }),
          name: "StartOffset",
          id: "StartOffset" + t,
          className: "valueAttrText"
        }
      ) }),
      /* @__PURE__ */ a.jsx(R, { item: !0, children: "days" }),
      /* @__PURE__ */ a.jsx(R, { item: !0, children: "and" }),
      /* @__PURE__ */ a.jsx(R, { item: !0, children: "ending with" }),
      /* @__PURE__ */ a.jsx(R, { item: !0, children: /* @__PURE__ */ a.jsx(
        Rt,
        {
          className: "EndWith",
          options: tl,
          value: s.EndWith,
          placeholder: "Select option...",
          onChange: (c) => l({ ...s, EndWith: c }),
          name: "EndWith",
          id: "EndWith" + t
        }
      ) }),
      /* @__PURE__ */ a.jsx(R, { item: !0, children: "+" }),
      /* @__PURE__ */ a.jsx(R, { item: !0, xs: 2, children: /* @__PURE__ */ a.jsx(
        Je,
        {
          type: "text",
          value: s.EndOffset,
          onChange: (c) => l({ ...s, EndOffset: +c.target.value }),
          name: "EndOffset",
          id: "EndOffset" + t,
          className: "valueAttrText"
        }
      ) }),
      /* @__PURE__ */ a.jsx(R, { item: !0, children: "days" })
    ] }) }) })
  ] });
}, bx = {
  "Observation period:": [
    "First",
    "PeriodStartDate",
    "PeriodEndDate",
    "AgeAtStart",
    "AgeAtEnd"
  ],
  "Payer plan period:": ["AgeAtStart", "AgeAtEnd"],
  "Observation:": ["VisitType"],
  "Procedure occurrence:": ["VisitType"],
  "Condition Occurrence:": ["VisitType"],
  "Device Exposure:": ["VisitType"],
  "Drug Exposure:": ["VisitType"],
  "Measurement:": ["VisitType"]
}, Rx = {
  "Observation:": ["VisitType"],
  "Procedure occurrence:": ["VisitType"],
  "Visit:": [],
  "Condition Occurrence:": ["VisitType"],
  "Device Exposure:": ["VisitType"],
  "Drug Exposure:": ["VisitType"],
  "Measurement:": ["VisitType"]
}, Oi = (e, t) => {
  const n = bx[e];
  return n ? !!n.includes(t) : !1;
}, Ox = (e, t) => {
  const n = Rx[e];
  return n ? !n.includes(t) : !0;
}, vx = it((e) => {
  const {
    attribute: t,
    details: n,
    subModules: r,
    updateAttribute: i,
    conceptSets: o,
    updateConceptSets: s,
    refreshConceptSetReference: l,
    embeddedReferenceOnly: c,
    removeAttribute: u,
    viewMode: p,
    typeContainer: d,
    parentId: f,
    criteriaName: h,
    conceptSetName: g
  } = e, { id: C, name: T, value: I } = t, {
    type: A,
    startText: S,
    domainId: _,
    standardConcept: v,
    extend: O,
    defaultParam: j,
    range: M,
    endText: w,
    altStartText: L,
    defaultOp: P,
    isExclusion: k
  } = n;
  return /* @__PURE__ */ a.jsxs(sd, { children: [
    /* @__PURE__ */ a.jsxs(
      ld,
      {
        isGroup: n.type === F.GROUP,
        children: [
          n.type === F.BOOL && /* @__PURE__ */ a.jsx(
            hx,
            {
              startText: Oi(h, C) ? L : S
            }
          ),
          n.type === F.RANGE && /* @__PURE__ */ a.jsx(
            Ax,
            {
              id: C,
              name: T,
              type: A,
              startText: S,
              value: I,
              subModules: r,
              updateAttribute: i,
              viewMode: p,
              endText: w
            }
          ),
          n.type === F.DATE && /* @__PURE__ */ a.jsx(
            ud,
            {
              id: C,
              name: T,
              type: A,
              startText: Oi(h, C) ? L : S,
              value: I,
              subModules: r,
              updateAttribute: i,
              viewMode: p,
              range: M
            }
          ),
          n.type === F.VALUE && /* @__PURE__ */ a.jsx(
            Qa,
            {
              id: C,
              name: T,
              type: A,
              startText: Oi(h, C) ? L : S,
              value: I,
              subModules: r,
              updateAttribute: i,
              viewMode: p,
              endText: w,
              defaultOp: P
            }
          ),
          n.type === F.TEXT && /* @__PURE__ */ a.jsx(
            Sx,
            {
              id: C,
              name: T,
              type: A,
              startText: S,
              value: I,
              subModules: r,
              updateAttribute: i,
              viewMode: p,
              defaultOp: P
            }
          ),
          n.type === F.VOCABULARY && /* @__PURE__ */ a.jsx(
            Ix,
            {
              id: C,
              name: T,
              startText: Oi(h, C) ? L : S,
              value: I,
              subModules: r,
              updateAttribute: i,
              domainId: _,
              standardConcept: v,
              viewMode: p,
              extend: O && Ox(h, C)
            }
          ),
          n.type === F.DROPDOWN && /* @__PURE__ */ a.jsx(
            yx,
            {
              id: C,
              name: T,
              type: A,
              startText: S,
              value: I,
              subModules: r,
              defaultTitle: j.name,
              updateAttribute: i,
              conceptSets: o,
              updateConceptSets: s,
              refreshConceptSetReference: l,
              embeddedReferenceOnly: c,
              typeContainer: d,
              parentId: f,
              viewMode: p,
              isExclusion: k
            }
          ),
          n.type === F.GROUP && /* @__PURE__ */ a.jsx(
            Tx,
            {
              id: C,
              name: T,
              type: A,
              startText: S,
              value: t.value,
              subModules: r,
              updateAttribute: i,
              conceptSets: o,
              updateConceptSets: s,
              refreshConceptSetReference: l,
              typeContainer: d,
              parentId: f,
              viewMode: p,
              criteriaName: h,
              conceptSetName: g,
              embeddedReferenceOnly: c
            }
          )
        ]
      }
    ),
    !p && /* @__PURE__ */ a.jsx(
      cd,
      {
        isGroup: n.type === F.GROUP,
        children: /* @__PURE__ */ a.jsx(
          Cr,
          {
            size: "small",
            onClick: () => {
              u(C);
            },
            color: "primary",
            iconName: "close",
            noExpand: !0,
            name: "closeCriteriaButton"
          }
        )
      }
    )
  ] });
}), Dx = (e, t) => {
  var n;
  switch (e) {
    case F.BOOL:
      return !1;
    case F.DATE:
    case F.VALUE:
      return !t || t.Value === null;
    case F.TEXT:
      return !t || t.Text === null;
    case F.VOCABULARY:
      return !t || t.length === 0 || ((n = t == null ? void 0 : t.baseValue) == null ? void 0 : n.length) === 0;
    case F.DROPDOWN:
      return t === null;
  }
}, _x = (e) => {
  const {
    initialAttributes: t,
    extend: n,
    subModules: r,
    sortBy: i,
    updateModel: o,
    conceptSets: s,
    updateConceptSets: l,
    refreshConceptSetReference: c,
    embeddedReferenceOnly: u,
    viewMode: p,
    addedDropdownAttribute: d,
    typeContainer: f,
    parentId: h,
    criteriaName: g,
    cleanDropdownAttribute: C,
    conceptSetName: T
  } = e, {
    attributes: I,
    isStartHook: A,
    addAttribute: S,
    updateAttribute: _,
    removeAttribute: v
  } = Sf(t);
  return Q(() => {
    A && !ke(I, t) && o(I);
  }, [I]), Q(() => {
    d && (S(d), C());
  }, [d]), A ? /* @__PURE__ */ a.jsx(a.Fragment, { children: Object.keys(I).length > 0 && /* @__PURE__ */ a.jsx(
    R,
    {
      item: !0,
      xs: 12,
      sx: {
        borderTop: p && g != "Demographic:" ? "0px dashed" : "1px dashed",
        borderColor: "borderColor.main",
        padding: p ? "0 8px" : 1
      },
      children: /* @__PURE__ */ a.jsx(
        R,
        {
          container: !0,
          spacing: p ? 0 : 0.5,
          className: "cohort-definition-attributes-list",
          children: i == null ? void 0 : i(Object.keys(I)).filter((O) => {
            if (p) {
              const j = I[O], M = mr[j.id];
              return !Dx(M.type, j.value);
            } else
              return !0;
          }).map((O) => /* @__PURE__ */ a.jsx(
            R,
            {
              item: !0,
              xs: 12,
              className: "cohort-definition-attributes-item",
              children: /* @__PURE__ */ a.jsx(
                vx,
                {
                  attribute: I[O],
                  details: mr[I[O].id],
                  subModules: r,
                  updateAttribute: _,
                  conceptSets: s,
                  updateConceptSets: l,
                  refreshConceptSetReference: c,
                  embeddedReferenceOnly: u,
                  removeAttribute: v,
                  viewMode: p,
                  typeContainer: f,
                  parentId: h,
                  criteriaName: g,
                  conceptSetName: T
                }
              )
            },
            O
          ))
        }
      )
    }
  ) }) : /* @__PURE__ */ a.jsx(Qt, { children: /* @__PURE__ */ a.jsx(Ct, { size: 32 }) });
}, Nx = me.div`
  font-size: 14px;
  margin-right: 8px;
`, wx = me.div``, dd = me.div`
  font-size: 14px;
  font-weight: 700;
  cursor: ${({ existConceptSet: e }) => e ? "pointer" : "default"};
`, Px = me.div`
  display: flex;
`, Za = ({ sx: e, children: t, className: n, viewMode: r, disableBorder: i, ...o }) => {
  const s = Ah(), l = {
    border: "1px dashed",
    borderColor: "borderColor.main",
    borderRadius: 1,
    transition: "border-color 500ms"
  }, c = {
    border: "1px solid",
    borderColor: "info.main",
    borderRadius: 1,
    transition: "all 500ms",
    boxShadow: "0px 0px 0px 1px " + s.palette.info.main
  }, [u, p] = J(l);
  return /* @__PURE__ */ a.jsx(
    R,
    {
      ...o,
      className: "criteria-content-wrapper " + (n || ""),
      sx: [u, ...Array.isArray(e) ? e : [e]],
      onMouseOver: (d) => {
        d.stopPropagation(), !r && !i && p(c);
      },
      onMouseOut: (d) => {
        d.stopPropagation(), !r && !i && p(l);
      },
      children: t
    }
  );
}, pd = ({
  viewMode: e,
  onRemove: t,
  iconName: n,
  title: r,
  children: i,
  baseText: o,
  hideRemove: s
}) => /* @__PURE__ */ a.jsx(
  Y,
  {
    sx: {
      padding: "6px 8px",
      fontSize: 14,
      // questionable
      bgcolor: o && !r || e ? "transparent" : "backgroundColor.main",
      borderRadius: "inherit"
    },
    className: "criteria-title-wrapper",
    children: /* @__PURE__ */ a.jsxs(R, { container: !0, alignItems: "center", justifyContent: "space-between", children: [
      r && /* @__PURE__ */ a.jsxs(
        R,
        {
          item: !0,
          fontWeight: 700,
          display: "flex",
          alignItems: "center",
          pr: e ? 0 : 1,
          children: [
            /* @__PURE__ */ a.jsx(
              bh,
              {
                iconName: n,
                sx: { display: "inline-flex", pr: 1, fontSize: 28 }
              }
            ),
            !e && r
          ]
        }
      ),
      o && /* @__PURE__ */ a.jsx(R, { item: !0, display: "flex", alignItems: "center", fontSize: 14, pr: 1, children: o }),
      /* @__PURE__ */ a.jsx(R, { item: !0, flexGrow: 1, children: i }),
      !e && !s && /* @__PURE__ */ a.jsx(R, { item: !0, pl: 1, children: /* @__PURE__ */ a.jsx(
        Cr,
        {
          onClick: t,
          color: "primary",
          iconName: "delete",
          noExpand: !0,
          name: "closeCriteriaButton"
        }
      ) })
    ] })
  }
), Sl = it((e) => {
  const {
    extend: t,
    criteria: n,
    details: r,
    subModules: i,
    updateCriteriaAttributes: o,
    updateCriteriaCodeSetId: s,
    removeCriteria: l,
    conceptSets: c,
    updateConceptSets: u,
    refreshConceptSetReference: p,
    embeddedReferenceOnly: d,
    typeContainer: f,
    parentId: h,
    viewMode: g,
    attrGroup: C,
    hasAction: T
  } = e, { id: I, codesetId: A } = n, { openModal: S, closeModal: _ } = Le(gn), [v, O] = J(A), [j, M] = J(
    Wh(
      n.attributes,
      mr
    )
  ), [w, L] = J(), P = v != null && v !== "" && v !== -1, k = ee(
    () => Yi(v, c),
    [v, c]
  ), z = ee(
    () => k || (P ? {
      id: v,
      name: r.defaultValue,
      expression: { items: [] },
      terminated: !0
    } : void 0),
    [v, r.defaultValue, P, k]
  ), B = ee(() => eu(
    r.attributes,
    lu,
    Object.keys(j)
  ), [r, j]), q = () => {
    O(-1);
  }, N = ee(() => {
    var W;
    const m = ((W = Yi(v, c)) == null ? void 0 : W.name) || r.defaultValue;
    return `${r.baseTextViewMode} ${m}`;
  }, [v, c]), ne = (m) => {
    L(m);
  }, ue = (m, W) => {
    const H = m.id ?? -1;
    O(H), W && u([...c, m]);
  };
  Q(() => {
    A !== v && O(A);
  }, [A]);
  const te = () => {
    S(
      () => /* @__PURE__ */ a.jsx(a.Fragment, { children: /* @__PURE__ */ a.jsx(
        i.concept,
        {
          type: "component",
          name: "view-concept-set-button",
          subModules: i,
          config: {
            conceptSets: c,
            conceptSetId: v
          }
        }
      ) }),
      "View concept set",
      {
        closeOnClickOutside: !0,
        onClose: _,
        width: "1000px"
      }
    );
  };
  return Q(() => {
    v !== A && s(I, v);
  }, [v]), Q(() => {
    const m = Yh(j);
    m && !ke(m, n.attributes) && o(I, m);
  }, [j]), /* @__PURE__ */ a.jsx(
    R,
    {
      container: !0,
      width: `calc(100% + ${T ? 36 : 0}px)`,
      mb: g && n.name != "Demographic" ? 0 : 1,
      children: /* @__PURE__ */ a.jsxs(
        Za,
        {
          item: !0,
          xs: 12,
          className: "cohort-definition-criteria-item",
          viewMode: n.name != "Demographic" ? g : !1,
          disableBorder: g && n.name === "Demographic",
          sx: g ? n.name != "Demographic" ? {
            border: "none",
            padding: "0px",
            "> .criteria-title-wrapper": {
              padding: "0px 10px"
            }
          } : {} : {},
          children: [
            /* @__PURE__ */ a.jsx(
              pd,
              {
                viewMode: g,
                iconName: n.name,
                title: !t || !r.extend ? r.titleText : void 0,
                baseText: r.baseText,
                hideRemove: t && n.name != "Demographic",
                onRemove: () => l(n.id),
                children: /* @__PURE__ */ a.jsxs(
                  R,
                  {
                    item: !0,
                    xs: !0,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    lineHeight: "30px",
                    minWidth: 0,
                    children: [
                      g ? /* @__PURE__ */ a.jsxs(
                        Y,
                        {
                          display: "flex",
                          alignItems: "center",
                          flexWrap: "nowrap",
                          minWidth: 0,
                          children: [
                            /* @__PURE__ */ a.jsx(
                              dd,
                              {
                                existConceptSet: P,
                                onClick: k ? te : () => {
                                },
                                children: P && (k == null ? void 0 : k.name) || r.defaultValue
                              }
                            ),
                            /* @__PURE__ */ a.jsx(
                              qn,
                              {
                                conceptSet: z,
                                viewMode: g,
                                onRefresh: p
                              }
                            )
                          ]
                        }
                      ) : /* @__PURE__ */ a.jsxs(
                        Y,
                        {
                          display: "flex",
                          alignItems: "center",
                          flexWrap: "nowrap",
                          minWidth: 0,
                          children: [
                            /* @__PURE__ */ a.jsx(wx, { children: r.defaultValue && /* @__PURE__ */ a.jsx(
                              i.concept,
                              {
                                type: "component",
                                name: "widget-concept-set-choose-button",
                                subModules: i,
                                config: {
                                  conceptSets: c,
                                  defaultValue: r.defaultValue,
                                  conceptSetId: v,
                                  onUpdate: ue,
                                  onClear: q,
                                  typeContainer: f,
                                  parentId: h,
                                  localImport: !0,
                                  embeddedReferenceOnly: d
                                }
                              }
                            ) }),
                            /* @__PURE__ */ a.jsx(
                              qn,
                              {
                                conceptSet: z,
                                viewMode: g,
                                onRefresh: p
                              }
                            )
                          ]
                        }
                      ),
                      /* @__PURE__ */ a.jsx(R, { item: !0, children: !g && B.length > 0 && /* @__PURE__ */ a.jsx(
                        vn,
                        {
                          options: B,
                          onClick: ne,
                          variant: "outlined",
                          title: "Attribute",
                          name: "Attribute",
                          closeOnSelect: !0,
                          preventOverflow: !0,
                          startIcon: /* @__PURE__ */ a.jsx(
                            ge,
                            {
                              iconName: "add",
                              sx: { "&.MuiSvgIcon-root": { fontSize: 16 } }
                            }
                          ),
                          endIcon: /* @__PURE__ */ a.jsx(ge, { fontSize: "small", iconName: "chevronFilled" })
                        }
                      ) })
                    ]
                  }
                )
              }
            ),
            /* @__PURE__ */ a.jsx(
              _x,
              {
                initialAttributes: j,
                addedDropdownAttribute: w,
                cleanDropdownAttribute: () => L(void 0),
                subModules: i,
                updateModel: M,
                sortBy: (m) => Hh(r.attributesSort, m),
                conceptSets: c,
                updateConceptSets: u,
                refreshConceptSetReference: p,
                embeddedReferenceOnly: d,
                typeContainer: f,
                parentId: h,
                viewMode: g,
                criteriaName: r.titleText,
                conceptSetName: N
              }
            )
          ]
        }
      )
    }
  );
}), ut = me.span`
  // margin: 0 4px;
`, un = me.div`
  margin-right: 5px;
  margin-left: 5px;
`, Il = me.label`
  display: flex;
  padding: 0px 6px;
  font-size: 14px;
  white-space: nowrap;
  align-items: center;
  > span {
    margin-right: 10px;
  }
`, jx = me.div`
  align-self: baseline;
`;
me.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  padding: 10px;
  font-size: 14px;
`;
me.div`
  padding: 3px;
`;
me.span`
  margin-left: 7px;
`;
me.div`
  /* margin-right: 10px; */
`;
const Al = me.div`
  display: inline-block;
  font-size: 14px;
  /* margin-top: -75px; */
  position: relative;
  top: -7px;
`, Lx = me.div`
  border-radius: 2px;
  padding: 8px;
  display: flex;
  flex-direction: row;
  font-size: 14px;
  /* background-color: ${({ theme: e, isGroup: t }) => e.palette.backgroundColor.dark}; */

  border-radius: 2px;
  padding: ${({ isGroup: e }) => e ? "0" : "4px 10px"};
  font-size: 14px;
  // margin-bottom: 4px;
`, kx = it((e) => {
  const { updateModel: t, type: n, value: r, viewMode: i, first: o } = e, [s, l] = J(r), { IsDistinct: c, Type: u, Count: p, CountColumn: d } = s;
  return Q(() => {
    ke(s, r) || t(s);
  }, [s]), /* @__PURE__ */ a.jsxs(
    R,
    {
      container: !0,
      className: "extend-criteria-occurrence",
      alignItems: "center",
      fontSize: 14,
      spacing: 0.5,
      children: [
        !o && /* @__PURE__ */ a.jsx(R, { item: !0, children: /* @__PURE__ */ a.jsx(ut, { children: n === "ALL" ? "and" : "or" }) }),
        /* @__PURE__ */ a.jsx(R, { item: !0, children: /* @__PURE__ */ a.jsx(ut, { children: "with" }) }),
        /* @__PURE__ */ a.jsx(R, { item: !0, children: i ? /* @__PURE__ */ a.jsx(ut, { children: ca.find((f) => f.value === u).name }) : /* @__PURE__ */ a.jsx(un, { children: /* @__PURE__ */ a.jsx(
          Rt,
          {
            className: "",
            options: ca,
            value: u,
            placeholder: "Select criteria type...",
            onChange: (f) => l({ ...s, Type: f }),
            name: "extendCriteriaType"
          }
        ) }) }),
        /* @__PURE__ */ a.jsx(R, { item: !0, children: i ? /* @__PURE__ */ a.jsx(ut, { children: p }) : /* @__PURE__ */ a.jsx(un, { children: /* @__PURE__ */ a.jsx(
          Gi,
          {
            value: p,
            onChange: (f) => l({ ...s, Count: f }),
            options: mf
          }
        ) }) }),
        /* @__PURE__ */ a.jsx(R, { item: !0, children: i ? /* @__PURE__ */ a.jsx(ut, { children: c ? /* @__PURE__ */ a.jsx("span", { children: "using distinct" }) : /* @__PURE__ */ a.jsx("span", { children: "using all" }) }) : /* @__PURE__ */ a.jsx(un, { children: /* @__PURE__ */ a.jsx(
          We,
          {
            onClick: () => l({ ...s, IsDistinct: !c }),
            fullWidth: !1,
            variant: "outlined",
            sx: { borderColor: "borderColor.main" },
            name: "isDistinct",
            children: c ? /* @__PURE__ */ a.jsx("span", { children: "using distinct" }) : /* @__PURE__ */ a.jsx("span", { children: "using all" })
          }
        ) }) }),
        c ? /* @__PURE__ */ a.jsx(R, { item: !0, children: i ? /* @__PURE__ */ a.jsx(ut, { children: ua.find(
          (f) => f.value === d
        ).name }) : /* @__PURE__ */ a.jsx(un, { children: /* @__PURE__ */ a.jsx(
          Rt,
          {
            className: "",
            options: ua,
            value: d,
            placeholder: "Select criteria count column...",
            onChange: (f) => l({ ...s, CountColumn: f }),
            fullWidth: !0,
            name: "extendCriteriaCountColumn"
          }
        ) }) }) : /* @__PURE__ */ a.jsx(R, { item: !0, children: /* @__PURE__ */ a.jsx(ut, { children: "occurrences of:" }) })
      ]
    }
  );
}), Ca = (e) => Object.fromEntries(
  Object.entries(e).filter(([t, n]) => n !== void 0)
), Pr = (e) => {
  var n, r, i, o;
  const t = {
    Start: Ca({
      Coeff: (n = e == null ? void 0 : e.Start) == null ? void 0 : n.Coeff,
      Days: (r = e == null ? void 0 : e.Start) == null ? void 0 : r.Days
    }),
    End: Ca({
      Coeff: (i = e == null ? void 0 : e.End) == null ? void 0 : i.Coeff,
      Days: (o = e == null ? void 0 : e.End) == null ? void 0 : o.Days
    })
  };
  return (e == null ? void 0 : e.UseEventEnd) !== void 0 && (t.UseEventEnd = e.UseEventEnd), (e == null ? void 0 : e.UseIndexEnd) !== void 0 && (t.UseIndexEnd = e.UseIndexEnd), t;
}, bl = it((e) => {
  var f, h, g, C;
  const { updateModel: t, value: n, children: r, viewMode: i } = e, [o, s] = J(
    () => Pr(n)
  ), { Start: l, End: c, UseEventEnd: u, UseIndexEnd: p } = o, d = (T, I) => {
    s((A) => {
      const S = Pr({
        ...A,
        [T]: Ca(I)
      });
      return ke(Pr(A), S) ? A : S;
    });
  };
  return Q(() => {
    const T = Pr(o), I = Pr(n);
    ke(T, I) || t(T);
  }, [o, n, t]), /* @__PURE__ */ a.jsxs(Lx, { className: "extend-criteria-start-end-window", children: [
    /* @__PURE__ */ a.jsxs(R, { container: !0, spacing: 0.5, alignItems: "center", children: [
      /* @__PURE__ */ a.jsx(R, { item: !0, children: /* @__PURE__ */ a.jsx(ut, { children: "where" }) }),
      /* @__PURE__ */ a.jsx(R, { item: !0, children: i ? /* @__PURE__ */ a.jsx(ut, { children: u ? /* @__PURE__ */ a.jsx("span", { children: "event ends" }) : /* @__PURE__ */ a.jsx("span", { children: "event starts" }) }) : /* @__PURE__ */ a.jsx(un, { children: /* @__PURE__ */ a.jsx(
        We,
        {
          onClick: () => s({ ...o, UseEventEnd: !u }),
          fullWidth: !1,
          variant: "outlined",
          name: "useEventEnd",
          sx: { minWidth: 110 },
          children: u ? /* @__PURE__ */ a.jsx("span", { children: "event ends" }) : /* @__PURE__ */ a.jsx("span", { children: "event starts" })
        }
      ) }) }),
      /* @__PURE__ */ a.jsx(R, { item: !0, children: /* @__PURE__ */ a.jsx(ut, { children: "between" }) }),
      /* @__PURE__ */ a.jsx(R, { item: !0, children: i ? /* @__PURE__ */ a.jsx(ut, { children: /* @__PURE__ */ a.jsx("strong", { children: ((f = Ai.find(
        (T) => T.value == `${l.Days}`
      )) == null ? void 0 : f.name) || l.Days }) }) : /* @__PURE__ */ a.jsx(un, { children: /* @__PURE__ */ a.jsx(
        Gi,
        {
          value: l.Days,
          onChange: (T) => {
            d("Start", {
              ...l,
              Days: T
            });
          },
          options: Ai
        }
      ) }) }),
      /* @__PURE__ */ a.jsx(R, { item: !0, children: /* @__PURE__ */ a.jsx(ut, { children: "days" }) }),
      /* @__PURE__ */ a.jsx(R, { item: !0, children: i ? /* @__PURE__ */ a.jsx(ut, { children: /* @__PURE__ */ a.jsx("strong", { children: (h = or.find((T) => T.value === l.Coeff)) == null ? void 0 : h.name }) }) : /* @__PURE__ */ a.jsx(un, { children: /* @__PURE__ */ a.jsx(
        Rt,
        {
          className: "",
          options: or,
          value: l.Coeff,
          placeholder: "Select option...",
          onChange: (T) => {
            d("Start", { ...l, Coeff: T });
          },
          name: "selectStart"
        }
      ) }) }),
      /* @__PURE__ */ a.jsx(R, { item: !0, children: /* @__PURE__ */ a.jsx(ut, { children: "and" }) }),
      /* @__PURE__ */ a.jsx(R, { item: !0, children: i ? /* @__PURE__ */ a.jsx(ut, { children: /* @__PURE__ */ a.jsx("strong", { children: ((g = Ai.find((T) => T.value == `${c.Days}`)) == null ? void 0 : g.name) || c.Days }) }) : /* @__PURE__ */ a.jsx(un, { children: /* @__PURE__ */ a.jsx(
        Gi,
        {
          value: c.Days,
          onChange: (T) => {
            d("End", {
              ...c,
              Days: T
            });
          },
          options: Ai
        }
      ) }) }),
      /* @__PURE__ */ a.jsx(R, { item: !0, children: /* @__PURE__ */ a.jsx(ut, { children: "days" }) }),
      /* @__PURE__ */ a.jsx(R, { item: !0, children: i ? /* @__PURE__ */ a.jsx(ut, { children: /* @__PURE__ */ a.jsx("strong", { children: (C = or.find((T) => T.value === c.Coeff)) == null ? void 0 : C.name }) }) : /* @__PURE__ */ a.jsx(un, { children: /* @__PURE__ */ a.jsx(
        Rt,
        {
          className: "",
          options: or,
          value: c.Coeff,
          placeholder: "Select option...",
          onChange: (T) => d("End", { ...c, Coeff: T }),
          name: "selectEnd"
        }
      ) }) }),
      /* @__PURE__ */ a.jsx(R, { item: !0, children: i ? /* @__PURE__ */ a.jsx(ut, { children: p ? /* @__PURE__ */ a.jsx("span", { children: "index end date" }) : /* @__PURE__ */ a.jsx("span", { children: "index start date" }) }) : /* @__PURE__ */ a.jsx(un, { children: /* @__PURE__ */ a.jsx(
        We,
        {
          onClick: () => s({ ...o, UseIndexEnd: !p }),
          fullWidth: !1,
          variant: "outlined",
          name: "indexStartEnd",
          children: p ? /* @__PURE__ */ a.jsx("span", { children: "index end date" }) : /* @__PURE__ */ a.jsx("span", { children: "index start date" })
        }
      ) }) })
    ] }),
    r
  ] });
}), Mx = it((e) => {
  const {
    children: t,
    criteria: n,
    details: r,
    parentConceptSet: i,
    updateExtendOptions: o,
    type: s,
    removeCriteria: l,
    attrGroup: c,
    viewMode: u,
    hiddenParentConcept: p,
    sectionType: d,
    sectionCount: f,
    hasAction: h,
    parentConceptSetName: g,
    hideIgnoreObservationPeriod: C,
    hiddenIgnoreObservationPeriodValue: T,
    showRestrictToSameVisitForAllCriteria: I,
    hideOccurrence: A,
    first: S
  } = e, { id: _, extendOptions: v } = n, O = I || da(n.name), j = !C && hu(n.name), M = j || T !== void 0, [w, L] = J({
    Occurrence: (v == null ? void 0 : v.Occurrence) || uu,
    StartWindow: (v == null ? void 0 : v.StartWindow) || ar,
    EndWindow: (v == null ? void 0 : v.EndWindow) || ar,
    IgnoreObservationPeriod: T ?? (v == null ? void 0 : v.IgnoreObservationPeriod) ?? (j ? pu(n.name) : void 0),
    RestrictVisit: (v == null ? void 0 : v.RestrictVisit) ?? (O ? du(n.name) : void 0)
  }), [P, k] = J(
    !!(v != null && v.EndWindow)
  ), {
    Occurrence: z,
    StartWindow: B,
    EndWindow: q,
    RestrictVisit: N,
    IgnoreObservationPeriod: ne
  } = w;
  Q(() => {
    const W = { ...w }, H = { ...v };
    P || delete W.EndWindow, O ? W.RestrictVisit = !!W.RestrictVisit : delete W.RestrictVisit, M ? T !== void 0 ? W.IgnoreObservationPeriod = T : W.IgnoreObservationPeriod = !!W.IgnoreObservationPeriod : delete W.IgnoreObservationPeriod, A && delete W.Occurrence, ke(W, H) || o(W, _);
  }, [w, P]), Q(() => {
    v != null && v.EndWindow && k(!0);
  }, []);
  const ue = ie(
    (W) => {
      L({
        ...w,
        Occurrence: W
      });
    },
    [w]
  ), te = ie(
    (W) => {
      L({
        ...w,
        StartWindow: W
      });
    },
    [w]
  ), m = ie(
    (W) => {
      L({
        ...w,
        EndWindow: W
      });
    },
    [w]
  );
  return /* @__PURE__ */ a.jsxs(
    Za,
    {
      className: "extend-criteria",
      width: `calc(100% + ${h ? "36px" : "0px"})`,
      viewMode: u,
      sx: {
        boxSizing: "border-box",
        "&:not(:last-of-type)": {
          mb: 1
        }
      },
      children: [
        /* @__PURE__ */ a.jsx(
          pd,
          {
            viewMode: u,
            onRemove: () => l(_),
            iconName: n.name,
            title: r.titleText,
            children: !A && /* @__PURE__ */ a.jsx(
              kx,
              {
                value: z,
                type: d,
                updateModel: ue,
                viewMode: u,
                first: S
              }
            )
          }
        ),
        /* @__PURE__ */ a.jsxs(
          R,
          {
            container: !0,
            p: 1,
            sx: { borderTop: "1px dashed", borderColor: "borderColor.main" },
            children: [
              /* @__PURE__ */ a.jsx(R, { item: !0, xs: 12, children: t }),
              /* @__PURE__ */ a.jsxs(
                R,
                {
                  item: !0,
                  xs: 12,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  children: [
                    /* @__PURE__ */ a.jsx(R, { item: !0, children: /* @__PURE__ */ a.jsx(
                      bl,
                      {
                        typeOfStartEnd: "first",
                        value: B,
                        updateModel: te,
                        viewMode: u
                      }
                    ) }),
                    /* @__PURE__ */ a.jsx(R, { item: !0, children: !P && !u && /* @__PURE__ */ a.jsx(
                      We,
                      {
                        onClick: () => k(!P),
                        fullWidth: !1,
                        variant: "outlined",
                        startIcon: /* @__PURE__ */ a.jsx(ge, { iconName: "add" }),
                        name: "addConstraint",
                        sx: { mb: 0.5, minWidth: 185 },
                        children: "Additional Constraint"
                      }
                    ) })
                  ]
                }
              ),
              /* @__PURE__ */ a.jsx(R, { item: !0, xs: 12, children: P && /* @__PURE__ */ a.jsx(
                bl,
                {
                  typeOfStartEnd: "second",
                  value: q,
                  updateModel: m,
                  viewMode: u,
                  children: /* @__PURE__ */ a.jsx(jx, { children: !u && /* @__PURE__ */ a.jsx(
                    Cr,
                    {
                      onClick: () => k(!P),
                      color: "primary",
                      iconName: "delete",
                      noExpand: !0,
                      name: "closeButton"
                    }
                  ) })
                }
              ) }),
              /* @__PURE__ */ a.jsxs(
                R,
                {
                  container: !0,
                  sx: (W) => ({
                    // backgroundColor: theme.palette.backgroundColor.dark,
                    borderRadius: 0.5,
                    padding: "4px 0",
                    fontSize: 14
                  }),
                  children: [
                    /* @__PURE__ */ a.jsx(R, { item: !0, xs: 12, mb: u ? 0 : 1, children: !p && /* @__PURE__ */ a.jsxs(fe, { px: 1, fontSize: 12, mb: 0.5, color: "textColor.label", children: [
                      "The index date refers to the event from the",
                      " ",
                      g || "Cohort Entry criteria"
                    ] }) }),
                    (O || j) && /* @__PURE__ */ a.jsxs(R, { item: !0, xs: 12, display: "flex", children: [
                      O && /* @__PURE__ */ a.jsx(R, { item: !0, pr: 2, children: u ? /* @__PURE__ */ a.jsx(a.Fragment, { children: N ? /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
                        /* @__PURE__ */ a.jsx(ge, { iconName: "check", className: "icon-analysis" }),
                        /* @__PURE__ */ a.jsx(Al, { children: "Restrict to the same visit occurrence" })
                      ] }) : /* @__PURE__ */ a.jsx(a.Fragment, {}) }) : /* @__PURE__ */ a.jsxs(Il, { children: [
                        /* @__PURE__ */ a.jsx(
                          hr,
                          {
                            disabled: u,
                            name: "Restrict",
                            onChange: () => L({
                              ...w,
                              RestrictVisit: !N
                            }),
                            checked: !!N,
                            size: "small"
                          }
                        ),
                        "Restrict to the same visit occurrence"
                      ] }) }),
                      j && /* @__PURE__ */ a.jsx(R, { item: !0, children: u ? /* @__PURE__ */ a.jsx(a.Fragment, { children: ne ? /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
                        /* @__PURE__ */ a.jsx(ge, { iconName: "check", className: "icon-analysis" }),
                        /* @__PURE__ */ a.jsx(Al, { children: "Allow events from outside observation period" })
                      ] }) : /* @__PURE__ */ a.jsx(a.Fragment, {}) }) : /* @__PURE__ */ a.jsxs(Il, { children: [
                        /* @__PURE__ */ a.jsx(
                          hr,
                          {
                            disabled: u,
                            name: "Ignore",
                            onChange: () => L({
                              ...w,
                              IgnoreObservationPeriod: !ne
                            }),
                            size: "small",
                            checked: !!ne
                          }
                        ),
                        "Allow events from outside observation period"
                      ] }) })
                    ] })
                  ]
                }
              )
            ]
          }
        )
      ]
    }
  );
}), Vx = me("div", {
  shouldForwardProp: (e) => e !== "isGroup"
})`
  align-self: flex-start;
  padding-left: 8px;
  min-width: 30px;
`, Ux = (e) => {
  const {
    criteria: t,
    subModules: n,
    removeCriteria: r,
    conceptSets: i,
    updateConceptSets: o,
    refreshConceptSetReference: s,
    embeddedReferenceOnly: l,
    typeContainer: c,
    parentId: u,
    viewMode: p,
    updateModel: d,
    hasAction: f,
    parentConceptSetName: h
  } = e, { id: g } = t, C = (T) => {
    d(t.id, T);
  };
  return /* @__PURE__ */ a.jsx(
    Za,
    {
      className: "criteria-group",
      p: 1,
      sx: {
        boxSizing: "border-box",
        "&:not(:last-of-type)": {
          mb: 1
        }
      },
      children: /* @__PURE__ */ a.jsx(R, { container: !0, children: /* @__PURE__ */ a.jsxs(R, { item: !0, xs: 12, display: "flex", justifyContent: "space-between", children: [
        /* @__PURE__ */ a.jsx(
          Ar,
          {
            extend: !0,
            subModules: n,
            value: t.group,
            updateModel: C,
            viewMode: p,
            typeContainer: c,
            parentId: u,
            conceptSets: i,
            updateConceptSets: o,
            refreshConceptSetReference: s,
            embeddedReferenceOnly: l,
            attrGroup: !0,
            hasAction: f,
            conceptSetName: h
          }
        ),
        !p && /* @__PURE__ */ a.jsx(Vx, { children: /* @__PURE__ */ a.jsx(
          Cr,
          {
            onClick: () => {
              r(g);
            },
            color: "primary",
            iconName: "delete",
            noExpand: !0,
            name: "closeCriteriaButton"
          }
        ) })
      ] }) })
    }
  );
};
me(fe)`
  font-size: 14px;
  font-weight: 700;
  margin-right: 8px;
`;
const Fx = me.div`
  font-size: 14px;
  color: #232323;
  font-weight: 700;
  /* padding-top: 4px; */
`;
me.div`
  text-align: right;
`;
me.div`
  font-size: 14px;
  margin-top: 10px;
`;
function Bx({ id: e, children: t }) {
  const {
    attributes: n,
    listeners: r,
    setNodeRef: i,
    transform: o,
    transition: s,
    isDragging: l
  } = ad({ id: e }), c = {
    transform: Cn.Transform.toString(o),
    transition: s,
    cursor: "grab",
    // While dragging, the moving copy is shown in a DragOverlay (see Criteries);
    // hide the original so it just leaves a placeholder gap and its nested
    // attribute editors don't distort under the sortable transform.
    opacity: l ? 0 : 1,
    borderRadius: "8px",
    marginBottom: "8px"
  };
  return /* @__PURE__ */ a.jsx("div", { ref: i, style: c, ...n, ...r, children: t });
}
const es = it((e) => {
  const {
    titleText: t,
    descriptionText: n,
    initialCriteries: r,
    addTextButton: i,
    optionsDropdown: o,
    updateModel: s,
    viewMode: l,
    extend: c,
    parentConceptSet: u,
    attrGroup: p,
    groupTitleText: d,
    children: f,
    hiddenParentConcept: h,
    count: g,
    sectionType: C,
    sectionCount: T,
    isParentCriteriaAction: I,
    parentCriteriaElement: A,
    clearParentCriteriaElement: S,
    hasAction: _,
    parentConceptSetName: v,
    hideIgnoreObservationPeriod: O,
    hiddenIgnoreObservationPeriodValue: j,
    showRestrictToSameVisitForAllCriteria: M,
    hideCriteriaControls: w,
    hideOccurrence: L,
    ...P
  } = e, {
    criteries: k,
    isStartHook: z,
    addCriteria: B,
    init: q,
    updateCriteriaAttributes: N,
    updateCriteriaCodeSetId: ne,
    updateExtendOptionsCriteria: ue,
    updateGroupCriteria: te,
    removeCriteria: m
  } = cm(r, {
    extend: c,
    hideOccurrence: L,
    hideIgnoreObservationPeriod: O,
    hiddenIgnoreObservationPeriodValue: j,
    showRestrictToSameVisitForAllCriteria: M
  }), W = ee(() => Object.keys(k), [k]), H = !!(t || d || !w && (f || !l && !I)), y = Pu(
    wu(Co, {
      activationConstraint: {
        distance: 8
      }
    })
  ), [X, V] = J(null);
  Q(() => {
    I && A && (B(A), S());
  }, [A]);
  const $ = ie(
    (oe) => {
      const { active: re, over: ye } = oe;
      if (re != null && re.id && (ye != null && ye.id) && re.id !== ye.id) {
        const Me = Object.keys(k), ot = Me.indexOf(re.id), Ue = Me.indexOf(ye.id), Ve = Ka(Me, ot, Ue), Qe = {};
        return Ve.forEach((pt) => {
          Qe[pt] = k[pt];
        }), s(Qe), q(Qe), Ve;
      }
    },
    [k, s]
  );
  Q(() => {
    var oe;
    (z && !ke(k, r) || z && !((oe = Object.keys(k)) != null && oe.length)) && s(k);
  }, [k]);
  const le = ie(
    (oe) => {
      const re = k[oe], ye = uo[re == null ? void 0 : re.name];
      return {
        criteria: re,
        details: ye
      };
    },
    [k]
  ), b = X ? le(X).details : null;
  return z ? /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    H && /* @__PURE__ */ a.jsxs(
      R,
      {
        container: !0,
        alignItems: "flex-start",
        className: "cohort-definition-criteria-list",
        mb: Object.keys(k).length > 0 && f ? 1 : 0,
        children: [
          /* @__PURE__ */ a.jsxs(R, { item: !0, xs: 9, children: [
            t && /* @__PURE__ */ a.jsx(
              R,
              {
                item: !0,
                xs: 12,
                display: "flex",
                alignItems: "center",
                mb: 1,
                className: "title-text",
                children: /* @__PURE__ */ a.jsx(
                  Kr,
                  {
                    title: t,
                    count: Object.keys(k).length
                  }
                )
              }
            ),
            d && /* @__PURE__ */ a.jsx(R, { item: !0, xs: 12, className: "group-title-text", children: /* @__PURE__ */ a.jsx(Fx, { children: d }) }),
            !w && Object.keys(k).length > 0 && f && /* @__PURE__ */ a.jsx(R, { item: !0, xs: 12, className: "children-text", children: f })
          ] }),
          /* @__PURE__ */ a.jsx(
            R,
            {
              item: !0,
              xs: 3,
              textAlign: "right",
              className: "cohort-definition-criteria-button",
              children: !w && !l && !I && /* @__PURE__ */ a.jsx(
                vn,
                {
                  variant: "outlined",
                  options: o,
                  onClick: B,
                  title: i || "",
                  name: i || "",
                  closeOnSelect: !0,
                  preventOverflow: !0,
                  startIcon: /* @__PURE__ */ a.jsx(ge, { iconName: "add" }),
                  endIcon: /* @__PURE__ */ a.jsx(ge, { fontSize: "small", iconName: "chevronFilled" })
                }
              )
            }
          )
        ]
      }
    ),
    n && Object.keys(k).length > 0 && /* @__PURE__ */ a.jsx(fe, { fontSize: 12, mb: 1, children: n }),
    /* @__PURE__ */ a.jsxs(
      Ku,
      {
        sensors: y,
        collisionDetection: ju,
        onDragStart: ({ active: oe }) => V(String(oe.id)),
        onDragEnd: (oe) => {
          V(null), $(oe);
        },
        onDragCancel: () => V(null),
        children: [
          /* @__PURE__ */ a.jsx(
            id,
            {
              items: W,
              strategy: td,
              children: W.map((oe, re) => {
                var Me, ot, Ue;
                const ye = le(oe);
                return /* @__PURE__ */ a.jsx(Bx, { id: oe, children: (Me = ye == null ? void 0 : ye.details) != null && Me.wrapCriteria ? /* @__PURE__ */ a.jsx(
                  Ux,
                  {
                    ...ye,
                    extend: !0,
                    updateModel: te,
                    viewMode: l,
                    removeCriteria: m,
                    parentConceptSet: u,
                    parentConceptSetName: v,
                    hasAction: !0,
                    ...P
                  }
                ) : c && ((ot = ye == null ? void 0 : ye.details) != null && ot.extend) ? /* @__PURE__ */ a.jsx(
                  Mx,
                  {
                    ...ye,
                    parentConceptSet: u,
                    updateExtendOptions: ue,
                    removeCriteria: m,
                    attrGroup: p,
                    viewMode: l,
                    hiddenParentConcept: h,
                    sectionType: C,
                    sectionCount: T,
                    first: re === 0,
                    hasAction: _,
                    parentConceptSetName: v,
                    hideIgnoreObservationPeriod: O,
                    hiddenIgnoreObservationPeriodValue: j,
                    showRestrictToSameVisitForAllCriteria: M,
                    hideOccurrence: L,
                    children: /* @__PURE__ */ a.jsx(
                      Sl,
                      {
                        ...ye,
                        updateCriteriaAttributes: N,
                        updateCriteriaCodeSetId: ne,
                        removeCriteria: m,
                        viewMode: l,
                        extend: c && ((Ue = ye == null ? void 0 : ye.details) == null ? void 0 : Ue.extend),
                        ...P
                      }
                    )
                  }
                ) : /* @__PURE__ */ a.jsx(
                  Sl,
                  {
                    ...ye,
                    updateCriteriaAttributes: N,
                    updateCriteriaCodeSetId: ne,
                    removeCriteria: m,
                    viewMode: l,
                    extend: c,
                    attrGroup: p,
                    hasAction: _,
                    ...P
                  }
                ) }, oe);
              })
            }
          ),
          /* @__PURE__ */ a.jsx(Zu, { children: b ? /* @__PURE__ */ a.jsxs(
            "div",
            {
              style: {
                display: "inline-flex",
                alignItems: "baseline",
                gap: 6,
                background: "#fff",
                border: "1px solid #c2cbe0",
                borderRadius: 8,
                padding: "8px 14px",
                boxShadow: "0 6px 20px rgba(23, 43, 77, 0.18)",
                cursor: "grabbing"
              },
              children: [
                /* @__PURE__ */ a.jsx(
                  fe,
                  {
                    sx: { fontSize: 14, fontWeight: 600, color: "#172b4d" },
                    children: b.titleText
                  }
                ),
                /* @__PURE__ */ a.jsx(fe, { sx: { fontSize: 14, color: "#5e6c84" }, children: b.baseText })
              ]
            }
          ) : null })
        ]
      }
    )
  ] }) : /* @__PURE__ */ a.jsx(Qt, { children: /* @__PURE__ */ a.jsx(Ct, { size: 32 }) });
}), $x = {
  addCriteriaButton: "Criteria to group",
  subSections: {
    havingFolovingCriteria: {
      startText: "having",
      type: "selectExt",
      options: ff,
      endText: "of the following criteria:"
    }
  },
  optionsForCriteriaButton: [
    D.DEMOGRAPHIC,
    D.CONDITION_ERA,
    D.CONDITION_OCCURRENCE,
    D.DEATH,
    D.DEVICE_EXPOSURE,
    D.DOSE_ERA,
    D.DRUG_ERA,
    D.DRUG_EXPOSURE,
    D.LOCATION_REGION,
    D.MEASUREMENT,
    D.OBSERVATION,
    D.OBSERVATION_PERIOD,
    D.PAYER_PLAN_PERIOD,
    D.PROCEDURE_OCCURRENCE,
    D.SPECIMEN,
    D.VISIT,
    D.VISIT_DETAILS,
    D.GROUP
  ]
}, Gx = me.div`
  display: flex;
  align-items: center;
  line-height: 30px;
  flex-wrap: wrap;
  margin-right: 4px;
`, zx = me.div`
  font-size: 12px;
`, Wx = me.div`
  margin: 0 10px;
`, Yx = me.div`
  font-size: 12px;
`, Hx = me.div`
  font-size: 12px;
  margin: 0 5px;
`, Ut = it(
  (e) => {
    var p;
    const {
      startText: t,
      children: n,
      endText: r,
      type: i = "select",
      options: o,
      value: s,
      viewMode: l,
      onChange: c
    } = e, u = (d) => {
      c(d);
    };
    return /* @__PURE__ */ a.jsxs(Gx, { children: [
      /* @__PURE__ */ a.jsx(zx, { className: "start-text", children: t }),
      l ? /* @__PURE__ */ a.jsx(Hx, { children: (p = o.find((d) => d.value == s)) == null ? void 0 : p.name }) : /* @__PURE__ */ a.jsxs(Wx, { children: [
        i === "select" && /* @__PURE__ */ a.jsxs(Re.Fragment, { children: [
          /* @__PURE__ */ a.jsx(
            Rt,
            {
              className: "",
              options: o,
              value: s,
              placeholder: "Select option...",
              onChange: u,
              name: "selectStart"
            }
          ),
          n
        ] }),
        i === "autocomplete" && /* @__PURE__ */ a.jsx(
          Gi,
          {
            value: s,
            onChange: (d) => {
              u(d);
            },
            options: o,
            className: "autocompleteValue"
          }
        ),
        i === "selectExt" && /* @__PURE__ */ a.jsxs(Re.Fragment, { children: [
          /* @__PURE__ */ a.jsx(
            Rt,
            {
              className: "",
              options: o,
              value: s,
              placeholder: "Select option...",
              onChange: u,
              name: "selectEnd"
            }
          ),
          ["AT_LEAST", "AT_MOST"].includes(s) && /* @__PURE__ */ a.jsx(Re.Fragment, { children: n })
        ] })
      ] }),
      /* @__PURE__ */ a.jsx(Yx, { className: "end-text", children: r })
    ] });
  }
), qx = (e, t) => typeof e == "number" ? e >= 0 : !t || typeof e != "string" ? !1 : e.trim() !== "" && e !== "-1", Ar = (e) => {
  const {
    extend: t,
    value: n,
    title: r,
    subModules: i,
    viewMode: o,
    typeContainer: s,
    parentId: l,
    description: c,
    addTextButton: u,
    updateModel: p,
    groupTitleText: d,
    hiddenParentConcept: f,
    parentCriteriaElement: h,
    clearParentCriteriaElement: g,
    isParentCriteriaAction: C,
    conceptSetName: T,
    hideIgnoreObservationPeriod: I,
    hiddenIgnoreObservationPeriodValue: A,
    showRestrictToSameVisitForAllCriteria: S,
    embeddedReferenceOnly: _,
    hasAction: v = !1,
    hideCriteriaControls: O,
    hideOccurrence: j,
    ...M
  } = e, [w, L] = J({
    Type: (n == null ? void 0 : n.Type) || "ALL",
    Count: (n == null ? void 0 : n.Count) || (["ANY", "ALL"].includes(n == null ? void 0 : n.Type) ? void 0 : 0),
    CriteriaList: (n == null ? void 0 : n.CriteriaList) || [],
    DemographicCriteriaList: (n == null ? void 0 : n.DemographicCriteriaList) || [],
    Groups: (n == null ? void 0 : n.Groups) || []
  }), { Type: P, Count: k, CriteriaList: z, DemographicCriteriaList: B, Groups: q } = w, N = _ || s === he.LIBRARY, ne = (V, $, le) => {
    const b = {};
    return V.forEach((oe) => {
      const re = Yt(), { CodesetId: ye, ...Me } = oe;
      b[re] = {
        id: re,
        name: "Demographic",
        codesetId: ye,
        attributes: Me
      };
    }), $.forEach((oe) => {
      const re = Yt(), { Criteria: ye, ...Me } = oe, ot = Object.keys(ye)[0], Ue = Object.values(ye)[0] || {}, { CodesetId: Ve, codesetId: Qe, ...pt } = Ue;
      b[re] = {
        id: re,
        name: ot,
        codesetId: Ve ?? Qe,
        attributes: pt,
        extendOptions: Me
      };
    }), le.forEach((oe) => {
      const re = Yt();
      b[re] = {
        id: re,
        name: "Group",
        codesetId: void 0,
        attributes: {},
        group: oe
      };
    }), b;
  }, ue = ie(
    (V) => {
      const $ = {
        CriteriaList: [],
        DemographicCriteriaList: [],
        Groups: []
      };
      return Object.keys(V).forEach((le) => {
        const b = V[le];
        switch (b.name) {
          case D.DEMOGRAPHIC:
            $.DemographicCriteriaList.push(
              b.attributes
            );
            break;
          case D.GROUP:
            $.Groups.push(b.group);
            break;
          default:
            $.CriteriaList.push({
              Criteria: {
                [b.name]: b.codesetId !== void 0 && b.codesetId !== null && b.codesetId !== -1 && qx(
                  b.codesetId,
                  N
                ) ? {
                  ...b.attributes,
                  CodesetId: b.codesetId
                } : b.attributes
              },
              ...b.extendOptions
            });
        }
      }), $;
    },
    [N]
  ), [te] = J(
    ne(
      B,
      z,
      q
    )
  ), { addCriteriaButton: m, optionsForCriteriaButton: W, subSections: H } = $x, y = ee(() => wn(
    W,
    yn
  ), [W]), X = (V) => {
    const $ = ue(V);
    L({
      ...w,
      ...$
    });
  };
  return Q(() => {
    let V = {
      Type: w.Type,
      CriteriaList: w.CriteriaList,
      DemographicCriteriaList: w.DemographicCriteriaList,
      Groups: w.Groups
    };
    w.Count >= 0 && w.Type !== "ALL" && (V.Count = w.Count), ke(V, n) || p(V);
  }, [w]), /* @__PURE__ */ a.jsx(R, { container: !0, className: "criteria-group-container", children: /* @__PURE__ */ a.jsx(R, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsx(
    es,
    {
      viewMode: o,
      groupTitleText: d,
      extend: !0,
      subModules: i,
      initialCriteries: te,
      addTextButton: u || m,
      optionsDropdown: y,
      updateModel: X,
      typeContainer: s,
      parentId: l,
      titleText: r,
      descriptionText: c,
      hiddenParentConcept: f,
      sectionType: P,
      sectionCount: k,
      parentCriteriaElement: h,
      clearParentCriteriaElement: g,
      isParentCriteriaAction: C,
      embeddedReferenceOnly: _,
      hasAction: v,
      parentConceptSetName: T,
      hideIgnoreObservationPeriod: I,
      hiddenIgnoreObservationPeriodValue: A,
      showRestrictToSameVisitForAllCriteria: S,
      hideCriteriaControls: O,
      hideOccurrence: j,
      ...M,
      children: /* @__PURE__ */ a.jsx(R, { container: !0, children: /* @__PURE__ */ a.jsx(R, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsx(
        Ut,
        {
          viewMode: o,
          startText: H.havingFolovingCriteria.startText,
          endText: H.havingFolovingCriteria.endText,
          options: H.havingFolovingCriteria.options,
          type: H.havingFolovingCriteria.type,
          onChange: (V) => {
            L({
              ...w,
              Type: V
            });
          },
          value: w.Type,
          children: /* @__PURE__ */ a.jsx(
            Rt,
            {
              className: "criteriaSelectNumeric",
              options: [
                {
                  value: 0,
                  name: "0"
                },
                ...z.map((V, $) => ({
                  value: $ + 1,
                  name: `${$ + 1}`
                }))
              ],
              value: w.Count,
              placeholder: "Select option...",
              onChange: (V) => {
                L({
                  ...w,
                  Count: V
                });
              },
              name: "selectStart"
            }
          )
        }
      ) }) })
    }
  ) }) });
}, Xx = me.div`
  font-size: 16px;
  color: ${({ theme: e }) => {
  var t;
  return (t = e.palette) == null ? void 0 : t.primary.main;
}};
  font-weight: 700;
  /* padding-top: 4px; */
`, Jx = me.div`
  margin-bottom: 8px;
`, Rl = [
  {
    id: "dsdsds",
    name: "Gender (M, F)",
    stratas: [
      {
        id: "fjoiewfwo31232",
        name: "Gender (M)",
        description: "--- Gender (M) ---",
        expression: {
          Type: "ALL",
          CriteriaList: [],
          DemographicCriteriaList: [
            {
              Gender: [
                {
                  CONCEPT_ID: 8507,
                  CONCEPT_NAME: "MALE",
                  STANDARD_CONCEPT: "S",
                  STANDARD_CONCEPT_CAPTION: "Standard",
                  INVALID_REASON: null,
                  INVALID_REASON_CAPTION: "Valid",
                  CONCEPT_CODE: "M",
                  DOMAIN_ID: "Gender",
                  VOCABULARY_ID: "Gender",
                  CONCEPT_CLASS_ID: "Gender",
                  id: null,
                  shortcut: null,
                  created: null,
                  modified: null,
                  actions: null
                }
              ]
            }
          ]
        }
      },
      {
        id: "fjoiewfwo355555",
        name: "Gender (F)",
        description: "--- Gender (F) ---",
        expression: {
          Type: "ALL",
          CriteriaList: [],
          DemographicCriteriaList: [
            {
              Gender: [
                {
                  CONCEPT_ID: 8532,
                  CONCEPT_NAME: "FEMALE",
                  STANDARD_CONCEPT: "S",
                  STANDARD_CONCEPT_CAPTION: "Standard",
                  INVALID_REASON: null,
                  INVALID_REASON_CAPTION: "Valid",
                  CONCEPT_CODE: "F",
                  DOMAIN_ID: "Gender",
                  VOCABULARY_ID: "Gender",
                  CONCEPT_CLASS_ID: "Gender",
                  id: null,
                  shortcut: null,
                  created: null,
                  modified: null,
                  actions: null
                }
              ]
            }
          ]
        }
      }
    ]
  },
  {
    id: "dsdsds456",
    name: "Gender (M)",
    stratas: [
      {
        id: "fjoiewfwo3lk1232",
        name: "Gender (M)",
        description: "--- Gender (M) ---",
        expression: {
          Type: "ALL",
          CriteriaList: [],
          DemographicCriteriaList: [
            {
              Gender: [
                {
                  CONCEPT_ID: 8507,
                  CONCEPT_NAME: "MALE",
                  STANDARD_CONCEPT: "S",
                  STANDARD_CONCEPT_CAPTION: "Standard",
                  INVALID_REASON: null,
                  INVALID_REASON_CAPTION: "Valid",
                  CONCEPT_CODE: "M",
                  DOMAIN_ID: "Gender",
                  VOCABULARY_ID: "Gender",
                  CONCEPT_CLASS_ID: "Gender",
                  id: null,
                  shortcut: null,
                  created: null,
                  modified: null,
                  actions: null
                }
              ]
            }
          ]
        }
      }
    ]
  },
  {
    id: "dsdsdgglos",
    name: "Gender (F)",
    stratas: [
      {
        id: "fjoiewfwo35534gg",
        name: "Gender (F)",
        description: "--- Gender (F) ---",
        expression: {
          Type: "ALL",
          CriteriaList: [],
          DemographicCriteriaList: [
            {
              Gender: [
                {
                  CONCEPT_ID: 8532,
                  CONCEPT_NAME: "FEMALE",
                  STANDARD_CONCEPT: "S",
                  STANDARD_CONCEPT_CAPTION: "Standard",
                  INVALID_REASON: null,
                  INVALID_REASON_CAPTION: "Valid",
                  CONCEPT_CODE: "F",
                  DOMAIN_ID: "Gender",
                  VOCABULARY_ID: "Gender",
                  CONCEPT_CLASS_ID: "Gender",
                  id: null,
                  shortcut: null,
                  created: null,
                  modified: null,
                  actions: null
                }
              ]
            }
          ]
        }
      }
    ]
  },
  {
    id: "dsoioi3333",
    name: "Age Groups #1 (0-10, 11-20, 21-30, 31-40, 41-50, 51-60, 61+)",
    stratas: [
      {
        id: "fjdfdf11",
        name: "Age 0 - 10",
        description: "--- Age 0 - 10 ---",
        expression: {
          Type: "ALL",
          CriteriaList: [],
          DemographicCriteriaList: [
            {
              Age: {
                Value: 0,
                Op: "bt",
                Extent: 10
              }
            }
          ]
        }
      },
      {
        id: "fjdfdf22",
        name: "Age 11 - 20",
        description: "--- Age 11 - 20 ---",
        expression: {
          Type: "ALL",
          CriteriaList: [],
          DemographicCriteriaList: [
            {
              Age: {
                Value: 11,
                Op: "bt",
                Extent: 20
              }
            }
          ]
        }
      },
      {
        id: "fjdfdf33",
        name: "Age 21 - 30",
        description: "--- Age 21 - 30 ---",
        expression: {
          Type: "ALL",
          CriteriaList: [],
          DemographicCriteriaList: [
            {
              Age: {
                Value: 21,
                Op: "bt",
                Extent: 30
              }
            }
          ]
        }
      },
      {
        id: "fjdfdf44",
        name: "Age 31 - 40",
        description: "--- Age 31 - 40 ---",
        expression: {
          Type: "ALL",
          CriteriaList: [],
          DemographicCriteriaList: [
            {
              Age: {
                Value: 31,
                Op: "bt",
                Extent: 40
              }
            }
          ]
        }
      },
      {
        id: "fjdfdf55",
        name: "Age 41 - 50",
        description: "--- Age 41 - 50 ---",
        expression: {
          Type: "ALL",
          CriteriaList: [],
          DemographicCriteriaList: [
            {
              Age: {
                Value: 41,
                Op: "bt",
                Extent: 50
              }
            }
          ]
        }
      },
      {
        id: "fjdfdf66",
        name: "Age 51 - 60",
        description: "--- Age 51 - 60 ---",
        expression: {
          Type: "ALL",
          CriteriaList: [],
          DemographicCriteriaList: [
            {
              Age: {
                Value: 51,
                Op: "bt",
                Extent: 60
              }
            }
          ]
        }
      },
      {
        id: "fjdfdf77",
        name: "Age 61+",
        description: "--- Age 61+ ---",
        expression: {
          Type: "ALL",
          CriteriaList: [],
          DemographicCriteriaList: [
            {
              Age: {
                Value: 61,
                Op: "gte"
              }
            }
          ]
        }
      }
    ]
  },
  {
    id: "dsdsdgglosiihtht",
    name: "Age Groups #2 (<40, 40+)",
    stratas: [
      {
        id: "fjoiewfwo35534gg",
        name: "Age < 40",
        description: "--- Age < 40 ---",
        expression: {
          Type: "ALL",
          CriteriaList: [],
          DemographicCriteriaList: [
            {
              Age: {
                Op: "lt",
                Value: 40
              }
            }
          ]
        }
      },
      {
        id: "fjoiewfwo35534gg",
        name: "Age 40+",
        description: "--- Age 40+ ---",
        expression: {
          Type: "ALL",
          CriteriaList: [],
          DemographicCriteriaList: [
            {
              Age: {
                Op: "gte",
                Value: 40
              }
            }
          ]
        }
      }
    ]
  },
  {
    id: "dsds11dgglqwqwqwoshtht",
    name: "Age Groups #3 (<60, 60+)",
    stratas: [
      {
        id: "fjoiewfwo35kk534gg",
        name: "Age < 60",
        description: "--- Age < 60 ---",
        expression: {
          Type: "ALL",
          CriteriaList: [],
          DemographicCriteriaList: [
            {
              Age: {
                Op: "lt",
                Value: 60
              }
            }
          ]
        }
      },
      {
        id: "fjoiewfwo355lolo34gg",
        name: "Age 60+",
        description: "--- Age 60+ ---",
        expression: {
          Type: "ALL",
          CriteriaList: [],
          DemographicCriteriaList: [
            {
              Age: {
                Op: "gte",
                Value: 60
              }
            }
          ]
        }
      }
    ]
  },
  {
    id: "dsoi98oi3333",
    name: "Age Groups Adolescent (0-1, 1-5, 6-10, 11-18) ",
    stratas: [
      {
        id: "fjdfdf1111",
        name: "Age 0 - 1",
        description: "--- Age 0 - 1 ---",
        expression: {
          Type: "ALL",
          CriteriaList: [],
          DemographicCriteriaList: [
            {
              Age: {
                Value: 0,
                Op: "bt",
                Extent: 1
              }
            }
          ]
        }
      },
      {
        id: "fjdfdf2222",
        name: "Age 1 - 5",
        description: "--- Age 1 - 5 ---",
        expression: {
          Type: "ALL",
          CriteriaList: [],
          DemographicCriteriaList: [
            {
              Age: {
                Value: 1,
                Op: "bt",
                Extent: 5
              }
            }
          ]
        }
      },
      {
        id: "fjdfdf3333",
        name: "Age 6 - 10",
        description: "--- Age 6 - 10 ---",
        expression: {
          Type: "ALL",
          CriteriaList: [],
          DemographicCriteriaList: [
            {
              Age: {
                Value: 6,
                Op: "bt",
                Extent: 10
              }
            }
          ]
        }
      },
      {
        id: "fjdfdf4444",
        name: "Age 11 - 18",
        description: "--- Age 11 - 18 ---",
        expression: {
          Type: "ALL",
          CriteriaList: [],
          DemographicCriteriaList: [
            {
              Age: {
                Value: 11,
                Op: "bt",
                Extent: 18
              }
            }
          ]
        }
      }
    ]
  },
  {
    id: "dsoi985566344423f",
    name: "Race (U.S. Census Bureau)",
    stratas: [
      {
        id: "fjdfdf22qq",
        name: "White",
        description: "--- White ---",
        expression: {
          Type: "ALL",
          CriteriaList: [],
          DemographicCriteriaList: [
            {
              Race: [
                {
                  CONCEPT_ID: 8527,
                  CONCEPT_NAME: "White",
                  STANDARD_CONCEPT: "S",
                  STANDARD_CONCEPT_CAPTION: "Standard",
                  INVALID_REASON: null,
                  INVALID_REASON_CAPTION: "Unknown",
                  CONCEPT_CODE: "5",
                  DOMAIN_ID: "Race",
                  VOCABULARY_ID: "Race",
                  CONCEPT_CLASS_ID: "Race"
                }
              ]
            }
          ]
        }
      },
      {
        id: "fjdfdf11qq",
        name: "Black or African American",
        description: "--- Black or African American ---",
        expression: {
          Type: "ALL",
          CriteriaList: [],
          DemographicCriteriaList: [
            {
              Race: [
                {
                  CONCEPT_ID: 8516,
                  CONCEPT_NAME: "Black or African American",
                  STANDARD_CONCEPT: "S",
                  STANDARD_CONCEPT_CAPTION: "Standard",
                  INVALID_REASON: null,
                  INVALID_REASON_CAPTION: "Unknown",
                  CONCEPT_CODE: "3",
                  DOMAIN_ID: "Race",
                  VOCABULARY_ID: "Race",
                  CONCEPT_CLASS_ID: "Race"
                }
              ]
            }
          ]
        }
      },
      {
        id: "fjdfdf55qq",
        name: "American Indian or Alaska Native",
        description: "--- American Indian or Alaska Native ---",
        expression: {
          Type: "ALL",
          CriteriaList: [],
          DemographicCriteriaList: [
            {
              Race: [
                {
                  CONCEPT_ID: 8657,
                  CONCEPT_NAME: "American Indian or Alaska Native",
                  STANDARD_CONCEPT: "S",
                  STANDARD_CONCEPT_CAPTION: "Standard",
                  INVALID_REASON: null,
                  INVALID_REASON_CAPTION: "Unknown",
                  CONCEPT_CODE: "1",
                  DOMAIN_ID: "Race",
                  VOCABULARY_ID: "Race",
                  CONCEPT_CLASS_ID: "Race"
                }
              ]
            }
          ]
        }
      },
      {
        id: "fjgg66hh66",
        name: "Asian",
        description: "--- Asian ---",
        expression: {
          Type: "ALL",
          CriteriaList: [],
          DemographicCriteriaList: [
            {
              Race: [
                {
                  CONCEPT_ID: 8515,
                  CONCEPT_NAME: "Asian",
                  STANDARD_CONCEPT: "S",
                  STANDARD_CONCEPT_CAPTION: "Standard",
                  INVALID_REASON: null,
                  INVALID_REASON_CAPTION: "Unknown",
                  CONCEPT_CODE: "2",
                  DOMAIN_ID: "Race",
                  VOCABULARY_ID: "Race",
                  CONCEPT_CLASS_ID: "Race"
                }
              ]
            }
          ]
        }
      },
      {
        id: "fjdfdf33qq",
        name: "Native Hawaiian or Other Pacific Islander",
        description: "--- Native Hawaiian or Other Pacific Islander ---",
        expression: {
          Type: "ALL",
          CriteriaList: [],
          DemographicCriteriaList: [
            {
              Race: [
                {
                  CONCEPT_ID: 8557,
                  CONCEPT_NAME: "Native Hawaiian or Other Pacific Islander",
                  STANDARD_CONCEPT: "S",
                  STANDARD_CONCEPT_CAPTION: "Standard",
                  INVALID_REASON: null,
                  INVALID_REASON_CAPTION: "Unknown",
                  CONCEPT_CODE: "4",
                  DOMAIN_ID: "Race",
                  VOCABULARY_ID: "Race",
                  CONCEPT_CLASS_ID: "Race"
                }
              ]
            }
          ]
        }
      }
    ]
  },
  {
    id: "dsoededrf4444",
    name: "Ethnic Group",
    stratas: [
      {
        id: "fj34340011",
        name: "Hispanic or Latino",
        description: "--- Hispanic or Latino ---",
        expression: {
          Type: "ALL",
          CriteriaList: [],
          DemographicCriteriaList: [
            {
              Ethnicity: [
                {
                  CONCEPT_ID: 38003563,
                  CONCEPT_NAME: "Hispanic or Latino",
                  STANDARD_CONCEPT: "S",
                  STANDARD_CONCEPT_CAPTION: "Standard",
                  INVALID_REASON: null,
                  INVALID_REASON_CAPTION: "Unknown",
                  CONCEPT_CODE: "Hispanic",
                  DOMAIN_ID: "Ethnicity",
                  VOCABULARY_ID: "Ethnicity",
                  CONCEPT_CLASS_ID: "Ethnicity"
                }
              ]
            }
          ]
        }
      },
      {
        id: "fj34340551",
        name: "Not Hispanic or Latino",
        description: "--- Not Hispanic or Latino ---",
        expression: {
          Type: "ALL",
          CriteriaList: [],
          DemographicCriteriaList: [
            {
              Ethnicity: [
                {
                  CONCEPT_ID: 38003564,
                  CONCEPT_NAME: "Not Hispanic or Latino",
                  STANDARD_CONCEPT: "S",
                  STANDARD_CONCEPT_CAPTION: "Standard",
                  INVALID_REASON: null,
                  INVALID_REASON_CAPTION: "Unknown",
                  CONCEPT_CODE: "Not Hispanic",
                  DOMAIN_ID: "Ethnicity",
                  VOCABULARY_ID: "Ethnicity",
                  CONCEPT_CLASS_ID: "Ethnicity"
                }
              ]
            }
          ]
        }
      }
    ]
  }
];
me.div`
  font-size: 16px;
  color: ${({ theme: e }) => {
  var t;
  return (t = e.palette) == null ? void 0 : t.primary.main;
}};
  font-weight: 700;
  padding-top: 4px;
`;
me.div`
  display: block;
  text-align: right;
`;
me(We)`
  border-radius: 4px;
  font-size: 14px;
  text-transform: initial;
  padding: 1px 15px;
`;
me.div`
  margin-bottom: 20px;
`;
const Ol = me(gr)`
  padding: 10px;
`, hd = (e) => {
  const { subModules: t, typeContainer: n, parentId: r, onChange: i, onClose: o } = e, [s, l] = J(null), [c, u] = J(!1), p = () => {
    i(s.stratas);
  };
  return /* @__PURE__ */ a.jsx(gr, { children: /* @__PURE__ */ a.jsxs(R, { container: !0, spacing: 2, p: 2, children: [
    /* @__PURE__ */ a.jsx(R, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsx(qe, { name: "criteria", textLabel: "Criteria", required: !0, children: /* @__PURE__ */ a.jsx(
      zi,
      {
        className: "",
        name: "criteria",
        id: "criteria",
        options: Rl.map((d) => ({
          name: d.name,
          value: d.id
        })),
        value: s == null ? void 0 : s.name,
        placeholder: "Select criteria...",
        fullWidth: !0,
        isOptionEqualToValue: (d, f) => d.value === f.value,
        onChange: (d, f) => {
          u(!0), setTimeout(() => {
            u(!1);
          }, 300);
          const h = Rl.find(
            (g) => g.id === f.value
          );
          l(h);
        },
        getOptionLabel: (d) => d.name
      }
    ) }) }),
    s && s.stratas.length > 0 && /* @__PURE__ */ a.jsx(R, { item: !0, xs: 12, p: 2, children: /* @__PURE__ */ a.jsxs(co, { children: [
      /* @__PURE__ */ a.jsx(
        We,
        {
          variant: "outlined",
          onClick: o,
          startIcon: /* @__PURE__ */ a.jsx(ge, { iconName: "deactivate" }),
          name: "delete",
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ a.jsx(
        We,
        {
          onClick: p,
          variant: "contained",
          color: "success",
          startIcon: /* @__PURE__ */ a.jsx(ge, { iconName: "submit" }),
          name: "save",
          children: "Choose"
        }
      )
    ] }) }),
    s && s.stratas.length > 0 && s.stratas.map((d, f) => /* @__PURE__ */ a.jsx(a.Fragment, { children: /* @__PURE__ */ a.jsx(
      R,
      {
        item: !0,
        xs: 12,
        className: "cohort-definition-inclusion-criteria-data",
        children: /* @__PURE__ */ a.jsx(
          Ua,
          {
            index: f,
            item: d,
            viewMode: !0,
            defaultState: !0,
            updateSection: () => {
            },
            copySection: () => {
            },
            removeSection: () => {
            },
            children: /* @__PURE__ */ a.jsxs(R, { item: !0, xs: 12, children: [
              !c && /* @__PURE__ */ a.jsx(Ol, { children: /* @__PURE__ */ a.jsx(
                Ar,
                {
                  extend: !0,
                  subModules: t,
                  value: d.expression,
                  updateModel: (h) => {
                  },
                  viewMode: !0,
                  typeContainer: n,
                  parentId: r,
                  groupTitleText: `Group criteria for ${d.name}`,
                  conceptSets: [],
                  updateConceptSets: (h) => {
                  },
                  hasAction: !1
                }
              ) }),
              c && /* @__PURE__ */ a.jsx(Ol, { children: /* @__PURE__ */ a.jsx(Qt, { children: /* @__PURE__ */ a.jsx(Ct, { size: 32 }) }) })
            ] })
          },
          f
        )
      }
    ) }))
  ] }) });
}, zr = (e) => typeof e == "object" && e !== null, fd = (e) => {
  if (zr(e))
    return typeof e.message == "string" ? e.message : void 0;
}, md = (e, t) => {
  const n = zr(e) && zr(e.response) && zr(e.response.data) && typeof e.response.data.message == "string" ? e.response.data.message : void 0;
  return n || t;
}, Ed = (e) => typeof e == "boolean" ? e : zr(e) ? typeof e.available == "boolean" ? e.available : typeof e.isAvailable == "boolean" ? e.isAvailable : typeof e.success == "boolean" ? e.success : typeof e.result == "boolean" ? e.result : typeof e.unique == "boolean" ? e.unique : typeof e.isUnique == "boolean" ? e.isUnique : typeof e.valid == "boolean" ? e.valid : typeof e.isValid == "boolean" ? e.isValid : typeof e.exists == "boolean" ? !e.exists : typeof e.duplicate == "boolean" ? !e.duplicate : typeof e.conflict == "boolean" ? !e.conflict : typeof e.used == "boolean" ? !e.used : !0 : !0, ur = async (e, t, n, r) => {
  const i = t == null ? void 0 : t.trim();
  if (!i)
    return {
      isValid: !1,
      message: "Name is required."
    };
  try {
    const o = await Tu(
      e,
      i,
      n,
      r
    ), s = Ed(o);
    return {
      isValid: s,
      message: (s ? void 0 : fd(o)) || (s ? void 0 : "Error! Name is already used by another object.")
    };
  } catch (o) {
    return {
      isValid: !1,
      message: md(
        o,
        "Unable to validate name uniqueness. Please try again."
      )
    };
  }
}, Kx = async (e, t, n, r) => {
  const i = t == null ? void 0 : t.trim();
  if (!i)
    return {
      isValid: !1,
      message: "Name is required."
    };
  try {
    const o = await Gf(
      e,
      i,
      n,
      r
    ), s = Ed(o);
    return {
      isValid: s,
      message: (s ? void 0 : fd(o)) || (s ? void 0 : "Error! Name is already used by another object.")
    };
  } catch (o) {
    return {
      isValid: !1,
      message: md(
        o,
        "Unable to validate name uniqueness. Please try again."
      )
    };
  }
}, xd = it((e) => {
  const { parentId: t, typeContainer: n, afterCreate: r, onCancel: i, createMethod: o } = e, [s, l] = J(!1), [c, u] = J(""), [p, d] = J({
    name: "",
    description: "",
    studyId: t
  }), f = ie(async () => {
    l(!0);
    const h = await ur(n, p.name, t);
    if (!h.isValid) {
      l(!1), u(h.message || "");
      return;
    }
    u(""), o(p).then((g) => {
      l(!1), r == null || r(g);
    });
  }, [t, p, o, n]);
  return /* @__PURE__ */ a.jsx(R, { container: !0, p: 2, children: /* @__PURE__ */ a.jsx(gr, { elevated: !0, outlined: !0, children: /* @__PURE__ */ a.jsxs(R, { container: !0, spacing: 2, p: 2, children: [
    /* @__PURE__ */ a.jsx(R, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsxs(qe, { name: "name", textLabel: "Name", required: !0, children: [
      /* @__PURE__ */ a.jsx(
        Je,
        {
          id: "name",
          name: "name",
          type: "text",
          size: "medium",
          value: p.name,
          placeholder: "Enter name",
          onChange: (h) => {
            u(""), d({ ...p, name: h.target.value });
          },
          fullWidth: !0
        }
      ),
      c && /* @__PURE__ */ a.jsx(fe, { color: "error.main", variant: "caption", children: c })
    ] }) }),
    /* @__PURE__ */ a.jsx(R, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsx(qe, { name: "description", textLabel: "Description", children: /* @__PURE__ */ a.jsx(
      Je,
      {
        id: "description",
        name: "description",
        type: "text",
        size: "medium",
        value: p.description,
        placeholder: "Enter description",
        onChange: (h) => d({ ...p, description: h.target.value }),
        fullWidth: !0,
        multiline: !0,
        minRows: 2,
        maxRows: 10
      }
    ) }) }),
    /* @__PURE__ */ a.jsx(R, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsxs(co, { children: [
      /* @__PURE__ */ a.jsx(
        We,
        {
          variant: "outlined",
          disabled: s,
          onClick: i,
          startIcon: /* @__PURE__ */ a.jsx(ge, { iconName: "deactivate" }),
          name: "cancel",
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ a.jsx(
        We,
        {
          disabled: s || En(p.name),
          onClick: f,
          variant: "contained",
          color: "success",
          startIcon: s ? /* @__PURE__ */ a.jsx(Ct, { size: 16 }) : /* @__PURE__ */ a.jsx(ge, { iconName: "submit" }),
          name: "save",
          children: "Save"
        }
      )
    ] }) })
  ] }) }) });
}), Qx = ze.CREATE_NEW_OBJECT, vl = ze.CREATE_NEW_VERSION, Zx = "Fully identical concept sets will not be created, instead existing ones will be re-used. Concept sets with the same name will create a new version of the existing ones and Cohort design will reference these newly created versions. Previously created concept-sets, which are not used anywhere else will be deleted(archived).", eC = "New Concept Set(s) will be created, even if identical Concept Set(s) exist.", jr = (e) => e.trim().replace(/^['"]|['"]$/g, "").replace(/^\[+/, "").replace(/\]+$/, "").trim(), ga = (e) => {
  if (Array.isArray(e))
    return e.map((t) => jr(String(t))).filter(Boolean);
  if (typeof e == "string") {
    const t = e.trim();
    if (!t) return [];
    try {
      const n = JSON.parse(t);
      if (Array.isArray(n))
        return n.map((r) => jr(String(r))).filter(Boolean);
    } catch {
    }
    if (t.startsWith("[") && t.endsWith("]")) {
      const n = t.slice(1, -1).trim();
      return n ? n.split(",").map(jr).filter(Boolean) : [];
    }
    return t.includes(",") ? t.split(",").map(jr).filter(Boolean) : [jr(t)].filter(Boolean);
  }
  return [];
}, tC = (e) => {
  if (!e) return {};
  if (typeof e == "string") {
    try {
      const t = JSON.parse(e);
      if (t && typeof t == "object" && !Array.isArray(t))
        return t;
    } catch {
      return { Description: e };
    }
    return { Description: e };
  }
  return e;
}, Dl = (e, t) => ga(e).map((n) => ({
  name: (t == null ? void 0 : t.get(n)) ?? n,
  value: n
})), _l = (e) => typeof e == "string" ? e : e.name, Nl = (e) => {
  if (typeof e == "boolean")
    return e;
  if (typeof e == "string") {
    const t = e.trim().toLowerCase();
    if (t === "true")
      return !0;
    if (t === "false")
      return !1;
  }
}, vi = (e) => {
  if (typeof e == "number" && Number.isFinite(e))
    return e;
  if (typeof e == "string" && e.trim() !== "") {
    const t = Number(e);
    if (Number.isFinite(t))
      return t;
  }
}, Yn = (e, t) => {
  var i;
  const n = t.map((o) => o.toLowerCase()), r = e == null ? void 0 : e.find((o) => {
    var l, c;
    const s = (c = (l = o.attribute) == null ? void 0 : l.name) == null ? void 0 : c.toLowerCase();
    return s ? n.includes(s) : !1;
  });
  return ((i = r == null ? void 0 : r.value) == null ? void 0 : i.trim()) || "";
}, nC = (e) => {
  const [t = "", n = ""] = e.split("#");
  return { aiJobId: t.trim(), clinicalTrials: n.trim() };
}, rC = (e, t) => {
  const n = vi(e["Search precision"]) ?? vi(
    Yn(t, [
      "Search precision",
      "ai-search-precision"
    ])
  );
  if (n !== void 0 && n >= 0 && n < Wi.length)
    return n;
  const r = Nl(e["~ai_skip_vector_search"]) ?? Nl(
    Yn(t, [
      "~ai_skip_vector_search",
      "ai_skip_vector_search",
      "ai-skip-vector-search"
    ])
  ), i = vi(e["~vector_search_result_limit"]) ?? vi(
    Yn(t, [
      "~vector_search_result_limit",
      "vector_search_result_limit",
      "ai-vector-search-result-limit"
    ])
  ), o = Wi.findIndex(
    (s) => s.skipVectorSearch === r && s.vectorSearchResultLimit === i
  );
  return o >= 0 ? o : 0;
}, iC = (e, t) => {
  var i;
  if ((i = e["NCT number"]) != null && i.trim())
    return e["NCT number"].trim();
  const n = Yn(t, [
    "NCT number",
    "ai-clinical-trials-id"
  ]);
  if (n)
    return n;
  const r = Yn(t, ["ai-job-id"]);
  return nC(r).clinicalTrials;
}, oC = (e) => {
  var n, r, i, o, s;
  var t = (((n = e.eligibilityModule) == null ? void 0 : n.eligibilityCriteria) || "").replace(/\\/g, "");
  return t != "" && !t.toLowerCase().includes("inclusion criteria") && (t = `Inclusion criteria:

` + t), `Entry events:

${(i = (r = e.conditionsModule) == null ? void 0 : r.conditions) == null ? void 0 : i.map((l) => `* ${l}
`).join("")}${((s = (o = e.armsInterventionsModule) == null ? void 0 : o.interventions) == null ? void 0 : s.map((l) => `* ${l.name}
`).join("")) || ""}
${t}
  `;
}, Cd = it(
  ({
    parentId: e,
    typeContainer: t,
    afterCreate: n,
    onCancel: r,
    onGenerateStart: i,
    onGenerateError: o,
    createMethod: s,
    entity: l,
    prompt: c,
    attributes: u
  }) => {
    var Ue, Ve, Qe, pt, qt;
    const { enqueueSnackbar: p } = Nn(), d = !!l, [f, h] = J(!1), [g, C] = J(""), [T, I] = J(!1), A = Ae(0), S = Ae(!1), [_, v] = J(vl), [O, j] = J(!1), M = kp(), w = tC(c), L = ga(w.Vocabulary).length > 0 ? w.Vocabulary : Yn(u, [
      "Vocabulary",
      "ai-vocabularies"
    ]), P = ga(w["Standard concept"]).length > 0 ? w["Standard concept"] : Yn(u, [
      "Standard concept",
      "ai-standard-concepts"
    ]), [k, z] = J(
      iC(w, u)
    ), [B, q] = J({
      text: w.Description || "",
      cohort_name: (l == null ? void 0 : l.name) || "",
      model_id: "",
      vocabulary: Dl(L),
      standard_concept: Dl(
        P,
        new Map(
          Array.from(qp, ([de, ae]) => [
            de,
            ae.caption
          ])
        )
      ),
      search_precision: rC(w, u)
    }), { settings: N } = Ba(
      (de) => de.user.data
    ), ne = Vp(s, e, l, "cohortdefinition"), { options: ue, status: te } = Up(), { options: m, status: W } = Fp(), H = ie(
      async (de, ae) => {
        const [Fe, vt] = await Promise.all([
          Qf(gf),
          Xi(
            "filter.metadata.value.subject.id",
            de
          )
        ]), Ye = Fe.content.find(
          (K) => K.name === "ai-prompt"
        );
        if (!Ye)
          return;
        const Tt = vt.content.find(
          (K) => {
            var pe;
            return ((pe = K.attribute) == null ? void 0 : pe.name) === "ai-prompt";
          }
        ), at = JSON.stringify({
          Description: ae.description,
          Vocabulary: ae.vocabulary,
          "Standard concept": ae.standardConcept,
          "Search precision": ae.searchPrecision,
          "~ai_skip_vector_search": ae.skipVectorSearch,
          "~vector_search_result_limit": ae.vectorSearchResultLimit,
          "NCT number": ae.clinicalTrialsId,
          "Conflict resolution": ae.conflictResolution
        }), U = {
          attribute: { id: Ye.id },
          dataSourceId: de,
          value: at
        };
        if (Tt != null && Tt.id) {
          await ha(U, Tt.id);
          return;
        }
        await pa(U);
      },
      []
    ), y = ie(
      ({
        target: { name: de, value: ae }
      }) => {
        q((Fe) => ({ ...Fe, [de]: ae }));
      },
      []
    ), X = ie(
      (de, ae) => {
        q((Fe) => ({ ...Fe, [de]: ae }));
      },
      []
    ), V = ie(async () => {
      var de;
      if (k)
        try {
          const ae = await Zf(k);
          (de = ae == null ? void 0 : ae.data) != null && de.protocolSection && q((Fe) => ({
            ...Fe,
            text: oC(ae.data.protocolSection)
          }));
        } catch (ae) {
          p({
            message: "Error fetching clinical trial data",
            variant: "error"
          }), console.error("Error:", ae);
        }
    }, [k]), $ = ie(
      async (de) => {
        if (!(f || En(B.cohort_name) || En(B.text))) {
          h(!0);
          try {
            if (!d) {
              const at = await ur(
                t,
                B.cohort_name,
                e
              );
              if (!at.isValid) {
                C(at.message || ""), h(!1);
                return;
              }
            }
            C(""), i ? i() : p({
              message: d ? "Cohort regenerate in progress..." : "Cohort generate in progress...",
              variant: "success"
            });
            const ae = Wi[B.search_precision] ?? Wi[0], Fe = B.vocabulary.map((at) => at.value), vt = B.standard_concept.map(
              (at) => at.value
            );
            let Ye = !1;
            const Tt = await ne.generate(
              {
                title: B.cohort_name,
                description: B.text,
                clinicalTrialsId: k,
                ...Fe.length ? { vocabulary: Fe } : {},
                ...vt.length ? { standardConcept: vt } : {},
                conflictResolution: de,
                skipVectorSearch: ae.skipVectorSearch,
                vectorSearchResultLimit: ae.vectorSearchResultLimit
              },
              (at) => {
                Ye = !0, n == null || n(at);
              }
            );
            try {
              await H(Tt.id, {
                description: B.text,
                vocabulary: Fe,
                standardConcept: vt,
                searchPrecision: B.search_precision,
                skipVectorSearch: ae.skipVectorSearch,
                vectorSearchResultLimit: ae.vectorSearchResultLimit,
                clinicalTrialsId: k,
                conflictResolution: de
              });
            } catch (at) {
              console.error("Error updating ai-prompt metadata:", at);
            }
            Ye || n == null || n(Tt);
          } catch (ae) {
            o == null || o(), p({ message: "Cohort not created", variant: "error" }), console.error("Error:", ae);
          } finally {
            h(!1);
          }
        }
      },
      [
        B,
        f,
        ne,
        n,
        k,
        p,
        d,
        H,
        t,
        e,
        i,
        o
      ]
    ), le = ie(() => {
      v(vl), I(!0);
    }, []), b = ie(() => {
      I(!1), S.current = !1, jo("dialog") >= A.current && window.history.back();
    }, []);
    Q(() => {
      if (T && !S.current) {
        const de = jo("dialog") + 1;
        A.current = de, Bp("dialog", de);
      }
      S.current = T;
    }, [T]), Q(() => {
      const de = (ae) => {
        T && jo("dialog", ae.state) < A.current && I(!1);
      };
      return window.addEventListener("popstate", de), () => {
        window.removeEventListener("popstate", de);
      };
    }, [T]);
    const oe = ie(async () => {
      b(), await $(_);
    }, [b, _, $]), re = ie(() => {
      if (d) {
        le();
        return;
      }
      $(Qx);
    }, [d, le, $]);
    Q(() => {
      if (te === ce.SUCCESS) {
        const de = ue.find((ae) => ae.isDefault);
        q((ae) => ({ ...ae, model_id: de == null ? void 0 : de.value }));
      }
    }, [te]);
    const [ye, Me] = Rh(), ot = Math.round((Me - 420) / 28);
    return [ce.INITIAL, ce.IN_PROGRESS].includes(te) || [ce.INITIAL, ce.IN_PROGRESS].includes(W) ? /* @__PURE__ */ a.jsx(Qt, { children: /* @__PURE__ */ a.jsx(Ct, {}) }) : /* @__PURE__ */ a.jsxs(R, { container: !0, p: 2, children: [
      /* @__PURE__ */ a.jsx(gr, { elevated: !0, outlined: !0, children: /* @__PURE__ */ a.jsxs(R, { container: !0, spacing: 2, p: 2, children: [
        /* @__PURE__ */ a.jsx(R, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsxs(qe, { name: "name", textLabel: "Name", required: !0, children: [
          /* @__PURE__ */ a.jsx(
            Je,
            {
              id: "name",
              name: "cohort_name",
              type: "text",
              size: "medium",
              value: B.cohort_name,
              disabled: !!l,
              placeholder: "Enter name",
              onChange: (de) => {
                C(""), y(de);
              },
              fullWidth: !0
            }
          ),
          g && /* @__PURE__ */ a.jsx(fe, { color: "error.main", variant: "caption", children: g })
        ] }) }),
        /* @__PURE__ */ a.jsx(R, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsx(qe, { name: "description", textLabel: "Description", required: !0, children: /* @__PURE__ */ a.jsx(
          Je,
          {
            id: "description",
            name: "text",
            type: "text",
            size: "medium",
            value: B.text,
            placeholder: "Enter description",
            onChange: y,
            fullWidth: !0,
            multiline: !0,
            minRows: 6,
            maxRows: ot ?? 20
          }
        ) }) }),
        ((Ue = N == null ? void 0 : N.services) == null ? void 0 : Ue["clinical-trials"]) && /* @__PURE__ */ a.jsx(R, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsx(
          qe,
          {
            name: "lookup",
            textLabel: "Look up in ClinicalTrials.gov",
            children: /* @__PURE__ */ a.jsxs(R, { container: !0, spacing: 2, children: [
              /* @__PURE__ */ a.jsx(R, { item: !0, xs: 9, children: /* @__PURE__ */ a.jsx(
                Je,
                {
                  id: "nct",
                  name: "nct",
                  type: "text",
                  size: "medium",
                  value: k,
                  placeholder: "*NCT*",
                  fullWidth: !0,
                  onChange: (de) => {
                    var ae;
                    z((ae = de.target.value) == null ? void 0 : ae.trim());
                  }
                }
              ) }),
              /* @__PURE__ */ a.jsx(R, { item: !0, xs: 3, children: /* @__PURE__ */ a.jsx(
                We,
                {
                  variant: "contained",
                  color: "primary",
                  fullWidth: !0,
                  onClick: V,
                  children: "Find"
                }
              ) })
            ] })
          }
        ) }),
        /* @__PURE__ */ a.jsx(R, { item: !0, xs: 12, mt: 2, children: /* @__PURE__ */ a.jsxs(Y, { children: [
          /* @__PURE__ */ a.jsxs(
            Y,
            {
              component: "button",
              type: "button",
              onClick: () => j((de) => !de),
              "aria-expanded": O,
              "aria-controls": M,
              sx: {
                p: 0,
                m: 0,
                border: 0,
                background: "transparent",
                display: "inline-flex",
                alignItems: "center",
                gap: 0.75,
                color: "textColor.main",
                cursor: "pointer",
                fontSize: 14,
                fontWeight: 700,
                lineHeight: "20px",
                "&:focus-visible": {
                  outline: "2px solid",
                  outlineColor: "primary.main",
                  outlineOffset: 2
                }
              },
              children: [
                "Concept Set options",
                /* @__PURE__ */ a.jsx(
                  ge,
                  {
                    iconName: "chevronFilled",
                    sx: {
                      fontSize: 8,
                      color: "#7B8599",
                      transform: O ? "rotate(180deg)" : "rotate(0deg)",
                      transition: "transform 0.2s ease"
                    }
                  }
                )
              ]
            }
          ),
          O && /* @__PURE__ */ a.jsxs(
            R,
            {
              container: !0,
              spacing: 2,
              id: M,
              sx: { pt: "16px" },
              children: [
                /* @__PURE__ */ a.jsx(R, { item: !0, xs: 12, sm: 6, children: /* @__PURE__ */ a.jsx(
                  qe,
                  {
                    name: "standard_concept",
                    textLabel: "Standard Concept",
                    children: /* @__PURE__ */ a.jsx(
                      zi,
                      {
                        id: "standard_concept",
                        name: "standard_concept",
                        options: ((Ve = m == null ? void 0 : m.standard_concepts) == null ? void 0 : Ve.filter(
                          (de) => {
                            var ae;
                            return !((ae = B.standard_concept) != null && ae.some(
                              (Fe) => Fe.value === de.value
                            ));
                          }
                        )) || [],
                        value: B.standard_concept,
                        placeholder: (Qe = B.standard_concept) != null && Qe.length ? "" : "Any",
                        multiple: !0,
                        onChange: (de, ae) => {
                          X("standard_concept", ae);
                        },
                        fullWidth: !0,
                        isOptionEqualToValue: (de, ae) => de.value === ae,
                        getOptionLabel: _l
                      }
                    )
                  }
                ) }),
                /* @__PURE__ */ a.jsx(R, { item: !0, xs: 12, sm: 6, children: /* @__PURE__ */ a.jsx(qe, { name: "vocabulary", textLabel: "Vocabulary", children: /* @__PURE__ */ a.jsx(
                  zi,
                  {
                    id: "vocabulary",
                    name: "vocabulary",
                    options: ((pt = m == null ? void 0 : m.vocabularies) == null ? void 0 : pt.filter(
                      (de) => {
                        var ae;
                        return !((ae = B.vocabulary) != null && ae.some(
                          (Fe) => Fe.value === de.value
                        ));
                      }
                    )) || [],
                    value: B.vocabulary,
                    multiple: !0,
                    placeholder: (qt = B.vocabulary) != null && qt.length ? "" : "Any",
                    onChange: (de, ae) => {
                      X("vocabulary", ae);
                    },
                    fullWidth: !0,
                    isOptionEqualToValue: (de, ae) => de.value === ae,
                    getOptionLabel: _l
                  }
                ) }) }),
                /* @__PURE__ */ a.jsx(R, { item: !0, xs: 12, sm: 6, children: /* @__PURE__ */ a.jsx(
                  qe,
                  {
                    name: "search_precision",
                    textLabel: "Search Precision",
                    children: /* @__PURE__ */ a.jsx(
                      Oh,
                      {
                        value: B.search_precision,
                        onChange: (de) => X("search_precision", de),
                        disabled: f
                      }
                    )
                  }
                ) })
              ]
            }
          )
        ] }) }),
        /* @__PURE__ */ a.jsx(R, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsxs(co, { children: [
          /* @__PURE__ */ a.jsx(
            We,
            {
              variant: "outlined",
              disabled: f,
              onClick: r,
              startIcon: /* @__PURE__ */ a.jsx(ge, { iconName: "deactivate" }),
              children: "Cancel"
            }
          ),
          /* @__PURE__ */ a.jsx(
            We,
            {
              disabled: f || En(B.cohort_name) || En(B.text),
              onClick: re,
              variant: "contained",
              color: "success",
              startIcon: f ? /* @__PURE__ */ a.jsx(Ct, { size: 16 }) : /* @__PURE__ */ a.jsx(ge, { iconName: "stars" }),
              children: d ? "Regenerate" : "Generate"
            }
          )
        ] }) })
      ] }) }),
      /* @__PURE__ */ a.jsxs(
        vh,
        {
          open: T,
          onClose: b,
          maxWidth: "sm",
          fullWidth: !0,
          children: [
            /* @__PURE__ */ a.jsx(Dh, { children: "Confirm duplicate concept-set handling:" }),
            /* @__PURE__ */ a.jsxs(_h, { children: [
              /* @__PURE__ */ a.jsx(fe, { variant: "body2", color: "text.secondary", sx: { mb: 1.5 }, children: "In case AI generates concept sets that already exist in current Workspace or Study, would you like to" }),
              /* @__PURE__ */ a.jsxs(Y, { display: "flex", flexDirection: "column", rowGap: 1, children: [
                /* @__PURE__ */ a.jsxs(Y, { display: "flex", alignItems: "center", columnGap: 0.5, children: [
                  /* @__PURE__ */ a.jsx(
                    $i,
                    {
                      checked: _ === "NEW_VERSION",
                      onChange: () => v("NEW_VERSION"),
                      name: "generate-conflict-resolution-dialog",
                      size: "small"
                    }
                  ),
                  /* @__PURE__ */ a.jsx(fe, { variant: "subtitle2", children: "OVERWRITE existing Concept Set(s) where possible (recommended)" }),
                  /* @__PURE__ */ a.jsx(Xe, { text: Zx, children: /* @__PURE__ */ a.jsx(
                    ge,
                    {
                      iconName: "info",
                      sx: { fontSize: 14, color: "text.secondary" }
                    }
                  ) })
                ] }),
                /* @__PURE__ */ a.jsxs(Y, { display: "flex", alignItems: "center", columnGap: 0.5, children: [
                  /* @__PURE__ */ a.jsx(
                    $i,
                    {
                      checked: _ === "NEW_OBJECT",
                      onChange: () => v("NEW_OBJECT"),
                      name: "generate-conflict-resolution-dialog",
                      size: "small"
                    }
                  ),
                  /* @__PURE__ */ a.jsx(fe, { variant: "subtitle2", children: "Create NEW Concept Set(s)" }),
                  /* @__PURE__ */ a.jsx(Xe, { text: eC, children: /* @__PURE__ */ a.jsx(
                    ge,
                    {
                      iconName: "info",
                      sx: { fontSize: 14, color: "text.secondary" }
                    }
                  ) })
                ] })
              ] })
            ] }),
            /* @__PURE__ */ a.jsxs(Nh, { children: [
              /* @__PURE__ */ a.jsx(
                We,
                {
                  variant: "outlined",
                  color: "darkGrey",
                  disabled: f,
                  onClick: b,
                  children: "Cancel"
                }
              ),
              /* @__PURE__ */ a.jsx(
                We,
                {
                  variant: "contained",
                  color: "success",
                  disabled: f,
                  onClick: () => {
                    oe();
                  },
                  children: d ? "Regenerate" : "Generate"
                }
              )
            ] })
          ]
        }
      )
    ] });
  }
), aC = ({ viewMode: e }) => {
  const t = yr(), n = au(), { openModal: r, closeModal: i } = Le(gn), [o, s] = J(), [l, c] = J(!1), { enqueueSnackbar: u } = Nn(), p = Le(
    Sn
  ), d = ee(() => p == null ? void 0 : p.config, []), f = Ba(
    (_) => _.user
  ), h = ee(() => {
    var _;
    return (_ = f.data.moduleIds) == null ? void 0 : _.includes("ai");
  }, [f]), g = ee(() => Zr(d.typeContainer, d.parentId), [d.typeContainer, d.parentId]), C = ee(() => vu(d.typeContainer, d.parentId), [d.typeContainer, d.parentId]), T = () => {
    n(of(d.typeContainer, d.parentId));
  }, I = () => {
    r(
      () => /* @__PURE__ */ a.jsx(
        xd,
        {
          parentId: d.parentId,
          typeContainer: d.typeContainer,
          createMethod: g,
          onCancel: i,
          afterCreate: (_) => {
            t(_.id), i(), T();
          }
        }
      ),
      "Add cohort",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: i
      }
    );
  }, A = () => {
    r(
      () => /* @__PURE__ */ a.jsx(
        Cd,
        {
          parentId: d.parentId,
          typeContainer: d.typeContainer,
          createMethod: g,
          onCancel: i,
          onGenerateStart: () => {
            i(), u({
              message: "Cohort generate in progress...",
              variant: "success"
            }), c(!0);
          },
          onGenerateError: () => {
            c(!1);
          },
          afterCreate: (_) => {
            t(`${_.id}`, {
              state: { aiGenerateRequested: !0 }
            }), T();
          }
        }
      ),
      "Generate Cohort",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: i
      }
    );
  }, S = () => {
    r(
      () => /* @__PURE__ */ a.jsx(
        Yc,
        {
          name: "cohorts",
          currentContainer: d.typeContainer,
          parentId: d.parentId,
          onChange: async () => {
            s(Yt()), i();
          },
          createListMethods: Ki,
          cols: za,
          createListFiltersMethod: fa,
          createMethodCreate: Zr,
          subModules: p.subModules,
          isSelect: !0,
          hideConflictResolutionMethod: !0,
          hideConflictResolutionControls: !0,
          successMessage: "Cohort(s) successfully imported.",
          atlasEntity: [Va.COHORT],
          manualImport: !0,
          manualImportComponent: /* @__PURE__ */ a.jsx(
            Ru,
            {
              typeContainer: d.typeContainer,
              parentId: d.parentId,
              importMethod: C,
              fullEntity: !0,
              onChange: (_) => {
                t(_.id), i(), T();
              }
            }
          )
        }
      ),
      "Import cohort",
      {
        onClose: i,
        closeOnClickOutside: !0
      }
    );
  };
  return l ? /* @__PURE__ */ a.jsx(Qt, { background: "/images/back.png", children: /* @__PURE__ */ a.jsx(Kc, {}) }) : /* @__PURE__ */ a.jsx(
    Hc,
    {
      reloadId: o,
      isImport: !0,
      onImport: S,
      onCreate: I,
      onGenerate: h && A,
      moduleConfig: p,
      viewMode: e,
      listConfig: {
        rowId: "id",
        loadingMessage: "Loading cohorts...",
        addButtonTitle: "Add cohort",
        tableTitle: "Cohorts",
        moduleDescription: "Cohort is a set of persons who satisfy one or more inclusion and/or exclusion criteria for a duration of time.",
        importButtonTitle: "Import",
        listInitialSort: { id: "modified.timestamp", desc: !0 },
        createCrudMethod: Ki,
        createFiltersPanel: fa,
        createSortingMethod: Ou,
        getCols: gm,
        metadataFilter: "&filter.metadata.subject=COHORT",
        extendedSearchEnabled: !1
      },
      variant: "description",
      allowDelete: !0
    }
  );
};
function sC(e, t, n) {
  var r = this, i = Ae(null), o = Ae(0), s = Ae(null), l = Ae([]), c = Ae(), u = Ae(), p = Ae(e), d = Ae(!0);
  Q(function() {
    p.current = e;
  }, [e]);
  var f = !t && t !== 0 && typeof window < "u";
  if (typeof e != "function") throw new TypeError("Expected a function");
  t = +t || 0;
  var h = !!(n = n || {}).leading, g = !("trailing" in n) || !!n.trailing, C = "maxWait" in n, T = C ? Math.max(+n.maxWait || 0, t) : null;
  Q(function() {
    return d.current = !0, function() {
      d.current = !1;
    };
  }, []);
  var I = ee(function() {
    var A = function(M) {
      var w = l.current, L = c.current;
      return l.current = c.current = null, o.current = M, u.current = p.current.apply(L, w);
    }, S = function(M, w) {
      f && cancelAnimationFrame(s.current), s.current = f ? requestAnimationFrame(M) : setTimeout(M, w);
    }, _ = function(M) {
      if (!d.current) return !1;
      var w = M - i.current;
      return !i.current || w >= t || w < 0 || C && M - o.current >= T;
    }, v = function(M) {
      return s.current = null, g && l.current ? A(M) : (l.current = c.current = null, u.current);
    }, O = function M() {
      var w = Date.now();
      if (_(w)) return v(w);
      if (d.current) {
        var L = t - (w - i.current), P = C ? Math.min(L, T - (w - o.current)) : L;
        S(M, P);
      }
    }, j = function() {
      var M = Date.now(), w = _(M);
      if (l.current = [].slice.call(arguments), c.current = r, i.current = M, w) {
        if (!s.current && d.current) return o.current = i.current, S(O, t), h ? A(i.current) : u.current;
        if (C) return S(O, t), A(i.current);
      }
      return s.current || S(O, t), u.current;
    };
    return j.cancel = function() {
      s.current && (f ? cancelAnimationFrame(s.current) : clearTimeout(s.current)), o.current = 0, l.current = i.current = c.current = s.current = null;
    }, j.isPending = function() {
      return !!s.current;
    }, j.flush = function() {
      return s.current ? v(Date.now()) : u.current;
    }, j;
  }, [h, C, t, T, g, f]);
  return I;
}
function lC(e, t) {
  return e === t;
}
function wl(e) {
  return typeof e == "function" ? function() {
    return e;
  } : e;
}
function cC(e, t, n) {
  var r, i, o = lC, s = (r = J(wl(e)), i = r[1], [r[0], ie(function(d) {
    return i(wl(d));
  }, [])]), l = s[0], c = s[1], u = sC(ie(function(d) {
    return c(d);
  }, [c]), t, n), p = Ae(e);
  return o(p.current, e) || (u(e), p.current = e), [l, u];
}
var sn = /* @__PURE__ */ ((e) => (e.SET_DEFINITION_RELOAD = "SET_DEFINITION_RELOAD", e.SET_DEFINITION = "SET_DEFINITION", e.SET_AI_ATTRIBUTES = "SET_AI_ATTRIBUTES", e.START_GENERATION = "START_GENERATION", e.UPDATE_DEFINITION = "UPDATE_DEFINITION", e.UPDATE_DEFINITION_BASE = "UPDATE_DEFINITION_BASE", e.CLEAR_DEFINITION = "CLEAR_DEFINITION", e.GET_SUMMARY = "GET_SUMMARY", e.SET_AI_RESULTS = "SET_AI_RESULTS", e.FINISH_GENERATION = "FINISH_GENERATION", e.INIT_DEFINITION = "INIT_DEFINITION", e))(sn || {});
const uC = {
  definition: null,
  definitionStatus: ce.INITIAL,
  definitionError: null,
  summary: {
    metadata: 0,
    versions: 0
  },
  aiAttrbutes: [],
  aiGenerate: !1,
  aiJobId: null,
  aiStatus: null,
  aiOutput: null,
  aiValues: null,
  aiCompleteTimestamp: null,
  aiCompleteGeneration: !0,
  aiGenerationPending: !1,
  clinicalTrials: null,
  isAiCohort: !1
}, dC = (e, t) => ui(e, (n) => {
  switch (t.type) {
    case "SET_DEFINITION_RELOAD": {
      n.definitionStatus = ce.IN_PROGRESS;
      break;
    }
    case "SET_DEFINITION":
      n.definitionStatus = ce.SUCCESS, n.definition = t.payload;
      break;
    case "UPDATE_DEFINITION":
      n.definition && (n.definition.expression[t.payload.prop] = t.payload.value);
      break;
    case "UPDATE_DEFINITION_BASE":
      n.definition && (n.definition = {
        ...n.definition,
        ...t.payload
      });
      break;
    case "INIT_DEFINITION":
      n.definitionStatus = ce.SUCCESS, n.definition = t.payload.definition, n.summary = t.payload.summary, n.aiValues = t.payload.aiMetadata.aiValues, t.payload.aiMetadata.aiGenerate && (n.aiGenerationPending = !1), n.aiGenerate = t.payload.aiMetadata.aiGenerate || n.aiGenerationPending, n.isAiCohort = t.payload.aiMetadata.isAiCohort;
      break;
    case "GET_SUMMARY":
      n.summary = t.payload;
      break;
    case "SET_AI_ATTRIBUTES":
      if (n.aiValues = t.payload.aiValues, n.isAiCohort = t.payload.isAiCohort, t.payload.terminalAiStatus) {
        n.aiGenerate = !1, n.aiGenerationPending = !1;
        break;
      }
      t.payload.aiGenerate && (n.aiGenerationPending = !1), n.aiGenerate = t.payload.aiGenerate || n.aiGenerationPending;
      break;
    case "START_GENERATION":
      n.aiGenerate = !0, n.aiGenerationPending = !0;
      break;
    case "CLEAR_DEFINITION":
      t.payload.forEach((r) => {
        delete n.definition.expression[r];
      });
      break;
  }
}), gd = {
  PrimaryCriteria: {
    CriteriaList: [],
    ObservationWindow: {
      PriorDays: 0,
      PostDays: 0
    },
    PrimaryCriteriaLimit: {
      Type: Ht.FIRST
    }
  },
  QualifiedLimit: {
    Type: Ht.FIRST
  },
  ExpressionLimit: {
    Type: Ht.FIRST
  },
  InclusionRules: [],
  CensoringCriteria: [],
  CollapseSettings: {
    CollapseType: Xp.ERA,
    EraPad: 0
  },
  CensorWindow: {},
  ConceptSets: []
};
function ni(e) {
  if (!e || typeof e != "object") return e;
  let t = {};
  for (let n in e) {
    let r = e[n];
    if (r !== void 0)
      if (typeof r == "object" && r !== null) {
        let i = Object.keys(r), o = { ...r };
        for (let s of i)
          if (s.endsWith("Exclude")) {
            let l = s.replace("Exclude", "");
            (o[s] === !1 || !i.includes(l)) && delete o[s];
          }
        t[n] = ni(o);
      } else
        t[n] = r;
  }
  return t;
}
function ts(e) {
  return Array.isArray(e) ? e.map((t) => {
    if (typeof t != "object" || t === null) return t;
    let n = ni(t);
    return n.CorrelatedCriteria && typeof n.CorrelatedCriteria == "object" && Array.isArray(n.CorrelatedCriteria.CriteriaList) && (n.CorrelatedCriteria.CriteriaList = ts(
      n.CorrelatedCriteria.CriteriaList
    )), n.Criteria && typeof n.Criteria == "object" && (n.Criteria = ni(n.Criteria)), n;
  }) : e;
}
function pC(e) {
  return Array.isArray(e) ? e.map((t) => {
    if (typeof t != "object" || t === null) return t;
    let n = ni(t);
    return n.expression && n.expression.CriteriaList && (n.expression.CriteriaList = ts(
      n.expression.CriteriaList
    )), n;
  }) : e;
}
function hC(e, t) {
  return {
    ...e,
    expression: {
      items: Object.values(t || {}).map((n) => {
        const { id: r, ...i } = n, o = n.excluded ?? n.isExcluded;
        return {
          ...i,
          concept: null,
          isExcluded: o,
          excluded: o,
          hierarchy: n.hierarchy,
          includeDescendants: n.includeDescendants,
          includeMapped: n.includeMapped
        };
      })
    }
  };
}
function io(e) {
  if (!e || typeof e != "object") return e;
  let t = ni(e);
  return t.PrimaryCriteria && Array.isArray(t.PrimaryCriteria.CriteriaList) && (t.PrimaryCriteria.CriteriaList = ts(
    t.PrimaryCriteria.CriteriaList
  )), t.InclusionRules && Array.isArray(t.InclusionRules) && (t.InclusionRules = pC(
    t.InclusionRules
  )), t.ConceptSets && (t.ConceptSets = (Array.isArray(t.ConceptSets) ? t.ConceptSets : Object.values(t.ConceptSets)).map((n) => {
    var r;
    if (typeof n == "object" && n !== null) {
      const { uuid: i, ...o } = n;
      return hC(o, (r = n.expression) == null ? void 0 : r.items);
    }
    return n;
  })), t;
}
const fC = (e, t, n, r) => {
  if (n !== ce.SUCCESS || r !== ce.SUCCESS || !e || !t)
    return !0;
  const i = ke(e.name, t.name) && ke(e.description, t.description);
  if (!e.expression && ke(t.expression, gd))
    return i;
  const o = io(e.expression), s = io(t.expression);
  return ke(o, s) && i;
}, mC = (e) => e == null ? !1 : typeof e == "string" ? e.trim().length > 0 : !0;
function EC(e) {
  var r;
  const t = (r = e == null ? void 0 : e.expression) == null ? void 0 : r.ConceptSets;
  if (!t) return e;
  const n = t.map((i) => {
    const { isNewImport: o, uuid: s, expression: l, ...c } = i, u = { ...c }, p = mC(s);
    return o === !0 && p ? u.uuid = s : (p && (u.uuid = s), l !== void 0 && (u.expression = l)), u;
  });
  return {
    ...e,
    expression: {
      ...e.expression,
      ConceptSets: n
    }
  };
}
function ya(e) {
  return Array.isArray(e) ? e.map((t) => ya(t)) : !e || typeof e != "object" ? e : Object.entries(e).reduce((t, [n, r]) => (r !== void 0 && (t[n] = ya(r)), t), {});
}
function xC(e) {
  const [t = "", n = ""] = e.split("#");
  return { aiJobId: t.trim(), clinicalTrials: n.trim() };
}
const yd = /^\s*(?:#{1,6}\s*)?(?:\d+[.)]\s*)?(?:Sources|Resources|References)(?:\s*(?:and|\/)\s*(?:Sources|Resources|References))*\s*:?\s*$/i, Td = /^(?:[-*\u2022]|\d+[.)])/;
function Sd(e) {
  const t = e.split(`
`), n = t.findIndex(
    (o) => yd.test(o.trim())
  );
  if (n === -1)
    return e;
  let r = !1, i = n + 1;
  for (; i < t.length && (Td.test(t[i].trim()) || t[i].trim() === ""); ) {
    const o = t[i].trim(), s = o.match(/https?:\/\/[^\s)]+/);
    if (s && !o.includes("](")) {
      const l = s[0], u = o.replace(/^(?:[-*\u2022]|\d+[.)])\s*/, "").replace(l, "").trim().replace(/[:\-.]+$/, "") || l;
      t[i] = `- [${u}](${l})`, r = !0;
    }
    i++;
  }
  return r ? t.join(`
`) : e;
}
function CC(e, t) {
  const n = `https://clinicaltrials.gov/study/${t}`, r = Sd(e), i = r.split(`
`), o = i.findIndex(
    (l) => yd.test(l.trim())
  );
  if (o === -1)
    return t ? `${r.trim()}

## Sources:
- [ClinicalTrials.gov reference: ${n}](${n})` : r;
  let s = o + 1;
  for (; s < i.length && (Td.test(i[s].trim()) || i[s].trim() === ""); )
    s++;
  return t && (i.some((c) => c.includes(n)) || i.splice(
    s,
    0,
    `- [ClinicalTrials.gov reference: ${n}](${n})`
  )), i.join(`
`);
}
function gC(e) {
  var r, i;
  const t = ((r = e.find(
    (o) => {
      var s;
      return ((s = o.attribute) == null ? void 0 : s.name) === "ai-clinical-trials-id";
    }
  )) == null ? void 0 : r.value) || "";
  if (t)
    return t.trim();
  const n = ((i = e.find((o) => {
    var s;
    return ((s = o.attribute) == null ? void 0 : s.name) === "ai-job-id";
  })) == null ? void 0 : i.value) || "";
  return xC(n).clinicalTrials;
}
function yC(e) {
  const t = gC(e);
  let n = !1;
  const r = e.map((i) => {
    var c;
    if (((c = i.attribute) == null ? void 0 : c.name) !== "ai-reasoning")
      return i;
    const o = i.value ?? "", s = Sd(o), l = t ? CC(s, t) : s;
    return l !== o ? (n = !0, {
      ...i,
      value: l
    }) : i;
  });
  return n ? r : e;
}
const TC = (e, t, n) => {
  const r = $p(
    e,
    t,
    n
  ), [i, o] = xr(
    dC,
    uC
  ), s = ie(
    async (A = !1) => {
      try {
        const S = await Jf(t);
        if (A)
          return S;
        o({
          type: sn.GET_SUMMARY,
          payload: S
        });
      } catch {
        return {
          metadata: 0,
          versions: 0
        };
      }
    },
    [t]
  ), l = async (A) => {
    await r.getEntity(), await c(!1, A);
  }, c = async (A = !1, S) => {
    var _;
    try {
      const v = await Xi(
        "filter.metadata.value.subject.id",
        t
      ), O = v.content.find(tu), j = yC(v.content), M = (_ = v.content.find(qh)) == null ? void 0 : _.value, w = (O == null ? void 0 : O.value) === "Yes" && ["IN_PROGRESS", "QUEUED"].includes(M || ""), L = {
        aiValues: j,
        // Terminal AI events are authoritative even if metadata is briefly stale.
        aiGenerate: S ? !1 : w,
        terminalAiStatus: S,
        isAiCohort: (O == null ? void 0 : O.value) === "Yes"
      };
      if (A)
        return L;
      o({
        type: sn.SET_AI_ATTRIBUTES,
        payload: L
      });
    } catch {
      return null;
    }
  }, u = ie(() => {
    if (i.definitionStatus != ce.SUCCESS)
      return;
    const A = io(r.draft.expression), S = io(i.definition.expression);
    return ke(A, S);
  }, [
    r.draft,
    i.definition,
    r.status,
    i.definitionStatus
  ]), p = ee(() => fC(
    r.draft,
    i.definition,
    r.status,
    i.definitionStatus
  ), [
    r.draft,
    i.definition,
    r.status,
    i.definitionStatus
  ]), d = ie(
    (A, S, _ = !1) => {
      const v = {
        ...A,
        expression: {
          ...gd,
          ...A.expression
        },
        ...S && {
          name: S.name,
          description: S.description
        }
      };
      if (_)
        return v;
      o({
        type: sn.SET_DEFINITION,
        payload: v
      });
    },
    []
  ), f = ie(
    (A, S) => {
      var v;
      const _ = (v = i.definition) == null ? void 0 : v.expression;
      ke(_ == null ? void 0 : _[A], S) || o({
        type: sn.UPDATE_DEFINITION,
        payload: {
          prop: A,
          value: S
        }
      });
    },
    [i.definition]
  ), h = ie(
    (A) => {
      o({
        type: sn.UPDATE_DEFINITION_BASE,
        payload: A
      });
    },
    []
  ), g = ie(
    (A) => {
      o({
        type: sn.CLEAR_DEFINITION,
        payload: A
      });
    },
    [i.definition]
  ), C = ie(
    async (A) => {
      var v, O;
      const S = {
        ...i.definition,
        expression: ya((v = i.definition) == null ? void 0 : v.expression)
      }, _ = EC(S);
      try {
        await r.updateEntity({
          ..._,
          name: A.name,
          description: A.description ?? ((O = i.definition) == null ? void 0 : O.description)
        }), await s();
      } catch (j) {
        console.error(j);
      }
    },
    [i.definition, r.updateEntity]
  ), T = ie(() => {
    o({
      type: sn.START_GENERATION
    });
  }, []), I = async (A) => {
    o({ type: sn.SET_DEFINITION_RELOAD });
    const S = await s(!0), _ = await c(!0), v = d(A, void 0, !0);
    o({
      type: sn.INIT_DEFINITION,
      payload: {
        summary: S,
        aiMetadata: _,
        definition: v
      }
    });
  };
  return Q(() => {
    var A, S, _, v;
    if (r.status === ce.SUCCESS) {
      const O = u(), j = (A = r.draft) == null ? void 0 : A.versionId, M = (S = i.definition) == null ? void 0 : S.versionId, w = (_ = r.draft) == null ? void 0 : _.designVersionId, L = (v = i.definition) == null ? void 0 : v.designVersionId;
      if (O && !(j !== M || w !== L)) {
        (async () => (await c(), await s()))();
        return;
      }
      I(r.draft);
    }
  }, [r.status, r.draft]), {
    ...i,
    ...r,
    updateDefinition: f,
    updateDefinitionBase: h,
    saveDefinition: C,
    setDefinition: d,
    isEqual: p,
    clearDefinition: g,
    getCountsSummary: s,
    refetchEntity: l,
    startGeneration: T
  };
}, SC = it((e) => {
  const {
    messages: t,
    setFilters: n,
    filter: r,
    filters: i,
    isLoading: o,
    fixEntity: s,
    fixEntityAvailability: l
  } = e;
  return /* @__PURE__ */ a.jsx(
    lh,
    {
      messages: t,
      setFilters: n,
      filters: i,
      filter: r,
      isLoading: o,
      fixEntity: s,
      fixEntityAvailability: l,
      loadingMessage: "Loading Cohort Messages"
    }
  );
});
var ri = /* @__PURE__ */ ((e) => (e.CONCEPT_SET_ID = "conceptSetId", e.RULE_NAME = "ruleName", e))(ri || {});
function IC(e, t, n) {
  var r;
  if (e.type === Bi.CONCEPT_SET && e.hasOwnProperty(ri.CONCEPT_SET_ID)) {
    const i = (t == null ? void 0 : t.ConceptSets) || [];
    if (i.find((s) => s.id === e.conceptSetId)) {
      const s = i.filter((l) => l.id !== e.conceptSetId);
      n("ConceptSets", s);
    }
  }
  if (e.type === Bi.INCOMPLETE_RULE && e.hasOwnProperty(ri.RULE_NAME)) {
    const i = ((r = t == null ? void 0 : t.definition) == null ? void 0 : r.InclusionRules) || [];
    if (i.find((s) => s.name === e.ruleName)) {
      const s = {
        ...t == null ? void 0 : t.definition,
        InclusionRules: i.filter(
          (l) => l.name !== e.ruleName
        )
      };
      n("InclusionRules", s);
    }
  }
}
function AC(e) {
  return e.type === Bi.CONCEPT_SET && e.hasOwnProperty(ri.CONCEPT_SET_ID) || e.type === Bi.INCOMPLETE_RULE && e.hasOwnProperty(ri.RULE_NAME);
}
const bC = it((e) => {
  const { data: t } = e, { exportCohort: n, getExportCohort: r } = Gp(
    ki.COHORT,
    null,
    t
  ), i = ee(
    () => n == null ? void 0 : n.expression,
    [n]
  ), o = ee(() => n == null ? void 0 : n.name, [n == null ? void 0 : n.name]), s = ee(
    () => nu(Jr.JSON),
    []
  );
  return Q(() => {
    t && r(t, "circe");
  }, [t]), /* @__PURE__ */ a.jsx(R, { container: !0, p: 2, children: /* @__PURE__ */ a.jsx(R, { item: !0, xs: 12, children: i ? /* @__PURE__ */ a.jsx(
    qc,
    {
      data: i,
      fileName: o,
      language: s,
      readOnly: !0,
      fileExtension: Jr.JSON
    }
  ) : /* @__PURE__ */ a.jsx(Qt, { children: /* @__PURE__ */ a.jsx(Ct, { size: 32 }) }) }) });
}), Di = [
  {
    value: "template-ohdsi",
    name: "Template OHDSI.SQL",
    requests: ["template", "ohdsi", "generic"]
  },
  {
    value: "mssql-server",
    name: "MSSQL Server",
    requests: ["sql server", "sql_server", "mssql", "ms_sql_server"]
  },
  {
    value: "ms-aps",
    name: "MS APS",
    requests: ["pdw", "aps", "sql_server_pdw"]
  },
  {
    value: "oracle",
    name: "Oracle",
    requests: ["oracle"]
  },
  {
    value: "postgresql",
    name: "PostgreSQL",
    requests: ["postgresql", "postgres"]
  },
  {
    value: "redshift",
    name: "Amazon Red Shift",
    requests: ["redshift"]
  },
  {
    value: "impala",
    name: "Impala",
    requests: ["impala"]
  },
  {
    value: "netezza",
    name: "Netezza",
    requests: ["netezza"]
  },
  {
    value: "bigquery",
    name: "Big Query",
    requests: ["bigquery", "google_bigquery"]
  },
  {
    value: "hive",
    name: "Apache Hive",
    requests: ["hive", "apache_hive"]
  },
  {
    value: "spark",
    name: "Spark",
    requests: ["spark"]
  },
  {
    value: "snowflake",
    name: "Snowflake",
    requests: ["snowflake"]
  },
  {
    value: "azure-synapse",
    name: "Azure Synapse",
    requests: ["synapse"]
  },
  {
    value: "iris",
    name: "InterSystems IRIS",
    requests: ["iris"]
  }
], RC = "-- SQL template is unavailable for selected database dialect", Pl = {
  tempDatabaseSchema: "@temp_database_schema",
  vocabularyDatabaseSchema: "@vocabulary_database_schema",
  cdmDatabaseSchema: "@cdm_database_schema",
  targetDatabaseSchema: "@target_database_schema",
  targetCohortTable: "@target_cohort_table",
  targetCohortId: "@target_cohort_id"
}, Go = (e) => typeof e == "object" && e !== null, OC = (e) => {
  if (!Go(e) || !Go(e.response))
    return "Failed to load SQL export";
  const t = e.response.data;
  return Go(t) && typeof t.message == "string" && t.message.trim() ? t.message : "Failed to load SQL export";
}, vC = (e) => ({
  tempDatabaseSchema: "",
  vocabularyDatabaseSchema: "",
  cdmDatabaseSchema: "",
  targetDatabaseSchema: "",
  targetCohortTable: "",
  targetCohortId: e || ""
}), DC = (e, t) => Object.keys(Pl).reduce(
  (n, r) => {
    const i = Pl[r], o = t[r].trim();
    return o ? n.split(i).join(o) : n;
  },
  e
), _C = it(
  ({ cohortId: e, cohortName: t, cohortShortcut: n }) => {
    const [r, i] = J("template-ohdsi"), [o, s] = J(""), [l, c] = J(ce.INITIAL), [u, p] = J(""), [d, f] = J(!1), [h, g] = J(
      () => vC(n)
    ), C = ee(
      () => Di.find((S) => S.value === r) || Di[0],
      [r]
    ), T = ee(
      () => nu(Jr.SQL),
      []
    ), I = ee(() => {
      const S = o || RC;
      return d ? DC(S, h) : S;
    }, [o, d, h]);
    Q(() => {
      let S = !0;
      return c(ce.IN_PROGRESS), p(""), rm(
        e,
        C.requests,
        r === "template-ohdsi"
      ).then((_) => {
        S && (s(_), c(ce.SUCCESS));
      }).catch((_) => {
        if (!S)
          return;
        const v = OC(_);
        p(v), s(""), c(ce.ERROR);
      }), () => {
        S = !1;
      };
    }, [e, C]);
    const A = (S, _) => {
      g((v) => ({
        ...v,
        [S]: _
      }));
    };
    return /* @__PURE__ */ a.jsxs(R, { container: !0, p: 2, spacing: 2, children: [
      /* @__PURE__ */ a.jsx(R, { item: !0, xs: 12, md: 8, children: /* @__PURE__ */ a.jsx(
        qe,
        {
          name: "databaseDialect",
          textLabel: "Database dialect",
          required: !0,
          children: /* @__PURE__ */ a.jsx(
            Rt,
            {
              id: "databaseDialect",
              name: "databaseDialect",
              options: Di,
              value: r,
              onChange: (S) => {
                var v;
                if (typeof S != "string")
                  return;
                const _ = (v = Di.find(
                  (O) => O.value === S
                )) == null ? void 0 : v.value;
                _ && i(_);
              },
              fullWidth: !0
            }
          )
        }
      ) }),
      /* @__PURE__ */ a.jsxs(R, { item: !0, xs: 12, md: 8, children: [
        l === ce.IN_PROGRESS && /* @__PURE__ */ a.jsx(Qt, { children: /* @__PURE__ */ a.jsx(Ct, { size: 32 }) }),
        l !== ce.IN_PROGRESS && /* @__PURE__ */ a.jsx(
          qc,
          {
            data: I,
            fileName: `${t}-${C.value}`,
            language: T,
            readOnly: !0,
            fileExtension: Jr.SQL
          },
          `${C.value}-${d ? "substituted" : "template"}`
        ),
        u && /* @__PURE__ */ a.jsx(
          fe,
          {
            variant: "body2",
            color: "error",
            mt: 1,
            className: "cohort-sql-export-error",
            children: u
          }
        )
      ] }),
      /* @__PURE__ */ a.jsxs(R, { item: !0, xs: 12, md: 4, children: [
        /* @__PURE__ */ a.jsx(
          fe,
          {
            component: "div",
            sx: {
              color: (S) => {
                var _, v;
                return (v = (_ = S.palette) == null ? void 0 : _.textColor) == null ? void 0 : v.header;
              },
              fontSize: 13,
              fontWeight: 700,
              mb: 1.25
            },
            children: "Parameter substitution"
          }
        ),
        /* @__PURE__ */ a.jsxs(R, { container: !0, rowGap: 1.25, children: [
          /* @__PURE__ */ a.jsx(R, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsx(
            qe,
            {
              name: "tempDatabaseSchema",
              textLabel: "temp_database_schema",
              children: /* @__PURE__ */ a.jsx(
                Je,
                {
                  id: "tempDatabaseSchema",
                  name: "tempDatabaseSchema",
                  value: h.tempDatabaseSchema,
                  onChange: (S) => A("tempDatabaseSchema", S.target.value),
                  fullWidth: !0
                }
              )
            }
          ) }),
          /* @__PURE__ */ a.jsx(R, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsx(
            qe,
            {
              name: "vocabularyDatabaseSchema",
              textLabel: "vocabulary_database_schema",
              children: /* @__PURE__ */ a.jsx(
                Je,
                {
                  id: "vocabularyDatabaseSchema",
                  name: "vocabularyDatabaseSchema",
                  value: h.vocabularyDatabaseSchema,
                  onChange: (S) => A(
                    "vocabularyDatabaseSchema",
                    S.target.value
                  ),
                  fullWidth: !0
                }
              )
            }
          ) }),
          /* @__PURE__ */ a.jsx(R, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsx(
            qe,
            {
              name: "cdmDatabaseSchema",
              textLabel: "cdm_database_schema",
              children: /* @__PURE__ */ a.jsx(
                Je,
                {
                  id: "cdmDatabaseSchema",
                  name: "cdmDatabaseSchema",
                  value: h.cdmDatabaseSchema,
                  onChange: (S) => A("cdmDatabaseSchema", S.target.value),
                  fullWidth: !0
                }
              )
            }
          ) }),
          /* @__PURE__ */ a.jsx(R, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsx(
            qe,
            {
              name: "targetDatabaseSchema",
              textLabel: "target_database_schema",
              children: /* @__PURE__ */ a.jsx(
                Je,
                {
                  id: "targetDatabaseSchema",
                  name: "targetDatabaseSchema",
                  value: h.targetDatabaseSchema,
                  onChange: (S) => A("targetDatabaseSchema", S.target.value),
                  fullWidth: !0
                }
              )
            }
          ) }),
          /* @__PURE__ */ a.jsx(R, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsx(
            qe,
            {
              name: "targetCohortTable",
              textLabel: "target_cohort_table",
              children: /* @__PURE__ */ a.jsx(
                Je,
                {
                  id: "targetCohortTable",
                  name: "targetCohortTable",
                  value: h.targetCohortTable,
                  onChange: (S) => A("targetCohortTable", S.target.value),
                  fullWidth: !0
                }
              )
            }
          ) }),
          /* @__PURE__ */ a.jsx(R, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsx(qe, { name: "targetCohortId", textLabel: "target_cohort_id", children: /* @__PURE__ */ a.jsx(
            Je,
            {
              id: "targetCohortId",
              name: "targetCohortId",
              value: h.targetCohortId,
              onChange: (S) => A("targetCohortId", S.target.value),
              fullWidth: !0
            }
          ) }) }),
          /* @__PURE__ */ a.jsx(R, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsxs(R, { container: !0, alignItems: "center", columnGap: 1.25, children: [
            /* @__PURE__ */ a.jsx(
              hr,
              {
                checked: d,
                onChange: (S) => f(S.target.checked)
              }
            ),
            /* @__PURE__ */ a.jsx(fe, { variant: "body2", children: "Apply parameter substitution" })
          ] }) })
        ] })
      ] })
    ] });
  }
), zo = {
  title: "Event persistence",
  textControlTextSections: {
    eventsPersistence: {
      startText: "Event will persist until:",
      options: hf,
      endText: ""
    }
  },
  persistentTypes: {
    FIXED: {
      title: "Fixed Duration Persistence:",
      description: "The event end date is derived from adding a number of days to the event's start or end date. If an offset is added to the event's start date, all cohort episodes will have the same fixed duration (subject to further censoring). If an offset is added to the event's end date, persons in the cohort may have varying cohort duration times due to the varying event durations (such as eras of persistent drug exposure or visit length of stay). This event persistence assures that the cohort end date will be no greater than the selected index event date, plus the days offset.",
      dateEdge: {
        startText: "Event date to offset from:",
        control: "select",
        options: cu,
        endText: ""
      },
      numberOfDays: {
        startText: "Number of days offset:",
        control: "select",
        type: "autocomplete",
        options: Wn,
        endText: "days"
      }
    },
    EXPOSURE: {
      title: "Continuous Exposure Persistence:",
      description: "Specify a concept set that contains one or more drugs. A drug era will be derived from all drug exposure events for any of the drugs within the concept set, using the specified persistence window as a maximum allowable gap in days between successive exposure events and adding a specified surveillance window to the final exposure event. If no exposure event end date is provided, then an exposure event end date is inferred to be event start date + days supply in cases when days supply is available or event start date + 1 day otherwise. This event persistence assures that the cohort end date will be no greater than the drug era end date.",
      selectDrugConcept: {
        startText: "Concept set containing the drug(s) of interest:",
        defaultTitle: "Select drug concept set",
        endText: ""
      },
      numberOfDaysPersistenceWindow: {
        startText: "Persistence window: allow for a maximum of",
        control: "select",
        type: "autocomplete",
        options: Wn,
        endText: "days between exposure records when inferring the era of persistence exposure"
      },
      numberOfDaysSurveillance: {
        startText: "Surveillance window: add",
        control: "select",
        type: "autocomplete",
        options: Wn,
        endText: "days to the end of the era of persistence exposure as an additional period of surveillance prior to cohort exit."
      },
      numberOfDaysForce: {
        preChooseText: "Use days supply and exposure end date for exposure duration.",
        startText: "Force drug exposure days supply to: ",
        control: "select",
        type: "autocomplete",
        options: Wn,
        endText: "days"
      }
    }
  }
}, NC = (e) => {
  var u, p;
  const { data: t, update: n, initValues: r, viewMode: i = !1 } = e, [o, s] = J({
    DateField: ((u = r == null ? void 0 : r.DateOffset) == null ? void 0 : u.DateField) || "StartDate",
    Offset: ((p = r == null ? void 0 : r.DateOffset) == null ? void 0 : p.Offset) || 0
  }), { DateField: l, Offset: c } = o;
  return Q(() => {
    ke(r, o) || n && n({
      DateOffset: o
    });
  }, [o]), /* @__PURE__ */ a.jsxs(Re.Fragment, { children: [
    /* @__PURE__ */ a.jsx(Y, { component: "h4", mt: 1, children: t.title }),
    /* @__PURE__ */ a.jsx(Y, { component: "p", sx: { fontSize: 12 }, children: t.description }),
    /* @__PURE__ */ a.jsxs(Y, { component: "ul", pl: 4, my: 1, children: [
      /* @__PURE__ */ a.jsx(Y, { component: "li", mb: 1, children: /* @__PURE__ */ a.jsx(
        Ut,
        {
          viewMode: i,
          startText: t.dateEdge.startText,
          endText: t.dateEdge.endText,
          onChange: (d) => s({ ...o, DateField: d }),
          options: t.dateEdge.options,
          value: l
        }
      ) }),
      /* @__PURE__ */ a.jsx(Y, { component: "li", children: /* @__PURE__ */ a.jsx(
        Ut,
        {
          viewMode: i,
          startText: t.numberOfDays.startText,
          type: t.numberOfDays.type,
          endText: t.numberOfDays.endText,
          onChange: (d) => s({ ...o, Offset: d }),
          options: t.numberOfDays.options,
          value: c
        }
      ) })
    ] })
  ] });
}, wC = (e) => {
  var k, z, B, q, N, ne, ue, te, m, W;
  const { data: t, update: n, initValues: r, viewMode: i = !1 } = e, [o, s] = J({
    DrugCodesetId: ((k = r == null ? void 0 : r.CustomEra) == null ? void 0 : k.DrugCodesetId) || -1,
    GapDays: ((z = r == null ? void 0 : r.CustomEra) == null ? void 0 : z.GapDays) || 0,
    Offset: ((B = r == null ? void 0 : r.CustomEra) == null ? void 0 : B.Offset) || 0,
    DaysSupplyOverride: ((q = r == null ? void 0 : r.CustomEra) == null ? void 0 : q.DaysSupplyOverride) || void 0
  }), { openModal: l, closeModal: c } = Le(gn), [u, p] = J(
    ((N = r == null ? void 0 : r.CustomEra) == null ? void 0 : N.DrugCodesetId) || -1
  ), { GapDays: d, Offset: f, DaysSupplyOverride: h } = o, [g, C] = J(
    !!((ne = r == null ? void 0 : r.CustomEra) != null && ne.DaysSupplyOverride)
  ), T = Le(
    Or
  ), { subModules: I, config: A } = Le(
    Sn
  ), { conceptSets: S, updateConceptSets: _, refreshConceptSetReference: v } = ee(() => T, [T]), O = Yi(u, S), { typeContainer: j, parentId: M } = A;
  Q(() => {
    let H = {
      GapDays: o.GapDays,
      Offset: o.Offset
    };
    o.DrugCodesetId && o.DrugCodesetId >= 0 && (H.DrugCodesetId = o.DrugCodesetId), g && (H.DaysSupplyOverride = o.DaysSupplyOverride), ke(H, r) || n && n({
      CustomEra: H
    });
  }, [o]);
  const w = () => {
    l(
      () => /* @__PURE__ */ a.jsx(a.Fragment, { children: /* @__PURE__ */ a.jsx(
        I.concept,
        {
          type: "component",
          name: "view-concept-set-button",
          subModules: I,
          config: {
            conceptSets: S,
            conceptSetId: u
          }
        }
      ) }),
      "View concept set",
      {
        closeOnClickOutside: !0,
        onClose: c,
        width: "1000px"
      }
    );
  }, L = () => {
    p(-1), s({
      ...o,
      DrugCodesetId: -1
    });
  }, P = (H, y) => {
    p(H.id), s({
      ...o,
      DrugCodesetId: H.id
    }), y && _([...S, H]);
  };
  return /* @__PURE__ */ a.jsxs(Re.Fragment, { children: [
    /* @__PURE__ */ a.jsx("h4", { children: t.title }),
    /* @__PURE__ */ a.jsx("p", { children: t.description }),
    /* @__PURE__ */ a.jsxs(Px, { children: [
      /* @__PURE__ */ a.jsx(Nx, { children: (ue = t == null ? void 0 : t.selectDrugConcept) == null ? void 0 : ue.startText }),
      i ? /* @__PURE__ */ a.jsxs(Y, { display: "flex", alignItems: "center", flexWrap: "nowrap", children: [
        /* @__PURE__ */ a.jsx(
          dd,
          {
            existConceptSet: u && u >= 0,
            onClick: u && u >= 0 ? w : () => {
            },
            children: u && u >= 0 ? O == null ? void 0 : O.name : (te = t == null ? void 0 : t.selectDrugConcept) == null ? void 0 : te.defaultTitle
          }
        ),
        /* @__PURE__ */ a.jsx(
          qn,
          {
            conceptSet: O,
            viewMode: i,
            onRefresh: v
          }
        )
      ] }) : /* @__PURE__ */ a.jsxs(Y, { display: "flex", alignItems: "center", flexWrap: "nowrap", children: [
        /* @__PURE__ */ a.jsx(
          I.concept,
          {
            type: "component",
            name: "widget-concept-set-choose-button",
            subModules: I,
            config: {
              conceptSets: S,
              defaultValue: (m = t == null ? void 0 : t.selectDrugConcept) == null ? void 0 : m.defaultTitle,
              conceptSetId: u,
              onUpdate: P,
              onClear: L,
              typeContainer: j,
              parentId: M,
              localImport: !0
            }
          }
        ),
        /* @__PURE__ */ a.jsx(
          qn,
          {
            conceptSet: O,
            viewMode: i,
            onRefresh: v
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ a.jsxs("ul", { children: [
      /* @__PURE__ */ a.jsx("li", { children: /* @__PURE__ */ a.jsx(
        Ut,
        {
          viewMode: i,
          startText: t.numberOfDaysPersistenceWindow.startText,
          type: t.numberOfDaysPersistenceWindow.type,
          endText: t.numberOfDaysPersistenceWindow.endText,
          onChange: (H) => s({ ...o, GapDays: H }),
          options: t.numberOfDaysPersistenceWindow.options,
          value: d
        }
      ) }),
      /* @__PURE__ */ a.jsx("li", { children: /* @__PURE__ */ a.jsx(
        Ut,
        {
          viewMode: i,
          startText: t.numberOfDaysSurveillance.startText,
          type: t.numberOfDaysSurveillance.type,
          endText: t.numberOfDaysSurveillance.endText,
          onChange: (H) => s({ ...o, Offset: H }),
          options: t.numberOfDaysSurveillance.options,
          value: f
        }
      ) }),
      /* @__PURE__ */ a.jsx("li", { children: g ? /* @__PURE__ */ a.jsxs(Y, { display: "flex", alignItems: "center", children: [
        /* @__PURE__ */ a.jsx(
          Ut,
          {
            viewMode: i,
            startText: t.numberOfDaysForce.startText,
            endText: t.numberOfDaysForce.endText,
            type: t.numberOfDaysForce.type,
            onChange: (H) => {
              s({ ...o, DaysSupplyOverride: H });
            },
            options: t.numberOfDaysForce.options,
            value: h
          }
        ),
        !i && /* @__PURE__ */ a.jsx(
          We,
          {
            onClick: () => {
              C(!1);
            },
            fullWidth: !1,
            variant: "text",
            name: "closeExposureDays",
            size: "small",
            children: "Close"
          }
        )
      ] }) : /* @__PURE__ */ a.jsx(Re.Fragment, { children: /* @__PURE__ */ a.jsxs(Y, { fontSize: 12, display: "flex", alignItems: "center", children: [
        /* @__PURE__ */ a.jsx("div", { children: (W = t == null ? void 0 : t.numberOfDaysForce) == null ? void 0 : W.preChooseText }),
        !i && /* @__PURE__ */ a.jsx(
          We,
          {
            onClick: () => {
              C(!0);
            },
            fullWidth: !1,
            variant: "text",
            name: "changeExposureDays",
            size: "small",
            children: "change"
          }
        )
      ] }) }) })
    ] }),
    /* @__PURE__ */ a.jsx("p", {})
  ] });
}, PC = me.div`
  color: ${({ theme: e }) => {
  var t, n;
  return (n = (t = e.palette) == null ? void 0 : t.textColor) == null ? void 0 : n.primary;
}};
  font-weight: 700;
  font-size: 14px;
`, jC = me.div`
  margin-bottom: 10px;
  border-bottom: 1px solid #d6d4d4;
  padding-bottom: 15px;
`, LC = me.div`
  margin-top: 5px;
  h4 {
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 5px;
  }
  p {
    font-size: 14px;
    margin: 0;
  }
`;
me.div`
  font-size: 14px;
  padding-bottom: 4px;
  font-weight: 700;
  color: ${({ theme: e }) => {
  var t;
  return (t = e.palette) == null ? void 0 : t.primary.main;
}};
  margin-left: 5px;
`;
const kC = ({
  data: e,
  update: t,
  clear: n,
  viewMode: r = !1
}) => {
  const [i, o] = J("END");
  Q(() => {
    e != null && e.DateOffset && o("FIXED"), e != null && e.CustomEra && o("EXPOSURE");
  }, []);
  const { title: s, textControlTextSections: l } = zo, { eventsPersistence: c } = l;
  return /* @__PURE__ */ a.jsx(jC, { className: "cohort-definition-event-persistance", children: /* @__PURE__ */ a.jsxs(R, { container: !0, children: [
    /* @__PURE__ */ a.jsx(R, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsx(PC, { children: s }) }),
    /* @__PURE__ */ a.jsx(R, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsxs(LC, { children: [
      /* @__PURE__ */ a.jsx(
        Ut,
        {
          viewMode: r,
          startText: c.startText,
          endText: c.endText,
          onChange: (u) => {
            u === "END" && n(), o(u);
          },
          options: c.options,
          value: i
        }
      ),
      i === "FIXED" && /* @__PURE__ */ a.jsx(
        NC,
        {
          update: t,
          initValues: e,
          data: zo.persistentTypes[i],
          viewMode: r
        }
      ),
      i === "EXPOSURE" && /* @__PURE__ */ a.jsx(
        wC,
        {
          update: t,
          initValues: e,
          data: zo.persistentTypes[i],
          viewMode: r
        }
      )
    ] }) })
  ] }) });
}, MC = {
  title: "Censoring events",
  addCriteriaButton: "Add censoring event",
  description: "Exit Cohort based on the following criteria:",
  optionsForCriteriaButton: [
    D.CONDITION_ERA,
    D.CONDITION_OCCURRENCE,
    D.DEATH,
    D.DEVICE_EXPOSURE,
    D.DOSE_ERA,
    D.DRUG_ERA,
    D.DRUG_EXPOSURE,
    D.MEASUREMENT,
    D.OBSERVATION,
    D.PAYER_PLAN_PERIOD,
    D.PROCEDURE_OCCURRENCE,
    D.SPECIMEN,
    D.VISIT,
    D.VISIT_DETAILS
  ]
}, VC = it(
  (e) => {
    const { data: t, update: n, clear: r, viewMode: i = !1 } = e, o = Le(
      Or
    ), { subModules: s, config: l } = Le(
      Sn
    ), [c, u] = J(
      ru(t)
    ), { typeContainer: p, parentId: d } = l, { addCriteriaButton: f, title: h, description: g, optionsForCriteriaButton: C } = MC, T = ee(() => wn(
      C,
      yn
    ), [C]), I = (A) => {
      u(A);
    };
    return Q(() => {
      const A = iu(c);
      ke(t, A) || n(A);
    }, [c]), /* @__PURE__ */ a.jsx(R, { container: !0, className: "cohort-definition-censoring-events", children: /* @__PURE__ */ a.jsx(R, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsx(
      es,
      {
        viewMode: i,
        extend: !1,
        subModules: s,
        initialCriteries: c,
        addTextButton: f,
        optionsDropdown: T,
        updateModel: I,
        typeContainer: p,
        parentId: d,
        titleText: h,
        descriptionText: g,
        ...o
      }
    ) }) });
  }
), UC = {
  textControlTextSections: {
    numberOfDays: {
      startText: "Specify era collapse gap size:",
      options: Wn,
      type: "autocomplete",
      endText: "days"
    }
  },
  leftRightCensor: {
    leftSensorText: "Left censor cohort start dates to",
    rightSensorText: "Right censor cohort end dates to"
  }
}, FC = ({
  dataAddition: e,
  updateAddition: t,
  viewMode: n
}) => {
  const [r, i] = J({
    CollapseType: e.CollapseSettings.CollapseType,
    EraPad: e.CollapseSettings.EraPad
  }), [o, s] = J({
    StartDate: e.CensorWindow.StartDate,
    EndDate: e.CensorWindow.EndDate
  }), { EraPad: l } = r, { StartDate: c, EndDate: u } = o, { textControlTextSections: p, leftRightCensor: d } = UC, { numberOfDays: f } = p;
  return Q(() => {
    ke(r, e.CollapseSettings) || t(r, Ms.CollapseSettings);
  }, [r]), Q(() => {
    const h = Xh(o, Jh);
    ke(h, e.CensorWindow) || (h ? (h.StartDate || delete h.StartDate, h.EndDate || delete h.EndDate, t(h, Ms.CensorWindow)) : t({}, "CensorWindow"));
  }, [o]), /* @__PURE__ */ a.jsxs(R, { container: !0, flexWrap: "nowrap", children: [
    /* @__PURE__ */ a.jsxs(R, { container: !0, columnSpacing: 3, rowSpacing: 1, flexWrap: "wrap", children: [
      /* @__PURE__ */ a.jsx(R, { item: !0, children: /* @__PURE__ */ a.jsx(
        Ut,
        {
          viewMode: n,
          startText: f.startText,
          endText: f.endText,
          type: f.type,
          onChange: (h) => {
            i({
              ...r,
              EraPad: h
            });
          },
          options: f.options,
          value: l
        }
      ) }),
      /* @__PURE__ */ a.jsxs(
        R,
        {
          item: !0,
          display: "flex",
          flexWrap: "nowrap",
          whiteSpace: "nowrap",
          alignItems: "center",
          children: [
            /* @__PURE__ */ a.jsxs(R, { item: !0, mr: 1, fontSize: 12, children: [
              d.leftSensorText,
              ":"
            ] }),
            /* @__PURE__ */ a.jsx(R, { item: !0, children: n ? /* @__PURE__ */ a.jsx(
              Y,
              {
                component: "span",
                sx: {
                  position: "relative",
                  top: "8px"
                },
                children: c
              }
            ) : /* @__PURE__ */ a.jsx(
              rr,
              {
                value: c,
                format: Gt.DATEPICKER_DATE,
                onChange: (h) => s({
                  ...o,
                  StartDate: ir(h, Gt.ISO_DATE)
                }),
                name: "cohortEraStartDate"
              }
            ) })
          ]
        }
      ),
      /* @__PURE__ */ a.jsxs(
        R,
        {
          item: !0,
          display: "flex",
          flexWrap: "nowrap",
          whiteSpace: "nowrap",
          alignItems: "center",
          children: [
            /* @__PURE__ */ a.jsxs(R, { item: !0, mr: 1, fontSize: 12, children: [
              d.rightSensorText,
              ":"
            ] }),
            /* @__PURE__ */ a.jsx(R, { item: !0, children: n ? /* @__PURE__ */ a.jsx(
              Y,
              {
                component: "span",
                sx: {
                  position: "relative",
                  top: "8px"
                },
                children: u
              }
            ) : /* @__PURE__ */ a.jsx(
              rr,
              {
                fullWidth: !1,
                value: u,
                format: Gt.DATEPICKER_DATE,
                onChange: (h) => {
                  s({
                    ...o,
                    EndDate: ir(h, Gt.ISO_DATE)
                  });
                },
                name: "cohortEraEndDate"
              }
            ) })
          ]
        }
      )
    ] }),
    !n && /* @__PURE__ */ a.jsx(
      R,
      {
        item: !0,
        minWidth: 150,
        textAlign: "right",
        sx: { "button .MuiTypography-root": { fontSize: "14px" } },
        children: /* @__PURE__ */ a.jsx(
          Cr,
          {
            iconName: "delete",
            onClick: () => {
              s({
                ...o,
                StartDate: null,
                EndDate: null
              });
            },
            color: "primary",
            title: "Clear censors",
            noCollapse: !0
          }
        )
      }
    )
  ] });
}, BC = (e, t, n, r) => (i, o, s = ze.COPY) => {
  switch (e) {
    case he.STUDY:
      return yu(t, i, o, s);
    case he.WORKSPACE:
      return gu(i, o, s);
    case "ATLAS":
      return Xf(n, r, i, o);
  }
}, $C = (e) => {
  const { id: t, typeContainer: n, parentId: r } = e, i = yr(), o = Le(
    Sn
  );
  return /* @__PURE__ */ a.jsx(
    Hc,
    {
      isImport: !1,
      isEnableMetadata: !0,
      moduleConfig: o,
      uniqName: "Usage",
      onRowClick: (s) => {
        const l = Cm(
          s.original.id,
          s.original.supertype,
          n,
          r
        );
        i(l);
      },
      listConfig: {
        rowId: "id",
        loadingMessage: "Loading Usage Cohorts...",
        tableTitle: "Used In",
        moduleDescription: "",
        listInitialSort: { id: "modified.timestamp", desc: !0 },
        addButtonTitle: null,
        createCrudMethod: () => ({
          fetch: (s, l, c, u) => Lf(t, {
            pageNumber: s,
            pageSize: l,
            sortBy: c,
            query: u
          })
        }),
        createFiltersPanel: () => ({
          getFilters: (s) => kf(s, t),
          formatFilters: Kh
        }),
        createSortingMethod: Ou,
        cols: ym
      },
      variant: "no-header",
      pinnedColumns: { left: ["type", "name"], right: [] },
      dense: !0
    }
  );
}, GC = ({}) => {
  const { id: e } = Qc(), { status: t, state: n } = zp(Au, e), r = Qh(n);
  return /* @__PURE__ */ a.jsx(ch, { board: r == null ? void 0 : r.board, status: t, list: r == null ? void 0 : r.list });
}, Fn = -730, On = 730, Ta = [-365, -180, -90, -30, 0, 30, 90, 180, 365], zC = Ta[Ta.length - 1], WC = Math.round(
  (zC + On) / 2
), YC = {
  default: "S1 Default",
  single: "S2.1 Single",
  multiple: "S2.2 Multiple",
  nested: "S2.3 Nested",
  dual_index: "S2.4 Dual Idx",
  calendar: "S2.5.2 Calendar",
  ppp: "S2.8 PPP",
  obs_period: "S4.4 Obs Period",
  eras: "S4.5 Eras",
  groups: "S4.6 Groups",
  unsupported: "Unsupported"
}, HC = {
  obs_end: "5.1 Obs End",
  start_plus_x: "5.2 Start+Xd",
  end_plus_x: "5.2 End+Xd",
  drug_persist: "5.3 Drug Persist.",
  censoring: "5.4 Censoring",
  unsupported: "Unsupported"
}, ns = {
  condition: "#E8683A",
  drug: "#3A8FE8",
  device: "#0EA5E9",
  measurement: "#8B5EC8",
  observation: "#C9A83A",
  procedure: "#2EAA6F",
  visit: "#E85BA0",
  demographic: "#94A3B8",
  death: "#111111",
  payer: "#7C3AED",
  other: "#8C8C8C"
}, Id = "#D97706", qC = "#059669", Lr = "#DC2626", XC = "#7C3AED", JC = {
  default: "No entry criteria detected. Timeline is rendered with baseline observation and exit markers only.",
  single: "Single primary clinical index event detected.",
  multiple: "Multiple primary index criteria detected.",
  nested: "Nested group criteria detected in entry/inclusion logic.",
  dual_index: "Multi-level nested criteria detected and shown as a dual-index visual state.",
  calendar: "Calendar date constraints detected in criteria attributes.",
  ppp: "Payer Plan Period is used as index criterion.",
  obs_period: "Observation Period criteria are present in cohort logic.",
  eras: "Cohort era collapse/censor window settings are configured.",
  groups: "Group logic (ALL/ANY/AT_LEAST/AT_MOST) is present.",
  unsupported: "Cohort structure is partially unsupported for strict scenario mapping. Baseline timeline is rendered."
}, jl = {
  obs_end: "Cohort exit is based on observation end.",
  start_plus_x: "Cohort exit uses fixed offset: start date + X days.",
  end_plus_x: "Cohort exit uses fixed offset: end date + X days.",
  drug_persist: "Cohort exit is based on continuous drug persistence (custom era settings).",
  censoring: "Cohort exit includes censoring criteria in addition to observation end.",
  unsupported: "End strategy is not one of supported v1 mappings. Timeline uses observation-end fallback marker."
}, Ad = {
  condition: "Condition",
  drug: "Drug",
  device: "Device",
  measurement: "Measurement",
  observation: "Observation",
  procedure: "Procedure",
  visit: "Visit",
  demographic: "Demographic",
  death: "Death",
  payer: "Payer",
  other: "Other"
}, KC = yn.reduce(
  (e, t) => (e[t.id] = t.name, e),
  {}
);
function rt(e) {
  if (typeof e == "number" && Number.isFinite(e))
    return e;
  if (typeof e == "string" && e.trim() !== "") {
    const t = Number(e);
    return Number.isFinite(t) ? t : null;
  }
  return null;
}
function bt(e) {
  return Math.min(On, Math.max(Fn, e));
}
function ii(e) {
  if (!e || typeof e != "object")
    return null;
  const t = e, n = Object.keys(t)[0];
  if (!n)
    return null;
  const r = t[n];
  return {
    type: n,
    payload: gt(r) ? r : {}
  };
}
function Tn(e) {
  return e.replace(/([a-z0-9])([A-Z])/g, "$1 $2").replace(/[_-]/g, " ").replace(/\s+/g, " ").trim().replace(/\b\w/g, (t) => t.toUpperCase());
}
function sr(e) {
  return `${e >= 0 ? "+" : ""}${e}d`;
}
function Ll(e) {
  return typeof e != "string" || e.trim() === "" ? "start date" : Tn(e).toLowerCase();
}
const bd = /* @__PURE__ */ new Set(["CodesetId", "CorrelatedCriteria"]), QC = /* @__PURE__ */ new Set([
  "CONCEPT_ID",
  "VOCABULARY_ID",
  "RECORD_COUNT",
  "DESCENDANT_RECORD_COUNT",
  "DOMAIN_ID",
  "CONCEPT_CLASS_ID",
  "STANDARD_CONCEPT",
  "INVALID_REASON",
  "CONCEPT_CODE",
  "baseValue"
]), ZC = {
  DateAdjustment: "Date adjustment",
  OccurrenceStartDate: "Occurrence start date",
  OccurrenceEndDate: "Occurrence end date",
  StartDate: "Start date",
  EndDate: "End date",
  EraStartDate: "Era start date",
  EraEndDate: "Era end date",
  EraLength: "Era length",
  PeriodStartDate: "Period start date",
  PeriodEndDate: "Period end date",
  PeriodLength: "Period length",
  Age: "Age",
  AgeAtStart: "Age at start",
  AgeAtEnd: "Age at end",
  Gender: "Gender",
  GenderCS: "Gender",
  Race: "Race",
  RaceCS: "Race",
  Ethnicity: "Ethnicity",
  EthnicityCS: "Ethnicity",
  ConditionStatus: "Condition status",
  ConditionStatusCS: "Condition status",
  ConditionTypeCS: "Condition type",
  DeathTypeCS: "Death type",
  DeviceTypeCS: "Device type",
  DoseUnitCS: "Dose unit",
  DrugTypeCS: "Drug type",
  MeasurementTypeCS: "Measurement type",
  ObservationTypeCS: "Observation type",
  OperatorCS: "Operator",
  PeriodTypeCS: "Period type",
  ProcedureTypeCS: "Procedure type",
  ModifierCS: "Modifier",
  QualifierCS: "Qualifier",
  RouteConceptCS: "Route",
  SpecimenTypeCS: "Specimen type",
  UnitCS: "Unit",
  ValueAsConceptCS: "Value as concept",
  VisitTypeCS: "Visit type",
  AnatomicSiteCS: "Anatomic site",
  DiseaseStatusCS: "Disease status",
  ProviderSpecialtyCS: "Provider specialty",
  PlaceOfServiceCS: "Place of service",
  StopReason: "Stop reason",
  PayerConcept: "Payer concept",
  PayerSourceConcept: "Payer source concept"
}, eg = {
  STARTING_WITH: "starting with",
  CONTAINING: "containing",
  ENDING_WITH: "ending with",
  NOT_STARTING_WITH: "not starting with",
  NOT_CONTAINING: "not containing",
  NOT_ENDING_WITH: "not ending with",
  lt: "less than",
  lte: "less or equal to",
  eq: "equal to",
  gt: "greater than",
  gte: "greater or equal to",
  bt: "between",
  "!bt": "not between",
  LESS_THAN: "less than",
  LESS_OR_EQUAL_TO: "less or equal to",
  EQUAL_TO: "equal to",
  GREATER_THAN: "greater than",
  GREATER_OR_EQUAL_TO: "greater or equal to",
  BETWEEN: "between",
  NOT_BETWEEN: "not between"
};
function gt(e) {
  return !!e && typeof e == "object" && !Array.isArray(e);
}
function nt(e) {
  return gt(e) ? e : {};
}
function oi(e) {
  return Array.isArray(e) ? e : [];
}
function tg(e) {
  return typeof e != "string" || e.trim() === "" ? "" : eg[e] || Tn(e).toLowerCase();
}
function ng(e) {
  return typeof e != "string" ? !1 : e === "BETWEEN" || e === "NOT_BETWEEN" || e === "bt" || e === "!bt";
}
function rg(e) {
  return e === e.toUpperCase() ? Tn(e.toLowerCase()) : e;
}
function Ur(e) {
  return Array.isArray(e) ? e.flatMap((t) => Ur(t)) : gt(e) ? typeof e.CONCEPT_NAME == "string" && e.CONCEPT_NAME.trim() !== "" ? [rg(e.CONCEPT_NAME.trim())] : gt(e.concept) ? Ur(e.concept) : Array.isArray(e.baseValue) ? Ur(e.baseValue) : Array.isArray(e.items) ? Ur(e.items) : [] : [];
}
function ai(e, t) {
  if (Array.isArray(e))
    return e.map((c) => ai(c, t)).filter(Boolean).join("; ");
  if (e == null)
    return "";
  if (typeof e == "string" || typeof e == "number") {
    const c = t ? ` ${t}` : "";
    return `${e}${c}`;
  }
  if (!gt(e))
    return String(e);
  const n = Ur(e);
  if (n.length > 0)
    return Array.from(new Set(n)).join(", ");
  const r = tg(e.Op), i = e.Value !== void 0 && e.Value !== null && e.Value !== "", o = e.Extent !== void 0 && e.Extent !== null && e.Extent !== "", s = e.Text !== void 0 && e.Text !== null && e.Text !== "";
  if (e.StartDate || e.EndDate)
    return e.StartDate && e.EndDate ? `between ${e.StartDate} and ${e.EndDate}` : e.StartDate ? `starting ${e.StartDate}` : `ending ${e.EndDate}`;
  if (r && (i || o)) {
    const c = t ? ` ${t}` : "";
    return ng(e.Op) && o ? `${r} ${e.Value} and ${e.Extent}${c}` : i ? `${r} ${e.Value}${c}` : r;
  }
  return r && s ? `${r} ${e.Text}` : s ? String(e.Text) : typeof e.CodesetId < "u" ? `codeset ${e.CodesetId}` : Object.entries(e).filter(([c]) => !(bd.has(c) || QC.has(c) || c.endsWith("Exclude"))).map(([c, u]) => {
    const p = ai(u);
    return p ? `${Tn(c)} ${p}` : "";
  }).filter(Boolean).join(", ");
}
function ig(e) {
  if (!gt(e))
    return ai(e);
  const t = rt(e.StartOffset) ?? 0, n = rt(e.EndOffset) ?? 0, r = Ll(e.StartWith), i = Ll(e.EndWith || "END_DATE");
  return `starting with ${r} ${sr(
    t
  )} and ending with ${i} ${sr(n)}`;
}
function Rd(e, t, n) {
  if (bd.has(e) || t == null || t === "")
    return null;
  const r = ZC[e] || Tn(e);
  if (e === "DateAdjustment")
    return `${r}: ${ig(t)}`;
  if (typeof t == "number") {
    const o = si(n, t);
    if (o)
      return `${r}: ${o}`;
  }
  if (gt(t) && typeof t.CodesetId < "u") {
    const o = si(
      n,
      rt(t.CodesetId)
    );
    if (o)
      return `${r}: ${o}`;
  }
  const i = ai(
    t,
    e === "PeriodLength" ? "days" : void 0
  );
  return i ? `${r}: ${i}` : null;
}
function og(e) {
  const t = e.replace(": greater or equal to ", " >= ").replace(": greater than ", " > ").replace(": less or equal to ", " <= ").replace(": less than ", " < ").replace(": equal to ", " = ").replace(": between ", " between "), n = t.match(/^Gender:\s*(.+)$/i);
  return n ? `${n[1]} gender` : t;
}
function ag(e, t) {
  const n = Object.entries(e || {}).map(([r, i]) => Rd(r, i, t)).filter(Boolean);
  if (n.length === 0) {
    const r = Object.keys(e || {});
    return r.length > 0 ? r.map((i) => Tn(i)).join(", ") : "Demographic criteria";
  }
  return n.map(og).join(", ");
}
function Io(e, t) {
  return !e || typeof e != "object" ? [] : Object.entries(e).map(([n, r]) => Rd(n, r, t)).filter(Boolean);
}
function rs(e) {
  return KC[e] || Tn(e);
}
function sg(e) {
  return e === D.CONDITION_OCCURRENCE ? "CONDITION" : e === D.CONDITION_ERA ? "CONDITION ERA" : rs(e);
}
function lg(e) {
  switch (e) {
    case D.CONDITION_ERA:
    case D.CONDITION_OCCURRENCE:
      return "condition";
    case D.DRUG_ERA:
    case D.DRUG_EXPOSURE:
    case D.DOSE_ERA:
      return "drug";
    case D.DEVICE_EXPOSURE:
      return "device";
    case D.MEASUREMENT:
      return "measurement";
    case D.OBSERVATION:
    case D.OBSERVATION_PERIOD:
      return "observation";
    case D.PROCEDURE_OCCURRENCE:
    case D.SPECIMEN:
      return "procedure";
    case D.VISIT:
    case D.VISIT_DETAILS:
      return "visit";
    case D.PAYER_PLAN_PERIOD:
      return "payer";
    case D.DEMOGRAPHIC:
      return "demographic";
    case D.DEATH:
      return "death";
    default:
      return "other";
  }
}
function cg(e) {
  return e === D.CONDITION_ERA || e === D.DRUG_ERA || e === D.DOSE_ERA;
}
function ug(e) {
  if (typeof e == "number")
    return `${e}d`;
  if (!gt(e))
    return "";
  const t = String(e.Op || "").toUpperCase(), n = rt(e.Value), r = rt(e.Extent);
  if ((t === "BETWEEN" || t === "BT" || t === "!BT" || t === "NOT_BETWEEN") && n !== null && r !== null) {
    const o = Math.min(n, r), s = Math.max(n, r);
    return `${t === "!BT" || t === "NOT_BETWEEN" ? "!" : ""}${o}-${s}d`;
  }
  if (n === null)
    return "";
  switch (t) {
    case "EQUAL_TO":
    case "EQ":
      return `=${n}d`;
    case "GREATER_THAN":
    case "GT":
      return `>${n}d`;
    case "GREATER_OR_EQUAL_TO":
    case "GTE":
      return `>=${n}d`;
    case "LESS_THAN":
    case "LT":
      return `<${n}d`;
    case "LESS_OR_EQUAL_TO":
    case "LTE":
      return `<=${n}d`;
    default:
      return `${n}d`;
  }
}
function dg(e) {
  const t = e == null ? void 0 : e.EraLength;
  if (!t || typeof t != "object")
    return;
  const n = ug(t);
  return n || ai(t, "days") || void 0;
}
function si(e, t) {
  if (!Number.isFinite(t) || t < 0)
    return null;
  const r = oi(e == null ? void 0 : e.ConceptSets).find(
    (i) => {
      var o;
      return Number((o = nt(i)) == null ? void 0 : o.id) === Number(t);
    }
  );
  return typeof (r == null ? void 0 : r.name) == "string" && r.name.trim() !== "" ? r.name : null;
}
function kl(e) {
  const t = gt(e) ? e : {}, n = rt(t.Days), r = rt(t.Coeff);
  return n === null ? null : n * (r === -1 ? -1 : 1);
}
function Sa(e) {
  const t = nt(e);
  if (!t)
    return {
      startDay: Fn,
      endDay: On,
      openStart: !0,
      openEnd: !0
    };
  const n = kl(t.Start), r = kl(t.End);
  if (n === null && r === null)
    return {
      startDay: Fn,
      endDay: On,
      openStart: !0,
      openEnd: !0
    };
  const i = n !== null, o = r !== null;
  let s = i ? n : Fn, l = o ? r : On;
  i && o && (s = Math.min(n, r), l = Math.max(n, r));
  const c = !i || s <= Fn, u = !o || l >= On;
  return {
    startDay: c ? Fn : bt(s),
    endDay: u ? On : bt(l),
    openStart: c,
    openEnd: u
  };
}
function Od(e) {
  const t = nt(e);
  return Sa(t.StartWindow);
}
function Ao(e, t, n, r) {
  const i = n ? "all days before" : `${e}d`, o = r ? "all days after" : `${t >= 0 ? "+" : ""}${t}d`;
  return `${i} to ${o}`;
}
function is(e) {
  if (typeof e == "number") {
    if (e === 0)
      return "exactly";
    if (e === 1)
      return "at most";
    if (e === 2)
      return "at least";
  }
  if (typeof e == "string") {
    const t = e.trim().toUpperCase();
    if (t === "0")
      return "exactly";
    if (t === "1")
      return "at most";
    if (t === "2")
      return "at least";
    if (t === "EXACTLY")
      return "exactly";
    if (t === "AT_MOST")
      return "at most";
    if (t === "AT_LEAST")
      return "at least";
  }
  return "";
}
function pg(e) {
  if (!gt(e))
    return !1;
  const t = is(e.Type), n = rt(e.Count);
  return t === "exactly" && n === 0;
}
function Ia(e) {
  return Array.isArray(e) ? e.some((t) => Ia(t)) : gt(e) ? Object.entries(e).some(([t, n]) => t.endsWith("Exclude") && n ? !0 : Ia(n)) : !1;
}
function hg(e, t) {
  if (!e && !t)
    return "";
  const n = [];
  if (t && Dn[t] ? n.push(`Group rule: ${Dn[t]}`) : t && t !== "ALL" && n.push(`Group rule: ${t}`), e) {
    const r = nt(e), i = rt(r.Count), o = is(r.Type) || (r.Type ? Dn[String(r.Type)] : null);
    o && i !== null ? n.push(`Occurrence: ${o} ${i} (x${i})`) : o && n.push(`Occurrence: ${o}`);
  }
  return n.join(" | ");
}
function vd(e) {
  const {
    id: t,
    expression: n,
    criteriaType: r,
    payload: i,
    extendCriteria: o,
    nestedDepth: s,
    groupType: l,
    exclusion: c = !1,
    isNested: u = !1,
    kind: p = "criteria",
    sourceJson: d
  } = e, f = lg(r), h = si(
    n,
    rt(i == null ? void 0 : i.CodesetId)
  ), g = Od(o), C = hg(
    o == null ? void 0 : o.Occurrence,
    l
  ), T = rs(r), I = sg(r), A = h || T, S = Io(i, n), _ = cg(r) ? dg(i) : void 0, v = [
    c ? "EXCLUSION criterion." : "",
    h ? `${Tn(T)} of ${h}` : "",
    `Window: ${Ao(
      g.startDay,
      g.endDay,
      g.openStart,
      g.openEnd
    )}`,
    C || "",
    ...S,
    u ? "Nested group criterion." : ""
  ].filter(Boolean).join(`
`);
  return {
    id: t,
    label: A,
    domain: f,
    criteriaBadge: I,
    tooltipTitle: T,
    startDay: g.startDay,
    endDay: g.endDay,
    nestedDepth: s,
    openStart: g.openStart,
    openEnd: g.openEnd,
    exclusion: c,
    isNested: u,
    occurrenceText: C || void 0,
    eraText: _,
    tooltip: v,
    kind: p,
    sourceJson: d
  };
}
function fg(e, t, n, r) {
  return !Array.isArray(e) || e.length === 0 ? [] : e.map((i, o) => {
    const s = nt(i), l = ag(s, r), c = Io(s, r);
    return {
      id: `${t}-demographic-${n}-${o}`,
      label: l,
      domain: "demographic",
      criteriaBadge: "Demographic",
      tooltipTitle: "Demographic",
      startDay: 0,
      endDay: 0,
      nestedDepth: n,
      openStart: !1,
      openEnd: !1,
      exclusion: !1,
      isNested: n > 0,
      tooltip: c.filter(Boolean).join(`
`),
      kind: "demographic",
      sourceJson: i
    };
  });
}
function Wr(e, t, n, r) {
  const i = [], o = /* @__PURE__ */ new Set();
  let s = r, l = !1;
  const c = [];
  i.push(
    ...fg(
      e == null ? void 0 : e.DemographicCriteriaList,
      n,
      r,
      t
    )
  ), (Array.isArray(e == null ? void 0 : e.CriteriaList) ? e.CriteriaList : []).forEach((f, h) => {
    var I;
    const g = ii(f == null ? void 0 : f.Criteria);
    if (!g)
      return;
    const C = pg(f == null ? void 0 : f.Occurrence) || Ia(g.payload);
    o.add(g.type), g.type === D.OBSERVATION_PERIOD && c.push({
      startWindow: Sa(f == null ? void 0 : f.StartWindow),
      endWindow: f != null && f.EndWindow ? Sa(f.EndWindow) : void 0
    }), i.push(
      vd({
        id: `${n}-criteria-${r}-${h}`,
        expression: t,
        criteriaType: g.type,
        payload: g.payload,
        extendCriteria: f,
        nestedDepth: r,
        groupType: typeof (e == null ? void 0 : e.Type) == "string" ? e.Type : void 0,
        exclusion: C,
        isNested: r > 0,
        sourceJson: f
      })
    );
    const T = (I = g.payload) == null ? void 0 : I.CorrelatedCriteria;
    if (gt(T)) {
      const A = Wr(
        T,
        t,
        `${n}-correlated-${h}`,
        r + 1
      );
      A.rows.forEach((S) => i.push(S)), A.criteriaTypes.forEach((S) => o.add(S)), A.observationPeriodWindows.forEach(
        (S) => c.push(S)
      ), l = l || A.hasGroups, s = Math.max(s, A.maxNestedDepth);
    }
  });
  const p = Array.isArray(e == null ? void 0 : e.Groups) ? e.Groups : [];
  p.length > 0 && (l = !0), p.forEach((f, h) => {
    const g = Wr(
      f,
      t,
      `${n}-group-${h}`,
      r + 1
    );
    g.rows.forEach((C) => i.push(C)), g.criteriaTypes.forEach((C) => o.add(C)), g.observationPeriodWindows.forEach(
      (C) => c.push(C)
    ), l = l || g.hasGroups || !0, s = Math.max(s, g.maxNestedDepth);
  }), e != null && e.Type && (e == null ? void 0 : e.Type) !== "ALL" && (l = !0);
  const d = (Array.isArray(e == null ? void 0 : e.CriteriaList) ? e.CriteriaList.length : 0) + (Array.isArray(e == null ? void 0 : e.DemographicCriteriaList) ? e.DemographicCriteriaList.length : 0);
  return r > 0 && (e == null ? void 0 : e.Type) === "ALL" && d > 1 && (l = !0), {
    rows: i,
    criteriaTypes: o,
    hasGroups: l,
    maxNestedDepth: s,
    observationPeriodWindows: c
  };
}
function Ml(e) {
  return [
    e.startDay,
    e.endDay,
    e.openStart ? 1 : 0,
    e.openEnd ? 1 : 0
  ].join("|");
}
function mg(e) {
  const n = e.indexOf("-criteria-");
  return n <= 0 ? "" : e.slice(0, n);
}
function Dd(e) {
  const { groupLabel: t, rows: n, sharedWindow: r } = e, i = [
    "Criteria group with shared timeline window.",
    `Group: ${t}`,
    `Shared window: ${r}`,
    `Elements: ${n.length}`,
    ""
  ];
  return n.forEach((o, s) => {
    const l = o.criteriaBadge || Ad[o.domain] || Tn(o.domain), c = (o.tooltip || o.label).split(`
`).map((u) => u.trim()).filter(Boolean);
    i.push(`${s + 1}. ${o.label} (${l})`), c.forEach((u) => i.push(u)), i.push("");
  }), i.join(`
`).trim();
}
function Wo(e) {
  const { rows: t, groupId: n, groupName: r } = e;
  if (t.length === 0)
    return t;
  const i = t.filter((l) => l.kind === "criteria");
  if (i.length < 2)
    return t;
  const o = i.reduce(
    (l, c) => {
      const u = mg(c.id);
      return !u || !u.startsWith(n) || (l[u] || (l[u] = []), l[u].push(c)), l;
    },
    {}
  ), s = /* @__PURE__ */ new Map();
  return Object.entries(o).forEach(([l, c]) => {
    if (c.length < 2)
      return;
    const u = Ml(c[0]);
    if (!c.every(
      (T) => Ml(T) === u
    ))
      return;
    const d = c[0], f = l === n && typeof r == "string" && r.trim() !== "" ? r.trim() : "Criteria group", h = `GROUP - ${f}`, g = new Set(c.map((T) => T.id)), C = {
      id: `grouped-${l}`,
      label: h,
      domain: "other",
      criteriaBadge: "Group",
      tooltipTitle: "GROUP",
      groupedInclusion: !0,
      startDay: d.startDay,
      endDay: d.endDay,
      openStart: d.openStart,
      openEnd: d.openEnd,
      exclusion: c.some((T) => T.exclusion),
      isNested: c.some((T) => T.isNested),
      nestedDepth: Math.min(...c.map((T) => T.nestedDepth || 0)),
      tooltip: Dd({
        groupLabel: f,
        rows: c,
        sharedWindow: Ao(
          d.startDay,
          d.endDay,
          d.openStart,
          d.openEnd
        )
      }),
      kind: "criteria",
      sourceJson: c.map((T) => T.sourceJson).filter((T) => T !== void 0)
    };
    c.forEach((T) => {
      s.set(T.id, {
        collapsed: C,
        hiddenIds: g,
        firstId: c[0].id
      });
    });
  }), s.size === 0 ? t : t.reduce((l, c) => {
    const u = s.get(c.id);
    return u ? (c.id === u.firstId && l.push(u.collapsed), l) : (l.push(c), l);
  }, []);
}
function Vl(e) {
  const { rows: t, groupName: n, fallbackGroupName: r = "Criteria group" } = e;
  if (t.length === 0)
    return t;
  const i = typeof n == "string" && n.trim() !== "" ? n.trim() : r;
  if (t.length === 1)
    return [
      {
        ...t[0],
        label: typeof n == "string" && n.trim() !== "" ? n.trim() : t[0].label
      }
    ];
  const o = Math.min(...t.map((u) => u.startDay)), s = Math.max(...t.map((u) => u.endDay)), l = t.some((u) => u.openStart), c = t.some((u) => u.openEnd);
  return [
    {
      id: `display-group-${t[0].id}`,
      label: `GROUP - ${i}`,
      domain: "other",
      criteriaBadge: "Group",
      tooltipTitle: "GROUP",
      groupedInclusion: !0,
      startDay: o,
      endDay: s,
      openStart: l,
      openEnd: c,
      exclusion: t.some((u) => u.exclusion),
      isNested: t.some((u) => u.isNested),
      nestedDepth: Math.min(...t.map((u) => u.nestedDepth || 0)),
      tooltip: Dd({
        groupLabel: i,
        rows: t,
        sharedWindow: Ao(o, s, l, c)
      }),
      kind: "criteria",
      sourceJson: t.map((u) => u.sourceJson).filter((u) => u !== void 0)
    }
  ];
}
function _d(e) {
  return typeof e == "string" ? /^\d{4}-\d{2}-\d{2}/.test(e) : !e || typeof e != "object" ? !1 : Object.values(e).some((t) => _d(t));
}
function Eg(e) {
  const t = nt(e == null ? void 0 : e.PrimaryCriteria);
  return oi(t.CriteriaList).map((r) => ii(r)).filter(Boolean);
}
function Nd(e) {
  const t = nt(e);
  return ii(t == null ? void 0 : t.Criteria) || ii(e);
}
function wd(e, t, n) {
  const r = si(
    n,
    rt(t == null ? void 0 : t.CodesetId)
  ), i = rs(e);
  return r ? `${i} of ${r}` : i;
}
function xg(e) {
  return typeof e != "string" || e.trim() === "" ? null : `Group rule: ${Dn[e] || e}`;
}
function Cg(e) {
  if (!gt(e))
    return { prefix: "", countSuffix: "" };
  const t = rt(e.Count), n = is(e.Type) || (e.Type ? Dn[String(e.Type)] : "");
  return {
    prefix: n && t !== null ? `${n} ${t} ` : n || "",
    countSuffix: t !== null ? ` (x${t})` : ""
  };
}
function gg(e) {
  var f, h;
  const { entry: t, expression: n, depth: r } = e, i = Nd(t);
  if (!i)
    return [];
  const o = "  ".repeat(r), { prefix: s, countSuffix: l } = Cg(
    (f = nt(t)) == null ? void 0 : f.Occurrence
  ), c = wd(
    i.type,
    i.payload,
    n
  ), u = Od(t), p = [
    `${o}* ${s}${c}${l}`,
    ...Io(i.payload, n).map(
      (g) => `${o}  ${g}`
    ),
    `${o}  Window: ${Ao(
      u.startDay,
      u.endDay,
      u.openStart,
      u.openEnd
    )}`
  ], d = (h = i.payload) == null ? void 0 : h.CorrelatedCriteria;
  return gt(d) && p.push(
    ...os({
      group: d,
      expression: n,
      depth: r + 1
    })
  ), p;
}
function os(e) {
  const { group: t, expression: n, depth: r } = e, i = "  ".repeat(r), o = [], s = xg(t == null ? void 0 : t.Type);
  return s && o.push(`${i}${s}`), oi(t == null ? void 0 : t.CriteriaList).forEach((l) => {
    o.push(
      ...gg({
        entry: l,
        expression: n,
        depth: r
      })
    );
  }), oi(t == null ? void 0 : t.Groups).forEach((l) => {
    o.push(
      ...os({
        group: nt(l),
        expression: n,
        depth: r + 1
      })
    );
  }), o;
}
function yg(e, t) {
  const n = t.flatMap((r) => {
    var l;
    const i = Nd(r);
    if (!i)
      return [];
    const o = [
      `* ${wd(i.type, i.payload, e)}`,
      ...Io(i.payload, e).map(
        (c) => `  ${c}`
      )
    ], s = (l = i.payload) == null ? void 0 : l.CorrelatedCriteria;
    return gt(s) && o.push(
      ...os({
        group: s,
        expression: e,
        depth: 1
      })
    ), o;
  });
  return n.length > 0 ? n.join(`
`) : "No index event configured.";
}
function Tg(e, t) {
  const n = [
    "default",
    "single",
    "multiple",
    "nested",
    "dual_index",
    "calendar",
    "ppp",
    "obs_period",
    "eras",
    "groups"
  ], r = {
    default: "Requires no primary criteria.",
    single: "Requires exactly one primary index criterion.",
    multiple: "Requires two or more primary index criteria.",
    nested: "Requires nested group criteria.",
    dual_index: "Requires multi-level nested criteria.",
    calendar: "Requires explicit calendar date constraints.",
    ppp: "Requires Payer Plan Period as index criterion.",
    obs_period: "Requires Observation Period criterion.",
    eras: "Requires cohort era settings (EraPad or CensorWindow).",
    groups: "Requires non-trivial group logic.",
    unsupported: "Scenario is unsupported."
  }, i = (o) => {
    switch (o) {
      case "default":
        return t.hasPrimary ? r.default : "";
      case "single":
        return !t.hasPrimary || t.hasMultiplePrimary ? r.single : "";
      case "multiple":
        return t.hasMultiplePrimary ? "" : r.multiple;
      case "nested":
        return t.hasNested ? "" : r.nested;
      case "dual_index":
        return t.hasDualIndex ? "" : r.dual_index;
      case "calendar":
        return t.hasCalendarDates ? "" : r.calendar;
      case "ppp":
        return t.hasPayerPlanPeriod ? "" : r.ppp;
      case "obs_period":
        return t.hasObservationPeriodCriteria ? "" : r.obs_period;
      case "eras":
        return t.hasEras ? "" : r.eras;
      case "groups":
        return t.hasGroups ? "" : r.groups;
      default:
        return r.unsupported;
    }
  };
  return n.map((o) => {
    const s = o !== e;
    return {
      id: o,
      label: YC[o],
      active: o === e,
      disabled: s,
      disabledReason: s ? i(o) : ""
    };
  });
}
function Sg(e, t) {
  if (!e.hasPrimary)
    return "default";
  const n = [];
  return e.hasDualIndex && n.push("dual_index"), e.hasEras && n.push("eras"), e.hasGroups && n.push("groups"), e.hasNested && n.push("nested"), e.hasObservationPeriodCriteria && n.push("obs_period"), e.hasPayerPlanPeriod && n.push("ppp"), e.hasCalendarDates && n.push("calendar"), e.hasMultiplePrimary && n.push("multiple"), n.length > 1 && t.push(
    `Multiple scenario signals detected (${n.join(
      ", "
    )}). Highest-priority state is selected for active tab.`
  ), n.length > 0 ? n[0] : "single";
}
function Pd(e, t) {
  return t ? bt(e) : WC;
}
function Ig(e, t) {
  const n = e[0];
  if (!n || n.openStart && n.openEnd)
    return bt(t + 120);
  if (n.startDay === n.endDay)
    return bt(Math.max(t + 15, n.startDay));
  const r = n.openStart ? t + 30 : n.startDay, i = n.openEnd ? t + 120 : n.endDay, o = Math.round((r + i) / 2);
  return bt(Math.max(t + 15, o));
}
function Ag(e, t, n, r, i, o, s) {
  var f;
  const l = Pd(
    i,
    o
  ), c = o ? "" : ' The observation period has no fixed length, so the exact day is unknown and the marker is placed in the "all days after" area.';
  if (t) {
    const h = Ig(
      r,
      i
    ), g = n ? "Death Censoring Event" : "Censoring Event", C = ((f = r[0]) == null ? void 0 : f.label) || "Configured censoring rule";
    return {
      active: "censoring",
      markerDay: l,
      markerColor: Lr,
      secondaryMarkerDay: h,
      secondaryMarkerLabel: g,
      secondaryMarkerColor: n ? ns.death : "#475569",
      secondaryMarkerTooltip: n ? `${C} triggers additional cohort exit after observation end.` : `${C} triggers additional cohort exit after observation end.`,
      tooltip: `Cohort exit occurs at observation end or at a censoring event (for example, death), whichever applies first.${c}`
    };
  }
  const u = nt(e == null ? void 0 : e.EndStrategy);
  if (!u || Object.keys(u).length === 0)
    return {
      active: "obs_end",
      markerDay: l,
      markerColor: Lr,
      tooltip: o ? void 0 : `Cohort exit is based on observation end.${c}`
    };
  const p = nt(u == null ? void 0 : u.CustomEra);
  if (Object.keys(p).length > 0) {
    const h = rt(p.GapDays) ?? 0, g = rt(p.Offset) ?? 0, C = rt(p.DaysSupplyOverride), T = si(e, rt(p.DrugCodesetId)) || "selected drug concept", I = bt(Math.max(0, i)), A = bt(I + g), S = Math.abs(g), _ = [
      `Continuous exposure persistence for ${T}.`,
      `Persistence window: ${h} days between exposure records.`,
      `Cohort exit is ${sr(g)} after drug_exposure_end.`,
      C !== null ? `Days supply override: ${C} days.` : ""
    ].filter(Boolean), v = [
      `Drug exposure end for ${T}.`,
      `Persistence window: ${h} days between exposure records.`,
      `Cohort exit offset: ${sr(g)}.`,
      C !== null ? `Days supply override: ${C} days.` : ""
    ].filter(Boolean);
    return {
      active: "drug_persist",
      markerDay: A,
      markerColor: XC,
      secondaryMarkerDay: I,
      secondaryMarkerLabel: "Drug Exposure End",
      secondaryMarkerColor: "#334155",
      secondaryMarkerTooltip: v.join(`
`),
      markerSpan: {
        startDay: I,
        endDay: A,
        label: `surveillance=${S}d`
      },
      tooltip: _.join(`
`)
    };
  }
  const d = nt(u == null ? void 0 : u.DateOffset);
  if (Object.keys(d).length > 0) {
    const h = rt(d.Offset) ?? 0, g = String(d.DateField || "").toLowerCase();
    if (g.includes("start")) {
      const C = sr(h), T = `${h >= 0 ? "+" : ""}${h}`;
      return {
        active: "start_plus_x",
        markerDay: bt(h),
        markerColor: Lr,
        activeLabelOverride: `5.2 Start${C}`,
        descriptionOverride: `Cohort exit uses fixed offset: start date ${T} days.`,
        tooltip: `Cohort exit uses fixed offset: start date ${T} days.`
      };
    }
    if (g.includes("end")) {
      const C = sr(h), T = `${h >= 0 ? "+" : ""}${h}`;
      return {
        active: "end_plus_x",
        markerDay: bt(l + h),
        markerColor: Lr,
        activeLabelOverride: `5.2 End${C}`,
        descriptionOverride: `Cohort exit uses fixed offset: end date ${T} days.`,
        tooltip: `Cohort exit uses fixed offset: end date ${T} days.${c}`
      };
    }
    s.push(
      `DateOffset end strategy (${d.DateField} + ${h}d) is not covered by v1 named tabs.`
    );
  } else
    s.push("EndStrategy shape is not recognized for v1 mapping.");
  return {
    active: "unsupported",
    markerDay: l,
    markerColor: Lr
  };
}
function bg(e, t, n) {
  const r = [
    "obs_end",
    "start_plus_x",
    "end_plus_x",
    "drug_persist",
    "censoring"
  ], i = {
    obs_end: "Active only when exit is observation-end based.",
    start_plus_x: "Active only for DateOffset(StartDate, +Xd).",
    end_plus_x: "Active only for DateOffset(EndDate, +Xd).",
    drug_persist: "Active only for CustomEra persistence exit.",
    censoring: "Active only when censoring criteria are configured.",
    unsupported: "Unsupported exit strategy."
  };
  return r.map((o) => {
    const s = o !== e;
    return {
      id: o,
      label: o === e && n ? n : HC[o],
      active: o === e,
      disabled: s,
      disabledReason: s ? o === "censoring" && !t.hasCensoring ? i.censoring : i[o] : ""
    };
  });
}
function Rg(e) {
  const t = [
    "condition",
    "drug",
    "device",
    "measurement",
    "observation",
    "procedure",
    "visit",
    "payer",
    "demographic",
    "death",
    "other"
  ], n = new Set(e.map((r) => r.domain));
  return t.filter((r) => n.has(r)).map((r) => ({
    domain: r,
    label: Ad[r],
    color: ns[r]
  }));
}
function Yo(e) {
  if (!e)
    return [];
  const t = [];
  return e.openStart || t.push(e.startDay), e.openEnd || t.push(e.endDay), t;
}
function Og(e) {
  const { defaultStartDay: t, defaultEndDay: n, observationPeriodWindows: r, warnings: i } = e;
  if (r.length === 0)
    return {
      startDay: t,
      endDay: n,
      hasConcreteEnd: !1
    };
  const o = r.flatMap((u) => [
    ...Yo(u.startWindow),
    ...Yo(u.endWindow)
  ]), s = r.flatMap(
    (u) => Yo(u.endWindow)
  );
  let l = o.length > 0 ? bt(Math.min(...o)) : t, c = o.length > 0 ? bt(Math.max(...o)) : n;
  if (l > c) {
    i.push(
      `Observation Period boundaries were inverted (${l}d..${c}d). They were normalized for timeline display.`
    );
    const u = Math.min(l, c), p = Math.max(l, c);
    l = u, c = p;
  }
  return {
    startDay: l,
    endDay: c,
    hasConcreteEnd: s.length > 0
  };
}
const vg = [
  "Timeline line appears in all scenario states.",
  "Labels use short criterion names with domain badges.",
  "Demographics are shown as index-aligned markers.",
  "Observation end and cohort exit labels stack when coinciding.",
  "Primary index criteria and nested index criteria are summarized in the Index tooltip.",
  "Nested inclusion criteria are rendered in regular inclusion rows in timeline.",
  "Exit tooltip expresses the active exit formula."
];
function Dg(e) {
  const t = nt(e == null ? void 0 : e.expression), n = [], r = Eg(t), i = r.reduce(
    (y, X, V) => {
      var oe;
      const $ = (oe = X == null ? void 0 : X.payload) == null ? void 0 : oe.CorrelatedCriteria;
      if (!gt($))
        return y;
      const le = Wr(
        $,
        t,
        `primary-correlated-${V}`,
        1
      );
      return Wo({
        rows: le.rows,
        groupId: `primary-correlated-${V}`
      }).forEach((re) => y.rows.push(re)), le.criteriaTypes.forEach((re) => y.criteriaTypes.add(re)), le.observationPeriodWindows.forEach(
        (re) => y.observationPeriodWindows.push(re)
      ), y.hasGroups = y.hasGroups || le.hasGroups, y.maxNestedDepth = Math.max(
        y.maxNestedDepth,
        le.maxNestedDepth
      ), y;
    },
    {
      rows: [],
      criteriaTypes: /* @__PURE__ */ new Set(),
      hasGroups: !1,
      maxNestedDepth: 0,
      observationPeriodWindows: []
    }
  ), o = Wr(
    nt(t == null ? void 0 : t.AdditionalCriteria),
    t,
    "additional",
    0
  ), s = Wo({
    rows: o.rows,
    groupId: "additional"
  }), l = {
    ...o,
    rows: Vl({
      rows: s,
      fallbackGroupName: "Restrict initial events"
    })
  }, u = (Array.isArray(t == null ? void 0 : t.InclusionRules) ? t.InclusionRules : []).reduce(
    (y, X, V) => {
      const $ = Wr(
        nt(X == null ? void 0 : X.expression),
        t,
        `inclusion-${V}`,
        0
      ), le = Wo({
        rows: $.rows,
        groupId: `inclusion-${V}`,
        groupName: X == null ? void 0 : X.name
      });
      return Vl({
        rows: le,
        groupName: X == null ? void 0 : X.name
      }).forEach((b) => y.rows.push(b)), $.criteriaTypes.forEach((b) => y.criteriaTypes.add(b)), $.observationPeriodWindows.forEach(
        (b) => y.observationPeriodWindows.push(b)
      ), y.hasGroups = y.hasGroups || $.hasGroups, y.maxNestedDepth = Math.max(
        y.maxNestedDepth,
        $.maxNestedDepth
      ), y;
    },
    {
      rows: [],
      criteriaTypes: /* @__PURE__ */ new Set(),
      hasGroups: !1,
      maxNestedDepth: 0,
      observationPeriodWindows: []
    }
  ), p = Array.isArray(t == null ? void 0 : t.CensoringCriteria) ? t.CensoringCriteria : [], d = [], f = /* @__PURE__ */ new Set();
  p.forEach((y, X) => {
    const V = ii(y);
    V && (f.add(V.type), d.push(
      vd({
        id: `censoring-${X}`,
        expression: t,
        criteriaType: V.type,
        payload: V.payload,
        nestedDepth: 0,
        exclusion: !0,
        isNested: !1,
        kind: "censoring",
        sourceJson: y
      })
    ));
  });
  const h = [
    ...l.rows,
    ...u.rows,
    ...d
  ], g = [
    ...h.filter((y) => y.domain !== "death"),
    ...h.filter((y) => y.domain === "death")
  ], C = /* @__PURE__ */ new Set();
  r.forEach((y) => C.add(y.type)), i.criteriaTypes.forEach((y) => C.add(y)), o.criteriaTypes.forEach((y) => C.add(y)), u.criteriaTypes.forEach((y) => C.add(y)), f.forEach((y) => C.add(y));
  const T = i.criteriaTypes.size > 0, I = Math.max(
    o.maxNestedDepth,
    u.maxNestedDepth
  ), A = {
    hasPrimary: r.length > 0,
    hasMultiplePrimary: r.length > 1,
    hasNested: T || I >= 1,
    hasDualIndex: i.maxNestedDepth >= 2 || I >= 2,
    hasCalendarDates: r.some((y) => _d(y.payload)),
    hasPayerPlanPeriod: r.some(
      (y) => y.type === D.PAYER_PLAN_PERIOD
    ),
    hasObservationPeriodCriteria: C.has(
      D.OBSERVATION_PERIOD
    ),
    hasEras: C.has(D.CONDITION_ERA) || C.has(D.DRUG_ERA) || C.has(D.DOSE_ERA) || (rt(nt(t == null ? void 0 : t.CollapseSettings).EraPad) ?? 0) > 0 || !!nt(t == null ? void 0 : t.CensorWindow).StartDate || !!nt(t == null ? void 0 : t.CensorWindow).EndDate,
    hasGroups: l.hasGroups || u.hasGroups,
    hasCensoring: d.length > 0
  }, S = d.some((y) => y.domain === "death"), _ = Sg(A, n), v = nt(t == null ? void 0 : t.PrimaryCriteria), O = nt(v == null ? void 0 : v.ObservationWindow), j = rt(O == null ? void 0 : O.PriorDays), M = rt(O == null ? void 0 : O.PostDays), w = bt(-1 * (j ?? 0)), L = bt(M ?? 0), P = [
    ...i.observationPeriodWindows,
    ...o.observationPeriodWindows,
    ...u.observationPeriodWindows
  ], k = Og({
    defaultStartDay: w,
    defaultEndDay: L,
    observationPeriodWindows: P,
    warnings: n
  }), z = k.startDay, B = k.endDay, q = Pd(
    B,
    k.hasConcreteEnd
  ), N = Ag(
    t,
    A.hasCensoring,
    S,
    d,
    B,
    k.hasConcreteEnd,
    n
  ), ne = bg(
    N.active,
    A,
    N.activeLabelOverride
  ), ue = oi(v.CriteriaList), te = yg(
    t,
    ue
  ), m = A.hasPrimary ? [
    {
      id: "index-primary",
      day: 0,
      label: "Index",
      color: Id,
      variant: "diamond",
      tooltip: te,
      sourceJson: r.length === 1 ? ue[0] : ue
    }
  ] : [];
  _ === "default" && g.length === 0 && n.push(
    "No criteria rows available; displaying baseline timeline only."
  );
  const W = Tg(_, A), H = Rg(g);
  return {
    title: (e == null ? void 0 : e.name) || "Cohort Criteria Timeline",
    scenario: {
      active: _,
      tabs: W,
      description: JC[_]
    },
    exit: {
      active: N.active,
      tabs: ne,
      description: N.descriptionOverride || jl[N.active],
      tooltip: N.tooltip || N.descriptionOverride || jl[N.active],
      markerDay: N.markerDay,
      markerColor: N.markerColor,
      secondaryMarkerDay: N.secondaryMarkerDay,
      secondaryMarkerLabel: N.secondaryMarkerLabel,
      secondaryMarkerColor: N.secondaryMarkerColor,
      secondaryMarkerTooltip: N.secondaryMarkerTooltip,
      markerSpan: N.markerSpan
    },
    index: {
      label: "Index Event",
      tooltip: te,
      markers: m
    },
    observation: {
      startDay: z,
      endDay: B,
      endMarkerDay: q,
      hasConcreteEnd: k.hasConcreteEnd
    },
    axis: {
      minDay: Fn,
      maxDay: On,
      ticks: Ta
    },
    rows: g,
    domainLegend: H,
    warnings: n,
    notes: vg
  };
}
const _n = {
  domains: ns,
  index: Id,
  secondaryIndex: qC
}, oo = 250, kt = 26, Bn = 10, _g = 6, Ul = 15, Ng = 8, Ho = "#4f5d7a", Fl = 2, Qn = 18, wg = kt * 2 + Bn * 4, Pg = 25, jg = 10, qo = 3, Lg = 1.2, kg = _n.domains.other, Mg = 2e3, Bl = {
  width: 38,
  height: 38,
  p: 0,
  border: "1px solid #D8DEE9",
  borderRadius: "6px",
  backgroundColor: "#FFFFFF",
  color: "#1F2A44",
  boxShadow: "0 1px 2px rgba(31, 42, 68, 0.08)",
  "&:hover": {
    backgroundColor: "#f8fafc",
    borderColor: "#c8d0dc"
  },
  "&.Mui-disabled": {
    backgroundColor: "#FFFFFF",
    borderColor: "#E5E7EB",
    color: "#A0A8B8"
  }
}, on = {
  [`& .${Gs.tooltip}`]: {
    backgroundColor: Ho,
    borderRadius: "12px",
    border: "1px solid rgba(148, 163, 184, 0.35)",
    boxShadow: "0 12px 32px rgba(2, 6, 23, 0.35)",
    p: 1.5,
    maxWidth: "430px",
    fontFamily: '"IBM Plex Sans", "Segoe UI", sans-serif'
  },
  [`& .${Gs.arrow}`]: {
    color: Ho,
    "&::before": {
      backgroundColor: Ho,
      border: "1px solid rgba(148, 163, 184, 0.35)",
      boxShadow: "none"
    }
  }
};
function Vg(e) {
  return JSON.stringify(e, null, 2);
}
function Er(e) {
  return typeof e == "object" && e !== null && !Array.isArray(e);
}
function jd(e) {
  return Array.isArray(e) ? e : Er(e) ? Object.values(e) : [];
}
function Ug(e) {
  return Er(e) ? e.STANDARD_CONCEPT === "N" || e.standardConcept === "N" : !1;
}
function Fg(e) {
  if (!Er(e))
    return {};
  const t = { ...e }, n = t.excluded, r = t.hierarchy;
  delete t.excluded, delete t.hierarchy, delete t.id;
  const i = t.concept, o = typeof t.isExcluded == "boolean" ? t.isExcluded : n, s = {
    ...t,
    ...typeof o == "boolean" ? { isExcluded: o } : {}
  };
  if (Ug(i)) {
    const l = typeof r == "boolean" ? r : t.includeDescendants;
    typeof l == "boolean" && (s.includeDescendants = l);
  }
  return delete s.excluded, delete s.id, s;
}
function Bg(e) {
  if (!Er(e))
    return {};
  const t = { ...e }, n = t.expression;
  delete t.currentVersionId, delete t.currentVersionOrdinal, delete t.externalId, delete t.referenceId, delete t.terminated, delete t.uuid, delete t.version, delete t.versionId, delete t.versionOrdinal;
  const r = Er(n) ? n : {};
  return {
    ...t,
    expression: {
      ...r,
      items: jd(r.items).map(Fg)
    }
  };
}
function $g(e) {
  const t = e == null ? void 0 : e.expression;
  return Er(t) ? {
    ...t,
    ConceptSets: jd(t.ConceptSets).map(Bg)
  } : t ?? null;
}
function Aa(e) {
  const { copyKey: t, data: n, copiedKey: r, onCopy: i, tooltip: o = "Copy JSON" } = e, s = r === t;
  return /* @__PURE__ */ a.jsx(Xe, { text: o, width: 120, children: /* @__PURE__ */ a.jsx(
    Qr,
    {
      size: "small",
      onClick: (l) => {
        l.stopPropagation(), i(t, n);
      },
      sx: {
        width: 24,
        height: 24,
        p: 0.25,
        color: s ? "#059669" : "#64748b",
        "&:hover": {
          backgroundColor: "#e2e8f0",
          color: "#0f172a"
        }
      },
      name: t,
      children: /* @__PURE__ */ a.jsx(
        Xe,
        {
          text: s ? "JSON copied to clipboard!" : "",
          controlled: !0,
          show: s,
          width: 170,
          children: /* @__PURE__ */ a.jsx(
            ge,
            {
              iconName: s ? "checkmark" : "copy",
              sx: { fontSize: 15 },
              name: o
            }
          )
        }
      )
    }
  ) });
}
function Gg(e) {
  const { isExit: t = !1 } = e, n = "#0f1f45";
  return /* @__PURE__ */ a.jsx(
    Y,
    {
      component: "svg",
      viewBox: "0 0 16 16",
      "aria-hidden": !0,
      sx: { width: 14, height: 14, display: "block" },
      children: t ? /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
        /* @__PURE__ */ a.jsx(
          "path",
          {
            d: "M2.5 13.5 L6.5 9.5",
            stroke: n,
            strokeWidth: "1.8",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ a.jsx(
          "path",
          {
            d: "M5.5 13.5 H2.5 V10.5",
            stroke: n,
            strokeWidth: "1.8",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            fill: "none"
          }
        ),
        /* @__PURE__ */ a.jsx(
          "path",
          {
            d: "M13.5 2.5 L9.5 6.5",
            stroke: n,
            strokeWidth: "1.8",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ a.jsx(
          "path",
          {
            d: "M10.5 2.5 H13.5 V5.5",
            stroke: n,
            strokeWidth: "1.8",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            fill: "none"
          }
        )
      ] }) : /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
        /* @__PURE__ */ a.jsx(
          "path",
          {
            d: "M6.5 6.5 L2.5 2.5",
            stroke: n,
            strokeWidth: "1.8",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ a.jsx(
          "path",
          {
            d: "M2.5 5.5 V2.5 H5.5",
            stroke: n,
            strokeWidth: "1.8",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            fill: "none"
          }
        ),
        /* @__PURE__ */ a.jsx(
          "path",
          {
            d: "M9.5 9.5 L13.5 13.5",
            stroke: n,
            strokeWidth: "1.8",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ a.jsx(
          "path",
          {
            d: "M10.5 13.5 H13.5 V10.5",
            stroke: n,
            strokeWidth: "1.8",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            fill: "none"
          }
        )
      ] })
    }
  );
}
function St(e, t, n) {
  return n <= t ? 0 : (e - t) / (n - t) * 100;
}
function zg(e) {
  return e.startDay === e.endDay ? e.startDay : e.openStart && e.openEnd ? 0 : !e.openStart && e.endDay <= 0 ? e.endDay : !e.openEnd && e.startDay >= 0 ? e.startDay : e.startDay <= 0 && e.endDay >= 0 ? 0 : e.openStart && !e.openEnd ? e.endDay : !e.openStart && e.openEnd ? e.startDay : Math.round((e.startDay + e.endDay) / 2);
}
function Ld(e, t) {
  return e.startDay === e.endDay || !e.openStart && e.openEnd ? e.startDay : e.openStart && !e.openEnd ? e.endDay : e.openStart && e.openEnd ? t : zg(e);
}
function Wg(e, t, n) {
  const r = [];
  return e.map((i) => ({
    ...i,
    pct: St(i.day, t, n),
    // Approximate text width in axis percent to avoid label collisions.
    halfWidthPct: Math.max(2.2, Math.min(18, i.text.length * 0.42))
  })).sort((i, o) => i.pct - o.pct).map((i) => {
    const o = i.pct - i.halfWidthPct, s = i.pct + i.halfWidthPct;
    let l = 0;
    for (; r[l] !== void 0 && o - r[l] < Ng; )
      l++;
    return r[l] = s, {
      id: i.id,
      day: i.day,
      text: i.text,
      color: i.color,
      lane: l
    };
  });
}
function Yg(e) {
  return _n.domains[e] || _n.domains.other;
}
function ba(e) {
  return e.groupedInclusion ? kg : Yg(e.domain);
}
function lr(e) {
  return e.criteriaBadge ? e.criteriaBadge : e.groupedInclusion ? "group" : e.domain;
}
function _i(e) {
  return e.tooltipTitle ? e.tooltipTitle : e.groupedInclusion ? "GROUP" : e.label;
}
function Hg(e, t) {
  return e ? e.split(`
`).map((n) => n.trimEnd()).filter((n) => n.trim() !== "").filter((n) => {
    if (!t)
      return !0;
    const r = n.trim();
    return !(r === t || r.startsWith(`${t}:`));
  }) : [];
}
function qg(e) {
  const t = e.trim().toLowerCase();
  if (t === "#111111" || t === "#000" || t === "#000000")
    return "#E2E8F0";
  const n = t.startsWith("#") ? t.slice(1) : t;
  if (!/^[0-9a-f]{3}$|^[0-9a-f]{6}$/.test(n))
    return e;
  const i = n.length === 3 ? n.split("").map((u) => u + u).join("") : n, o = parseInt(i.slice(0, 2), 16) / 255, s = parseInt(i.slice(2, 4), 16) / 255, l = parseInt(i.slice(4, 6), 16) / 255;
  return 0.2126 * o + 0.7152 * s + 0.0722 * l < 0.35 ? "#E2E8F0" : e;
}
function Mn(e, t = !1) {
  return {
    cursor: "pointer",
    transition: "filter 0.15s ease, box-shadow 0.15s ease, border-color 0.15s ease, opacity 0.15s ease",
    "&:hover": {
      filter: "brightness(1.18) saturate(1.22)",
      ...t ? { boxShadow: `0 0 0 1px ${e}66, 0 8px 18px ${e}33` } : {},
      zIndex: 14
    }
  };
}
function Xg(e) {
  return {
    cursor: "pointer",
    transition: "background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease, filter 0.15s ease",
    "&:hover": {
      background: e,
      borderColor: e,
      boxShadow: `0 0 0 1px ${e}, 0 10px 22px ${e}40`,
      filter: "brightness(1.04) saturate(1.12)",
      zIndex: 7
    },
    "&:hover .timeline-open-cap": {
      backgroundColor: "#FFFFFF",
      color: e,
      borderColor: e
    },
    "&:hover .timeline-bar-text": {
      color: "#FFFFFF",
      backgroundColor: "transparent",
      textShadow: "0 1px 2px rgba(15, 23, 42, 0.35)"
    },
    "&:hover .timeline-inline-tag": {
      color: "#FFFFFF",
      borderColor: "#FFFFFFB3",
      backgroundColor: `${e}C0`
    }
  };
}
function Jg(e) {
  return {
    cursor: "pointer",
    transition: "box-shadow 0.15s ease, filter 0.15s ease",
    "&:hover": {
      boxShadow: `0 0 0 2px #ffffff, 0 0 0 1px ${e}66, 0 8px 18px ${e}33`,
      filter: "brightness(1.08) saturate(1.15)"
    }
  };
}
function an(e) {
  const {
    title: t,
    color: n,
    details: r,
    domainBadge: i,
    domainBadgeVariant: o = "chip"
  } = e, s = qg(n), l = Hg(r, t);
  return /* @__PURE__ */ a.jsxs(Y, { sx: { minWidth: "260px" }, children: [
    /* @__PURE__ */ a.jsxs(Y, { sx: { display: "flex", alignItems: "center", gap: 1, mb: 0.75 }, children: [
      /* @__PURE__ */ a.jsx(
        fe,
        {
          sx: {
            color: s,
            fontSize: "13px",
            letterSpacing: "0.08em",
            textTransform: "uppercase",
            fontWeight: 800,
            fontFamily: '"IBM Plex Sans Condensed", "IBM Plex Sans", sans-serif'
          },
          children: t
        }
      ),
      i && o === "inline" && /* @__PURE__ */ a.jsxs(
        fe,
        {
          sx: {
            color: s,
            fontSize: "11px",
            fontWeight: 800,
            fontFamily: '"IBM Plex Sans Condensed", "IBM Plex Sans", sans-serif'
          },
          children: [
            "(",
            i,
            ")"
          ]
        }
      ),
      i && o === "chip" && /* @__PURE__ */ a.jsx(
        Y,
        {
          sx: {
            fontSize: "12px",
            fontWeight: 700,
            color: s,
            border: `1px solid ${s}66`,
            backgroundColor: `${s}1F`,
            borderRadius: "6px",
            px: 0.75,
            py: "1px",
            textTransform: "uppercase",
            letterSpacing: "0.06em"
          },
          children: i
        }
      )
    ] }),
    l.length > 0 && /* @__PURE__ */ a.jsx(Y, { sx: { display: "flex", flexDirection: "column", gap: 0.35 }, children: l.map((c, u) => /* @__PURE__ */ a.jsx(
      fe,
      {
        sx: {
          color: "#E2E8F0",
          fontSize: "14px",
          lineHeight: 1.35,
          fontFamily: '"IBM Plex Sans", "Segoe UI", sans-serif',
          whiteSpace: "pre-wrap"
        },
        children: c
      },
      `${c}-${u}`
    )) })
  ] });
}
function Kg(e) {
  const { row: t, copiedKey: n, onCopyJson: r } = e, i = ba(t);
  return t.kind === "demographic" ? /* @__PURE__ */ a.jsxs(
    Y,
    {
      sx: {
        height: `${kt + 6}px`,
        mb: `${_g}px`,
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        pr: 1,
        gap: 0.75
      },
      children: [
        /* @__PURE__ */ a.jsx(
          fe,
          {
            sx: {
              fontSize: "14px",
              color: "#94a3b8",
              fontStyle: "italic"
            },
            children: t.label
          }
        ),
        /* @__PURE__ */ a.jsx(
          Y,
          {
            sx: {
              fontSize: "11px",
              fontWeight: 700,
              color: i,
              border: `1px solid ${i}33`,
              backgroundColor: `${i}14`,
              borderRadius: "4px",
              px: 0.75,
              py: "1px",
              textTransform: "uppercase",
              letterSpacing: "0.03em"
            },
            children: lr(t)
          }
        ),
        /* @__PURE__ */ a.jsx(
          Aa,
          {
            copyKey: `timeline-row-${t.id}`,
            data: t.sourceJson ?? t,
            copiedKey: n,
            onCopy: r,
            tooltip: "Copy element JSON"
          }
        )
      ]
    }
  ) : /* @__PURE__ */ a.jsxs(
    Y,
    {
      sx: {
        height: `${kt}px`,
        mb: `${Bn}px`,
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        pr: 1,
        gap: t.secondaryIndexAnchor ? 0.35 : 0.75
      },
      children: [
        t.secondaryIndexAnchor && /* @__PURE__ */ a.jsx(
          Y,
          {
            sx: {
              width: "11px",
              height: "11px",
              borderRadius: "2px",
              backgroundColor: _n.secondaryIndex,
              transform: "rotate(45deg)",
              flexShrink: 0,
              mr: 0
            }
          }
        ),
        /* @__PURE__ */ a.jsx(
          fe,
          {
            sx: {
              fontSize: "14px",
              color: "#323b4b",
              maxWidth: `${oo - 84}px`,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap"
            },
            children: t.label
          }
        ),
        /* @__PURE__ */ a.jsx(
          Y,
          {
            sx: {
              fontSize: "11px",
              fontWeight: 700,
              color: i,
              border: `1px solid ${i}33`,
              backgroundColor: `${i}14`,
              borderRadius: "4px",
              px: 0.75,
              py: "1px",
              textTransform: "uppercase",
              letterSpacing: "0.03em"
            },
            children: lr(t)
          }
        ),
        t.exclusion && /* @__PURE__ */ a.jsx(
          Y,
          {
            sx: {
              fontSize: "11px",
              fontWeight: 700,
              color: "#B45309",
              border: "1px solid #FCD34D",
              backgroundColor: "#FFFBEB",
              borderRadius: "4px",
              px: 0.75,
              py: "1px",
              textTransform: "uppercase",
              letterSpacing: "0.03em"
            },
            children: "Excl"
          }
        ),
        /* @__PURE__ */ a.jsx(
          Aa,
          {
            copyKey: `timeline-row-${t.id}`,
            data: t.sourceJson ?? t,
            copiedKey: n,
            onCopy: r,
            tooltip: "Copy element JSON"
          }
        )
      ]
    }
  );
}
function Qg(e) {
  var z, B, q;
  const {
    rows: t,
    axis: n,
    indexMarkers: r,
    observationStartDay: i,
    observationEndDay: o,
    observationEndIsOpen: s,
    exitMarkerDay: l,
    exitColor: c,
    exitTooltip: u,
    secondaryMarkerDay: p,
    secondaryMarkerLabel: d,
    secondaryMarkerColor: f,
    secondaryMarkerTooltip: h,
    markerSpan: g,
    copiedKey: C,
    onCopyJson: T
  } = e, I = r.length > 0, A = I ? 1 : 0, S = t.length + A, _ = ((z = r[0]) == null ? void 0 : z.day) ?? 0, v = (B = r.find(
    (N) => N.id === "index-secondary"
  )) == null ? void 0 : B.day, O = Math.max(
    S * (kt + Bn) + Bn,
    wg
  ), j = (N) => Bn + N * (kt + Bn), M = j(0) + kt / 2, w = t.findIndex(
    (N) => N.secondaryIndexAnchor
  ), L = t.findIndex((N) => N.kind !== "demographic"), P = w >= 0 && ((q = t[w]) != null && q.secondaryIndexAnchor) ? 10 : 0, k = w >= 0 ? j(w + A) + kt / 2 - P : L >= 0 ? j(L + A) + kt / 2 : M;
  return /* @__PURE__ */ a.jsxs(Y, { sx: { display: "flex", width: "100%" }, children: [
    /* @__PURE__ */ a.jsxs(Y, { sx: { width: `${oo}px`, flexShrink: 0, mt: "6px" }, children: [
      I && /* @__PURE__ */ a.jsxs(
        Y,
        {
          sx: {
            height: `${kt}px`,
            mb: `${Bn}px`,
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            pr: 1,
            gap: 1
          },
          children: [
            /* @__PURE__ */ a.jsx(
              fe,
              {
                sx: {
                  fontSize: "15px",
                  color: _n.index,
                  fontWeight: 700
                },
                children: r[0].label
              }
            ),
            /* @__PURE__ */ a.jsx(
              Aa,
              {
                copyKey: `timeline-marker-${r[0].id}`,
                data: r[0].sourceJson ?? r[0],
                copiedKey: C,
                onCopy: T,
                tooltip: "Copy index JSON"
              }
            )
          ]
        }
      ),
      t.map((N) => /* @__PURE__ */ a.jsx(
        Xe,
        {
          text: /* @__PURE__ */ a.jsx(
            an,
            {
              title: _i(N),
              color: ba(N),
              details: N.tooltip || N.label,
              domainBadge: lr(N)
            }
          ),
          placement: "left",
          sx: on,
          children: /* @__PURE__ */ a.jsx("span", { children: /* @__PURE__ */ a.jsx(
            Kg,
            {
              row: N,
              copiedKey: C,
              onCopyJson: T
            }
          ) })
        },
        N.id
      ))
    ] }),
    /* @__PURE__ */ a.jsxs(Y, { sx: { flex: 1, position: "relative", height: `${O}px` }, children: [
      n.ticks.map((N) => /* @__PURE__ */ a.jsx(
        Y,
        {
          sx: {
            position: "absolute",
            left: `${St(N, n.minDay, n.maxDay)}%`,
            top: 0,
            bottom: 0,
            width: "1px",
            transform: "translateX(-0.5px)",
            backgroundColor: "#eef1f5"
          }
        },
        `tick-${N}`
      )),
      /* @__PURE__ */ a.jsx(
        Xe,
        {
          text: /* @__PURE__ */ a.jsx(
            an,
            {
              title: "Obs Start",
              color: "#94a3b8",
              details: "Observation start boundary"
            }
          ),
          sx: on,
          children: /* @__PURE__ */ a.jsx(
            Y,
            {
              sx: {
                position: "absolute",
                left: `${St(
                  i,
                  n.minDay,
                  n.maxDay
                )}%`,
                top: 0,
                bottom: 0,
                borderLeft: "1.5px dashed #94a3b8",
                transform: "translateX(-0.5px)",
                zIndex: 2,
                ...Mn("#94a3b8")
              }
            }
          )
        }
      ),
      /* @__PURE__ */ a.jsx(
        Xe,
        {
          text: /* @__PURE__ */ a.jsx(
            an,
            {
              title: "Obs End",
              color: "#94a3b8",
              details: s ? "Observation continues past the chart: the period has no fixed length, so the end day is unknown." : "Observation end boundary"
            }
          ),
          sx: on,
          children: /* @__PURE__ */ a.jsx(
            Y,
            {
              sx: {
                position: "absolute",
                left: `${St(
                  o,
                  n.minDay,
                  n.maxDay
                )}%`,
                top: 0,
                bottom: 0,
                borderLeft: "1.5px dashed #94a3b8",
                transform: "translateX(-0.5px)",
                zIndex: 2,
                ...Mn("#94a3b8")
              }
            }
          )
        }
      ),
      r.map((N, ne) => {
        const ue = ne === 0 ? M : k, te = `${St(N.day, n.minDay, n.maxDay)}%`;
        return /* @__PURE__ */ a.jsxs(
          Y,
          {
            sx: {
              position: "absolute",
              left: te,
              top: 0,
              bottom: 0,
              width: "24px",
              transform: "translateX(-12px)",
              zIndex: 12,
              pointerEvents: "none"
            },
            children: [
              /* @__PURE__ */ a.jsx(
                Y,
                {
                  className: "timeline-index-line",
                  sx: {
                    position: "absolute",
                    left: "50%",
                    top: 0,
                    bottom: 0,
                    width: 0,
                    borderLeft: `2px solid ${N.color}`,
                    transform: "translateX(-1px)",
                    opacity: ne === 0 ? 1 : 0.85,
                    pointerEvents: "none"
                  }
                }
              ),
              /* @__PURE__ */ a.jsx(
                Xe,
                {
                  text: /* @__PURE__ */ a.jsx(
                    an,
                    {
                      title: N.label,
                      color: N.color,
                      details: N.tooltip || N.label,
                      domainBadge: ne === 0 ? "any of" : "index 2",
                      domainBadgeVariant: ne === 0 ? "inline" : "chip"
                    }
                  ),
                  sx: on,
                  children: /* @__PURE__ */ a.jsx(
                    Y,
                    {
                      className: "timeline-index-diamond",
                      sx: {
                        position: "absolute",
                        left: "50%",
                        top: `${ue - 7}px`,
                        width: "14px",
                        height: "14px",
                        borderRadius: "2px",
                        backgroundColor: N.color,
                        transform: "translateX(-50%) rotate(45deg)",
                        boxShadow: "0 0 0 2px #ffffff",
                        pointerEvents: "auto",
                        ...Jg(N.color)
                      }
                    }
                  )
                }
              )
            ]
          },
          N.id
        );
      }),
      /* @__PURE__ */ a.jsx(
        Xe,
        {
          text: /* @__PURE__ */ a.jsx(
            an,
            {
              title: "Cohort Exit",
              color: c,
              details: u
            }
          ),
          sx: on,
          children: /* @__PURE__ */ a.jsx(
            Y,
            {
              sx: {
                position: "absolute",
                left: `${St(l, n.minDay, n.maxDay)}%`,
                top: 0,
                bottom: 0,
                width: "3px",
                backgroundColor: c,
                transform: "translateX(-1.5px)",
                borderRadius: "2px",
                zIndex: 4,
                ...Mn(c)
              }
            }
          )
        }
      ),
      typeof p == "number" && /* @__PURE__ */ a.jsx(
        Xe,
        {
          text: /* @__PURE__ */ a.jsx(
            an,
            {
              title: d || "Secondary marker",
              color: f || "#334155",
              details: h || d || "Secondary exit marker"
            }
          ),
          sx: on,
          children: /* @__PURE__ */ a.jsx(
            Y,
            {
              sx: {
                position: "absolute",
                left: `${St(
                  p,
                  n.minDay,
                  n.maxDay
                )}%`,
                top: 0,
                bottom: 0,
                width: "2px",
                borderLeft: `2px dashed ${f || "#334155"}`,
                transform: "translateX(-1px)",
                borderRadius: "2px",
                zIndex: 4,
                ...Mn(f || "#334155")
              }
            }
          )
        }
      ),
      g && /* @__PURE__ */ a.jsx(
        Xe,
        {
          text: /* @__PURE__ */ a.jsx(
            an,
            {
              title: g.label,
              color: c,
              details: `Interval between Drug Exposure End and Cohort Exit: ${Math.abs(
                g.endDay - g.startDay
              )} days.`,
              domainBadge: "exit interval"
            }
          ),
          sx: on,
          children: /* @__PURE__ */ a.jsx(
            Y,
            {
              sx: {
                position: "absolute",
                top: "-3px",
                left: `${Math.max(
                  0,
                  Math.min(
                    100,
                    St(g.endDay, n.minDay, n.maxDay) - Lg
                  )
                )}%`,
                width: `${Pg}px`,
                height: `${jg}px`,
                transform: "translateX(-12px)",
                borderTop: `${qo}px solid ${c}`,
                borderLeft: `${qo}px solid ${c}`,
                borderRight: `${qo}px solid ${c}`,
                borderTopLeftRadius: "4px",
                borderTopRightRadius: "6px",
                borderBottomRightRadius: "2px",
                boxSizing: "border-box",
                zIndex: 6,
                ...Mn(c)
              },
              children: /* @__PURE__ */ a.jsx(
                fe,
                {
                  sx: {
                    position: "absolute",
                    bottom: "calc(200% - 6px)",
                    left: "212%",
                    transform: "translateX(-100%)",
                    fontSize: "11px",
                    fontWeight: 700,
                    color: c,
                    whiteSpace: "nowrap",
                    lineHeight: 1,
                    textAlign: "right"
                  },
                  children: g.label
                }
              )
            }
          )
        }
      ),
      t.map((N, ne) => {
        const ue = j(ne + A), te = ba(N), m = N.secondaryIndexAnchor ? 10 : 0, W = kt + Fl, H = N.secondaryIndexAnchor && N.inlineTagText ? 40 : W, y = N.secondaryIndexAnchor && N.inlineTagText ? Math.max(
          0,
          ue - m - (H - kt) / 2
        ) : ue - Fl / 2 - m, X = St(N.startDay, n.minDay, n.maxDay), V = St(N.endDay, n.minDay, n.maxDay), $ = Math.max(0.6, V - X);
        N.openStart && N.openEnd || N.openStart || N.openEnd;
        const le = N.secondaryIndexAnchor && typeof v == "number" ? Math.max(
          6,
          Math.min(
            94,
            (St(v, n.minDay, n.maxDay) - X) / $ * 100
          )
        ) : void 0;
        if (N.kind === "demographic")
          return /* @__PURE__ */ a.jsx(
            Xe,
            {
              text: /* @__PURE__ */ a.jsx(
                an,
                {
                  title: _i(N),
                  color: "#94a3b8",
                  details: N.tooltip || N.label,
                  domainBadge: lr(N)
                }
              ),
              sx: on,
              children: /* @__PURE__ */ a.jsx(
                Y,
                {
                  sx: {
                    position: "absolute",
                    left: `${St(0, n.minDay, n.maxDay)}%`,
                    top: `${ue + kt / 2 - 6}px`,
                    width: "12px",
                    height: "12px",
                    borderRadius: "50%",
                    backgroundColor: "#94a3b8",
                    transform: "translateX(-6px)",
                    zIndex: 16,
                    boxShadow: "0 0 0 2px white",
                    ...Mn("#94a3b8")
                  }
                }
              )
            },
            N.id
          );
        if (N.domain === "death") {
          const b = Ld(N, o), oe = b === _, re = oe ? 4 : 2;
          return /* @__PURE__ */ a.jsx(
            Xe,
            {
              text: /* @__PURE__ */ a.jsx(
                an,
                {
                  title: _i(N),
                  color: te,
                  details: N.tooltip || N.label,
                  domainBadge: lr(N)
                }
              ),
              sx: on,
              children: /* @__PURE__ */ a.jsx(
                Y,
                {
                  "data-testid": `timeline-death-line-${N.id}`,
                  sx: {
                    position: "absolute",
                    left: `${St(b, n.minDay, n.maxDay)}%`,
                    top: oe ? `${ue - 2}px` : 0,
                    bottom: oe ? "auto" : 0,
                    height: oe ? `${kt + 4}px` : "auto",
                    width: `${re}px`,
                    background: te,
                    transform: `translateX(-${re / 2}px)`,
                    zIndex: 18,
                    borderRadius: "2px",
                    ...Mn(te)
                  },
                  children: !oe && /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
                    /* @__PURE__ */ a.jsx(
                      Y,
                      {
                        sx: {
                          position: "absolute",
                          left: "50%",
                          bottom: "25px",
                          width: "4px",
                          height: "4px",
                          borderRadius: "50%",
                          backgroundColor: te,
                          transform: "translateX(-50%)"
                        }
                      }
                    ),
                    /* @__PURE__ */ a.jsx(
                      Y,
                      {
                        sx: {
                          position: "absolute",
                          left: "50%",
                          bottom: "12px",
                          width: "9px",
                          height: "9px",
                          borderRadius: "50%",
                          backgroundColor: te,
                          transform: "translateX(-50%)"
                        }
                      }
                    ),
                    /* @__PURE__ */ a.jsx(
                      Y,
                      {
                        sx: {
                          position: "absolute",
                          left: "50%",
                          bottom: "4px",
                          width: "4px",
                          height: "4px",
                          borderRadius: "50%",
                          backgroundColor: te,
                          transform: "translateX(-50%)"
                        }
                      }
                    )
                  ] })
                }
              )
            },
            N.id
          );
        }
        return /* @__PURE__ */ a.jsx(
          Xe,
          {
            text: /* @__PURE__ */ a.jsx(
              an,
              {
                title: _i(N),
                color: te,
                details: N.tooltip || N.label,
                domainBadge: lr(N)
              }
            ),
            sx: on,
            children: /* @__PURE__ */ a.jsxs(
              Y,
              {
                sx: {
                  position: "absolute",
                  left: `${X}%`,
                  top: `${y}px`,
                  height: `${H}px`,
                  width: `${$}%`,
                  border: `1px solid ${te}55`,
                  background: N.exclusion ? `repeating-linear-gradient(135deg, ${te}22, ${te}22 4px, transparent 4px, transparent 8px)` : `${te}2B`,
                  zIndex: 3,
                  borderRadius: "12px",
                  ...Xg(te)
                },
                children: [
                  N.openStart && /* @__PURE__ */ a.jsx(
                    Y,
                    {
                      className: "timeline-open-cap",
                      sx: {
                        position: "absolute",
                        left: "2px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        width: `${Qn}px`,
                        height: `${Qn}px`,
                        borderRadius: "50%",
                        backgroundColor: te,
                        color: "white",
                        border: `1px solid ${te}`,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "14px",
                        lineHeight: 1,
                        fontWeight: 800,
                        transition: "background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease"
                      },
                      children: "❮"
                    }
                  ),
                  N.openEnd && /* @__PURE__ */ a.jsx(
                    Y,
                    {
                      className: "timeline-open-cap",
                      sx: {
                        position: "absolute",
                        right: "2px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        width: `${Qn}px`,
                        height: `${Qn}px`,
                        borderRadius: "50%",
                        backgroundColor: te,
                        color: "white",
                        border: `1px solid ${te}`,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "14px",
                        lineHeight: 1,
                        fontWeight: 800,
                        transition: "background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease"
                      },
                      children: "❯"
                    }
                  ),
                  N.eraText && /* @__PURE__ */ a.jsx(
                    fe,
                    {
                      className: "timeline-bar-text",
                      sx: {
                        position: "absolute",
                        left: "50%",
                        top: "50%",
                        transform: "translate(-50%, -50%)",
                        maxWidth: N.openStart || N.openEnd ? `calc(100% - ${Qn + 12}px)` : "calc(100% - 12px)",
                        fontSize: "12px",
                        lineHeight: 1,
                        fontWeight: 700,
                        color: te,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        textAlign: "center",
                        px: 0.5,
                        backgroundColor: "transparent",
                        borderRadius: "3px",
                        pointerEvents: "none"
                      },
                      children: N.eraText
                    }
                  ),
                  typeof le == "number" && !N.secondaryIndexAnchor && /* @__PURE__ */ a.jsx(
                    Y,
                    {
                      sx: {
                        position: "absolute",
                        left: `${le}%`,
                        top: "50%",
                        width: "14px",
                        height: "14px",
                        borderRadius: "3px",
                        backgroundColor: _n.secondaryIndex,
                        transform: "translate(-50%, -50%) rotate(45deg)",
                        boxShadow: "0 0 0 2px #ffffff",
                        zIndex: 5,
                        pointerEvents: "none"
                      }
                    }
                  ),
                  N.inlineTagText && /* @__PURE__ */ a.jsx(
                    fe,
                    {
                      className: "timeline-inline-tag",
                      sx: {
                        position: "absolute",
                        ...typeof le == "number" ? {
                          left: `calc(${le}% - 3px)`
                        } : {
                          right: N.openEnd ? `${Qn + 8}px` : "6px"
                        },
                        top: typeof le == "number" ? "calc(50% + 5px)" : "50%",
                        transform: typeof le == "number" ? "translate(-100%, 0)" : "translateY(-50%)",
                        maxWidth: typeof le == "number" ? "40px" : "56px",
                        fontSize: typeof le == "number" ? "10px" : "11px",
                        lineHeight: 1,
                        fontWeight: 700,
                        color: te,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        textTransform: "uppercase",
                        px: typeof le == "number" ? 0.5 : 0.75,
                        py: typeof le == "number" ? "1px" : "2px",
                        borderRadius: typeof le == "number" ? "3px" : "4px",
                        border: `1px solid ${te}66`,
                        backgroundColor: `${te}22`,
                        pointerEvents: "none",
                        transition: "color 0.15s ease, border-color 0.15s ease, background-color 0.15s ease"
                      },
                      children: N.inlineTagText
                    }
                  )
                ]
              }
            )
          },
          N.id
        );
      }),
      /* @__PURE__ */ a.jsx(
        Y,
        {
          sx: {
            position: "absolute",
            left: 0,
            right: 0,
            bottom: 0,
            borderTop: "1px solid #a9afb9",
            zIndex: 1
          }
        }
      )
    ] })
  ] });
}
const Zg = ({
  definition: e
}) => {
  const [t, n] = J(!1), [r, i] = J(!1), [o, s] = J(null), l = Ae(null), c = Ae(null), u = t || r, p = ee(
    () => Dg(e || null),
    [e]
  ), d = ee(() => {
    const C = [
      {
        id: "obs-start",
        day: p.observation.startDay,
        text: "Obs Start",
        color: "#94a3b8"
      },
      {
        id: "obs-end",
        day: p.observation.endMarkerDay,
        text: "Obs End",
        color: "#94a3b8"
      },
      {
        id: "cohort-exit",
        day: p.exit.markerDay,
        text: "Cohort Exit",
        color: p.exit.markerColor
      }
    ];
    p.index.markers.forEach((I) => {
      C.push({
        id: I.id,
        day: I.day,
        text: I.label,
        color: I.color
      });
    });
    const T = p.rows.find((I) => I.domain === "death");
    return T && C.push({
      id: `death-label-${T.id}`,
      day: Ld(T, p.observation.endMarkerDay),
      text: "Death",
      color: "#111111"
    }), typeof p.exit.secondaryMarkerDay == "number" && C.push({
      id: "secondary-exit-marker",
      day: p.exit.secondaryMarkerDay,
      text: p.exit.secondaryMarkerLabel || "Secondary marker",
      color: p.exit.secondaryMarkerColor || "#334155"
    }), Wg(C, p.axis.minDay, p.axis.maxDay);
  }, [p]), f = (Math.max(0, ...d.map((C) => C.lane)) + 1) * Ul + 4;
  Q(() => {
    const C = () => {
      const T = document.fullscreenElement === l.current;
      n(T), T && i(!1);
    };
    return document.addEventListener("fullscreenchange", C), () => document.removeEventListener("fullscreenchange", C);
  }, []), Q(() => () => {
    c.current && clearTimeout(c.current);
  }, []), Q(() => {
    if (!r)
      return;
    const C = document.body.style.overflow;
    return document.body.style.overflow = "hidden", () => {
      document.body.style.overflow = C;
    };
  }, [r]);
  const h = async () => {
    var A, S, _;
    if (!l.current)
      return;
    if (r) {
      i(!1);
      return;
    }
    if (document.fullscreenElement) {
      try {
        await ((A = document.exitFullscreen) == null ? void 0 : A.call(document));
      } catch {
        n(!1);
      }
      return;
    }
    const C = document.permissionsPolicy, T = document.featurePolicy;
    if (!(((S = C == null ? void 0 : C.allowsFeature) == null ? void 0 : S.call(C, "fullscreen")) ?? ((_ = T == null ? void 0 : T.allowsFeature) == null ? void 0 : _.call(T, "fullscreen")) ?? !0) || typeof l.current.requestFullscreen != "function") {
      i(!0);
      return;
    }
    try {
      await l.current.requestFullscreen();
    } catch {
      i(!0);
    }
  }, g = async (C, T) => {
    await navigator.clipboard.writeText(Vg(T)), s(C), c.current && clearTimeout(c.current), c.current = setTimeout(() => {
      s(null), c.current = null;
    }, Mg);
  };
  return /* @__PURE__ */ a.jsx(
    Y,
    {
      ref: l,
      sx: {
        backgroundColor: u ? "#f5f6f8" : "transparent",
        borderRadius: r ? 0 : "10px",
        p: u ? 4 : 0,
        ...r ? {
          position: "fixed",
          inset: 0,
          zIndex: 1400,
          overflowY: "auto"
        } : {}
      },
      children: /* @__PURE__ */ a.jsxs(
        wh,
        {
          variant: "outlined",
          sx: { p: 2, borderRadius: "10px", borderColor: "#e5e7eb" },
          children: [
            /* @__PURE__ */ a.jsxs(R, { item: !0, sx: { display: "flex", gap: 1, justifyContent: "end" }, children: [
              /* @__PURE__ */ a.jsx(
                Xe,
                {
                  text: "Copy cohort JSON",
                  placement: "left",
                  disabled: o === "timeline-cohort",
                  children: /* @__PURE__ */ a.jsx(Y, { component: "span", sx: { display: "inline-flex" }, children: /* @__PURE__ */ a.jsx(
                    Xe,
                    {
                      text: "Cohort JSON copied to clipboard!",
                      controlled: !0,
                      show: o === "timeline-cohort",
                      placement: "left",
                      width: 190,
                      children: /* @__PURE__ */ a.jsx(
                        Qr,
                        {
                          size: "small",
                          "aria-label": "Copy cohort JSON",
                          onClick: () => g(
                            "timeline-cohort",
                            $g(e)
                          ),
                          disabled: !e,
                          sx: Bl,
                          name: "Copy cohort JSON",
                          children: /* @__PURE__ */ a.jsx(
                            ge,
                            {
                              iconName: o === "timeline-cohort" ? "checkmark" : "copy",
                              sx: { fontSize: 18, color: "inherit" },
                              name: "Copy cohort JSON"
                            }
                          )
                        }
                      )
                    }
                  ) })
                }
              ),
              /* @__PURE__ */ a.jsx(
                Xe,
                {
                  text: u ? "Exit Fullscreen" : "Expand to full screen",
                  placement: "left",
                  children: /* @__PURE__ */ a.jsx(
                    Qr,
                    {
                      size: "small",
                      "aria-label": u ? "Exit Fullscreen" : "Expand to full screen",
                      onClick: h,
                      sx: Bl,
                      name: u ? "Exit Fullscreen" : "Expand to full screen",
                      children: /* @__PURE__ */ a.jsx(Gg, { isExit: u })
                    }
                  )
                }
              )
            ] }),
            /* @__PURE__ */ a.jsx(
              Y,
              {
                sx: {
                  ml: `${oo}px`,
                  mb: 0.5,
                  height: `${f}px`,
                  position: "relative",
                  fontSize: "12px"
                },
                children: d.map((C) => /* @__PURE__ */ a.jsx(
                  fe,
                  {
                    sx: {
                      position: "absolute",
                      left: `${St(
                        C.day,
                        p.axis.minDay,
                        p.axis.maxDay
                      )}%`,
                      top: `${C.lane * Ul}px`,
                      transform: "translateX(-50%)",
                      fontSize: "12px",
                      lineHeight: 1.1,
                      color: C.color,
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                      fontWeight: 700,
                      px: 0.25,
                      backgroundColor: "white",
                      borderRadius: "2px",
                      whiteSpace: "nowrap"
                    },
                    children: C.text
                  },
                  C.id
                ))
              }
            ),
            /* @__PURE__ */ a.jsx(
              Qg,
              {
                rows: p.rows,
                axis: p.axis,
                indexMarkers: p.index.markers,
                observationStartDay: p.observation.startDay,
                observationEndDay: p.observation.endMarkerDay,
                observationEndIsOpen: !p.observation.hasConcreteEnd,
                exitMarkerDay: p.exit.markerDay,
                exitColor: p.exit.markerColor,
                exitTooltip: p.exit.tooltip,
                secondaryMarkerDay: p.exit.secondaryMarkerDay,
                secondaryMarkerLabel: p.exit.secondaryMarkerLabel,
                secondaryMarkerColor: p.exit.secondaryMarkerColor,
                secondaryMarkerTooltip: p.exit.secondaryMarkerTooltip,
                markerSpan: p.exit.markerSpan,
                copiedKey: o,
                onCopyJson: g
              }
            ),
            /* @__PURE__ */ a.jsxs(
              Y,
              {
                sx: {
                  ml: `${oo}px`,
                  mt: 0.75,
                  mb: 1.25,
                  position: "relative",
                  height: "30px"
                },
                children: [
                  /* @__PURE__ */ a.jsxs(
                    fe,
                    {
                      sx: {
                        position: "absolute",
                        left: 0,
                        top: 2,
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "6px",
                        fontSize: "12px",
                        color: "#8b93a2",
                        textTransform: "uppercase",
                        fontWeight: 700,
                        letterSpacing: "0.04em"
                      },
                      children: [
                        /* @__PURE__ */ a.jsx(
                          Y,
                          {
                            component: "span",
                            sx: { fontSize: "10px", lineHeight: 1, color: "#8b93a2" },
                            children: "◄"
                          }
                        ),
                        "All days before"
                      ]
                    }
                  ),
                  p.axis.ticks.map((C) => /* @__PURE__ */ a.jsxs(
                    Y,
                    {
                      sx: {
                        position: "absolute",
                        left: `${St(
                          C,
                          p.axis.minDay,
                          p.axis.maxDay
                        )}%`,
                        transform: "translateX(-50%)",
                        textAlign: "center",
                        color: C === 0 ? _n.index : "#9ca3af",
                        fontSize: "12px"
                      },
                      children: [
                        /* @__PURE__ */ a.jsx(
                          Y,
                          {
                            sx: {
                              width: "1px",
                              height: "5px",
                              backgroundColor: "#d5dbe3",
                              mx: "auto"
                            }
                          }
                        ),
                        /* @__PURE__ */ a.jsx(Y, { children: C === 0 ? "0" : `${C > 0 ? "+" : ""}${C}d` })
                      ]
                    },
                    `axis-${C}`
                  )),
                  /* @__PURE__ */ a.jsxs(
                    fe,
                    {
                      sx: {
                        position: "absolute",
                        right: 0,
                        top: 2,
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "6px",
                        fontSize: "12px",
                        color: "#8b93a2",
                        textTransform: "uppercase",
                        fontWeight: 700,
                        letterSpacing: "0.04em"
                      },
                      children: [
                        "All days after",
                        /* @__PURE__ */ a.jsx(
                          Y,
                          {
                            component: "span",
                            sx: { fontSize: "10px", lineHeight: 1, color: "#8b93a2" },
                            children: "►"
                          }
                        )
                      ]
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ a.jsx(Fa, {}),
            /* @__PURE__ */ a.jsxs(Y, { sx: { mt: 1.25, display: "flex", gap: 2, flexWrap: "wrap" }, children: [
              p.index.markers.length > 0 && /* @__PURE__ */ a.jsxs(Y, { sx: { display: "flex", alignItems: "center", gap: 0.75 }, children: [
                /* @__PURE__ */ a.jsx(
                  Y,
                  {
                    sx: {
                      width: "10px",
                      height: "10px",
                      borderRadius: "2px",
                      transform: "rotate(45deg)",
                      backgroundColor: _n.index
                    }
                  }
                ),
                /* @__PURE__ */ a.jsx(fe, { sx: { fontSize: "13px", color: "#4b5563" }, children: "Entry / Index" })
              ] }),
              /* @__PURE__ */ a.jsxs(Y, { sx: { display: "flex", alignItems: "center", gap: 0.75 }, children: [
                /* @__PURE__ */ a.jsx(
                  Y,
                  {
                    sx: {
                      width: "10px",
                      height: "10px",
                      borderRadius: "50%",
                      backgroundColor: "#94a3b8"
                    }
                  }
                ),
                /* @__PURE__ */ a.jsx(fe, { sx: { fontSize: "13px", color: "#4b5563" }, children: "Demographic (index)" })
              ] }),
              /* @__PURE__ */ a.jsxs(Y, { sx: { display: "flex", alignItems: "center", gap: 0.75 }, children: [
                /* @__PURE__ */ a.jsx(
                  Y,
                  {
                    sx: {
                      width: "14px",
                      height: "3px",
                      backgroundColor: p.exit.markerColor
                    }
                  }
                ),
                /* @__PURE__ */ a.jsx(fe, { sx: { fontSize: "13px", color: "#4b5563" }, children: "Cohort Exit" })
              ] }),
              /* @__PURE__ */ a.jsxs(Y, { sx: { display: "flex", alignItems: "center", gap: 0.75 }, children: [
                /* @__PURE__ */ a.jsx(Y, { sx: { width: "14px", borderTop: "1.5px dashed #94a3b8" } }),
                /* @__PURE__ */ a.jsx(fe, { sx: { fontSize: "13px", color: "#4b5563" }, children: "Observation boundary" })
              ] }),
              p.domainLegend.map((C) => /* @__PURE__ */ a.jsxs(
                Y,
                {
                  sx: { display: "flex", alignItems: "center", gap: 0.75 },
                  children: [
                    /* @__PURE__ */ a.jsx(
                      Y,
                      {
                        sx: {
                          width: "12px",
                          height: "9px",
                          borderRadius: "2px",
                          border: `1px solid ${C.color}55`,
                          backgroundColor: `${C.color}2B`
                        }
                      }
                    ),
                    /* @__PURE__ */ a.jsx(fe, { sx: { fontSize: "13px", color: C.color }, children: C.label })
                  ]
                },
                C.domain
              ))
            ] })
          ]
        }
      )
    }
  );
};
function ey(e, t) {
  const n = {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (n.padRight ? " " : "") + "," + (n.padLeft === !1 ? "" : " ")
  ).trim();
}
const ty = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, ny = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, ry = {};
function $l(e, t) {
  return (ry.jsx ? ny : ty).test(e);
}
const iy = /[ \t\n\f\r]/g;
function oy(e) {
  return typeof e == "object" ? e.type === "text" ? Gl(e.value) : !1 : Gl(e);
}
function Gl(e) {
  return e.replace(iy, "") === "";
}
class xi {
  /**
   * @param {SchemaType['property']} property
   *   Property.
   * @param {SchemaType['normal']} normal
   *   Normal.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Schema.
   */
  constructor(t, n, r) {
    this.normal = n, this.property = t, r && (this.space = r);
  }
}
xi.prototype.normal = {};
xi.prototype.property = {};
xi.prototype.space = void 0;
function kd(e, t) {
  const n = {}, r = {};
  for (const i of e)
    Object.assign(n, i.property), Object.assign(r, i.normal);
  return new xi(n, r, t);
}
function Ra(e) {
  return e.toLowerCase();
}
class wt {
  /**
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @returns
   *   Info.
   */
  constructor(t, n) {
    this.attribute = n, this.property = t;
  }
}
wt.prototype.attribute = "";
wt.prototype.booleanish = !1;
wt.prototype.boolean = !1;
wt.prototype.commaOrSpaceSeparated = !1;
wt.prototype.commaSeparated = !1;
wt.prototype.defined = !1;
wt.prototype.mustUseProperty = !1;
wt.prototype.number = !1;
wt.prototype.overloadedBoolean = !1;
wt.prototype.property = "";
wt.prototype.spaceSeparated = !1;
wt.prototype.space = void 0;
let ay = 0;
const Ie = Jn(), tt = Jn(), Oa = Jn(), Z = Jn(), $e = Jn(), dr = Jn(), Lt = Jn();
function Jn() {
  return 2 ** ++ay;
}
const va = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: Ie,
  booleanish: tt,
  commaOrSpaceSeparated: Lt,
  commaSeparated: dr,
  number: Z,
  overloadedBoolean: Oa,
  spaceSeparated: $e
}, Symbol.toStringTag, { value: "Module" })), Xo = (
  /** @type {ReadonlyArray<keyof typeof types>} */
  Object.keys(va)
);
class as extends wt {
  /**
   * @constructor
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @param {number | null | undefined} [mask]
   *   Mask.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Info.
   */
  constructor(t, n, r, i) {
    let o = -1;
    if (super(t, n), zl(this, "space", i), typeof r == "number")
      for (; ++o < Xo.length; ) {
        const s = Xo[o];
        zl(this, Xo[o], (r & va[s]) === va[s]);
      }
  }
}
as.prototype.defined = !0;
function zl(e, t, n) {
  n && (e[t] = n);
}
function br(e) {
  const t = {}, n = {};
  for (const [r, i] of Object.entries(e.properties)) {
    const o = new as(
      r,
      e.transform(e.attributes || {}, r),
      i,
      e.space
    );
    e.mustUseProperty && e.mustUseProperty.includes(r) && (o.mustUseProperty = !0), t[r] = o, n[Ra(r)] = r, n[Ra(o.attribute)] = r;
  }
  return new xi(t, n, e.space);
}
const Md = br({
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: tt,
    ariaAutoComplete: null,
    ariaBusy: tt,
    ariaChecked: tt,
    ariaColCount: Z,
    ariaColIndex: Z,
    ariaColSpan: Z,
    ariaControls: $e,
    ariaCurrent: null,
    ariaDescribedBy: $e,
    ariaDetails: null,
    ariaDisabled: tt,
    ariaDropEffect: $e,
    ariaErrorMessage: null,
    ariaExpanded: tt,
    ariaFlowTo: $e,
    ariaGrabbed: tt,
    ariaHasPopup: null,
    ariaHidden: tt,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: $e,
    ariaLevel: Z,
    ariaLive: null,
    ariaModal: tt,
    ariaMultiLine: tt,
    ariaMultiSelectable: tt,
    ariaOrientation: null,
    ariaOwns: $e,
    ariaPlaceholder: null,
    ariaPosInSet: Z,
    ariaPressed: tt,
    ariaReadOnly: tt,
    ariaRelevant: null,
    ariaRequired: tt,
    ariaRoleDescription: $e,
    ariaRowCount: Z,
    ariaRowIndex: Z,
    ariaRowSpan: Z,
    ariaSelected: tt,
    ariaSetSize: Z,
    ariaSort: null,
    ariaValueMax: Z,
    ariaValueMin: Z,
    ariaValueNow: Z,
    ariaValueText: null,
    role: null
  },
  transform(e, t) {
    return t === "role" ? t : "aria-" + t.slice(4).toLowerCase();
  }
});
function Vd(e, t) {
  return t in e ? e[t] : t;
}
function Ud(e, t) {
  return Vd(e, t.toLowerCase());
}
const sy = br({
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: dr,
    acceptCharset: $e,
    accessKey: $e,
    action: null,
    allow: null,
    allowFullScreen: Ie,
    allowPaymentRequest: Ie,
    allowUserMedia: Ie,
    alt: null,
    as: null,
    async: Ie,
    autoCapitalize: null,
    autoComplete: $e,
    autoFocus: Ie,
    autoPlay: Ie,
    blocking: $e,
    capture: null,
    charSet: null,
    checked: Ie,
    cite: null,
    className: $e,
    cols: Z,
    colSpan: null,
    content: null,
    contentEditable: tt,
    controls: Ie,
    controlsList: $e,
    coords: Z | dr,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: Ie,
    defer: Ie,
    dir: null,
    dirName: null,
    disabled: Ie,
    download: Oa,
    draggable: tt,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: Ie,
    formTarget: null,
    headers: $e,
    height: Z,
    hidden: Oa,
    high: Z,
    href: null,
    hrefLang: null,
    htmlFor: $e,
    httpEquiv: $e,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: Ie,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: Ie,
    itemId: null,
    itemProp: $e,
    itemRef: $e,
    itemScope: Ie,
    itemType: $e,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: Ie,
    low: Z,
    manifest: null,
    max: null,
    maxLength: Z,
    media: null,
    method: null,
    min: null,
    minLength: Z,
    multiple: Ie,
    muted: Ie,
    name: null,
    nonce: null,
    noModule: Ie,
    noValidate: Ie,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: Ie,
    optimum: Z,
    pattern: null,
    ping: $e,
    placeholder: null,
    playsInline: Ie,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: Ie,
    referrerPolicy: null,
    rel: $e,
    required: Ie,
    reversed: Ie,
    rows: Z,
    rowSpan: Z,
    sandbox: $e,
    scope: null,
    scoped: Ie,
    seamless: Ie,
    selected: Ie,
    shadowRootClonable: Ie,
    shadowRootDelegatesFocus: Ie,
    shadowRootMode: null,
    shape: null,
    size: Z,
    sizes: null,
    slot: null,
    span: Z,
    spellCheck: tt,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: Z,
    step: null,
    style: null,
    tabIndex: Z,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: Ie,
    useMap: null,
    value: tt,
    width: Z,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: $e,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: Z,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: Z,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: Ie,
    // Lists. Use CSS to reduce space between items instead
    declare: Ie,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: Z,
    // `<img>` and `<object>`
    leftMargin: Z,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: Z,
    // `<body>`
    marginWidth: Z,
    // `<body>`
    noResize: Ie,
    // `<frame>`
    noHref: Ie,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: Ie,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: Ie,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: Z,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: tt,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: Z,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: Z,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: Ie,
    disableRemotePlayback: Ie,
    prefix: null,
    property: null,
    results: Z,
    security: null,
    unselectable: null
  },
  space: "html",
  transform: Ud
}), ly = br({
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  properties: {
    about: Lt,
    accentHeight: Z,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: Z,
    amplitude: Z,
    arabicForm: null,
    ascent: Z,
    attributeName: null,
    attributeType: null,
    azimuth: Z,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: Z,
    by: null,
    calcMode: null,
    capHeight: Z,
    className: $e,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: Z,
    diffuseConstant: Z,
    direction: null,
    display: null,
    dur: null,
    divisor: Z,
    dominantBaseline: null,
    download: Ie,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: Z,
    enableBackground: null,
    end: null,
    event: null,
    exponent: Z,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: Z,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: dr,
    g2: dr,
    glyphName: dr,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: Z,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: Z,
    horizOriginX: Z,
    horizOriginY: Z,
    id: null,
    ideographic: Z,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: Z,
    k: Z,
    k1: Z,
    k2: Z,
    k3: Z,
    k4: Z,
    kernelMatrix: Lt,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: Z,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: Z,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: Z,
    overlineThickness: Z,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: Z,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: $e,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: Z,
    pointsAtY: Z,
    pointsAtZ: Z,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: Lt,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: Lt,
    rev: Lt,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: Lt,
    requiredFeatures: Lt,
    requiredFonts: Lt,
    requiredFormats: Lt,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: Z,
    specularExponent: Z,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: Z,
    strikethroughThickness: Z,
    string: null,
    stroke: null,
    strokeDashArray: Lt,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: Z,
    strokeOpacity: Z,
    strokeWidth: null,
    style: null,
    surfaceScale: Z,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: Lt,
    tabIndex: Z,
    tableValues: null,
    target: null,
    targetX: Z,
    targetY: Z,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: Lt,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: Z,
    underlineThickness: Z,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: Z,
    values: null,
    vAlphabetic: Z,
    vMathematical: Z,
    vectorEffect: null,
    vHanging: Z,
    vIdeographic: Z,
    version: null,
    vertAdvY: Z,
    vertOriginX: Z,
    vertOriginY: Z,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: Z,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  },
  space: "svg",
  transform: Vd
}), Fd = br({
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  },
  space: "xlink",
  transform(e, t) {
    return "xlink:" + t.slice(5).toLowerCase();
  }
}), Bd = br({
  attributes: { xmlnsxlink: "xmlns:xlink" },
  properties: { xmlnsXLink: null, xmlns: null },
  space: "xmlns",
  transform: Ud
}), $d = br({
  properties: { xmlBase: null, xmlLang: null, xmlSpace: null },
  space: "xml",
  transform(e, t) {
    return "xml:" + t.slice(3).toLowerCase();
  }
}), cy = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, uy = /[A-Z]/g, Wl = /-[a-z]/g, dy = /^data[-\w.:]+$/i;
function py(e, t) {
  const n = Ra(t);
  let r = t, i = wt;
  if (n in e.normal)
    return e.property[e.normal[n]];
  if (n.length > 4 && n.slice(0, 4) === "data" && dy.test(t)) {
    if (t.charAt(4) === "-") {
      const o = t.slice(5).replace(Wl, fy);
      r = "data" + o.charAt(0).toUpperCase() + o.slice(1);
    } else {
      const o = t.slice(4);
      if (!Wl.test(o)) {
        let s = o.replace(uy, hy);
        s.charAt(0) !== "-" && (s = "-" + s), t = "data" + s;
      }
    }
    i = as;
  }
  return new i(r, t);
}
function hy(e) {
  return "-" + e.toLowerCase();
}
function fy(e) {
  return e.charAt(1).toUpperCase();
}
const my = kd([Md, sy, Fd, Bd, $d], "html"), ss = kd([Md, ly, Fd, Bd, $d], "svg");
function Ey(e) {
  return e.join(" ").trim();
}
var ls = {}, Yl = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, xy = /\n/g, Cy = /^\s*/, gy = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, yy = /^:\s*/, Ty = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, Sy = /^[;\s]*/, Iy = /^\s+|\s+$/g, Ay = `
`, Hl = "/", ql = "*", $n = "", by = "comment", Ry = "declaration", Oy = function(e, t) {
  if (typeof e != "string")
    throw new TypeError("First argument must be a string");
  if (!e) return [];
  t = t || {};
  var n = 1, r = 1;
  function i(g) {
    var C = g.match(xy);
    C && (n += C.length);
    var T = g.lastIndexOf(Ay);
    r = ~T ? g.length - T : r + g.length;
  }
  function o() {
    var g = { line: n, column: r };
    return function(C) {
      return C.position = new s(g), u(), C;
    };
  }
  function s(g) {
    this.start = g, this.end = { line: n, column: r }, this.source = t.source;
  }
  s.prototype.content = e;
  function l(g) {
    var C = new Error(
      t.source + ":" + n + ":" + r + ": " + g
    );
    if (C.reason = g, C.filename = t.source, C.line = n, C.column = r, C.source = e, !t.silent) throw C;
  }
  function c(g) {
    var C = g.exec(e);
    if (C) {
      var T = C[0];
      return i(T), e = e.slice(T.length), C;
    }
  }
  function u() {
    c(Cy);
  }
  function p(g) {
    var C;
    for (g = g || []; C = d(); )
      C !== !1 && g.push(C);
    return g;
  }
  function d() {
    var g = o();
    if (!(Hl != e.charAt(0) || ql != e.charAt(1))) {
      for (var C = 2; $n != e.charAt(C) && (ql != e.charAt(C) || Hl != e.charAt(C + 1)); )
        ++C;
      if (C += 2, $n === e.charAt(C - 1))
        return l("End of comment missing");
      var T = e.slice(2, C - 2);
      return r += 2, i(T), e = e.slice(C), r += 2, g({
        type: by,
        comment: T
      });
    }
  }
  function f() {
    var g = o(), C = c(gy);
    if (C) {
      if (d(), !c(yy)) return l("property missing ':'");
      var T = c(Ty), I = g({
        type: Ry,
        property: Xl(C[0].replace(Yl, $n)),
        value: T ? Xl(T[0].replace(Yl, $n)) : $n
      });
      return c(Sy), I;
    }
  }
  function h() {
    var g = [];
    p(g);
    for (var C; C = f(); )
      C !== !1 && (g.push(C), p(g));
    return g;
  }
  return u(), h();
};
function Xl(e) {
  return e ? e.replace(Iy, $n) : $n;
}
var vy = Hi && Hi.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(ls, "__esModule", { value: !0 });
ls.default = _y;
var Dy = vy(Oy);
function _y(e, t) {
  var n = null;
  if (!e || typeof e != "string")
    return n;
  var r = (0, Dy.default)(e), i = typeof t == "function";
  return r.forEach(function(o) {
    if (o.type === "declaration") {
      var s = o.property, l = o.value;
      i ? t(s, l, o) : l && (n = n || {}, n[s] = l);
    }
  }), n;
}
var bo = {};
Object.defineProperty(bo, "__esModule", { value: !0 });
bo.camelCase = void 0;
var Ny = /^--[a-zA-Z0-9_-]+$/, wy = /-([a-z])/g, Py = /^[^-]+$/, jy = /^-(webkit|moz|ms|o|khtml)-/, Ly = /^-(ms)-/, ky = function(e) {
  return !e || Py.test(e) || Ny.test(e);
}, My = function(e, t) {
  return t.toUpperCase();
}, Jl = function(e, t) {
  return "".concat(t, "-");
}, Vy = function(e, t) {
  return t === void 0 && (t = {}), ky(e) ? e : (e = e.toLowerCase(), t.reactCompat ? e = e.replace(Ly, Jl) : e = e.replace(jy, Jl), e.replace(wy, My));
};
bo.camelCase = Vy;
var Uy = Hi && Hi.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
}, Fy = Uy(ls), By = bo;
function Da(e, t) {
  var n = {};
  return !e || typeof e != "string" || (0, Fy.default)(e, function(r, i) {
    r && i && (n[(0, By.camelCase)(r, t)] = i);
  }), n;
}
Da.default = Da;
var $y = Da;
const Gy = /* @__PURE__ */ su($y), Gd = zd("end"), cs = zd("start");
function zd(e) {
  return t;
  function t(n) {
    const r = n && n.position && n.position[e] || {};
    if (typeof r.line == "number" && r.line > 0 && typeof r.column == "number" && r.column > 0)
      return {
        line: r.line,
        column: r.column,
        offset: typeof r.offset == "number" && r.offset > -1 ? r.offset : void 0
      };
  }
}
function zy(e) {
  const t = cs(e), n = Gd(e);
  if (t && n)
    return { start: t, end: n };
}
function Yr(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? Kl(e.position) : "start" in e || "end" in e ? Kl(e) : "line" in e || "column" in e ? _a(e) : "";
}
function _a(e) {
  return Ql(e && e.line) + ":" + Ql(e && e.column);
}
function Kl(e) {
  return _a(e && e.start) + "-" + _a(e && e.end);
}
function Ql(e) {
  return e && typeof e == "number" ? e : 1;
}
class yt extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(t, n, r) {
    super(), typeof n == "string" && (r = n, n = void 0);
    let i = "", o = {}, s = !1;
    if (n && ("line" in n && "column" in n ? o = { place: n } : "start" in n && "end" in n ? o = { place: n } : "type" in n ? o = {
      ancestors: [n],
      place: n.position
    } : o = { ...n }), typeof t == "string" ? i = t : !o.cause && t && (s = !0, i = t.message, o.cause = t), !o.ruleId && !o.source && typeof r == "string") {
      const c = r.indexOf(":");
      c === -1 ? o.ruleId = r : (o.source = r.slice(0, c), o.ruleId = r.slice(c + 1));
    }
    if (!o.place && o.ancestors && o.ancestors) {
      const c = o.ancestors[o.ancestors.length - 1];
      c && (o.place = c.position);
    }
    const l = o.place && "start" in o.place ? o.place.start : o.place;
    this.ancestors = o.ancestors || void 0, this.cause = o.cause || void 0, this.column = l ? l.column : void 0, this.fatal = void 0, this.file, this.message = i, this.line = l ? l.line : void 0, this.name = Yr(o.place) || "1:1", this.place = o.place || void 0, this.reason = this.message, this.ruleId = o.ruleId || void 0, this.source = o.source || void 0, this.stack = s && o.cause && typeof o.cause.stack == "string" ? o.cause.stack : "", this.actual, this.expected, this.note, this.url;
  }
}
yt.prototype.file = "";
yt.prototype.name = "";
yt.prototype.reason = "";
yt.prototype.message = "";
yt.prototype.stack = "";
yt.prototype.column = void 0;
yt.prototype.line = void 0;
yt.prototype.ancestors = void 0;
yt.prototype.cause = void 0;
yt.prototype.fatal = void 0;
yt.prototype.place = void 0;
yt.prototype.ruleId = void 0;
yt.prototype.source = void 0;
const us = {}.hasOwnProperty, Wy = /* @__PURE__ */ new Map(), Yy = /[A-Z]/g, Hy = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]), qy = /* @__PURE__ */ new Set(["td", "th"]), Wd = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function Xy(e, t) {
  if (!t || t.Fragment === void 0)
    throw new TypeError("Expected `Fragment` in options");
  const n = t.filePath || void 0;
  let r;
  if (t.development) {
    if (typeof t.jsxDEV != "function")
      throw new TypeError(
        "Expected `jsxDEV` in options when `development: true`"
      );
    r = rT(n, t.jsxDEV);
  } else {
    if (typeof t.jsx != "function")
      throw new TypeError("Expected `jsx` in production options");
    if (typeof t.jsxs != "function")
      throw new TypeError("Expected `jsxs` in production options");
    r = nT(n, t.jsx, t.jsxs);
  }
  const i = {
    Fragment: t.Fragment,
    ancestors: [],
    components: t.components || {},
    create: r,
    elementAttributeNameCase: t.elementAttributeNameCase || "react",
    evaluater: t.createEvaluater ? t.createEvaluater() : void 0,
    filePath: n,
    ignoreInvalidStyle: t.ignoreInvalidStyle || !1,
    passKeys: t.passKeys !== !1,
    passNode: t.passNode || !1,
    schema: t.space === "svg" ? ss : my,
    stylePropertyNameCase: t.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: t.tableCellAlignToStyle !== !1
  }, o = Yd(i, e, void 0);
  return o && typeof o != "string" ? o : i.create(
    e,
    i.Fragment,
    { children: o || void 0 },
    void 0
  );
}
function Yd(e, t, n) {
  if (t.type === "element")
    return Jy(e, t, n);
  if (t.type === "mdxFlowExpression" || t.type === "mdxTextExpression")
    return Ky(e, t);
  if (t.type === "mdxJsxFlowElement" || t.type === "mdxJsxTextElement")
    return Zy(e, t, n);
  if (t.type === "mdxjsEsm")
    return Qy(e, t);
  if (t.type === "root")
    return eT(e, t, n);
  if (t.type === "text")
    return tT(e, t);
}
function Jy(e, t, n) {
  const r = e.schema;
  let i = r;
  t.tagName.toLowerCase() === "svg" && r.space === "html" && (i = ss, e.schema = i), e.ancestors.push(t);
  const o = qd(e, t.tagName, !1), s = iT(e, t);
  let l = ps(e, t);
  return Hy.has(t.tagName) && (l = l.filter(function(c) {
    return typeof c == "string" ? !oy(c) : !0;
  })), Hd(e, s, o, t), ds(s, l), e.ancestors.pop(), e.schema = r, e.create(t, o, s, n);
}
function Ky(e, t) {
  if (t.data && t.data.estree && e.evaluater) {
    const r = t.data.estree.body[0];
    return r.type, /** @type {Child | undefined} */
    e.evaluater.evaluateExpression(r.expression);
  }
  li(e, t.position);
}
function Qy(e, t) {
  if (t.data && t.data.estree && e.evaluater)
    return (
      /** @type {Child | undefined} */
      e.evaluater.evaluateProgram(t.data.estree)
    );
  li(e, t.position);
}
function Zy(e, t, n) {
  const r = e.schema;
  let i = r;
  t.name === "svg" && r.space === "html" && (i = ss, e.schema = i), e.ancestors.push(t);
  const o = t.name === null ? e.Fragment : qd(e, t.name, !0), s = oT(e, t), l = ps(e, t);
  return Hd(e, s, o, t), ds(s, l), e.ancestors.pop(), e.schema = r, e.create(t, o, s, n);
}
function eT(e, t, n) {
  const r = {};
  return ds(r, ps(e, t)), e.create(t, e.Fragment, r, n);
}
function tT(e, t) {
  return t.value;
}
function Hd(e, t, n, r) {
  typeof n != "string" && n !== e.Fragment && e.passNode && (t.node = r);
}
function ds(e, t) {
  if (t.length > 0) {
    const n = t.length > 1 ? t : t[0];
    n && (e.children = n);
  }
}
function nT(e, t, n) {
  return r;
  function r(i, o, s, l) {
    const u = Array.isArray(s.children) ? n : t;
    return l ? u(o, s, l) : u(o, s);
  }
}
function rT(e, t) {
  return n;
  function n(r, i, o, s) {
    const l = Array.isArray(o.children), c = cs(r);
    return t(
      i,
      o,
      s,
      l,
      {
        columnNumber: c ? c.column - 1 : void 0,
        fileName: e,
        lineNumber: c ? c.line : void 0
      },
      void 0
    );
  }
}
function iT(e, t) {
  const n = {};
  let r, i;
  for (i in t.properties)
    if (i !== "children" && us.call(t.properties, i)) {
      const o = aT(e, i, t.properties[i]);
      if (o) {
        const [s, l] = o;
        e.tableCellAlignToStyle && s === "align" && typeof l == "string" && qy.has(t.tagName) ? r = l : n[s] = l;
      }
    }
  if (r) {
    const o = (
      /** @type {Style} */
      n.style || (n.style = {})
    );
    o[e.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = r;
  }
  return n;
}
function oT(e, t) {
  const n = {};
  for (const r of t.attributes)
    if (r.type === "mdxJsxExpressionAttribute")
      if (r.data && r.data.estree && e.evaluater) {
        const o = r.data.estree.body[0];
        o.type;
        const s = o.expression;
        s.type;
        const l = s.properties[0];
        l.type, Object.assign(
          n,
          e.evaluater.evaluateExpression(l.argument)
        );
      } else
        li(e, t.position);
    else {
      const i = r.name;
      let o;
      if (r.value && typeof r.value == "object")
        if (r.value.data && r.value.data.estree && e.evaluater) {
          const l = r.value.data.estree.body[0];
          l.type, o = e.evaluater.evaluateExpression(l.expression);
        } else
          li(e, t.position);
      else
        o = r.value === null ? !0 : r.value;
      n[i] = /** @type {Props[keyof Props]} */
      o;
    }
  return n;
}
function ps(e, t) {
  const n = [];
  let r = -1;
  const i = e.passKeys ? /* @__PURE__ */ new Map() : Wy;
  for (; ++r < t.children.length; ) {
    const o = t.children[r];
    let s;
    if (e.passKeys) {
      const c = o.type === "element" ? o.tagName : o.type === "mdxJsxFlowElement" || o.type === "mdxJsxTextElement" ? o.name : void 0;
      if (c) {
        const u = i.get(c) || 0;
        s = c + "-" + u, i.set(c, u + 1);
      }
    }
    const l = Yd(e, o, s);
    l !== void 0 && n.push(l);
  }
  return n;
}
function aT(e, t, n) {
  const r = py(e.schema, t);
  if (!(n == null || typeof n == "number" && Number.isNaN(n))) {
    if (Array.isArray(n) && (n = r.commaSeparated ? ey(n) : Ey(n)), r.property === "style") {
      let i = typeof n == "object" ? n : sT(e, String(n));
      return e.stylePropertyNameCase === "css" && (i = lT(i)), ["style", i];
    }
    return [
      e.elementAttributeNameCase === "react" && r.space ? cy[r.property] || r.property : r.attribute,
      n
    ];
  }
}
function sT(e, t) {
  try {
    return Gy(t, { reactCompat: !0 });
  } catch (n) {
    if (e.ignoreInvalidStyle)
      return {};
    const r = (
      /** @type {Error} */
      n
    ), i = new yt("Cannot parse `style` attribute", {
      ancestors: e.ancestors,
      cause: r,
      ruleId: "style",
      source: "hast-util-to-jsx-runtime"
    });
    throw i.file = e.filePath || void 0, i.url = Wd + "#cannot-parse-style-attribute", i;
  }
}
function qd(e, t, n) {
  let r;
  if (!n)
    r = { type: "Literal", value: t };
  else if (t.includes(".")) {
    const i = t.split(".");
    let o = -1, s;
    for (; ++o < i.length; ) {
      const l = $l(i[o]) ? { type: "Identifier", name: i[o] } : { type: "Literal", value: i[o] };
      s = s ? {
        type: "MemberExpression",
        object: s,
        property: l,
        computed: !!(o && l.type === "Literal"),
        optional: !1
      } : l;
    }
    r = s;
  } else
    r = $l(t) && !/^[a-z]/.test(t) ? { type: "Identifier", name: t } : { type: "Literal", value: t };
  if (r.type === "Literal") {
    const i = (
      /** @type {string | number} */
      r.value
    );
    return us.call(e.components, i) ? e.components[i] : i;
  }
  if (e.evaluater)
    return e.evaluater.evaluateExpression(r);
  li(e);
}
function li(e, t) {
  const n = new yt(
    "Cannot handle MDX estrees without `createEvaluater`",
    {
      ancestors: e.ancestors,
      place: t,
      ruleId: "mdx-estree",
      source: "hast-util-to-jsx-runtime"
    }
  );
  throw n.file = e.filePath || void 0, n.url = Wd + "#cannot-handle-mdx-estrees-without-createevaluater", n;
}
function lT(e) {
  const t = {};
  let n;
  for (n in e)
    us.call(e, n) && (t[cT(n)] = e[n]);
  return t;
}
function cT(e) {
  let t = e.replace(Yy, uT);
  return t.slice(0, 3) === "ms-" && (t = "-" + t), t;
}
function uT(e) {
  return "-" + e.toLowerCase();
}
const Jo = {
  action: ["form"],
  cite: ["blockquote", "del", "ins", "q"],
  data: ["object"],
  formAction: ["button", "input"],
  href: ["a", "area", "base", "link"],
  icon: ["menuitem"],
  itemId: null,
  manifest: ["html"],
  ping: ["a", "area"],
  poster: ["video"],
  src: [
    "audio",
    "embed",
    "iframe",
    "img",
    "input",
    "script",
    "source",
    "track",
    "video"
  ]
}, dT = {};
function pT(e, t) {
  const n = dT, r = typeof n.includeImageAlt == "boolean" ? n.includeImageAlt : !0, i = typeof n.includeHtml == "boolean" ? n.includeHtml : !0;
  return Xd(e, r, i);
}
function Xd(e, t, n) {
  if (hT(e)) {
    if ("value" in e)
      return e.type === "html" && !n ? "" : e.value;
    if (t && "alt" in e && e.alt)
      return e.alt;
    if ("children" in e)
      return Zl(e.children, t, n);
  }
  return Array.isArray(e) ? Zl(e, t, n) : "";
}
function Zl(e, t, n) {
  const r = [];
  let i = -1;
  for (; ++i < e.length; )
    r[i] = Xd(e[i], t, n);
  return r.join("");
}
function hT(e) {
  return !!(e && typeof e == "object");
}
const ec = document.createElement("i");
function hs(e) {
  const t = "&" + e + ";";
  ec.innerHTML = t;
  const n = ec.textContent;
  return (
    // @ts-expect-error: TypeScript is wrong that `textContent` on elements can
    // yield `null`.
    n.charCodeAt(n.length - 1) === 59 && e !== "semi" || n === t ? !1 : n
  );
}
function pn(e, t, n, r) {
  const i = e.length;
  let o = 0, s;
  if (t < 0 ? t = -t > i ? 0 : i + t : t = t > i ? i : t, n = n > 0 ? n : 0, r.length < 1e4)
    s = Array.from(r), s.unshift(t, n), e.splice(...s);
  else
    for (n && e.splice(t, n); o < r.length; )
      s = r.slice(o, o + 1e4), s.unshift(t, 0), e.splice(...s), o += 1e4, t += 1e4;
}
function Wt(e, t) {
  return e.length > 0 ? (pn(e, e.length, 0, t), e) : t;
}
const tc = {}.hasOwnProperty;
function fT(e) {
  const t = {};
  let n = -1;
  for (; ++n < e.length; )
    mT(t, e[n]);
  return t;
}
function mT(e, t) {
  let n;
  for (n in t) {
    const i = (tc.call(e, n) ? e[n] : void 0) || (e[n] = {}), o = t[n];
    let s;
    if (o)
      for (s in o) {
        tc.call(i, s) || (i[s] = []);
        const l = o[s];
        ET(
          // @ts-expect-error Looks like a list.
          i[s],
          Array.isArray(l) ? l : l ? [l] : []
        );
      }
  }
}
function ET(e, t) {
  let n = -1;
  const r = [];
  for (; ++n < t.length; )
    (t[n].add === "after" ? e : r).push(t[n]);
  pn(e, 0, 0, r);
}
function Jd(e, t) {
  const n = Number.parseInt(e, t);
  return (
    // C0 except for HT, LF, FF, CR, space.
    n < 9 || n === 11 || n > 13 && n < 32 || // Control character (DEL) of C0, and C1 controls.
    n > 126 && n < 160 || // Lone high surrogates and low surrogates.
    n > 55295 && n < 57344 || // Noncharacters.
    n > 64975 && n < 65008 || /* eslint-disable no-bitwise */
    (n & 65535) === 65535 || (n & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    n > 1114111 ? "�" : String.fromCodePoint(n)
  );
}
function pr(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const dn = Pn(/[A-Za-z]/), Vt = Pn(/[\dA-Za-z]/), xT = Pn(/[#-'*+\--9=?A-Z^-~]/);
function Na(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < 32 || e === 127)
  );
}
const wa = Pn(/\d/), CT = Pn(/[\dA-Fa-f]/), gT = Pn(/[!-/:-@[-`{-~]/);
function Ee(e) {
  return e !== null && e < -2;
}
function Nt(e) {
  return e !== null && (e < 0 || e === 32);
}
function we(e) {
  return e === -2 || e === -1 || e === 32;
}
const yT = Pn(new RegExp("\\p{P}|\\p{S}", "u")), TT = Pn(/\s/);
function Pn(e) {
  return t;
  function t(n) {
    return n !== null && n > -1 && e.test(String.fromCharCode(n));
  }
}
function Rr(e) {
  const t = [];
  let n = -1, r = 0, i = 0;
  for (; ++n < e.length; ) {
    const o = e.charCodeAt(n);
    let s = "";
    if (o === 37 && Vt(e.charCodeAt(n + 1)) && Vt(e.charCodeAt(n + 2)))
      i = 2;
    else if (o < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(o)) || (s = String.fromCharCode(o));
    else if (o > 55295 && o < 57344) {
      const l = e.charCodeAt(n + 1);
      o < 56320 && l > 56319 && l < 57344 ? (s = String.fromCharCode(o, l), i = 1) : s = "�";
    } else
      s = String.fromCharCode(o);
    s && (t.push(e.slice(r, n), encodeURIComponent(s)), r = n + i + 1, s = ""), i && (n += i, i = 0);
  }
  return t.join("") + e.slice(r);
}
function Ge(e, t, n, r) {
  const i = r ? r - 1 : Number.POSITIVE_INFINITY;
  let o = 0;
  return s;
  function s(c) {
    return we(c) ? (e.enter(n), l(c)) : t(c);
  }
  function l(c) {
    return we(c) && o++ < i ? (e.consume(c), l) : (e.exit(n), t(c));
  }
}
const ST = {
  tokenize: IT
};
function IT(e) {
  const t = e.attempt(this.parser.constructs.contentInitial, r, i);
  let n;
  return t;
  function r(l) {
    if (l === null) {
      e.consume(l);
      return;
    }
    return e.enter("lineEnding"), e.consume(l), e.exit("lineEnding"), Ge(e, t, "linePrefix");
  }
  function i(l) {
    return e.enter("paragraph"), o(l);
  }
  function o(l) {
    const c = e.enter("chunkText", {
      contentType: "text",
      previous: n
    });
    return n && (n.next = c), n = c, s(l);
  }
  function s(l) {
    if (l === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(l);
      return;
    }
    return Ee(l) ? (e.consume(l), e.exit("chunkText"), o) : (e.consume(l), s);
  }
}
const AT = {
  tokenize: bT
}, nc = {
  tokenize: RT
};
function bT(e) {
  const t = this, n = [];
  let r = 0, i, o, s;
  return l;
  function l(S) {
    if (r < n.length) {
      const _ = n[r];
      return t.containerState = _[1], e.attempt(_[0].continuation, c, u)(S);
    }
    return u(S);
  }
  function c(S) {
    if (r++, t.containerState._closeFlow) {
      t.containerState._closeFlow = void 0, i && A();
      const _ = t.events.length;
      let v = _, O;
      for (; v--; )
        if (t.events[v][0] === "exit" && t.events[v][1].type === "chunkFlow") {
          O = t.events[v][1].end;
          break;
        }
      I(r);
      let j = _;
      for (; j < t.events.length; )
        t.events[j][1].end = {
          ...O
        }, j++;
      return pn(t.events, v + 1, 0, t.events.slice(_)), t.events.length = j, u(S);
    }
    return l(S);
  }
  function u(S) {
    if (r === n.length) {
      if (!i)
        return f(S);
      if (i.currentConstruct && i.currentConstruct.concrete)
        return g(S);
      t.interrupt = !!(i.currentConstruct && !i._gfmTableDynamicInterruptHack);
    }
    return t.containerState = {}, e.check(nc, p, d)(S);
  }
  function p(S) {
    return i && A(), I(r), f(S);
  }
  function d(S) {
    return t.parser.lazy[t.now().line] = r !== n.length, s = t.now().offset, g(S);
  }
  function f(S) {
    return t.containerState = {}, e.attempt(nc, h, g)(S);
  }
  function h(S) {
    return r++, n.push([t.currentConstruct, t.containerState]), f(S);
  }
  function g(S) {
    if (S === null) {
      i && A(), I(0), e.consume(S);
      return;
    }
    return i = i || t.parser.flow(t.now()), e.enter("chunkFlow", {
      _tokenizer: i,
      contentType: "flow",
      previous: o
    }), C(S);
  }
  function C(S) {
    if (S === null) {
      T(e.exit("chunkFlow"), !0), I(0), e.consume(S);
      return;
    }
    return Ee(S) ? (e.consume(S), T(e.exit("chunkFlow")), r = 0, t.interrupt = void 0, l) : (e.consume(S), C);
  }
  function T(S, _) {
    const v = t.sliceStream(S);
    if (_ && v.push(null), S.previous = o, o && (o.next = S), o = S, i.defineSkip(S.start), i.write(v), t.parser.lazy[S.start.line]) {
      let O = i.events.length;
      for (; O--; )
        if (
          // The token starts before the line ending…
          i.events[O][1].start.offset < s && // …and either is not ended yet…
          (!i.events[O][1].end || // …or ends after it.
          i.events[O][1].end.offset > s)
        )
          return;
      const j = t.events.length;
      let M = j, w, L;
      for (; M--; )
        if (t.events[M][0] === "exit" && t.events[M][1].type === "chunkFlow") {
          if (w) {
            L = t.events[M][1].end;
            break;
          }
          w = !0;
        }
      for (I(r), O = j; O < t.events.length; )
        t.events[O][1].end = {
          ...L
        }, O++;
      pn(t.events, M + 1, 0, t.events.slice(j)), t.events.length = O;
    }
  }
  function I(S) {
    let _ = n.length;
    for (; _-- > S; ) {
      const v = n[_];
      t.containerState = v[1], v[0].exit.call(t, e);
    }
    n.length = S;
  }
  function A() {
    i.write([null]), o = void 0, i = void 0, t.containerState._closeFlow = void 0;
  }
}
function RT(e, t, n) {
  return Ge(e, e.attempt(this.parser.constructs.document, t, n), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
}
function rc(e) {
  if (e === null || Nt(e) || TT(e))
    return 1;
  if (yT(e))
    return 2;
}
function fs(e, t, n) {
  const r = [];
  let i = -1;
  for (; ++i < e.length; ) {
    const o = e[i].resolveAll;
    o && !r.includes(o) && (t = o(t, n), r.push(o));
  }
  return t;
}
const Pa = {
  name: "attention",
  resolveAll: OT,
  tokenize: vT
};
function OT(e, t) {
  let n = -1, r, i, o, s, l, c, u, p;
  for (; ++n < e.length; )
    if (e[n][0] === "enter" && e[n][1].type === "attentionSequence" && e[n][1]._close) {
      for (r = n; r--; )
        if (e[r][0] === "exit" && e[r][1].type === "attentionSequence" && e[r][1]._open && // If the markers are the same:
        t.sliceSerialize(e[r][1]).charCodeAt(0) === t.sliceSerialize(e[n][1]).charCodeAt(0)) {
          if ((e[r][1]._close || e[n][1]._open) && (e[n][1].end.offset - e[n][1].start.offset) % 3 && !((e[r][1].end.offset - e[r][1].start.offset + e[n][1].end.offset - e[n][1].start.offset) % 3))
            continue;
          c = e[r][1].end.offset - e[r][1].start.offset > 1 && e[n][1].end.offset - e[n][1].start.offset > 1 ? 2 : 1;
          const d = {
            ...e[r][1].end
          }, f = {
            ...e[n][1].start
          };
          ic(d, -c), ic(f, c), s = {
            type: c > 1 ? "strongSequence" : "emphasisSequence",
            start: d,
            end: {
              ...e[r][1].end
            }
          }, l = {
            type: c > 1 ? "strongSequence" : "emphasisSequence",
            start: {
              ...e[n][1].start
            },
            end: f
          }, o = {
            type: c > 1 ? "strongText" : "emphasisText",
            start: {
              ...e[r][1].end
            },
            end: {
              ...e[n][1].start
            }
          }, i = {
            type: c > 1 ? "strong" : "emphasis",
            start: {
              ...s.start
            },
            end: {
              ...l.end
            }
          }, e[r][1].end = {
            ...s.start
          }, e[n][1].start = {
            ...l.end
          }, u = [], e[r][1].end.offset - e[r][1].start.offset && (u = Wt(u, [["enter", e[r][1], t], ["exit", e[r][1], t]])), u = Wt(u, [["enter", i, t], ["enter", s, t], ["exit", s, t], ["enter", o, t]]), u = Wt(u, fs(t.parser.constructs.insideSpan.null, e.slice(r + 1, n), t)), u = Wt(u, [["exit", o, t], ["enter", l, t], ["exit", l, t], ["exit", i, t]]), e[n][1].end.offset - e[n][1].start.offset ? (p = 2, u = Wt(u, [["enter", e[n][1], t], ["exit", e[n][1], t]])) : p = 0, pn(e, r - 1, n - r + 3, u), n = r + u.length - p - 2;
          break;
        }
    }
  for (n = -1; ++n < e.length; )
    e[n][1].type === "attentionSequence" && (e[n][1].type = "data");
  return e;
}
function vT(e, t) {
  const n = this.parser.constructs.attentionMarkers.null, r = this.previous, i = rc(r);
  let o;
  return s;
  function s(c) {
    return o = c, e.enter("attentionSequence"), l(c);
  }
  function l(c) {
    if (c === o)
      return e.consume(c), l;
    const u = e.exit("attentionSequence"), p = rc(c), d = !p || p === 2 && i || n.includes(c), f = !i || i === 2 && p || n.includes(r);
    return u._open = !!(o === 42 ? d : d && (i || !f)), u._close = !!(o === 42 ? f : f && (p || !d)), t(c);
  }
}
function ic(e, t) {
  e.column += t, e.offset += t, e._bufferIndex += t;
}
const DT = {
  name: "autolink",
  tokenize: _T
};
function _T(e, t, n) {
  let r = 0;
  return i;
  function i(h) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(h), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), o;
  }
  function o(h) {
    return dn(h) ? (e.consume(h), s) : h === 64 ? n(h) : u(h);
  }
  function s(h) {
    return h === 43 || h === 45 || h === 46 || Vt(h) ? (r = 1, l(h)) : u(h);
  }
  function l(h) {
    return h === 58 ? (e.consume(h), r = 0, c) : (h === 43 || h === 45 || h === 46 || Vt(h)) && r++ < 32 ? (e.consume(h), l) : (r = 0, u(h));
  }
  function c(h) {
    return h === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(h), e.exit("autolinkMarker"), e.exit("autolink"), t) : h === null || h === 32 || h === 60 || Na(h) ? n(h) : (e.consume(h), c);
  }
  function u(h) {
    return h === 64 ? (e.consume(h), p) : xT(h) ? (e.consume(h), u) : n(h);
  }
  function p(h) {
    return Vt(h) ? d(h) : n(h);
  }
  function d(h) {
    return h === 46 ? (e.consume(h), r = 0, p) : h === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(h), e.exit("autolinkMarker"), e.exit("autolink"), t) : f(h);
  }
  function f(h) {
    if ((h === 45 || Vt(h)) && r++ < 63) {
      const g = h === 45 ? f : d;
      return e.consume(h), g;
    }
    return n(h);
  }
}
const Ro = {
  partial: !0,
  tokenize: NT
};
function NT(e, t, n) {
  return r;
  function r(o) {
    return we(o) ? Ge(e, i, "linePrefix")(o) : i(o);
  }
  function i(o) {
    return o === null || Ee(o) ? t(o) : n(o);
  }
}
const Kd = {
  continuation: {
    tokenize: PT
  },
  exit: jT,
  name: "blockQuote",
  tokenize: wT
};
function wT(e, t, n) {
  const r = this;
  return i;
  function i(s) {
    if (s === 62) {
      const l = r.containerState;
      return l.open || (e.enter("blockQuote", {
        _container: !0
      }), l.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(s), e.exit("blockQuoteMarker"), o;
    }
    return n(s);
  }
  function o(s) {
    return we(s) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(s), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), t) : (e.exit("blockQuotePrefix"), t(s));
  }
}
function PT(e, t, n) {
  const r = this;
  return i;
  function i(s) {
    return we(s) ? Ge(e, o, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(s) : o(s);
  }
  function o(s) {
    return e.attempt(Kd, t, n)(s);
  }
}
function jT(e) {
  e.exit("blockQuote");
}
const Qd = {
  name: "characterEscape",
  tokenize: LT
};
function LT(e, t, n) {
  return r;
  function r(o) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(o), e.exit("escapeMarker"), i;
  }
  function i(o) {
    return gT(o) ? (e.enter("characterEscapeValue"), e.consume(o), e.exit("characterEscapeValue"), e.exit("characterEscape"), t) : n(o);
  }
}
const Zd = {
  name: "characterReference",
  tokenize: kT
};
function kT(e, t, n) {
  const r = this;
  let i = 0, o, s;
  return l;
  function l(d) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(d), e.exit("characterReferenceMarker"), c;
  }
  function c(d) {
    return d === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(d), e.exit("characterReferenceMarkerNumeric"), u) : (e.enter("characterReferenceValue"), o = 31, s = Vt, p(d));
  }
  function u(d) {
    return d === 88 || d === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(d), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), o = 6, s = CT, p) : (e.enter("characterReferenceValue"), o = 7, s = wa, p(d));
  }
  function p(d) {
    if (d === 59 && i) {
      const f = e.exit("characterReferenceValue");
      return s === Vt && !hs(r.sliceSerialize(f)) ? n(d) : (e.enter("characterReferenceMarker"), e.consume(d), e.exit("characterReferenceMarker"), e.exit("characterReference"), t);
    }
    return s(d) && i++ < o ? (e.consume(d), p) : n(d);
  }
}
const oc = {
  partial: !0,
  tokenize: VT
}, ac = {
  concrete: !0,
  name: "codeFenced",
  tokenize: MT
};
function MT(e, t, n) {
  const r = this, i = {
    partial: !0,
    tokenize: v
  };
  let o = 0, s = 0, l;
  return c;
  function c(O) {
    return u(O);
  }
  function u(O) {
    const j = r.events[r.events.length - 1];
    return o = j && j[1].type === "linePrefix" ? j[2].sliceSerialize(j[1], !0).length : 0, l = O, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), p(O);
  }
  function p(O) {
    return O === l ? (s++, e.consume(O), p) : s < 3 ? n(O) : (e.exit("codeFencedFenceSequence"), we(O) ? Ge(e, d, "whitespace")(O) : d(O));
  }
  function d(O) {
    return O === null || Ee(O) ? (e.exit("codeFencedFence"), r.interrupt ? t(O) : e.check(oc, C, _)(O)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
      contentType: "string"
    }), f(O));
  }
  function f(O) {
    return O === null || Ee(O) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), d(O)) : we(O) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), Ge(e, h, "whitespace")(O)) : O === 96 && O === l ? n(O) : (e.consume(O), f);
  }
  function h(O) {
    return O === null || Ee(O) ? d(O) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), g(O));
  }
  function g(O) {
    return O === null || Ee(O) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), d(O)) : O === 96 && O === l ? n(O) : (e.consume(O), g);
  }
  function C(O) {
    return e.attempt(i, _, T)(O);
  }
  function T(O) {
    return e.enter("lineEnding"), e.consume(O), e.exit("lineEnding"), I;
  }
  function I(O) {
    return o > 0 && we(O) ? Ge(e, A, "linePrefix", o + 1)(O) : A(O);
  }
  function A(O) {
    return O === null || Ee(O) ? e.check(oc, C, _)(O) : (e.enter("codeFlowValue"), S(O));
  }
  function S(O) {
    return O === null || Ee(O) ? (e.exit("codeFlowValue"), A(O)) : (e.consume(O), S);
  }
  function _(O) {
    return e.exit("codeFenced"), t(O);
  }
  function v(O, j, M) {
    let w = 0;
    return L;
    function L(q) {
      return O.enter("lineEnding"), O.consume(q), O.exit("lineEnding"), P;
    }
    function P(q) {
      return O.enter("codeFencedFence"), we(q) ? Ge(O, k, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(q) : k(q);
    }
    function k(q) {
      return q === l ? (O.enter("codeFencedFenceSequence"), z(q)) : M(q);
    }
    function z(q) {
      return q === l ? (w++, O.consume(q), z) : w >= s ? (O.exit("codeFencedFenceSequence"), we(q) ? Ge(O, B, "whitespace")(q) : B(q)) : M(q);
    }
    function B(q) {
      return q === null || Ee(q) ? (O.exit("codeFencedFence"), j(q)) : M(q);
    }
  }
}
function VT(e, t, n) {
  const r = this;
  return i;
  function i(s) {
    return s === null ? n(s) : (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), o);
  }
  function o(s) {
    return r.parser.lazy[r.now().line] ? n(s) : t(s);
  }
}
const Ko = {
  name: "codeIndented",
  tokenize: FT
}, UT = {
  partial: !0,
  tokenize: BT
};
function FT(e, t, n) {
  const r = this;
  return i;
  function i(u) {
    return e.enter("codeIndented"), Ge(e, o, "linePrefix", 5)(u);
  }
  function o(u) {
    const p = r.events[r.events.length - 1];
    return p && p[1].type === "linePrefix" && p[2].sliceSerialize(p[1], !0).length >= 4 ? s(u) : n(u);
  }
  function s(u) {
    return u === null ? c(u) : Ee(u) ? e.attempt(UT, s, c)(u) : (e.enter("codeFlowValue"), l(u));
  }
  function l(u) {
    return u === null || Ee(u) ? (e.exit("codeFlowValue"), s(u)) : (e.consume(u), l);
  }
  function c(u) {
    return e.exit("codeIndented"), t(u);
  }
}
function BT(e, t, n) {
  const r = this;
  return i;
  function i(s) {
    return r.parser.lazy[r.now().line] ? n(s) : Ee(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), i) : Ge(e, o, "linePrefix", 5)(s);
  }
  function o(s) {
    const l = r.events[r.events.length - 1];
    return l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? t(s) : Ee(s) ? i(s) : n(s);
  }
}
const $T = {
  name: "codeText",
  previous: zT,
  resolve: GT,
  tokenize: WT
};
function GT(e) {
  let t = e.length - 4, n = 3, r, i;
  if ((e[n][1].type === "lineEnding" || e[n][1].type === "space") && (e[t][1].type === "lineEnding" || e[t][1].type === "space")) {
    for (r = n; ++r < t; )
      if (e[r][1].type === "codeTextData") {
        e[n][1].type = "codeTextPadding", e[t][1].type = "codeTextPadding", n += 2, t -= 2;
        break;
      }
  }
  for (r = n - 1, t++; ++r <= t; )
    i === void 0 ? r !== t && e[r][1].type !== "lineEnding" && (i = r) : (r === t || e[r][1].type === "lineEnding") && (e[i][1].type = "codeTextData", r !== i + 2 && (e[i][1].end = e[r - 1][1].end, e.splice(i + 2, r - i - 2), t -= r - i - 2, r = i + 2), i = void 0);
  return e;
}
function zT(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function WT(e, t, n) {
  let r = 0, i, o;
  return s;
  function s(d) {
    return e.enter("codeText"), e.enter("codeTextSequence"), l(d);
  }
  function l(d) {
    return d === 96 ? (e.consume(d), r++, l) : (e.exit("codeTextSequence"), c(d));
  }
  function c(d) {
    return d === null ? n(d) : d === 32 ? (e.enter("space"), e.consume(d), e.exit("space"), c) : d === 96 ? (o = e.enter("codeTextSequence"), i = 0, p(d)) : Ee(d) ? (e.enter("lineEnding"), e.consume(d), e.exit("lineEnding"), c) : (e.enter("codeTextData"), u(d));
  }
  function u(d) {
    return d === null || d === 32 || d === 96 || Ee(d) ? (e.exit("codeTextData"), c(d)) : (e.consume(d), u);
  }
  function p(d) {
    return d === 96 ? (e.consume(d), i++, p) : i === r ? (e.exit("codeTextSequence"), e.exit("codeText"), t(d)) : (o.type = "codeTextData", u(d));
  }
}
class YT {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(t) {
    this.left = t ? [...t] : [], this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(t) {
    if (t < 0 || t >= this.left.length + this.right.length)
      throw new RangeError("Cannot access index `" + t + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    return t < this.left.length ? this.left[t] : this.right[this.right.length - t + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    return this.setCursor(0), this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(t, n) {
    const r = n ?? Number.POSITIVE_INFINITY;
    return r < this.left.length ? this.left.slice(t, r) : t > this.left.length ? this.right.slice(this.right.length - r + this.left.length, this.right.length - t + this.left.length).reverse() : this.left.slice(t).concat(this.right.slice(this.right.length - r + this.left.length).reverse());
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(t, n, r) {
    const i = n || 0;
    this.setCursor(Math.trunc(t));
    const o = this.right.splice(this.right.length - i, Number.POSITIVE_INFINITY);
    return r && kr(this.left, r), o.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    return this.setCursor(Number.POSITIVE_INFINITY), this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(t) {
    this.setCursor(Number.POSITIVE_INFINITY), this.left.push(t);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(t) {
    this.setCursor(Number.POSITIVE_INFINITY), kr(this.left, t);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(t) {
    this.setCursor(0), this.right.push(t);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(t) {
    this.setCursor(0), kr(this.right, t.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(t) {
    if (!(t === this.left.length || t > this.left.length && this.right.length === 0 || t < 0 && this.left.length === 0))
      if (t < this.left.length) {
        const n = this.left.splice(t, Number.POSITIVE_INFINITY);
        kr(this.right, n.reverse());
      } else {
        const n = this.right.splice(this.left.length + this.right.length - t, Number.POSITIVE_INFINITY);
        kr(this.left, n.reverse());
      }
  }
}
function kr(e, t) {
  let n = 0;
  if (t.length < 1e4)
    e.push(...t);
  else
    for (; n < t.length; )
      e.push(...t.slice(n, n + 1e4)), n += 1e4;
}
function ep(e) {
  const t = {};
  let n = -1, r, i, o, s, l, c, u;
  const p = new YT(e);
  for (; ++n < p.length; ) {
    for (; n in t; )
      n = t[n];
    if (r = p.get(n), n && r[1].type === "chunkFlow" && p.get(n - 1)[1].type === "listItemPrefix" && (c = r[1]._tokenizer.events, o = 0, o < c.length && c[o][1].type === "lineEndingBlank" && (o += 2), o < c.length && c[o][1].type === "content"))
      for (; ++o < c.length && c[o][1].type !== "content"; )
        c[o][1].type === "chunkText" && (c[o][1]._isInFirstContentOfListItem = !0, o++);
    if (r[0] === "enter")
      r[1].contentType && (Object.assign(t, HT(p, n)), n = t[n], u = !0);
    else if (r[1]._container) {
      for (o = n, i = void 0; o--; )
        if (s = p.get(o), s[1].type === "lineEnding" || s[1].type === "lineEndingBlank")
          s[0] === "enter" && (i && (p.get(i)[1].type = "lineEndingBlank"), s[1].type = "lineEnding", i = o);
        else if (!(s[1].type === "linePrefix" || s[1].type === "listItemIndent")) break;
      i && (r[1].end = {
        ...p.get(i)[1].start
      }, l = p.slice(i, n), l.unshift(r), p.splice(i, n - i + 1, l));
    }
  }
  return pn(e, 0, Number.POSITIVE_INFINITY, p.slice(0)), !u;
}
function HT(e, t) {
  const n = e.get(t)[1], r = e.get(t)[2];
  let i = t - 1;
  const o = [];
  let s = n._tokenizer;
  s || (s = r.parser[n.contentType](n.start), n._contentTypeTextTrailing && (s._contentTypeTextTrailing = !0));
  const l = s.events, c = [], u = {};
  let p, d, f = -1, h = n, g = 0, C = 0;
  const T = [C];
  for (; h; ) {
    for (; e.get(++i)[1] !== h; )
      ;
    o.push(i), h._tokenizer || (p = r.sliceStream(h), h.next || p.push(null), d && s.defineSkip(h.start), h._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = !0), s.write(p), h._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = void 0)), d = h, h = h.next;
  }
  for (h = n; ++f < l.length; )
    // Find a void token that includes a break.
    l[f][0] === "exit" && l[f - 1][0] === "enter" && l[f][1].type === l[f - 1][1].type && l[f][1].start.line !== l[f][1].end.line && (C = f + 1, T.push(C), h._tokenizer = void 0, h.previous = void 0, h = h.next);
  for (s.events = [], h ? (h._tokenizer = void 0, h.previous = void 0) : T.pop(), f = T.length; f--; ) {
    const I = l.slice(T[f], T[f + 1]), A = o.pop();
    c.push([A, A + I.length - 1]), e.splice(A, 2, I);
  }
  for (c.reverse(), f = -1; ++f < c.length; )
    u[g + c[f][0]] = g + c[f][1], g += c[f][1] - c[f][0] - 1;
  return u;
}
const qT = {
  resolve: JT,
  tokenize: KT
}, XT = {
  partial: !0,
  tokenize: QT
};
function JT(e) {
  return ep(e), e;
}
function KT(e, t) {
  let n;
  return r;
  function r(l) {
    return e.enter("content"), n = e.enter("chunkContent", {
      contentType: "content"
    }), i(l);
  }
  function i(l) {
    return l === null ? o(l) : Ee(l) ? e.check(XT, s, o)(l) : (e.consume(l), i);
  }
  function o(l) {
    return e.exit("chunkContent"), e.exit("content"), t(l);
  }
  function s(l) {
    return e.consume(l), e.exit("chunkContent"), n.next = e.enter("chunkContent", {
      contentType: "content",
      previous: n
    }), n = n.next, i;
  }
}
function QT(e, t, n) {
  const r = this;
  return i;
  function i(s) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), Ge(e, o, "linePrefix");
  }
  function o(s) {
    if (s === null || Ee(s))
      return n(s);
    const l = r.events[r.events.length - 1];
    return !r.parser.constructs.disable.null.includes("codeIndented") && l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? t(s) : e.interrupt(r.parser.constructs.flow, n, t)(s);
  }
}
function tp(e, t, n, r, i, o, s, l, c) {
  const u = c || Number.POSITIVE_INFINITY;
  let p = 0;
  return d;
  function d(I) {
    return I === 60 ? (e.enter(r), e.enter(i), e.enter(o), e.consume(I), e.exit(o), f) : I === null || I === 32 || I === 41 || Na(I) ? n(I) : (e.enter(r), e.enter(s), e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), C(I));
  }
  function f(I) {
    return I === 62 ? (e.enter(o), e.consume(I), e.exit(o), e.exit(i), e.exit(r), t) : (e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), h(I));
  }
  function h(I) {
    return I === 62 ? (e.exit("chunkString"), e.exit(l), f(I)) : I === null || I === 60 || Ee(I) ? n(I) : (e.consume(I), I === 92 ? g : h);
  }
  function g(I) {
    return I === 60 || I === 62 || I === 92 ? (e.consume(I), h) : h(I);
  }
  function C(I) {
    return !p && (I === null || I === 41 || Nt(I)) ? (e.exit("chunkString"), e.exit(l), e.exit(s), e.exit(r), t(I)) : p < u && I === 40 ? (e.consume(I), p++, C) : I === 41 ? (e.consume(I), p--, C) : I === null || I === 32 || I === 40 || Na(I) ? n(I) : (e.consume(I), I === 92 ? T : C);
  }
  function T(I) {
    return I === 40 || I === 41 || I === 92 ? (e.consume(I), C) : C(I);
  }
}
function np(e, t, n, r, i, o) {
  const s = this;
  let l = 0, c;
  return u;
  function u(h) {
    return e.enter(r), e.enter(i), e.consume(h), e.exit(i), e.enter(o), p;
  }
  function p(h) {
    return l > 999 || h === null || h === 91 || h === 93 && !c || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    h === 94 && !l && "_hiddenFootnoteSupport" in s.parser.constructs ? n(h) : h === 93 ? (e.exit(o), e.enter(i), e.consume(h), e.exit(i), e.exit(r), t) : Ee(h) ? (e.enter("lineEnding"), e.consume(h), e.exit("lineEnding"), p) : (e.enter("chunkString", {
      contentType: "string"
    }), d(h));
  }
  function d(h) {
    return h === null || h === 91 || h === 93 || Ee(h) || l++ > 999 ? (e.exit("chunkString"), p(h)) : (e.consume(h), c || (c = !we(h)), h === 92 ? f : d);
  }
  function f(h) {
    return h === 91 || h === 92 || h === 93 ? (e.consume(h), l++, d) : d(h);
  }
}
function rp(e, t, n, r, i, o) {
  let s;
  return l;
  function l(f) {
    return f === 34 || f === 39 || f === 40 ? (e.enter(r), e.enter(i), e.consume(f), e.exit(i), s = f === 40 ? 41 : f, c) : n(f);
  }
  function c(f) {
    return f === s ? (e.enter(i), e.consume(f), e.exit(i), e.exit(r), t) : (e.enter(o), u(f));
  }
  function u(f) {
    return f === s ? (e.exit(o), c(s)) : f === null ? n(f) : Ee(f) ? (e.enter("lineEnding"), e.consume(f), e.exit("lineEnding"), Ge(e, u, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), p(f));
  }
  function p(f) {
    return f === s || f === null || Ee(f) ? (e.exit("chunkString"), u(f)) : (e.consume(f), f === 92 ? d : p);
  }
  function d(f) {
    return f === s || f === 92 ? (e.consume(f), p) : p(f);
  }
}
function Hr(e, t) {
  let n;
  return r;
  function r(i) {
    return Ee(i) ? (e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), n = !0, r) : we(i) ? Ge(e, r, n ? "linePrefix" : "lineSuffix")(i) : t(i);
  }
}
const ZT = {
  name: "definition",
  tokenize: tS
}, eS = {
  partial: !0,
  tokenize: nS
};
function tS(e, t, n) {
  const r = this;
  let i;
  return o;
  function o(h) {
    return e.enter("definition"), s(h);
  }
  function s(h) {
    return np.call(
      r,
      e,
      l,
      // Note: we don’t need to reset the way `markdown-rs` does.
      n,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(h);
  }
  function l(h) {
    return i = pr(r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1)), h === 58 ? (e.enter("definitionMarker"), e.consume(h), e.exit("definitionMarker"), c) : n(h);
  }
  function c(h) {
    return Nt(h) ? Hr(e, u)(h) : u(h);
  }
  function u(h) {
    return tp(
      e,
      p,
      // Note: we don’t need to reset the way `markdown-rs` does.
      n,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(h);
  }
  function p(h) {
    return e.attempt(eS, d, d)(h);
  }
  function d(h) {
    return we(h) ? Ge(e, f, "whitespace")(h) : f(h);
  }
  function f(h) {
    return h === null || Ee(h) ? (e.exit("definition"), r.parser.defined.push(i), t(h)) : n(h);
  }
}
function nS(e, t, n) {
  return r;
  function r(l) {
    return Nt(l) ? Hr(e, i)(l) : n(l);
  }
  function i(l) {
    return rp(e, o, n, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(l);
  }
  function o(l) {
    return we(l) ? Ge(e, s, "whitespace")(l) : s(l);
  }
  function s(l) {
    return l === null || Ee(l) ? t(l) : n(l);
  }
}
const rS = {
  name: "hardBreakEscape",
  tokenize: iS
};
function iS(e, t, n) {
  return r;
  function r(o) {
    return e.enter("hardBreakEscape"), e.consume(o), i;
  }
  function i(o) {
    return Ee(o) ? (e.exit("hardBreakEscape"), t(o)) : n(o);
  }
}
const oS = {
  name: "headingAtx",
  resolve: aS,
  tokenize: sS
};
function aS(e, t) {
  let n = e.length - 2, r = 3, i, o;
  return e[r][1].type === "whitespace" && (r += 2), n - 2 > r && e[n][1].type === "whitespace" && (n -= 2), e[n][1].type === "atxHeadingSequence" && (r === n - 1 || n - 4 > r && e[n - 2][1].type === "whitespace") && (n -= r + 1 === n ? 2 : 4), n > r && (i = {
    type: "atxHeadingText",
    start: e[r][1].start,
    end: e[n][1].end
  }, o = {
    type: "chunkText",
    start: e[r][1].start,
    end: e[n][1].end,
    contentType: "text"
  }, pn(e, r, n - r + 1, [["enter", i, t], ["enter", o, t], ["exit", o, t], ["exit", i, t]])), e;
}
function sS(e, t, n) {
  let r = 0;
  return i;
  function i(p) {
    return e.enter("atxHeading"), o(p);
  }
  function o(p) {
    return e.enter("atxHeadingSequence"), s(p);
  }
  function s(p) {
    return p === 35 && r++ < 6 ? (e.consume(p), s) : p === null || Nt(p) ? (e.exit("atxHeadingSequence"), l(p)) : n(p);
  }
  function l(p) {
    return p === 35 ? (e.enter("atxHeadingSequence"), c(p)) : p === null || Ee(p) ? (e.exit("atxHeading"), t(p)) : we(p) ? Ge(e, l, "whitespace")(p) : (e.enter("atxHeadingText"), u(p));
  }
  function c(p) {
    return p === 35 ? (e.consume(p), c) : (e.exit("atxHeadingSequence"), l(p));
  }
  function u(p) {
    return p === null || p === 35 || Nt(p) ? (e.exit("atxHeadingText"), l(p)) : (e.consume(p), u);
  }
}
const lS = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], sc = ["pre", "script", "style", "textarea"], cS = {
  concrete: !0,
  name: "htmlFlow",
  resolveTo: pS,
  tokenize: hS
}, uS = {
  partial: !0,
  tokenize: mS
}, dS = {
  partial: !0,
  tokenize: fS
};
function pS(e) {
  let t = e.length;
  for (; t-- && !(e[t][0] === "enter" && e[t][1].type === "htmlFlow"); )
    ;
  return t > 1 && e[t - 2][1].type === "linePrefix" && (e[t][1].start = e[t - 2][1].start, e[t + 1][1].start = e[t - 2][1].start, e.splice(t - 2, 2)), e;
}
function hS(e, t, n) {
  const r = this;
  let i, o, s, l, c;
  return u;
  function u(y) {
    return p(y);
  }
  function p(y) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(y), d;
  }
  function d(y) {
    return y === 33 ? (e.consume(y), f) : y === 47 ? (e.consume(y), o = !0, C) : y === 63 ? (e.consume(y), i = 3, r.interrupt ? t : m) : dn(y) ? (e.consume(y), s = String.fromCharCode(y), T) : n(y);
  }
  function f(y) {
    return y === 45 ? (e.consume(y), i = 2, h) : y === 91 ? (e.consume(y), i = 5, l = 0, g) : dn(y) ? (e.consume(y), i = 4, r.interrupt ? t : m) : n(y);
  }
  function h(y) {
    return y === 45 ? (e.consume(y), r.interrupt ? t : m) : n(y);
  }
  function g(y) {
    const X = "CDATA[";
    return y === X.charCodeAt(l++) ? (e.consume(y), l === X.length ? r.interrupt ? t : k : g) : n(y);
  }
  function C(y) {
    return dn(y) ? (e.consume(y), s = String.fromCharCode(y), T) : n(y);
  }
  function T(y) {
    if (y === null || y === 47 || y === 62 || Nt(y)) {
      const X = y === 47, V = s.toLowerCase();
      return !X && !o && sc.includes(V) ? (i = 1, r.interrupt ? t(y) : k(y)) : lS.includes(s.toLowerCase()) ? (i = 6, X ? (e.consume(y), I) : r.interrupt ? t(y) : k(y)) : (i = 7, r.interrupt && !r.parser.lazy[r.now().line] ? n(y) : o ? A(y) : S(y));
    }
    return y === 45 || Vt(y) ? (e.consume(y), s += String.fromCharCode(y), T) : n(y);
  }
  function I(y) {
    return y === 62 ? (e.consume(y), r.interrupt ? t : k) : n(y);
  }
  function A(y) {
    return we(y) ? (e.consume(y), A) : L(y);
  }
  function S(y) {
    return y === 47 ? (e.consume(y), L) : y === 58 || y === 95 || dn(y) ? (e.consume(y), _) : we(y) ? (e.consume(y), S) : L(y);
  }
  function _(y) {
    return y === 45 || y === 46 || y === 58 || y === 95 || Vt(y) ? (e.consume(y), _) : v(y);
  }
  function v(y) {
    return y === 61 ? (e.consume(y), O) : we(y) ? (e.consume(y), v) : S(y);
  }
  function O(y) {
    return y === null || y === 60 || y === 61 || y === 62 || y === 96 ? n(y) : y === 34 || y === 39 ? (e.consume(y), c = y, j) : we(y) ? (e.consume(y), O) : M(y);
  }
  function j(y) {
    return y === c ? (e.consume(y), c = null, w) : y === null || Ee(y) ? n(y) : (e.consume(y), j);
  }
  function M(y) {
    return y === null || y === 34 || y === 39 || y === 47 || y === 60 || y === 61 || y === 62 || y === 96 || Nt(y) ? v(y) : (e.consume(y), M);
  }
  function w(y) {
    return y === 47 || y === 62 || we(y) ? S(y) : n(y);
  }
  function L(y) {
    return y === 62 ? (e.consume(y), P) : n(y);
  }
  function P(y) {
    return y === null || Ee(y) ? k(y) : we(y) ? (e.consume(y), P) : n(y);
  }
  function k(y) {
    return y === 45 && i === 2 ? (e.consume(y), N) : y === 60 && i === 1 ? (e.consume(y), ne) : y === 62 && i === 4 ? (e.consume(y), W) : y === 63 && i === 3 ? (e.consume(y), m) : y === 93 && i === 5 ? (e.consume(y), te) : Ee(y) && (i === 6 || i === 7) ? (e.exit("htmlFlowData"), e.check(uS, H, z)(y)) : y === null || Ee(y) ? (e.exit("htmlFlowData"), z(y)) : (e.consume(y), k);
  }
  function z(y) {
    return e.check(dS, B, H)(y);
  }
  function B(y) {
    return e.enter("lineEnding"), e.consume(y), e.exit("lineEnding"), q;
  }
  function q(y) {
    return y === null || Ee(y) ? z(y) : (e.enter("htmlFlowData"), k(y));
  }
  function N(y) {
    return y === 45 ? (e.consume(y), m) : k(y);
  }
  function ne(y) {
    return y === 47 ? (e.consume(y), s = "", ue) : k(y);
  }
  function ue(y) {
    if (y === 62) {
      const X = s.toLowerCase();
      return sc.includes(X) ? (e.consume(y), W) : k(y);
    }
    return dn(y) && s.length < 8 ? (e.consume(y), s += String.fromCharCode(y), ue) : k(y);
  }
  function te(y) {
    return y === 93 ? (e.consume(y), m) : k(y);
  }
  function m(y) {
    return y === 62 ? (e.consume(y), W) : y === 45 && i === 2 ? (e.consume(y), m) : k(y);
  }
  function W(y) {
    return y === null || Ee(y) ? (e.exit("htmlFlowData"), H(y)) : (e.consume(y), W);
  }
  function H(y) {
    return e.exit("htmlFlow"), t(y);
  }
}
function fS(e, t, n) {
  const r = this;
  return i;
  function i(s) {
    return Ee(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), o) : n(s);
  }
  function o(s) {
    return r.parser.lazy[r.now().line] ? n(s) : t(s);
  }
}
function mS(e, t, n) {
  return r;
  function r(i) {
    return e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), e.attempt(Ro, t, n);
  }
}
const ES = {
  name: "htmlText",
  tokenize: xS
};
function xS(e, t, n) {
  const r = this;
  let i, o, s;
  return l;
  function l(m) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(m), c;
  }
  function c(m) {
    return m === 33 ? (e.consume(m), u) : m === 47 ? (e.consume(m), v) : m === 63 ? (e.consume(m), S) : dn(m) ? (e.consume(m), M) : n(m);
  }
  function u(m) {
    return m === 45 ? (e.consume(m), p) : m === 91 ? (e.consume(m), o = 0, g) : dn(m) ? (e.consume(m), A) : n(m);
  }
  function p(m) {
    return m === 45 ? (e.consume(m), h) : n(m);
  }
  function d(m) {
    return m === null ? n(m) : m === 45 ? (e.consume(m), f) : Ee(m) ? (s = d, ne(m)) : (e.consume(m), d);
  }
  function f(m) {
    return m === 45 ? (e.consume(m), h) : d(m);
  }
  function h(m) {
    return m === 62 ? N(m) : m === 45 ? f(m) : d(m);
  }
  function g(m) {
    const W = "CDATA[";
    return m === W.charCodeAt(o++) ? (e.consume(m), o === W.length ? C : g) : n(m);
  }
  function C(m) {
    return m === null ? n(m) : m === 93 ? (e.consume(m), T) : Ee(m) ? (s = C, ne(m)) : (e.consume(m), C);
  }
  function T(m) {
    return m === 93 ? (e.consume(m), I) : C(m);
  }
  function I(m) {
    return m === 62 ? N(m) : m === 93 ? (e.consume(m), I) : C(m);
  }
  function A(m) {
    return m === null || m === 62 ? N(m) : Ee(m) ? (s = A, ne(m)) : (e.consume(m), A);
  }
  function S(m) {
    return m === null ? n(m) : m === 63 ? (e.consume(m), _) : Ee(m) ? (s = S, ne(m)) : (e.consume(m), S);
  }
  function _(m) {
    return m === 62 ? N(m) : S(m);
  }
  function v(m) {
    return dn(m) ? (e.consume(m), O) : n(m);
  }
  function O(m) {
    return m === 45 || Vt(m) ? (e.consume(m), O) : j(m);
  }
  function j(m) {
    return Ee(m) ? (s = j, ne(m)) : we(m) ? (e.consume(m), j) : N(m);
  }
  function M(m) {
    return m === 45 || Vt(m) ? (e.consume(m), M) : m === 47 || m === 62 || Nt(m) ? w(m) : n(m);
  }
  function w(m) {
    return m === 47 ? (e.consume(m), N) : m === 58 || m === 95 || dn(m) ? (e.consume(m), L) : Ee(m) ? (s = w, ne(m)) : we(m) ? (e.consume(m), w) : N(m);
  }
  function L(m) {
    return m === 45 || m === 46 || m === 58 || m === 95 || Vt(m) ? (e.consume(m), L) : P(m);
  }
  function P(m) {
    return m === 61 ? (e.consume(m), k) : Ee(m) ? (s = P, ne(m)) : we(m) ? (e.consume(m), P) : w(m);
  }
  function k(m) {
    return m === null || m === 60 || m === 61 || m === 62 || m === 96 ? n(m) : m === 34 || m === 39 ? (e.consume(m), i = m, z) : Ee(m) ? (s = k, ne(m)) : we(m) ? (e.consume(m), k) : (e.consume(m), B);
  }
  function z(m) {
    return m === i ? (e.consume(m), i = void 0, q) : m === null ? n(m) : Ee(m) ? (s = z, ne(m)) : (e.consume(m), z);
  }
  function B(m) {
    return m === null || m === 34 || m === 39 || m === 60 || m === 61 || m === 96 ? n(m) : m === 47 || m === 62 || Nt(m) ? w(m) : (e.consume(m), B);
  }
  function q(m) {
    return m === 47 || m === 62 || Nt(m) ? w(m) : n(m);
  }
  function N(m) {
    return m === 62 ? (e.consume(m), e.exit("htmlTextData"), e.exit("htmlText"), t) : n(m);
  }
  function ne(m) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(m), e.exit("lineEnding"), ue;
  }
  function ue(m) {
    return we(m) ? Ge(e, te, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(m) : te(m);
  }
  function te(m) {
    return e.enter("htmlTextData"), s(m);
  }
}
const ms = {
  name: "labelEnd",
  resolveAll: TS,
  resolveTo: SS,
  tokenize: IS
}, CS = {
  tokenize: AS
}, gS = {
  tokenize: bS
}, yS = {
  tokenize: RS
};
function TS(e) {
  let t = -1;
  const n = [];
  for (; ++t < e.length; ) {
    const r = e[t][1];
    if (n.push(e[t]), r.type === "labelImage" || r.type === "labelLink" || r.type === "labelEnd") {
      const i = r.type === "labelImage" ? 4 : 2;
      r.type = "data", t += i;
    }
  }
  return e.length !== n.length && pn(e, 0, e.length, n), e;
}
function SS(e, t) {
  let n = e.length, r = 0, i, o, s, l;
  for (; n--; )
    if (i = e[n][1], o) {
      if (i.type === "link" || i.type === "labelLink" && i._inactive)
        break;
      e[n][0] === "enter" && i.type === "labelLink" && (i._inactive = !0);
    } else if (s) {
      if (e[n][0] === "enter" && (i.type === "labelImage" || i.type === "labelLink") && !i._balanced && (o = n, i.type !== "labelLink")) {
        r = 2;
        break;
      }
    } else i.type === "labelEnd" && (s = n);
  const c = {
    type: e[o][1].type === "labelLink" ? "link" : "image",
    start: {
      ...e[o][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  }, u = {
    type: "label",
    start: {
      ...e[o][1].start
    },
    end: {
      ...e[s][1].end
    }
  }, p = {
    type: "labelText",
    start: {
      ...e[o + r + 2][1].end
    },
    end: {
      ...e[s - 2][1].start
    }
  };
  return l = [["enter", c, t], ["enter", u, t]], l = Wt(l, e.slice(o + 1, o + r + 3)), l = Wt(l, [["enter", p, t]]), l = Wt(l, fs(t.parser.constructs.insideSpan.null, e.slice(o + r + 4, s - 3), t)), l = Wt(l, [["exit", p, t], e[s - 2], e[s - 1], ["exit", u, t]]), l = Wt(l, e.slice(s + 1)), l = Wt(l, [["exit", c, t]]), pn(e, o, e.length, l), e;
}
function IS(e, t, n) {
  const r = this;
  let i = r.events.length, o, s;
  for (; i--; )
    if ((r.events[i][1].type === "labelImage" || r.events[i][1].type === "labelLink") && !r.events[i][1]._balanced) {
      o = r.events[i][1];
      break;
    }
  return l;
  function l(f) {
    return o ? o._inactive ? d(f) : (s = r.parser.defined.includes(pr(r.sliceSerialize({
      start: o.end,
      end: r.now()
    }))), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(f), e.exit("labelMarker"), e.exit("labelEnd"), c) : n(f);
  }
  function c(f) {
    return f === 40 ? e.attempt(CS, p, s ? p : d)(f) : f === 91 ? e.attempt(gS, p, s ? u : d)(f) : s ? p(f) : d(f);
  }
  function u(f) {
    return e.attempt(yS, p, d)(f);
  }
  function p(f) {
    return t(f);
  }
  function d(f) {
    return o._balanced = !0, n(f);
  }
}
function AS(e, t, n) {
  return r;
  function r(d) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(d), e.exit("resourceMarker"), i;
  }
  function i(d) {
    return Nt(d) ? Hr(e, o)(d) : o(d);
  }
  function o(d) {
    return d === 41 ? p(d) : tp(e, s, l, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(d);
  }
  function s(d) {
    return Nt(d) ? Hr(e, c)(d) : p(d);
  }
  function l(d) {
    return n(d);
  }
  function c(d) {
    return d === 34 || d === 39 || d === 40 ? rp(e, u, n, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(d) : p(d);
  }
  function u(d) {
    return Nt(d) ? Hr(e, p)(d) : p(d);
  }
  function p(d) {
    return d === 41 ? (e.enter("resourceMarker"), e.consume(d), e.exit("resourceMarker"), e.exit("resource"), t) : n(d);
  }
}
function bS(e, t, n) {
  const r = this;
  return i;
  function i(l) {
    return np.call(r, e, o, s, "reference", "referenceMarker", "referenceString")(l);
  }
  function o(l) {
    return r.parser.defined.includes(pr(r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1))) ? t(l) : n(l);
  }
  function s(l) {
    return n(l);
  }
}
function RS(e, t, n) {
  return r;
  function r(o) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), i;
  }
  function i(o) {
    return o === 93 ? (e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), e.exit("reference"), t) : n(o);
  }
}
const OS = {
  name: "labelStartImage",
  resolveAll: ms.resolveAll,
  tokenize: vS
};
function vS(e, t, n) {
  const r = this;
  return i;
  function i(l) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(l), e.exit("labelImageMarker"), o;
  }
  function o(l) {
    return l === 91 ? (e.enter("labelMarker"), e.consume(l), e.exit("labelMarker"), e.exit("labelImage"), s) : n(l);
  }
  function s(l) {
    return l === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(l) : t(l);
  }
}
const DS = {
  name: "labelStartLink",
  resolveAll: ms.resolveAll,
  tokenize: _S
};
function _S(e, t, n) {
  const r = this;
  return i;
  function i(s) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(s), e.exit("labelMarker"), e.exit("labelLink"), o;
  }
  function o(s) {
    return s === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(s) : t(s);
  }
}
const Qo = {
  name: "lineEnding",
  tokenize: NS
};
function NS(e, t) {
  return n;
  function n(r) {
    return e.enter("lineEnding"), e.consume(r), e.exit("lineEnding"), Ge(e, t, "linePrefix");
  }
}
const Vi = {
  name: "thematicBreak",
  tokenize: wS
};
function wS(e, t, n) {
  let r = 0, i;
  return o;
  function o(u) {
    return e.enter("thematicBreak"), s(u);
  }
  function s(u) {
    return i = u, l(u);
  }
  function l(u) {
    return u === i ? (e.enter("thematicBreakSequence"), c(u)) : r >= 3 && (u === null || Ee(u)) ? (e.exit("thematicBreak"), t(u)) : n(u);
  }
  function c(u) {
    return u === i ? (e.consume(u), r++, c) : (e.exit("thematicBreakSequence"), we(u) ? Ge(e, l, "whitespace")(u) : l(u));
  }
}
const _t = {
  continuation: {
    tokenize: kS
  },
  exit: VS,
  name: "list",
  tokenize: LS
}, PS = {
  partial: !0,
  tokenize: US
}, jS = {
  partial: !0,
  tokenize: MS
};
function LS(e, t, n) {
  const r = this, i = r.events[r.events.length - 1];
  let o = i && i[1].type === "linePrefix" ? i[2].sliceSerialize(i[1], !0).length : 0, s = 0;
  return l;
  function l(h) {
    const g = r.containerState.type || (h === 42 || h === 43 || h === 45 ? "listUnordered" : "listOrdered");
    if (g === "listUnordered" ? !r.containerState.marker || h === r.containerState.marker : wa(h)) {
      if (r.containerState.type || (r.containerState.type = g, e.enter(g, {
        _container: !0
      })), g === "listUnordered")
        return e.enter("listItemPrefix"), h === 42 || h === 45 ? e.check(Vi, n, u)(h) : u(h);
      if (!r.interrupt || h === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), c(h);
    }
    return n(h);
  }
  function c(h) {
    return wa(h) && ++s < 10 ? (e.consume(h), c) : (!r.interrupt || s < 2) && (r.containerState.marker ? h === r.containerState.marker : h === 41 || h === 46) ? (e.exit("listItemValue"), u(h)) : n(h);
  }
  function u(h) {
    return e.enter("listItemMarker"), e.consume(h), e.exit("listItemMarker"), r.containerState.marker = r.containerState.marker || h, e.check(
      Ro,
      // Can’t be empty when interrupting.
      r.interrupt ? n : p,
      e.attempt(PS, f, d)
    );
  }
  function p(h) {
    return r.containerState.initialBlankLine = !0, o++, f(h);
  }
  function d(h) {
    return we(h) ? (e.enter("listItemPrefixWhitespace"), e.consume(h), e.exit("listItemPrefixWhitespace"), f) : n(h);
  }
  function f(h) {
    return r.containerState.size = o + r.sliceSerialize(e.exit("listItemPrefix"), !0).length, t(h);
  }
}
function kS(e, t, n) {
  const r = this;
  return r.containerState._closeFlow = void 0, e.check(Ro, i, o);
  function i(l) {
    return r.containerState.furtherBlankLines = r.containerState.furtherBlankLines || r.containerState.initialBlankLine, Ge(e, t, "listItemIndent", r.containerState.size + 1)(l);
  }
  function o(l) {
    return r.containerState.furtherBlankLines || !we(l) ? (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, s(l)) : (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, e.attempt(jS, t, s)(l));
  }
  function s(l) {
    return r.containerState._closeFlow = !0, r.interrupt = void 0, Ge(e, e.attempt(_t, t, n), "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(l);
  }
}
function MS(e, t, n) {
  const r = this;
  return Ge(e, i, "listItemIndent", r.containerState.size + 1);
  function i(o) {
    const s = r.events[r.events.length - 1];
    return s && s[1].type === "listItemIndent" && s[2].sliceSerialize(s[1], !0).length === r.containerState.size ? t(o) : n(o);
  }
}
function VS(e) {
  e.exit(this.containerState.type);
}
function US(e, t, n) {
  const r = this;
  return Ge(e, i, "listItemPrefixWhitespace", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
  function i(o) {
    const s = r.events[r.events.length - 1];
    return !we(o) && s && s[1].type === "listItemPrefixWhitespace" ? t(o) : n(o);
  }
}
const lc = {
  name: "setextUnderline",
  resolveTo: FS,
  tokenize: BS
};
function FS(e, t) {
  let n = e.length, r, i, o;
  for (; n--; )
    if (e[n][0] === "enter") {
      if (e[n][1].type === "content") {
        r = n;
        break;
      }
      e[n][1].type === "paragraph" && (i = n);
    } else
      e[n][1].type === "content" && e.splice(n, 1), !o && e[n][1].type === "definition" && (o = n);
  const s = {
    type: "setextHeading",
    start: {
      ...e[r][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  };
  return e[i][1].type = "setextHeadingText", o ? (e.splice(i, 0, ["enter", s, t]), e.splice(o + 1, 0, ["exit", e[r][1], t]), e[r][1].end = {
    ...e[o][1].end
  }) : e[r][1] = s, e.push(["exit", s, t]), e;
}
function BS(e, t, n) {
  const r = this;
  let i;
  return o;
  function o(u) {
    let p = r.events.length, d;
    for (; p--; )
      if (r.events[p][1].type !== "lineEnding" && r.events[p][1].type !== "linePrefix" && r.events[p][1].type !== "content") {
        d = r.events[p][1].type === "paragraph";
        break;
      }
    return !r.parser.lazy[r.now().line] && (r.interrupt || d) ? (e.enter("setextHeadingLine"), i = u, s(u)) : n(u);
  }
  function s(u) {
    return e.enter("setextHeadingLineSequence"), l(u);
  }
  function l(u) {
    return u === i ? (e.consume(u), l) : (e.exit("setextHeadingLineSequence"), we(u) ? Ge(e, c, "lineSuffix")(u) : c(u));
  }
  function c(u) {
    return u === null || Ee(u) ? (e.exit("setextHeadingLine"), t(u)) : n(u);
  }
}
const $S = {
  tokenize: GS
};
function GS(e) {
  const t = this, n = e.attempt(
    // Try to parse a blank line.
    Ro,
    r,
    // Try to parse initial flow (essentially, only code).
    e.attempt(this.parser.constructs.flowInitial, i, Ge(e, e.attempt(this.parser.constructs.flow, i, e.attempt(qT, i)), "linePrefix"))
  );
  return n;
  function r(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(o), e.exit("lineEndingBlank"), t.currentConstruct = void 0, n;
  }
  function i(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), t.currentConstruct = void 0, n;
  }
}
const zS = {
  resolveAll: op()
}, WS = ip("string"), YS = ip("text");
function ip(e) {
  return {
    resolveAll: op(e === "text" ? HS : void 0),
    tokenize: t
  };
  function t(n) {
    const r = this, i = this.parser.constructs[e], o = n.attempt(i, s, l);
    return s;
    function s(p) {
      return u(p) ? o(p) : l(p);
    }
    function l(p) {
      if (p === null) {
        n.consume(p);
        return;
      }
      return n.enter("data"), n.consume(p), c;
    }
    function c(p) {
      return u(p) ? (n.exit("data"), o(p)) : (n.consume(p), c);
    }
    function u(p) {
      if (p === null)
        return !0;
      const d = i[p];
      let f = -1;
      if (d)
        for (; ++f < d.length; ) {
          const h = d[f];
          if (!h.previous || h.previous.call(r, r.previous))
            return !0;
        }
      return !1;
    }
  }
}
function op(e) {
  return t;
  function t(n, r) {
    let i = -1, o;
    for (; ++i <= n.length; )
      o === void 0 ? n[i] && n[i][1].type === "data" && (o = i, i++) : (!n[i] || n[i][1].type !== "data") && (i !== o + 2 && (n[o][1].end = n[i - 1][1].end, n.splice(o + 2, i - o - 2), i = o + 2), o = void 0);
    return e ? e(n, r) : n;
  }
}
function HS(e, t) {
  let n = 0;
  for (; ++n <= e.length; )
    if ((n === e.length || e[n][1].type === "lineEnding") && e[n - 1][1].type === "data") {
      const r = e[n - 1][1], i = t.sliceStream(r);
      let o = i.length, s = -1, l = 0, c;
      for (; o--; ) {
        const u = i[o];
        if (typeof u == "string") {
          for (s = u.length; u.charCodeAt(s - 1) === 32; )
            l++, s--;
          if (s) break;
          s = -1;
        } else if (u === -2)
          c = !0, l++;
        else if (u !== -1) {
          o++;
          break;
        }
      }
      if (t._contentTypeTextTrailing && n === e.length && (l = 0), l) {
        const u = {
          type: n === e.length || c || l < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            _bufferIndex: o ? s : r.start._bufferIndex + s,
            _index: r.start._index + o,
            line: r.end.line,
            column: r.end.column - l,
            offset: r.end.offset - l
          },
          end: {
            ...r.end
          }
        };
        r.end = {
          ...u.start
        }, r.start.offset === r.end.offset ? Object.assign(r, u) : (e.splice(n, 0, ["enter", u, t], ["exit", u, t]), n += 2);
      }
      n++;
    }
  return e;
}
const qS = {
  42: _t,
  43: _t,
  45: _t,
  48: _t,
  49: _t,
  50: _t,
  51: _t,
  52: _t,
  53: _t,
  54: _t,
  55: _t,
  56: _t,
  57: _t,
  62: Kd
}, XS = {
  91: ZT
}, JS = {
  [-2]: Ko,
  [-1]: Ko,
  32: Ko
}, KS = {
  35: oS,
  42: Vi,
  45: [lc, Vi],
  60: cS,
  61: lc,
  95: Vi,
  96: ac,
  126: ac
}, QS = {
  38: Zd,
  92: Qd
}, ZS = {
  [-5]: Qo,
  [-4]: Qo,
  [-3]: Qo,
  33: OS,
  38: Zd,
  42: Pa,
  60: [DT, ES],
  91: DS,
  92: [rS, Qd],
  93: ms,
  95: Pa,
  96: $T
}, eI = {
  null: [Pa, zS]
}, tI = {
  null: [42, 95]
}, nI = {
  null: []
}, rI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: tI,
  contentInitial: XS,
  disable: nI,
  document: qS,
  flow: KS,
  flowInitial: JS,
  insideSpan: eI,
  string: QS,
  text: ZS
}, Symbol.toStringTag, { value: "Module" }));
function iI(e, t, n) {
  let r = {
    _bufferIndex: -1,
    _index: 0,
    line: n && n.line || 1,
    column: n && n.column || 1,
    offset: n && n.offset || 0
  };
  const i = {}, o = [];
  let s = [], l = [];
  const c = {
    attempt: j(v),
    check: j(O),
    consume: A,
    enter: S,
    exit: _,
    interrupt: j(O, {
      interrupt: !0
    })
  }, u = {
    code: null,
    containerState: {},
    defineSkip: C,
    events: [],
    now: g,
    parser: e,
    previous: null,
    sliceSerialize: f,
    sliceStream: h,
    write: d
  };
  let p = t.tokenize.call(u, c);
  return t.resolveAll && o.push(t), u;
  function d(P) {
    return s = Wt(s, P), T(), s[s.length - 1] !== null ? [] : (M(t, 0), u.events = fs(o, u.events, u), u.events);
  }
  function f(P, k) {
    return aI(h(P), k);
  }
  function h(P) {
    return oI(s, P);
  }
  function g() {
    const {
      _bufferIndex: P,
      _index: k,
      line: z,
      column: B,
      offset: q
    } = r;
    return {
      _bufferIndex: P,
      _index: k,
      line: z,
      column: B,
      offset: q
    };
  }
  function C(P) {
    i[P.line] = P.column, L();
  }
  function T() {
    let P;
    for (; r._index < s.length; ) {
      const k = s[r._index];
      if (typeof k == "string")
        for (P = r._index, r._bufferIndex < 0 && (r._bufferIndex = 0); r._index === P && r._bufferIndex < k.length; )
          I(k.charCodeAt(r._bufferIndex));
      else
        I(k);
    }
  }
  function I(P) {
    p = p(P);
  }
  function A(P) {
    Ee(P) ? (r.line++, r.column = 1, r.offset += P === -3 ? 2 : 1, L()) : P !== -1 && (r.column++, r.offset++), r._bufferIndex < 0 ? r._index++ : (r._bufferIndex++, r._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
    // strings.
    /** @type {string} */
    s[r._index].length && (r._bufferIndex = -1, r._index++)), u.previous = P;
  }
  function S(P, k) {
    const z = k || {};
    return z.type = P, z.start = g(), u.events.push(["enter", z, u]), l.push(z), z;
  }
  function _(P) {
    const k = l.pop();
    return k.end = g(), u.events.push(["exit", k, u]), k;
  }
  function v(P, k) {
    M(P, k.from);
  }
  function O(P, k) {
    k.restore();
  }
  function j(P, k) {
    return z;
    function z(B, q, N) {
      let ne, ue, te, m;
      return Array.isArray(B) ? (
        /* c8 ignore next 1 */
        H(B)
      ) : "tokenize" in B ? (
        // Looks like a construct.
        H([
          /** @type {Construct} */
          B
        ])
      ) : W(B);
      function W($) {
        return le;
        function le(b) {
          const oe = b !== null && $[b], re = b !== null && $.null, ye = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(oe) ? oe : oe ? [oe] : [],
            ...Array.isArray(re) ? re : re ? [re] : []
          ];
          return H(ye)(b);
        }
      }
      function H($) {
        return ne = $, ue = 0, $.length === 0 ? N : y($[ue]);
      }
      function y($) {
        return le;
        function le(b) {
          return m = w(), te = $, $.partial || (u.currentConstruct = $), $.name && u.parser.constructs.disable.null.includes($.name) ? V() : $.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            k ? Object.assign(Object.create(u), k) : u,
            c,
            X,
            V
          )(b);
        }
      }
      function X($) {
        return P(te, m), q;
      }
      function V($) {
        return m.restore(), ++ue < ne.length ? y(ne[ue]) : N;
      }
    }
  }
  function M(P, k) {
    P.resolveAll && !o.includes(P) && o.push(P), P.resolve && pn(u.events, k, u.events.length - k, P.resolve(u.events.slice(k), u)), P.resolveTo && (u.events = P.resolveTo(u.events, u));
  }
  function w() {
    const P = g(), k = u.previous, z = u.currentConstruct, B = u.events.length, q = Array.from(l);
    return {
      from: B,
      restore: N
    };
    function N() {
      r = P, u.previous = k, u.currentConstruct = z, u.events.length = B, l = q, L();
    }
  }
  function L() {
    r.line in i && r.column < 2 && (r.column = i[r.line], r.offset += i[r.line] - 1);
  }
}
function oI(e, t) {
  const n = t.start._index, r = t.start._bufferIndex, i = t.end._index, o = t.end._bufferIndex;
  let s;
  if (n === i)
    s = [e[n].slice(r, o)];
  else {
    if (s = e.slice(n, i), r > -1) {
      const l = s[0];
      typeof l == "string" ? s[0] = l.slice(r) : s.shift();
    }
    o > 0 && s.push(e[i].slice(0, o));
  }
  return s;
}
function aI(e, t) {
  let n = -1;
  const r = [];
  let i;
  for (; ++n < e.length; ) {
    const o = e[n];
    let s;
    if (typeof o == "string")
      s = o;
    else switch (o) {
      case -5: {
        s = "\r";
        break;
      }
      case -4: {
        s = `
`;
        break;
      }
      case -3: {
        s = `\r
`;
        break;
      }
      case -2: {
        s = t ? " " : "	";
        break;
      }
      case -1: {
        if (!t && i) continue;
        s = " ";
        break;
      }
      default:
        s = String.fromCharCode(o);
    }
    i = o === -2, r.push(s);
  }
  return r.join("");
}
function sI(e) {
  const r = {
    constructs: (
      /** @type {FullNormalizedExtension} */
      fT([rI, ...(e || {}).extensions || []])
    ),
    content: i(ST),
    defined: [],
    document: i(AT),
    flow: i($S),
    lazy: {},
    string: i(WS),
    text: i(YS)
  };
  return r;
  function i(o) {
    return s;
    function s(l) {
      return iI(r, o, l);
    }
  }
}
function lI(e) {
  for (; !ep(e); )
    ;
  return e;
}
const cc = /[\0\t\n\r]/g;
function cI() {
  let e = 1, t = "", n = !0, r;
  return i;
  function i(o, s, l) {
    const c = [];
    let u, p, d, f, h;
    for (o = t + (typeof o == "string" ? o.toString() : new TextDecoder(s || void 0).decode(o)), d = 0, t = "", n && (o.charCodeAt(0) === 65279 && d++, n = void 0); d < o.length; ) {
      if (cc.lastIndex = d, u = cc.exec(o), f = u && u.index !== void 0 ? u.index : o.length, h = o.charCodeAt(f), !u) {
        t = o.slice(d);
        break;
      }
      if (h === 10 && d === f && r)
        c.push(-3), r = void 0;
      else
        switch (r && (c.push(-5), r = void 0), d < f && (c.push(o.slice(d, f)), e += f - d), h) {
          case 0: {
            c.push(65533), e++;
            break;
          }
          case 9: {
            for (p = Math.ceil(e / 4) * 4, c.push(-2); e++ < p; ) c.push(-1);
            break;
          }
          case 10: {
            c.push(-4), e = 1;
            break;
          }
          default:
            r = !0, e = 1;
        }
      d = f + 1;
    }
    return l && (r && c.push(-5), t && c.push(t), c.push(null)), c;
  }
}
const uI = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function dI(e) {
  return e.replace(uI, pI);
}
function pI(e, t, n) {
  if (t)
    return t;
  if (n.charCodeAt(0) === 35) {
    const i = n.charCodeAt(1), o = i === 120 || i === 88;
    return Jd(n.slice(o ? 2 : 1), o ? 16 : 10);
  }
  return hs(n) || e;
}
const ap = {}.hasOwnProperty;
function hI(e, t, n) {
  return typeof t != "string" && (n = t, t = void 0), fI(n)(lI(sI(n).document().write(cI()(e, t, !0))));
}
function fI(e) {
  const t = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: o(de),
      autolinkProtocol: w,
      autolinkEmail: w,
      atxHeading: o(Ve),
      blockQuote: o(re),
      characterEscape: w,
      characterReference: w,
      codeFenced: o(ye),
      codeFencedFenceInfo: s,
      codeFencedFenceMeta: s,
      codeIndented: o(ye, s),
      codeText: o(Me, s),
      codeTextData: w,
      data: w,
      codeFlowValue: w,
      definition: o(ot),
      definitionDestinationString: s,
      definitionLabelString: s,
      definitionTitleString: s,
      emphasis: o(Ue),
      hardBreakEscape: o(Qe),
      hardBreakTrailing: o(Qe),
      htmlFlow: o(pt, s),
      htmlFlowData: w,
      htmlText: o(pt, s),
      htmlTextData: w,
      image: o(qt),
      label: s,
      link: o(de),
      listItem: o(Fe),
      listItemValue: f,
      listOrdered: o(ae, d),
      listUnordered: o(ae),
      paragraph: o(vt),
      reference: y,
      referenceString: s,
      resourceDestinationString: s,
      resourceTitleString: s,
      setextHeading: o(Ve),
      strong: o(Ye),
      thematicBreak: o(at)
    },
    exit: {
      atxHeading: c(),
      atxHeadingSequence: v,
      autolink: c(),
      autolinkEmail: oe,
      autolinkProtocol: b,
      blockQuote: c(),
      characterEscapeValue: L,
      characterReferenceMarkerHexadecimal: V,
      characterReferenceMarkerNumeric: V,
      characterReferenceValue: $,
      characterReference: le,
      codeFenced: c(T),
      codeFencedFence: C,
      codeFencedFenceInfo: h,
      codeFencedFenceMeta: g,
      codeFlowValue: L,
      codeIndented: c(I),
      codeText: c(q),
      codeTextData: L,
      data: L,
      definition: c(),
      definitionDestinationString: _,
      definitionLabelString: A,
      definitionTitleString: S,
      emphasis: c(),
      hardBreakEscape: c(k),
      hardBreakTrailing: c(k),
      htmlFlow: c(z),
      htmlFlowData: L,
      htmlText: c(B),
      htmlTextData: L,
      image: c(ne),
      label: te,
      labelText: ue,
      lineEnding: P,
      link: c(N),
      listItem: c(),
      listOrdered: c(),
      listUnordered: c(),
      paragraph: c(),
      referenceString: X,
      resourceDestinationString: m,
      resourceTitleString: W,
      resource: H,
      setextHeading: c(M),
      setextHeadingLineSequence: j,
      setextHeadingText: O,
      strong: c(),
      thematicBreak: c()
    }
  };
  sp(t, (e || {}).mdastExtensions || []);
  const n = {};
  return r;
  function r(U) {
    let K = {
      type: "root",
      children: []
    };
    const pe = {
      stack: [K],
      tokenStack: [],
      config: t,
      enter: l,
      exit: u,
      buffer: s,
      resume: p,
      data: n
    }, Ce = [];
    let ve = -1;
    for (; ++ve < U.length; )
      if (U[ve][1].type === "listOrdered" || U[ve][1].type === "listUnordered")
        if (U[ve][0] === "enter")
          Ce.push(ve);
        else {
          const He = Ce.pop();
          ve = i(U, He, ve);
        }
    for (ve = -1; ++ve < U.length; ) {
      const He = t[U[ve][0]];
      ap.call(He, U[ve][1].type) && He[U[ve][1].type].call(Object.assign({
        sliceSerialize: U[ve][2].sliceSerialize
      }, pe), U[ve][1]);
    }
    if (pe.tokenStack.length > 0) {
      const He = pe.tokenStack[pe.tokenStack.length - 1];
      (He[1] || uc).call(pe, void 0, He[0]);
    }
    for (K.position = {
      start: bn(U.length > 0 ? U[0][1].start : {
        line: 1,
        column: 1,
        offset: 0
      }),
      end: bn(U.length > 0 ? U[U.length - 2][1].end : {
        line: 1,
        column: 1,
        offset: 0
      })
    }, ve = -1; ++ve < t.transforms.length; )
      K = t.transforms[ve](K) || K;
    return K;
  }
  function i(U, K, pe) {
    let Ce = K - 1, ve = -1, He = !1, Pt, Pe, hn, Xt;
    for (; ++Ce <= pe; ) {
      const Ze = U[Ce];
      switch (Ze[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          Ze[0] === "enter" ? ve++ : ve--, Xt = void 0;
          break;
        }
        case "lineEndingBlank": {
          Ze[0] === "enter" && (Pt && !Xt && !ve && !hn && (hn = Ce), Xt = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          Xt = void 0;
      }
      if (!ve && Ze[0] === "enter" && Ze[1].type === "listItemPrefix" || ve === -1 && Ze[0] === "exit" && (Ze[1].type === "listUnordered" || Ze[1].type === "listOrdered")) {
        if (Pt) {
          let tn = Ce;
          for (Pe = void 0; tn--; ) {
            const Dt = U[tn];
            if (Dt[1].type === "lineEnding" || Dt[1].type === "lineEndingBlank") {
              if (Dt[0] === "exit") continue;
              Pe && (U[Pe][1].type = "lineEndingBlank", He = !0), Dt[1].type = "lineEnding", Pe = tn;
            } else if (!(Dt[1].type === "linePrefix" || Dt[1].type === "blockQuotePrefix" || Dt[1].type === "blockQuotePrefixWhitespace" || Dt[1].type === "blockQuoteMarker" || Dt[1].type === "listItemIndent")) break;
          }
          hn && (!Pe || hn < Pe) && (Pt._spread = !0), Pt.end = Object.assign({}, Pe ? U[Pe][1].start : Ze[1].end), U.splice(Pe || Ce, 0, ["exit", Pt, Ze[2]]), Ce++, pe++;
        }
        if (Ze[1].type === "listItemPrefix") {
          const tn = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, Ze[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          Pt = tn, U.splice(Ce, 0, ["enter", tn, Ze[2]]), Ce++, pe++, hn = void 0, Xt = !0;
        }
      }
    }
    return U[K][1]._spread = He, pe;
  }
  function o(U, K) {
    return pe;
    function pe(Ce) {
      l.call(this, U(Ce), Ce), K && K.call(this, Ce);
    }
  }
  function s() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function l(U, K, pe) {
    this.stack[this.stack.length - 1].children.push(U), this.stack.push(U), this.tokenStack.push([K, pe || void 0]), U.position = {
      start: bn(K.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function c(U) {
    return K;
    function K(pe) {
      U && U.call(this, pe), u.call(this, pe);
    }
  }
  function u(U, K) {
    const pe = this.stack.pop(), Ce = this.tokenStack.pop();
    if (Ce)
      Ce[0].type !== U.type && (K ? K.call(this, U, Ce[0]) : (Ce[1] || uc).call(this, U, Ce[0]));
    else throw new Error("Cannot close `" + U.type + "` (" + Yr({
      start: U.start,
      end: U.end
    }) + "): it’s not open");
    pe.position.end = bn(U.end);
  }
  function p() {
    return pT(this.stack.pop());
  }
  function d() {
    this.data.expectingFirstListItemValue = !0;
  }
  function f(U) {
    if (this.data.expectingFirstListItemValue) {
      const K = this.stack[this.stack.length - 2];
      K.start = Number.parseInt(this.sliceSerialize(U), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function h() {
    const U = this.resume(), K = this.stack[this.stack.length - 1];
    K.lang = U;
  }
  function g() {
    const U = this.resume(), K = this.stack[this.stack.length - 1];
    K.meta = U;
  }
  function C() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function T() {
    const U = this.resume(), K = this.stack[this.stack.length - 1];
    K.value = U.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function I() {
    const U = this.resume(), K = this.stack[this.stack.length - 1];
    K.value = U.replace(/(\r?\n|\r)$/g, "");
  }
  function A(U) {
    const K = this.resume(), pe = this.stack[this.stack.length - 1];
    pe.label = K, pe.identifier = pr(this.sliceSerialize(U)).toLowerCase();
  }
  function S() {
    const U = this.resume(), K = this.stack[this.stack.length - 1];
    K.title = U;
  }
  function _() {
    const U = this.resume(), K = this.stack[this.stack.length - 1];
    K.url = U;
  }
  function v(U) {
    const K = this.stack[this.stack.length - 1];
    if (!K.depth) {
      const pe = this.sliceSerialize(U).length;
      K.depth = pe;
    }
  }
  function O() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function j(U) {
    const K = this.stack[this.stack.length - 1];
    K.depth = this.sliceSerialize(U).codePointAt(0) === 61 ? 1 : 2;
  }
  function M() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function w(U) {
    const pe = this.stack[this.stack.length - 1].children;
    let Ce = pe[pe.length - 1];
    (!Ce || Ce.type !== "text") && (Ce = Tt(), Ce.position = {
      start: bn(U.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, pe.push(Ce)), this.stack.push(Ce);
  }
  function L(U) {
    const K = this.stack.pop();
    K.value += this.sliceSerialize(U), K.position.end = bn(U.end);
  }
  function P(U) {
    const K = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const pe = K.children[K.children.length - 1];
      pe.position.end = bn(U.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && t.canContainEols.includes(K.type) && (w.call(this, U), L.call(this, U));
  }
  function k() {
    this.data.atHardBreak = !0;
  }
  function z() {
    const U = this.resume(), K = this.stack[this.stack.length - 1];
    K.value = U;
  }
  function B() {
    const U = this.resume(), K = this.stack[this.stack.length - 1];
    K.value = U;
  }
  function q() {
    const U = this.resume(), K = this.stack[this.stack.length - 1];
    K.value = U;
  }
  function N() {
    const U = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const K = this.data.referenceType || "shortcut";
      U.type += "Reference", U.referenceType = K, delete U.url, delete U.title;
    } else
      delete U.identifier, delete U.label;
    this.data.referenceType = void 0;
  }
  function ne() {
    const U = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const K = this.data.referenceType || "shortcut";
      U.type += "Reference", U.referenceType = K, delete U.url, delete U.title;
    } else
      delete U.identifier, delete U.label;
    this.data.referenceType = void 0;
  }
  function ue(U) {
    const K = this.sliceSerialize(U), pe = this.stack[this.stack.length - 2];
    pe.label = dI(K), pe.identifier = pr(K).toLowerCase();
  }
  function te() {
    const U = this.stack[this.stack.length - 1], K = this.resume(), pe = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, pe.type === "link") {
      const Ce = U.children;
      pe.children = Ce;
    } else
      pe.alt = K;
  }
  function m() {
    const U = this.resume(), K = this.stack[this.stack.length - 1];
    K.url = U;
  }
  function W() {
    const U = this.resume(), K = this.stack[this.stack.length - 1];
    K.title = U;
  }
  function H() {
    this.data.inReference = void 0;
  }
  function y() {
    this.data.referenceType = "collapsed";
  }
  function X(U) {
    const K = this.resume(), pe = this.stack[this.stack.length - 1];
    pe.label = K, pe.identifier = pr(this.sliceSerialize(U)).toLowerCase(), this.data.referenceType = "full";
  }
  function V(U) {
    this.data.characterReferenceType = U.type;
  }
  function $(U) {
    const K = this.sliceSerialize(U), pe = this.data.characterReferenceType;
    let Ce;
    pe ? (Ce = Jd(K, pe === "characterReferenceMarkerNumeric" ? 10 : 16), this.data.characterReferenceType = void 0) : Ce = hs(K);
    const ve = this.stack[this.stack.length - 1];
    ve.value += Ce;
  }
  function le(U) {
    const K = this.stack.pop();
    K.position.end = bn(U.end);
  }
  function b(U) {
    L.call(this, U);
    const K = this.stack[this.stack.length - 1];
    K.url = this.sliceSerialize(U);
  }
  function oe(U) {
    L.call(this, U);
    const K = this.stack[this.stack.length - 1];
    K.url = "mailto:" + this.sliceSerialize(U);
  }
  function re() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function ye() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function Me() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function ot() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function Ue() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function Ve() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function Qe() {
    return {
      type: "break"
    };
  }
  function pt() {
    return {
      type: "html",
      value: ""
    };
  }
  function qt() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function de() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function ae(U) {
    return {
      type: "list",
      ordered: U.type === "listOrdered",
      start: null,
      spread: U._spread,
      children: []
    };
  }
  function Fe(U) {
    return {
      type: "listItem",
      spread: U._spread,
      checked: null,
      children: []
    };
  }
  function vt() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function Ye() {
    return {
      type: "strong",
      children: []
    };
  }
  function Tt() {
    return {
      type: "text",
      value: ""
    };
  }
  function at() {
    return {
      type: "thematicBreak"
    };
  }
}
function bn(e) {
  return {
    line: e.line,
    column: e.column,
    offset: e.offset
  };
}
function sp(e, t) {
  let n = -1;
  for (; ++n < t.length; ) {
    const r = t[n];
    Array.isArray(r) ? sp(e, r) : mI(e, r);
  }
}
function mI(e, t) {
  let n;
  for (n in t)
    if (ap.call(t, n))
      switch (n) {
        case "canContainEols": {
          const r = t[n];
          r && e[n].push(...r);
          break;
        }
        case "transforms": {
          const r = t[n];
          r && e[n].push(...r);
          break;
        }
        case "enter":
        case "exit": {
          const r = t[n];
          r && Object.assign(e[n], r);
          break;
        }
      }
}
function uc(e, t) {
  throw e ? new Error("Cannot close `" + e.type + "` (" + Yr({
    start: e.start,
    end: e.end
  }) + "): a different token (`" + t.type + "`, " + Yr({
    start: t.start,
    end: t.end
  }) + ") is open") : new Error("Cannot close document, a token (`" + t.type + "`, " + Yr({
    start: t.start,
    end: t.end
  }) + ") is still open");
}
function EI(e) {
  const t = this;
  t.parser = n;
  function n(r) {
    return hI(r, {
      ...t.data("settings"),
      ...e,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: t.data("micromarkExtensions") || [],
      mdastExtensions: t.data("fromMarkdownExtensions") || []
    });
  }
}
function xI(e, t) {
  const n = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: e.wrap(e.all(t), !0)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function CI(e, t) {
  const n = { type: "element", tagName: "br", properties: {}, children: [] };
  return e.patch(t, n), [e.applyData(t, n), { type: "text", value: `
` }];
}
function gI(e, t) {
  const n = t.value ? t.value + `
` : "", r = {};
  t.lang && (r.className = ["language-" + t.lang]);
  let i = {
    type: "element",
    tagName: "code",
    properties: r,
    children: [{ type: "text", value: n }]
  };
  return t.meta && (i.data = { meta: t.meta }), e.patch(t, i), i = e.applyData(t, i), i = { type: "element", tagName: "pre", properties: {}, children: [i] }, e.patch(t, i), i;
}
function yI(e, t) {
  const n = {
    type: "element",
    tagName: "del",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function TI(e, t) {
  const n = {
    type: "element",
    tagName: "em",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function SI(e, t) {
  const n = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", r = String(t.identifier).toUpperCase(), i = Rr(r.toLowerCase()), o = e.footnoteOrder.indexOf(r);
  let s, l = e.footnoteCounts.get(r);
  l === void 0 ? (l = 0, e.footnoteOrder.push(r), s = e.footnoteOrder.length) : s = o + 1, l += 1, e.footnoteCounts.set(r, l);
  const c = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + n + "fn-" + i,
      id: n + "fnref-" + i + (l > 1 ? "-" + l : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(s) }]
  };
  e.patch(t, c);
  const u = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [c]
  };
  return e.patch(t, u), e.applyData(t, u);
}
function II(e, t) {
  const n = {
    type: "element",
    tagName: "h" + t.depth,
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function AI(e, t) {
  if (e.options.allowDangerousHtml) {
    const n = { type: "raw", value: t.value };
    return e.patch(t, n), e.applyData(t, n);
  }
}
function lp(e, t) {
  const n = t.referenceType;
  let r = "]";
  if (n === "collapsed" ? r += "[]" : n === "full" && (r += "[" + (t.label || t.identifier) + "]"), t.type === "imageReference")
    return [{ type: "text", value: "![" + t.alt + r }];
  const i = e.all(t), o = i[0];
  o && o.type === "text" ? o.value = "[" + o.value : i.unshift({ type: "text", value: "[" });
  const s = i[i.length - 1];
  return s && s.type === "text" ? s.value += r : i.push({ type: "text", value: r }), i;
}
function bI(e, t) {
  const n = String(t.identifier).toUpperCase(), r = e.definitionById.get(n);
  if (!r)
    return lp(e, t);
  const i = { src: Rr(r.url || ""), alt: t.alt };
  r.title !== null && r.title !== void 0 && (i.title = r.title);
  const o = { type: "element", tagName: "img", properties: i, children: [] };
  return e.patch(t, o), e.applyData(t, o);
}
function RI(e, t) {
  const n = { src: Rr(t.url) };
  t.alt !== null && t.alt !== void 0 && (n.alt = t.alt), t.title !== null && t.title !== void 0 && (n.title = t.title);
  const r = { type: "element", tagName: "img", properties: n, children: [] };
  return e.patch(t, r), e.applyData(t, r);
}
function OI(e, t) {
  const n = { type: "text", value: t.value.replace(/\r?\n|\r/g, " ") };
  e.patch(t, n);
  const r = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [n]
  };
  return e.patch(t, r), e.applyData(t, r);
}
function vI(e, t) {
  const n = String(t.identifier).toUpperCase(), r = e.definitionById.get(n);
  if (!r)
    return lp(e, t);
  const i = { href: Rr(r.url || "") };
  r.title !== null && r.title !== void 0 && (i.title = r.title);
  const o = {
    type: "element",
    tagName: "a",
    properties: i,
    children: e.all(t)
  };
  return e.patch(t, o), e.applyData(t, o);
}
function DI(e, t) {
  const n = { href: Rr(t.url) };
  t.title !== null && t.title !== void 0 && (n.title = t.title);
  const r = {
    type: "element",
    tagName: "a",
    properties: n,
    children: e.all(t)
  };
  return e.patch(t, r), e.applyData(t, r);
}
function _I(e, t, n) {
  const r = e.all(t), i = n ? NI(n) : cp(t), o = {}, s = [];
  if (typeof t.checked == "boolean") {
    const p = r[0];
    let d;
    p && p.type === "element" && p.tagName === "p" ? d = p : (d = { type: "element", tagName: "p", properties: {}, children: [] }, r.unshift(d)), d.children.length > 0 && d.children.unshift({ type: "text", value: " " }), d.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: t.checked, disabled: !0 },
      children: []
    }), o.className = ["task-list-item"];
  }
  let l = -1;
  for (; ++l < r.length; ) {
    const p = r[l];
    (i || l !== 0 || p.type !== "element" || p.tagName !== "p") && s.push({ type: "text", value: `
` }), p.type === "element" && p.tagName === "p" && !i ? s.push(...p.children) : s.push(p);
  }
  const c = r[r.length - 1];
  c && (i || c.type !== "element" || c.tagName !== "p") && s.push({ type: "text", value: `
` });
  const u = { type: "element", tagName: "li", properties: o, children: s };
  return e.patch(t, u), e.applyData(t, u);
}
function NI(e) {
  let t = !1;
  if (e.type === "list") {
    t = e.spread || !1;
    const n = e.children;
    let r = -1;
    for (; !t && ++r < n.length; )
      t = cp(n[r]);
  }
  return t;
}
function cp(e) {
  const t = e.spread;
  return t ?? e.children.length > 1;
}
function wI(e, t) {
  const n = {}, r = e.all(t);
  let i = -1;
  for (typeof t.start == "number" && t.start !== 1 && (n.start = t.start); ++i < r.length; ) {
    const s = r[i];
    if (s.type === "element" && s.tagName === "li" && s.properties && Array.isArray(s.properties.className) && s.properties.className.includes("task-list-item")) {
      n.className = ["contains-task-list"];
      break;
    }
  }
  const o = {
    type: "element",
    tagName: t.ordered ? "ol" : "ul",
    properties: n,
    children: e.wrap(r, !0)
  };
  return e.patch(t, o), e.applyData(t, o);
}
function PI(e, t) {
  const n = {
    type: "element",
    tagName: "p",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function jI(e, t) {
  const n = { type: "root", children: e.wrap(e.all(t)) };
  return e.patch(t, n), e.applyData(t, n);
}
function LI(e, t) {
  const n = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function kI(e, t) {
  const n = e.all(t), r = n.shift(), i = [];
  if (r) {
    const s = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: e.wrap([r], !0)
    };
    e.patch(t.children[0], s), i.push(s);
  }
  if (n.length > 0) {
    const s = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: e.wrap(n, !0)
    }, l = cs(t.children[1]), c = Gd(t.children[t.children.length - 1]);
    l && c && (s.position = { start: l, end: c }), i.push(s);
  }
  const o = {
    type: "element",
    tagName: "table",
    properties: {},
    children: e.wrap(i, !0)
  };
  return e.patch(t, o), e.applyData(t, o);
}
function MI(e, t, n) {
  const r = n ? n.children : void 0, o = (r ? r.indexOf(t) : 1) === 0 ? "th" : "td", s = n && n.type === "table" ? n.align : void 0, l = s ? s.length : t.children.length;
  let c = -1;
  const u = [];
  for (; ++c < l; ) {
    const d = t.children[c], f = {}, h = s ? s[c] : void 0;
    h && (f.align = h);
    let g = { type: "element", tagName: o, properties: f, children: [] };
    d && (g.children = e.all(d), e.patch(d, g), g = e.applyData(d, g)), u.push(g);
  }
  const p = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: e.wrap(u, !0)
  };
  return e.patch(t, p), e.applyData(t, p);
}
function VI(e, t) {
  const n = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
const dc = 9, pc = 32;
function UI(e) {
  const t = String(e), n = /\r?\n|\r/g;
  let r = n.exec(t), i = 0;
  const o = [];
  for (; r; )
    o.push(
      hc(t.slice(i, r.index), i > 0, !0),
      r[0]
    ), i = r.index + r[0].length, r = n.exec(t);
  return o.push(hc(t.slice(i), i > 0, !1)), o.join("");
}
function hc(e, t, n) {
  let r = 0, i = e.length;
  if (t) {
    let o = e.codePointAt(r);
    for (; o === dc || o === pc; )
      r++, o = e.codePointAt(r);
  }
  if (n) {
    let o = e.codePointAt(i - 1);
    for (; o === dc || o === pc; )
      i--, o = e.codePointAt(i - 1);
  }
  return i > r ? e.slice(r, i) : "";
}
function FI(e, t) {
  const n = { type: "text", value: UI(String(t.value)) };
  return e.patch(t, n), e.applyData(t, n);
}
function BI(e, t) {
  const n = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return e.patch(t, n), e.applyData(t, n);
}
const $I = {
  blockquote: xI,
  break: CI,
  code: gI,
  delete: yI,
  emphasis: TI,
  footnoteReference: SI,
  heading: II,
  html: AI,
  imageReference: bI,
  image: RI,
  inlineCode: OI,
  linkReference: vI,
  link: DI,
  listItem: _I,
  list: wI,
  paragraph: PI,
  // @ts-expect-error: root is different, but hard to type.
  root: jI,
  strong: LI,
  table: kI,
  tableCell: VI,
  tableRow: MI,
  text: FI,
  thematicBreak: BI,
  toml: Ni,
  yaml: Ni,
  definition: Ni,
  footnoteDefinition: Ni
};
function Ni() {
}
const up = -1, Oo = 0, qr = 1, ao = 2, Es = 3, xs = 4, Cs = 5, gs = 6, dp = 7, pp = 8, fc = typeof self == "object" ? self : globalThis, GI = (e, t) => {
  const n = (i, o) => (e.set(o, i), i), r = (i) => {
    if (e.has(i))
      return e.get(i);
    const [o, s] = t[i];
    switch (o) {
      case Oo:
      case up:
        return n(s, i);
      case qr: {
        const l = n([], i);
        for (const c of s)
          l.push(r(c));
        return l;
      }
      case ao: {
        const l = n({}, i);
        for (const [c, u] of s)
          l[r(c)] = r(u);
        return l;
      }
      case Es:
        return n(new Date(s), i);
      case xs: {
        const { source: l, flags: c } = s;
        return n(new RegExp(l, c), i);
      }
      case Cs: {
        const l = n(/* @__PURE__ */ new Map(), i);
        for (const [c, u] of s)
          l.set(r(c), r(u));
        return l;
      }
      case gs: {
        const l = n(/* @__PURE__ */ new Set(), i);
        for (const c of s)
          l.add(r(c));
        return l;
      }
      case dp: {
        const { name: l, message: c } = s;
        return n(new fc[l](c), i);
      }
      case pp:
        return n(BigInt(s), i);
      case "BigInt":
        return n(Object(BigInt(s)), i);
      case "ArrayBuffer":
        return n(new Uint8Array(s).buffer, s);
      case "DataView": {
        const { buffer: l } = new Uint8Array(s);
        return n(new DataView(l), s);
      }
    }
    return n(new fc[o](s), i);
  };
  return r;
}, mc = (e) => GI(/* @__PURE__ */ new Map(), e)(0), Zn = "", { toString: zI } = {}, { keys: WI } = Object, Mr = (e) => {
  const t = typeof e;
  if (t !== "object" || !e)
    return [Oo, t];
  const n = zI.call(e).slice(8, -1);
  switch (n) {
    case "Array":
      return [qr, Zn];
    case "Object":
      return [ao, Zn];
    case "Date":
      return [Es, Zn];
    case "RegExp":
      return [xs, Zn];
    case "Map":
      return [Cs, Zn];
    case "Set":
      return [gs, Zn];
    case "DataView":
      return [qr, n];
  }
  return n.includes("Array") ? [qr, n] : n.includes("Error") ? [dp, n] : [ao, n];
}, wi = ([e, t]) => e === Oo && (t === "function" || t === "symbol"), YI = (e, t, n, r) => {
  const i = (s, l) => {
    const c = r.push(s) - 1;
    return n.set(l, c), c;
  }, o = (s) => {
    if (n.has(s))
      return n.get(s);
    let [l, c] = Mr(s);
    switch (l) {
      case Oo: {
        let p = s;
        switch (c) {
          case "bigint":
            l = pp, p = s.toString();
            break;
          case "function":
          case "symbol":
            if (e)
              throw new TypeError("unable to serialize " + c);
            p = null;
            break;
          case "undefined":
            return i([up], s);
        }
        return i([l, p], s);
      }
      case qr: {
        if (c) {
          let f = s;
          return c === "DataView" ? f = new Uint8Array(s.buffer) : c === "ArrayBuffer" && (f = new Uint8Array(s)), i([c, [...f]], s);
        }
        const p = [], d = i([l, p], s);
        for (const f of s)
          p.push(o(f));
        return d;
      }
      case ao: {
        if (c)
          switch (c) {
            case "BigInt":
              return i([c, s.toString()], s);
            case "Boolean":
            case "Number":
            case "String":
              return i([c, s.valueOf()], s);
          }
        if (t && "toJSON" in s)
          return o(s.toJSON());
        const p = [], d = i([l, p], s);
        for (const f of WI(s))
          (e || !wi(Mr(s[f]))) && p.push([o(f), o(s[f])]);
        return d;
      }
      case Es:
        return i([l, s.toISOString()], s);
      case xs: {
        const { source: p, flags: d } = s;
        return i([l, { source: p, flags: d }], s);
      }
      case Cs: {
        const p = [], d = i([l, p], s);
        for (const [f, h] of s)
          (e || !(wi(Mr(f)) || wi(Mr(h)))) && p.push([o(f), o(h)]);
        return d;
      }
      case gs: {
        const p = [], d = i([l, p], s);
        for (const f of s)
          (e || !wi(Mr(f))) && p.push(o(f));
        return d;
      }
    }
    const { message: u } = s;
    return i([l, { name: c, message: u }], s);
  };
  return o;
}, Ec = (e, { json: t, lossy: n } = {}) => {
  const r = [];
  return YI(!(t || n), !!t, /* @__PURE__ */ new Map(), r)(e), r;
}, so = typeof structuredClone == "function" ? (
  /* c8 ignore start */
  (e, t) => t && ("json" in t || "lossy" in t) ? mc(Ec(e, t)) : structuredClone(e)
) : (e, t) => mc(Ec(e, t));
function HI(e, t) {
  const n = [{ type: "text", value: "↩" }];
  return t > 1 && n.push({
    type: "element",
    tagName: "sup",
    properties: {},
    children: [{ type: "text", value: String(t) }]
  }), n;
}
function qI(e, t) {
  return "Back to reference " + (e + 1) + (t > 1 ? "-" + t : "");
}
function XI(e) {
  const t = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", n = e.options.footnoteBackContent || HI, r = e.options.footnoteBackLabel || qI, i = e.options.footnoteLabel || "Footnotes", o = e.options.footnoteLabelTagName || "h2", s = e.options.footnoteLabelProperties || {
    className: ["sr-only"]
  }, l = [];
  let c = -1;
  for (; ++c < e.footnoteOrder.length; ) {
    const u = e.footnoteById.get(
      e.footnoteOrder[c]
    );
    if (!u)
      continue;
    const p = e.all(u), d = String(u.identifier).toUpperCase(), f = Rr(d.toLowerCase());
    let h = 0;
    const g = [], C = e.footnoteCounts.get(d);
    for (; C !== void 0 && ++h <= C; ) {
      g.length > 0 && g.push({ type: "text", value: " " });
      let A = typeof n == "string" ? n : n(c, h);
      typeof A == "string" && (A = { type: "text", value: A }), g.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + t + "fnref-" + f + (h > 1 ? "-" + h : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof r == "string" ? r : r(c, h),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(A) ? A : [A]
      });
    }
    const T = p[p.length - 1];
    if (T && T.type === "element" && T.tagName === "p") {
      const A = T.children[T.children.length - 1];
      A && A.type === "text" ? A.value += " " : T.children.push({ type: "text", value: " " }), T.children.push(...g);
    } else
      p.push(...g);
    const I = {
      type: "element",
      tagName: "li",
      properties: { id: t + "fn-" + f },
      children: e.wrap(p, !0)
    };
    e.patch(u, I), l.push(I);
  }
  if (l.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: o,
          properties: {
            ...so(s),
            id: "footnote-label"
          },
          children: [{ type: "text", value: i }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: e.wrap(l, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
const hp = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  function(e) {
    if (e == null)
      return ZI;
    if (typeof e == "function")
      return vo(e);
    if (typeof e == "object")
      return Array.isArray(e) ? JI(e) : KI(e);
    if (typeof e == "string")
      return QI(e);
    throw new Error("Expected function, string, or object as test");
  }
);
function JI(e) {
  const t = [];
  let n = -1;
  for (; ++n < e.length; )
    t[n] = hp(e[n]);
  return vo(r);
  function r(...i) {
    let o = -1;
    for (; ++o < t.length; )
      if (t[o].apply(this, i)) return !0;
    return !1;
  }
}
function KI(e) {
  const t = (
    /** @type {Record<string, unknown>} */
    e
  );
  return vo(n);
  function n(r) {
    const i = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      r
    );
    let o;
    for (o in e)
      if (i[o] !== t[o]) return !1;
    return !0;
  }
}
function QI(e) {
  return vo(t);
  function t(n) {
    return n && n.type === e;
  }
}
function vo(e) {
  return t;
  function t(n, r, i) {
    return !!(eA(n) && e.call(
      this,
      n,
      typeof r == "number" ? r : void 0,
      i || void 0
    ));
  }
}
function ZI() {
  return !0;
}
function eA(e) {
  return e !== null && typeof e == "object" && "type" in e;
}
const fp = [], tA = !0, xc = !1, nA = "skip";
function rA(e, t, n, r) {
  let i;
  typeof t == "function" && typeof n != "function" ? (r = n, n = t) : i = t;
  const o = hp(i), s = r ? -1 : 1;
  l(e, void 0, [])();
  function l(c, u, p) {
    const d = (
      /** @type {Record<string, unknown>} */
      c && typeof c == "object" ? c : {}
    );
    if (typeof d.type == "string") {
      const h = (
        // `hast`
        typeof d.tagName == "string" ? d.tagName : (
          // `xast`
          typeof d.name == "string" ? d.name : void 0
        )
      );
      Object.defineProperty(f, "name", {
        value: "node (" + (c.type + (h ? "<" + h + ">" : "")) + ")"
      });
    }
    return f;
    function f() {
      let h = fp, g, C, T;
      if ((!t || o(c, u, p[p.length - 1] || void 0)) && (h = iA(n(c, p)), h[0] === xc))
        return h;
      if ("children" in c && c.children) {
        const I = (
          /** @type {UnistParent} */
          c
        );
        if (I.children && h[0] !== nA)
          for (C = (r ? I.children.length : -1) + s, T = p.concat(I); C > -1 && C < I.children.length; ) {
            const A = I.children[C];
            if (g = l(A, C, T)(), g[0] === xc)
              return g;
            C = typeof g[1] == "number" ? g[1] : C + s;
          }
      }
      return h;
    }
  }
}
function iA(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [tA, e] : e == null ? fp : [e];
}
function mp(e, t, n, r) {
  let i, o, s;
  typeof t == "function" && typeof n != "function" ? (o = void 0, s = t, i = n) : (o = t, s = n, i = r), rA(e, o, l, i);
  function l(c, u) {
    const p = u[u.length - 1], d = p ? p.children.indexOf(c) : void 0;
    return s(c, d, p);
  }
}
const ja = {}.hasOwnProperty, oA = {};
function aA(e, t) {
  const n = t || oA, r = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map(), s = { ...$I, ...n.handlers }, l = {
    all: u,
    applyData: lA,
    definitionById: r,
    footnoteById: i,
    footnoteCounts: o,
    footnoteOrder: [],
    handlers: s,
    one: c,
    options: n,
    patch: sA,
    wrap: uA
  };
  return mp(e, function(p) {
    if (p.type === "definition" || p.type === "footnoteDefinition") {
      const d = p.type === "definition" ? r : i, f = String(p.identifier).toUpperCase();
      d.has(f) || d.set(f, p);
    }
  }), l;
  function c(p, d) {
    const f = p.type, h = l.handlers[f];
    if (ja.call(l.handlers, f) && h)
      return h(l, p, d);
    if (l.options.passThrough && l.options.passThrough.includes(f)) {
      if ("children" in p) {
        const { children: C, ...T } = p, I = so(T);
        return I.children = l.all(p), I;
      }
      return so(p);
    }
    return (l.options.unknownHandler || cA)(l, p, d);
  }
  function u(p) {
    const d = [];
    if ("children" in p) {
      const f = p.children;
      let h = -1;
      for (; ++h < f.length; ) {
        const g = l.one(f[h], p);
        if (g) {
          if (h && f[h - 1].type === "break" && (!Array.isArray(g) && g.type === "text" && (g.value = Cc(g.value)), !Array.isArray(g) && g.type === "element")) {
            const C = g.children[0];
            C && C.type === "text" && (C.value = Cc(C.value));
          }
          Array.isArray(g) ? d.push(...g) : d.push(g);
        }
      }
    }
    return d;
  }
}
function sA(e, t) {
  e.position && (t.position = zy(e));
}
function lA(e, t) {
  let n = t;
  if (e && e.data) {
    const r = e.data.hName, i = e.data.hChildren, o = e.data.hProperties;
    if (typeof r == "string")
      if (n.type === "element")
        n.tagName = r;
      else {
        const s = "children" in n ? n.children : [n];
        n = { type: "element", tagName: r, properties: {}, children: s };
      }
    n.type === "element" && o && Object.assign(n.properties, so(o)), "children" in n && n.children && i !== null && i !== void 0 && (n.children = i);
  }
  return n;
}
function cA(e, t) {
  const n = t.data || {}, r = "value" in t && !(ja.call(n, "hProperties") || ja.call(n, "hChildren")) ? { type: "text", value: t.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, r), e.applyData(t, r);
}
function uA(e, t) {
  const n = [];
  let r = -1;
  for (t && n.push({ type: "text", value: `
` }); ++r < e.length; )
    r && n.push({ type: "text", value: `
` }), n.push(e[r]);
  return t && e.length > 0 && n.push({ type: "text", value: `
` }), n;
}
function Cc(e) {
  let t = 0, n = e.charCodeAt(t);
  for (; n === 9 || n === 32; )
    t++, n = e.charCodeAt(t);
  return e.slice(t);
}
function gc(e, t) {
  const n = aA(e, t), r = n.one(e, void 0), i = XI(n), o = Array.isArray(r) ? { type: "root", children: r } : r || { type: "root", children: [] };
  return i && o.children.push({ type: "text", value: `
` }, i), o;
}
function dA(e, t) {
  return e && "run" in e ? async function(n, r) {
    const i = (
      /** @type {HastRoot} */
      gc(n, { file: r, ...t })
    );
    await e.run(i, r);
  } : function(n, r) {
    return (
      /** @type {HastRoot} */
      gc(n, { file: r, ...e || t })
    );
  };
}
function yc(e) {
  if (e)
    throw e;
}
var Ui = Object.prototype.hasOwnProperty, Ep = Object.prototype.toString, Tc = Object.defineProperty, Sc = Object.getOwnPropertyDescriptor, Ic = function(t) {
  return typeof Array.isArray == "function" ? Array.isArray(t) : Ep.call(t) === "[object Array]";
}, Ac = function(t) {
  if (!t || Ep.call(t) !== "[object Object]")
    return !1;
  var n = Ui.call(t, "constructor"), r = t.constructor && t.constructor.prototype && Ui.call(t.constructor.prototype, "isPrototypeOf");
  if (t.constructor && !n && !r)
    return !1;
  var i;
  for (i in t)
    ;
  return typeof i > "u" || Ui.call(t, i);
}, bc = function(t, n) {
  Tc && n.name === "__proto__" ? Tc(t, n.name, {
    enumerable: !0,
    configurable: !0,
    value: n.newValue,
    writable: !0
  }) : t[n.name] = n.newValue;
}, Rc = function(t, n) {
  if (n === "__proto__")
    if (Ui.call(t, n)) {
      if (Sc)
        return Sc(t, n).value;
    } else return;
  return t[n];
}, pA = function e() {
  var t, n, r, i, o, s, l = arguments[0], c = 1, u = arguments.length, p = !1;
  for (typeof l == "boolean" && (p = l, l = arguments[1] || {}, c = 2), (l == null || typeof l != "object" && typeof l != "function") && (l = {}); c < u; ++c)
    if (t = arguments[c], t != null)
      for (n in t)
        r = Rc(l, n), i = Rc(t, n), l !== i && (p && i && (Ac(i) || (o = Ic(i))) ? (o ? (o = !1, s = r && Ic(r) ? r : []) : s = r && Ac(r) ? r : {}, bc(l, { name: n, newValue: e(p, s, i) })) : typeof i < "u" && bc(l, { name: n, newValue: i }));
  return l;
};
const Zo = /* @__PURE__ */ su(pA);
function La(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function hA() {
  const e = [], t = { run: n, use: r };
  return t;
  function n(...i) {
    let o = -1;
    const s = i.pop();
    if (typeof s != "function")
      throw new TypeError("Expected function as last argument, not " + s);
    l(null, ...i);
    function l(c, ...u) {
      const p = e[++o];
      let d = -1;
      if (c) {
        s(c);
        return;
      }
      for (; ++d < i.length; )
        (u[d] === null || u[d] === void 0) && (u[d] = i[d]);
      i = u, p ? fA(p, l)(...u) : s(null, ...u);
    }
  }
  function r(i) {
    if (typeof i != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + i
      );
    return e.push(i), t;
  }
}
function fA(e, t) {
  let n;
  return r;
  function r(...s) {
    const l = e.length > s.length;
    let c;
    l && s.push(i);
    try {
      c = e.apply(this, s);
    } catch (u) {
      const p = (
        /** @type {Error} */
        u
      );
      if (l && n)
        throw p;
      return i(p);
    }
    l || (c && c.then && typeof c.then == "function" ? c.then(o, i) : c instanceof Error ? i(c) : o(c));
  }
  function i(s, ...l) {
    n || (n = !0, t(s, ...l));
  }
  function o(s) {
    i(null, s);
  }
}
const cn = { basename: mA, dirname: EA, extname: xA, join: CA, sep: "/" };
function mA(e, t) {
  if (t !== void 0 && typeof t != "string")
    throw new TypeError('"ext" argument must be a string');
  Ci(e);
  let n = 0, r = -1, i = e.length, o;
  if (t === void 0 || t.length === 0 || t.length > e.length) {
    for (; i--; )
      if (e.codePointAt(i) === 47) {
        if (o) {
          n = i + 1;
          break;
        }
      } else r < 0 && (o = !0, r = i + 1);
    return r < 0 ? "" : e.slice(n, r);
  }
  if (t === e)
    return "";
  let s = -1, l = t.length - 1;
  for (; i--; )
    if (e.codePointAt(i) === 47) {
      if (o) {
        n = i + 1;
        break;
      }
    } else
      s < 0 && (o = !0, s = i + 1), l > -1 && (e.codePointAt(i) === t.codePointAt(l--) ? l < 0 && (r = i) : (l = -1, r = s));
  return n === r ? r = s : r < 0 && (r = e.length), e.slice(n, r);
}
function EA(e) {
  if (Ci(e), e.length === 0)
    return ".";
  let t = -1, n = e.length, r;
  for (; --n; )
    if (e.codePointAt(n) === 47) {
      if (r) {
        t = n;
        break;
      }
    } else r || (r = !0);
  return t < 0 ? e.codePointAt(0) === 47 ? "/" : "." : t === 1 && e.codePointAt(0) === 47 ? "//" : e.slice(0, t);
}
function xA(e) {
  Ci(e);
  let t = e.length, n = -1, r = 0, i = -1, o = 0, s;
  for (; t--; ) {
    const l = e.codePointAt(t);
    if (l === 47) {
      if (s) {
        r = t + 1;
        break;
      }
      continue;
    }
    n < 0 && (s = !0, n = t + 1), l === 46 ? i < 0 ? i = t : o !== 1 && (o = 1) : i > -1 && (o = -1);
  }
  return i < 0 || n < 0 || // We saw a non-dot character immediately before the dot.
  o === 0 || // The (right-most) trimmed path component is exactly `..`.
  o === 1 && i === n - 1 && i === r + 1 ? "" : e.slice(i, n);
}
function CA(...e) {
  let t = -1, n;
  for (; ++t < e.length; )
    Ci(e[t]), e[t] && (n = n === void 0 ? e[t] : n + "/" + e[t]);
  return n === void 0 ? "." : gA(n);
}
function gA(e) {
  Ci(e);
  const t = e.codePointAt(0) === 47;
  let n = yA(e, !t);
  return n.length === 0 && !t && (n = "."), n.length > 0 && e.codePointAt(e.length - 1) === 47 && (n += "/"), t ? "/" + n : n;
}
function yA(e, t) {
  let n = "", r = 0, i = -1, o = 0, s = -1, l, c;
  for (; ++s <= e.length; ) {
    if (s < e.length)
      l = e.codePointAt(s);
    else {
      if (l === 47)
        break;
      l = 47;
    }
    if (l === 47) {
      if (!(i === s - 1 || o === 1)) if (i !== s - 1 && o === 2) {
        if (n.length < 2 || r !== 2 || n.codePointAt(n.length - 1) !== 46 || n.codePointAt(n.length - 2) !== 46) {
          if (n.length > 2) {
            if (c = n.lastIndexOf("/"), c !== n.length - 1) {
              c < 0 ? (n = "", r = 0) : (n = n.slice(0, c), r = n.length - 1 - n.lastIndexOf("/")), i = s, o = 0;
              continue;
            }
          } else if (n.length > 0) {
            n = "", r = 0, i = s, o = 0;
            continue;
          }
        }
        t && (n = n.length > 0 ? n + "/.." : "..", r = 2);
      } else
        n.length > 0 ? n += "/" + e.slice(i + 1, s) : n = e.slice(i + 1, s), r = s - i - 1;
      i = s, o = 0;
    } else l === 46 && o > -1 ? o++ : o = -1;
  }
  return n;
}
function Ci(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const TA = { cwd: SA };
function SA() {
  return "/";
}
function ka(e) {
  return !!(e !== null && typeof e == "object" && "href" in e && e.href && "protocol" in e && e.protocol && // @ts-expect-error: indexing is fine.
  e.auth === void 0);
}
function IA(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!ka(e)) {
    const t = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw t.code = "ERR_INVALID_ARG_TYPE", t;
  }
  if (e.protocol !== "file:") {
    const t = new TypeError("The URL must be of scheme file");
    throw t.code = "ERR_INVALID_URL_SCHEME", t;
  }
  return AA(e);
}
function AA(e) {
  if (e.hostname !== "") {
    const r = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw r.code = "ERR_INVALID_FILE_URL_HOST", r;
  }
  const t = e.pathname;
  let n = -1;
  for (; ++n < t.length; )
    if (t.codePointAt(n) === 37 && t.codePointAt(n + 1) === 50) {
      const r = t.codePointAt(n + 2);
      if (r === 70 || r === 102) {
        const i = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw i.code = "ERR_INVALID_FILE_URL_PATH", i;
      }
    }
  return decodeURIComponent(t);
}
const ea = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class xp {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(t) {
    let n;
    t ? ka(t) ? n = { path: t } : typeof t == "string" || bA(t) ? n = { value: t } : n = t : n = {}, this.cwd = "cwd" in n ? "" : TA.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let r = -1;
    for (; ++r < ea.length; ) {
      const o = ea[r];
      o in n && n[o] !== void 0 && n[o] !== null && (this[o] = o === "history" ? [...n[o]] : n[o]);
    }
    let i;
    for (i in n)
      ea.includes(i) || (this[i] = n[i]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? cn.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(t) {
    na(t, "basename"), ta(t, "basename"), this.path = cn.join(this.dirname || "", t);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? cn.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(t) {
    Oc(this.basename, "dirname"), this.path = cn.join(t || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? cn.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(t) {
    if (ta(t, "extname"), Oc(this.dirname, "extname"), t) {
      if (t.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (t.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = cn.join(this.dirname, this.stem + (t || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(t) {
    ka(t) && (t = IA(t)), na(t, "path"), this.path !== t && this.history.push(t);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? cn.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(t) {
    na(t, "stem"), ta(t, "stem"), this.path = cn.join(this.dirname || "", t + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(t, n, r) {
    const i = this.message(t, n, r);
    throw i.fatal = !0, i;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(t, n, r) {
    const i = this.message(t, n, r);
    return i.fatal = void 0, i;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(t, n, r) {
    const i = new yt(
      // @ts-expect-error: the overloads are fine.
      t,
      n,
      r
    );
    return this.path && (i.name = this.path + ":" + i.name, i.file = this.path), i.fatal = !1, this.messages.push(i), i;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(t) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(t || void 0).decode(this.value);
  }
}
function ta(e, t) {
  if (e && e.includes(cn.sep))
    throw new Error(
      "`" + t + "` cannot be a path: did not expect `" + cn.sep + "`"
    );
}
function na(e, t) {
  if (!e)
    throw new Error("`" + t + "` cannot be empty");
}
function Oc(e, t) {
  if (!e)
    throw new Error("Setting `" + t + "` requires `path` to be set too");
}
function bA(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const RA = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  function(e) {
    const r = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      this.constructor.prototype
    ), i = r[e], o = function() {
      return i.apply(o, arguments);
    };
    return Object.setPrototypeOf(o, r), o;
  }
), OA = {}.hasOwnProperty;
class ys extends RA {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = hA();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const t = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new ys()
    );
    let n = -1;
    for (; ++n < this.attachers.length; ) {
      const r = this.attachers[n];
      t.use(...r);
    }
    return t.data(Zo(!0, {}, this.namespace)), t;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(t, n) {
    return typeof t == "string" ? arguments.length === 2 ? (oa("data", this.frozen), this.namespace[t] = n, this) : OA.call(this.namespace, t) && this.namespace[t] || void 0 : t ? (oa("data", this.frozen), this.namespace = t, this) : this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen)
      return this;
    const t = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    for (; ++this.freezeIndex < this.attachers.length; ) {
      const [n, ...r] = this.attachers[this.freezeIndex];
      if (r[0] === !1)
        continue;
      r[0] === !0 && (r[0] = void 0);
      const i = n.call(t, ...r);
      typeof i == "function" && this.transformers.use(i);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(t) {
    this.freeze();
    const n = Pi(t), r = this.parser || this.Parser;
    return ra("parse", r), r(String(n), n);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(t, n) {
    const r = this;
    return this.freeze(), ra("process", this.parser || this.Parser), ia("process", this.compiler || this.Compiler), n ? i(void 0, n) : new Promise(i);
    function i(o, s) {
      const l = Pi(t), c = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        r.parse(l)
      );
      r.run(c, l, function(p, d, f) {
        if (p || !d || !f)
          return u(p);
        const h = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          d
        ), g = r.stringify(h, f);
        _A(g) ? f.value = g : f.result = g, u(
          p,
          /** @type {VFileWithOutput<CompileResult>} */
          f
        );
      });
      function u(p, d) {
        p || !d ? s(p) : o ? o(d) : n(void 0, d);
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(t) {
    let n = !1, r;
    return this.freeze(), ra("processSync", this.parser || this.Parser), ia("processSync", this.compiler || this.Compiler), this.process(t, i), Dc("processSync", "process", n), r;
    function i(o, s) {
      n = !0, yc(o), r = s;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(t, n, r) {
    vc(t), this.freeze();
    const i = this.transformers;
    return !r && typeof n == "function" && (r = n, n = void 0), r ? o(void 0, r) : new Promise(o);
    function o(s, l) {
      const c = Pi(n);
      i.run(t, c, u);
      function u(p, d, f) {
        const h = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          d || t
        );
        p ? l(p) : s ? s(h) : r(void 0, h, f);
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(t, n) {
    let r = !1, i;
    return this.run(t, n, o), Dc("runSync", "run", r), i;
    function o(s, l) {
      yc(s), i = l, r = !0;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(t, n) {
    this.freeze();
    const r = Pi(n), i = this.compiler || this.Compiler;
    return ia("stringify", i), vc(t), i(t, r);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(t, ...n) {
    const r = this.attachers, i = this.namespace;
    if (oa("use", this.frozen), t != null) if (typeof t == "function")
      c(t, n);
    else if (typeof t == "object")
      Array.isArray(t) ? l(t) : s(t);
    else
      throw new TypeError("Expected usable value, not `" + t + "`");
    return this;
    function o(u) {
      if (typeof u == "function")
        c(u, []);
      else if (typeof u == "object")
        if (Array.isArray(u)) {
          const [p, ...d] = (
            /** @type {PluginTuple<Array<unknown>>} */
            u
          );
          c(p, d);
        } else
          s(u);
      else
        throw new TypeError("Expected usable value, not `" + u + "`");
    }
    function s(u) {
      if (!("plugins" in u) && !("settings" in u))
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      l(u.plugins), u.settings && (i.settings = Zo(!0, i.settings, u.settings));
    }
    function l(u) {
      let p = -1;
      if (u != null) if (Array.isArray(u))
        for (; ++p < u.length; ) {
          const d = u[p];
          o(d);
        }
      else
        throw new TypeError("Expected a list of plugins, not `" + u + "`");
    }
    function c(u, p) {
      let d = -1, f = -1;
      for (; ++d < r.length; )
        if (r[d][0] === u) {
          f = d;
          break;
        }
      if (f === -1)
        r.push([u, ...p]);
      else if (p.length > 0) {
        let [h, ...g] = p;
        const C = r[f][1];
        La(C) && La(h) && (h = Zo(!0, C, h)), r[f] = [u, h, ...g];
      }
    }
  }
}
const vA = new ys().freeze();
function ra(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `parser`");
}
function ia(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `compiler`");
}
function oa(e, t) {
  if (t)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function vc(e) {
  if (!La(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function Dc(e, t, n) {
  if (!n)
    throw new Error(
      "`" + e + "` finished async. Use `" + t + "` instead"
    );
}
function Pi(e) {
  return DA(e) ? e : new xp(e);
}
function DA(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function _A(e) {
  return typeof e == "string" || NA(e);
}
function NA(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const wA = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", _c = [], Nc = { allowDangerousHtml: !0 }, PA = /^(https?|ircs?|mailto|xmpp)$/i, jA = [
  { from: "astPlugins", id: "remove-buggy-html-in-markdown-parser" },
  { from: "allowDangerousHtml", id: "remove-buggy-html-in-markdown-parser" },
  {
    from: "allowNode",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowElement"
  },
  {
    from: "allowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowedElements"
  },
  {
    from: "disallowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "disallowedElements"
  },
  { from: "escapeHtml", id: "remove-buggy-html-in-markdown-parser" },
  { from: "includeElementIndex", id: "#remove-includeelementindex" },
  {
    from: "includeNodeIndex",
    id: "change-includenodeindex-to-includeelementindex"
  },
  { from: "linkTarget", id: "remove-linktarget" },
  { from: "plugins", id: "change-plugins-to-remarkplugins", to: "remarkPlugins" },
  { from: "rawSourcePos", id: "#remove-rawsourcepos" },
  { from: "renderers", id: "change-renderers-to-components", to: "components" },
  { from: "source", id: "change-source-to-children", to: "children" },
  { from: "sourcePos", id: "#remove-sourcepos" },
  { from: "transformImageUri", id: "#add-urltransform", to: "urlTransform" },
  { from: "transformLinkUri", id: "#add-urltransform", to: "urlTransform" }
];
function LA(e) {
  const t = e.allowedElements, n = e.allowElement, r = e.children || "", i = e.className, o = e.components, s = e.disallowedElements, l = e.rehypePlugins || _c, c = e.remarkPlugins || _c, u = e.remarkRehypeOptions ? { ...e.remarkRehypeOptions, ...Nc } : Nc, p = e.skipHtml, d = e.unwrapDisallowed, f = e.urlTransform || kA, h = vA().use(EI).use(c).use(dA, u).use(l), g = new xp();
  typeof r == "string" && (g.value = r);
  for (const A of jA)
    Object.hasOwn(e, A.from) && ("" + A.from + (A.to ? "use `" + A.to + "` instead" : "remove it") + wA + A.id, void 0);
  const C = h.parse(g);
  let T = h.runSync(C, g);
  return i && (T = {
    type: "element",
    tagName: "div",
    properties: { className: i },
    // Assume no doctypes.
    children: (
      /** @type {Array<ElementContent>} */
      T.type === "root" ? T.children : [T]
    )
  }), mp(T, I), Xy(T, {
    Fragment: a.Fragment,
    // @ts-expect-error
    // React components are allowed to return numbers,
    // but not according to the types in hast-util-to-jsx-runtime
    components: o,
    ignoreInvalidStyle: !0,
    jsx: a.jsx,
    jsxs: a.jsxs,
    passKeys: !0,
    passNode: !0
  });
  function I(A, S, _) {
    if (A.type === "raw" && _ && typeof S == "number")
      return p ? _.children.splice(S, 1) : _.children[S] = { type: "text", value: A.value }, S;
    if (A.type === "element") {
      let v;
      for (v in Jo)
        if (Object.hasOwn(Jo, v) && Object.hasOwn(A.properties, v)) {
          const O = A.properties[v], j = Jo[v];
          (j === null || j.includes(A.tagName)) && (A.properties[v] = f(String(O || ""), v, A));
        }
    }
    if (A.type === "element") {
      let v = t ? !t.includes(A.tagName) : s ? s.includes(A.tagName) : !1;
      if (!v && n && typeof S == "number" && (v = !n(A, S, _)), v && _ && typeof S == "number")
        return d && A.children ? _.children.splice(S, 1, ...A.children) : _.children.splice(S, 1), S;
    }
  }
}
function kA(e) {
  const t = e.indexOf(":"), n = e.indexOf("?"), r = e.indexOf("#"), i = e.indexOf("/");
  return (
    // If there is no protocol, it’s relative.
    t === -1 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    i !== -1 && t > i || n !== -1 && t > n || r !== -1 && t > r || // It is a protocol, it should be allowed.
    PA.test(e.slice(0, t)) ? e : ""
  );
}
const MA = /appendix\s*\d*\s*:?\s*concept\s*set\s*definitions/i, wc = 18, Pc = 14, VA = 18, UA = 16, FA = 1e6, jc = /* @__PURE__ */ new Map(), BA = (e) => /<\/?[a-z][\w:-]*(?:\s[^<>]*)?>/i.test(e), $A = (e) => e ? e.replace(/^\uFEFF/, "").replace(/\u200B/g, "").replace(/\\r\\n/g, `
`).replace(/\\n/g, `
`).replace(/\\r/g, `
`).replace(/\r\n/g, `
`).replace(/\r/g, `
`).trim() : "", xt = (e) => typeof e == "number" ? String(e) : typeof e == "string" && e.trim().length > 0 ? e.trim() : "-", ji = (e) => e ? "YES" : "NO", Li = (e) => !!e, GA = (e) => Array.isArray(e) ? e : e && typeof e == "object" ? Object.values(e) : [], zA = (e) => e.map((t) => {
  var n, r, i, o, s, l, c, u, p, d, f, h, g;
  return {
    conceptId: xt((n = t == null ? void 0 : t.concept) == null ? void 0 : n.CONCEPT_ID),
    conceptCode: xt((r = t == null ? void 0 : t.concept) == null ? void 0 : r.CONCEPT_CODE),
    conceptName: xt((i = t == null ? void 0 : t.concept) == null ? void 0 : i.CONCEPT_NAME),
    standardConcept: xt(
      ((o = t == null ? void 0 : t.concept) == null ? void 0 : o.STANDARD_CONCEPT_CAPTION) ?? ((s = t == null ? void 0 : t.concept) == null ? void 0 : s.STANDARD_CONCEPT)
    ),
    standardConceptCode: xt((l = t == null ? void 0 : t.concept) == null ? void 0 : l.STANDARD_CONCEPT),
    conceptClass: xt((c = t == null ? void 0 : t.concept) == null ? void 0 : c.CONCEPT_CLASS_ID),
    domain: xt((u = t == null ? void 0 : t.concept) == null ? void 0 : u.DOMAIN_ID),
    vocabulary: xt((p = t == null ? void 0 : t.concept) == null ? void 0 : p.VOCABULARY_ID),
    recordCount: ((d = t == null ? void 0 : t.concept) == null ? void 0 : d.RECORD_COUNT) ?? "-",
    descendantRecordCount: ((f = t == null ? void 0 : t.concept) == null ? void 0 : f.DESCENDANT_RECORD_COUNT) ?? "-",
    personCount: ((h = t == null ? void 0 : t.concept) == null ? void 0 : h.PERSON_COUNT) ?? "-",
    descendantPersonCount: ((g = t == null ? void 0 : t.concept) == null ? void 0 : g.DESCENDANT_PERSON_COUNT) ?? "-",
    excluded: Li((t == null ? void 0 : t.excluded) ?? (t == null ? void 0 : t.isExcluded)),
    descendants: Li((t == null ? void 0 : t.includeDescendants) ?? (t == null ? void 0 : t.descendants)),
    mapped: Li((t == null ? void 0 : t.includeMapped) ?? (t == null ? void 0 : t.mapped)),
    hierarchy: Li(t == null ? void 0 : t.hierarchy)
  };
}), WA = (e) => zA(GA(e)), YA = (e) => ({
  conceptId: xt(e == null ? void 0 : e.CONCEPT_ID),
  conceptCode: xt(e == null ? void 0 : e.CONCEPT_CODE),
  conceptName: xt(e == null ? void 0 : e.CONCEPT_NAME),
  standardConcept: xt(
    (e == null ? void 0 : e.STANDARD_CONCEPT_CAPTION) ?? (e == null ? void 0 : e.STANDARD_CONCEPT)
  ),
  standardConceptCode: xt(e == null ? void 0 : e.STANDARD_CONCEPT),
  conceptClass: xt(e == null ? void 0 : e.CONCEPT_CLASS_ID),
  domain: xt(e == null ? void 0 : e.DOMAIN_ID),
  vocabulary: xt(e == null ? void 0 : e.VOCABULARY_ID),
  recordCount: (e == null ? void 0 : e.RECORD_COUNT) ?? "-",
  descendantRecordCount: (e == null ? void 0 : e.DESCENDANT_RECORD_COUNT) ?? "-",
  personCount: (e == null ? void 0 : e.PERSON_COUNT) ?? "-",
  descendantPersonCount: (e == null ? void 0 : e.DESCENDANT_PERSON_COUNT) ?? "-",
  excluded: !1,
  descendants: !1,
  mapped: !1,
  hierarchy: !1
}), HA = (e) => (Array.isArray(e) ? e : (e == null ? void 0 : e.content) || []).map(YA), Cp = (e) => String(
  e.uuid || e.id || e.currentVersionId || e.versionId || ""
), qA = (e) => {
  const t = e.expression || {};
  return [
    Cp(e),
    JSON.stringify((t == null ? void 0 : t.items) || [])
  ].join(":");
}, Ma = (e, t) => {
  if (!e.requestId)
    return Promise.resolve([]);
  const n = `${e.cacheKey}:${t}`, r = jc.get(n);
  if (r)
    return r;
  const i = Se.post(
    `/conceptset/${e.requestId}/${t}/list?size=${FA}&page=0&sort=`,
    { delta: [] }
  ).then(
    (o) => HA((o == null ? void 0 : o.data) ?? o)
  ).catch(() => []);
  return jc.set(n, i), i;
}, gp = [
  {
    header: "Id",
    accessorKey: "conceptId",
    id: "conceptId",
    size: 100,
    enableColumnFilter: !1
  },
  {
    header: "Code",
    accessorKey: "conceptCode",
    id: "conceptCode",
    size: 120,
    enableColumnFilter: !1,
    sortingFn: "alphanumeric"
  },
  {
    header: "Name",
    accessorKey: "conceptName",
    id: "conceptName",
    size: 220,
    minSize: 140,
    filterFn: (e, t, n) => {
      const r = Array.isArray(n) ? n[0] : n, i = String(r || "").trim().toLowerCase();
      return i ? [
        e.original.conceptId,
        e.original.conceptCode,
        e.original.conceptName
      ].map((o) => String(o || "").toLowerCase()).some((o) => o.includes(i)) : !0;
    },
    meta: {
      filterVariant: "value"
    }
  },
  {
    header: "Standard Concept",
    accessorKey: "standardConceptCode",
    id: "standardConcept",
    size: 150,
    filterFn: "arrIncludesSomeEqual",
    cell: ({ renderValue: e, row: t }) => {
      const { color: n, caption: r } = Hs(e());
      return /* @__PURE__ */ a.jsx(
        jh,
        {
          text: t.original.standardConcept || r,
          color: n,
          align: "center",
          minWidth: 92
        }
      );
    },
    meta: {
      renderFilter: (e) => Hs(e).caption
    }
  },
  {
    header: "Class",
    accessorKey: "conceptClass",
    id: "conceptClass",
    size: 120,
    filterFn: "arrIncludesSomeEqual"
  },
  {
    header: "Domain",
    accessorKey: "domain",
    id: "domain",
    size: 120,
    filterFn: "arrIncludesSomeEqual"
  },
  {
    header: "Vocabulary",
    accessorKey: "vocabulary",
    id: "vocabulary",
    size: 140,
    filterFn: "arrIncludesSomeEqual"
  },
  {
    header: "RC",
    accessorKey: "recordCount",
    id: "recordCount",
    size: 80,
    enableColumnFilter: !1
  },
  {
    header: "DRC",
    accessorKey: "descendantRecordCount",
    id: "descendantRecordCount",
    size: 80,
    enableColumnFilter: !1
  },
  {
    header: "PC",
    accessorKey: "personCount",
    id: "personCount",
    size: 80,
    enableColumnFilter: !1
  },
  {
    header: "DPC",
    accessorKey: "descendantPersonCount",
    id: "descendantPersonCount",
    size: 80,
    enableColumnFilter: !1
  }
], XA = [
  ...gp,
  {
    header: "Exclude",
    accessorKey: "excluded",
    id: "excluded",
    size: 110,
    enableSorting: !1,
    enableColumnFilter: !1,
    meta: {
      align: "center",
      headerAlign: "center"
    },
    cell: (e) => /* @__PURE__ */ a.jsx(
      Si,
      {
        ...e,
        value: e.renderValue(),
        align: "center",
        disabled: !0
      }
    )
  },
  {
    header: "Descendants",
    accessorKey: "descendants",
    id: "descendants",
    size: 130,
    enableSorting: !1,
    enableColumnFilter: !1,
    meta: {
      align: "center",
      headerAlign: "center"
    },
    cell: (e) => /* @__PURE__ */ a.jsx(
      Si,
      {
        ...e,
        value: e.renderValue(),
        align: "center",
        disabled: !0
      }
    )
  },
  {
    header: "Mapped",
    accessorKey: "mapped",
    id: "mapped",
    size: 110,
    enableSorting: !1,
    enableColumnFilter: !1,
    meta: {
      align: "center",
      headerAlign: "center"
    },
    cell: (e) => /* @__PURE__ */ a.jsx(
      Si,
      {
        ...e,
        value: e.renderValue(),
        align: "center",
        disabled: !0
      }
    )
  },
  {
    header: "Hierarchy",
    accessorKey: "hierarchy",
    id: "hierarchy",
    size: 120,
    enableSorting: !1,
    enableColumnFilter: !1,
    meta: {
      align: "center",
      headerAlign: "center"
    },
    cell: (e) => /* @__PURE__ */ a.jsx(
      Si,
      {
        ...e,
        value: e.renderValue(),
        align: "center",
        disabled: !0
      }
    )
  }
], JA = gp, Fi = (e, t) => {
  const n = "Id	Code	Name	Standard Concept	Class	Domain	Vocabulary	RC	DRC	PC	DPC	Exclude	Descendants	Mapped	Hierarchy";
  return t.length ? [
    e,
    n,
    ...t.map(
      (r) => [
        r.conceptId,
        r.conceptCode,
        r.conceptName,
        r.standardConcept,
        r.conceptClass,
        r.domain,
        r.vocabulary,
        r.recordCount,
        r.descendantRecordCount,
        r.personCount,
        r.descendantPersonCount,
        ji(r.excluded),
        ji(r.descendants),
        ji(r.mapped),
        ji(r.hierarchy)
      ].join("	")
    )
  ].join(`
`) : `${e}
[no concepts]`;
}, KA = async (e) => e.length ? ["Concept Set Definitions", ...await Promise.all(
  e.map(async (n, r) => {
    const [i, o] = await Promise.all([
      Ma(n, tr.INCLUDED_CONCEPTS),
      Ma(n, tr.INCLUDED_SOURCE_CODES)
    ]);
    return [
      `${r + 1}. ${n.name}`,
      Fi("Expression", n.expressionRows),
      Fi("Included concepts", i),
      Fi("Included source codes", o)
    ].join(`

`);
  })
)].join(`

`) : "", QA = (e, t, n) => {
  const r = t === "expression" ? "Expression" : t === "source" ? "Included source codes" : "Included concepts";
  return [`${e.name}`, Fi(r, n)].join(`

`);
}, yp = async (e) => {
  var t;
  if (!e)
    return !1;
  try {
    if ((t = navigator == null ? void 0 : navigator.clipboard) != null && t.writeText)
      return await navigator.clipboard.writeText(e), !0;
  } catch {
    return Lc(e);
  }
  return Lc(e);
}, ZA = ({ conceptSet: e }) => {
  const { enqueueSnackbar: t } = Nn(), [n, r] = J("included"), [i, o] = J([]), [s, l] = J([]), [c, u] = J(ce.INITIAL), [p, d] = J(ce.INITIAL), f = ie(
    async (A) => {
      const S = A === tr.INCLUDED_CONCEPTS ? o : l, _ = A === tr.INCLUDED_CONCEPTS ? u : d;
      _(ce.IN_PROGRESS);
      try {
        const v = await Ma(e, A);
        S(v), _(ce.SUCCESS);
      } catch {
        S([]), _(ce.ERROR);
      }
    },
    [e]
  );
  Q(() => {
    o([]), l([]), f(tr.INCLUDED_CONCEPTS), f(tr.INCLUDED_SOURCE_CODES);
  }, [f]);
  const h = n === "expression" ? e.expressionRows : n === "source" ? s : i, g = n === "source" ? p : n === "included" ? c : ce.SUCCESS, C = n === "expression" ? XA : JA, T = ee(
    () => [
      {
        value: "expression",
        title: "Expression",
        onTabClick: r
      },
      {
        value: "included",
        title: /* @__PURE__ */ a.jsx(
          $t,
          {
            title: "Included concepts",
            count: i.length,
            status: c,
            dense: !0
          }
        ),
        onTabClick: r
      },
      {
        value: "source",
        title: /* @__PURE__ */ a.jsx(
          $t,
          {
            title: "Included source codes",
            count: s.length,
            status: p,
            dense: !0
          }
        ),
        onTabClick: r
      }
    ],
    [i.length, c, s.length, p]
  ), I = ie(async () => {
    const A = await yp(
      QA(e, n, h)
    );
    t({
      message: A ? "Concept set table copied to clipboard." : "Unable to copy table text.",
      variant: A ? "success" : "error"
    });
  }, [h, n, e, t]);
  return /* @__PURE__ */ a.jsxs(
    Y,
    {
      sx: {
        border: "1px solid #d8dee9",
        borderRadius: 0.5,
        overflow: "hidden"
      },
      children: [
        /* @__PURE__ */ a.jsxs(
          Y,
          {
            sx: {
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              bgcolor: "#fff",
              px: 1
            },
            children: [
              /* @__PURE__ */ a.jsx(Xc, { tabs: T, active: n, secondary: !0 }),
              /* @__PURE__ */ a.jsx(Xe, { text: "Copy active table", placement: "left", children: /* @__PURE__ */ a.jsx(
                "button",
                {
                  type: "button",
                  "aria-label": "Copy active table",
                  onClick: I,
                  style: {
                    width: 32,
                    height: 32,
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "1px solid #D8DEE9",
                    borderRadius: 5,
                    background: "#FFFFFF",
                    color: "#1F2A44",
                    cursor: "pointer"
                  },
                  children: /* @__PURE__ */ a.jsx(
                    ge,
                    {
                      iconName: "copy",
                      iconStatus: void 0,
                      ref: void 0,
                      sx: { fontSize: 16, color: "#1F2A44" }
                    }
                  )
                }
              ) })
            ]
          }
        ),
        /* @__PURE__ */ a.jsx(Fa, {}),
        /* @__PURE__ */ a.jsx(
          Y,
          {
            sx: {
              px: 1.5,
              py: 1.25,
              bgcolor: "#f8fafc",
              borderBottom: "1px solid #d8dee9",
              fontSize: 13,
              lineHeight: "18px"
            },
            children: "Concept Set Expression is a formula that allows large concept lists to be presented more compactly with Exclude, Descendants, Mapped and Hierarchy options."
          }
        ),
        /* @__PURE__ */ a.jsx(
          Y,
          {
            sx: {
              p: 1,
              "& .divTable": { fontSize: "13px" },
              "& .td": { height: "34px", fontSize: "13px", padding: "0 10px" },
              "& .th": { height: "28px", fontSize: "12px", padding: "0 10px" },
              "& .table-pagination__container": { pt: 0.5 }
            },
            children: /* @__PURE__ */ a.jsx(
              Ph,
              {
                variant: "uncontrolled",
                columns: C,
                data: h,
                enableFiltering: !0,
                showFilterToggle: !0,
                filtersDefaultClosed: !0,
                loading: g === ce.IN_PROGRESS,
                noDataText: "No concepts available.",
                resetPaginationKey: `${e.cacheKey}-${n}`
              }
            )
          }
        )
      ]
    }
  );
}, eb = (e, t) => `${t + 1}. ${e.name}`, tb = (e, t) => {
  const n = e || {}, r = n.expression || {}, i = Cp(n);
  return {
    id: String(
      (e == null ? void 0 : e.id) ?? (e == null ? void 0 : e.uuid) ?? `${e == null ? void 0 : e.name}-${t}`
    ),
    requestId: i,
    cacheKey: qA(n),
    name: (e == null ? void 0 : e.name) || `Concept set ${t + 1}`,
    expressionRows: WA(r == null ? void 0 : r.items)
  };
}, Lc = (e) => {
  if (!e)
    return !1;
  const t = document.createElement("textarea");
  t.value = e, t.style.position = "fixed", t.style.left = "-9999px", document.body.appendChild(t), t.focus(), t.select();
  let n = !1;
  try {
    n = document.execCommand("copy");
  } catch {
    n = !1;
  }
  return document.body.removeChild(t), n;
}, nb = ({
  definition: e,
  printFriendlyExpression: t = ""
}) => {
  var d, f;
  const { enqueueSnackbar: n } = Nn(), r = Ae(null), i = (d = e == null ? void 0 : e.name) == null ? void 0 : d.trim(), o = ee(
    () => $A(t),
    [t]
  ), s = ee(
    () => {
      var h;
      return ((h = e == null ? void 0 : e.expression) == null ? void 0 : h.ConceptSets) || [];
    },
    [(f = e == null ? void 0 : e.expression) == null ? void 0 : f.ConceptSets]
  ), l = ee(
    () => MA.test(o),
    [o]
  ), c = s.length > 0 && !l, u = ee(
    () => c ? s.map(tb) : [],
    [s, c]
  ), p = ie(async () => {
    var A;
    const h = r.current, g = ((A = h == null ? void 0 : h.innerText) == null ? void 0 : A.trim()) || "", C = await KA(u), T = [i, g, C].filter(Boolean).join(`

`).trim();
    if (!T) {
      n({
        message: "Nothing to copy.",
        variant: "warning"
      });
      return;
    }
    if (await yp(T)) {
      n({
        message: "Text copied to clipboard.",
        variant: "success"
      });
      return;
    }
    n({
      message: "Unable to copy text. Please copy manually.",
      variant: "error"
    });
  }, [i, u, n]);
  return /* @__PURE__ */ a.jsx(Y, { sx: { pr: 0 }, children: /* @__PURE__ */ a.jsxs(
    Y,
    {
      sx: {
        backgroundColor: "#fff",
        border: "1px solid #d8dee9",
        borderRadius: 1,
        color: "textColor.primary"
      },
      children: [
        i && /* @__PURE__ */ a.jsxs(
          Y,
          {
            sx: {
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              px: 2.5,
              pt: 1.5,
              pb: 1
            },
            children: [
              /* @__PURE__ */ a.jsx(
                fe,
                {
                  component: "h1",
                  variant: "h1",
                  sx: {
                    fontSize: wc,
                    fontWeight: 700,
                    lineHeight: "22px",
                    m: 0
                  },
                  children: i
                }
              ),
              /* @__PURE__ */ a.jsx(Xe, { text: "Copy text", placement: "left", children: /* @__PURE__ */ a.jsx(
                "button",
                {
                  type: "button",
                  "aria-label": "Copy text",
                  onClick: p,
                  style: {
                    width: 38,
                    height: 38,
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "1px solid #D8DEE9",
                    borderRadius: 6,
                    background: "#FFFFFF",
                    color: "#1F2A44",
                    cursor: "pointer",
                    boxShadow: "0 1px 2px rgba(31, 42, 68, 0.08)"
                  },
                  children: /* @__PURE__ */ a.jsx(
                    ge,
                    {
                      iconName: "copy",
                      iconStatus: void 0,
                      ref: void 0,
                      sx: { fontSize: 18, color: "#1F2A44" }
                    }
                  )
                }
              ) })
            ]
          }
        ),
        /* @__PURE__ */ a.jsx(
          Y,
          {
            sx: {
              borderBottom: "1px solid #e8edf5"
            }
          }
        ),
        /* @__PURE__ */ a.jsx(
          Y,
          {
            ref: r,
            sx: {
              px: 2.5,
              pt: 2,
              pb: 0,
              overflowX: "auto",
              fontSize: Pc,
              "& h1": {
                fontSize: wc,
                lineHeight: "22px",
                margin: "0 0 16px 0"
              },
              "& h2": { fontSize: 19, lineHeight: 1.32, margin: "24px 0 12px 0" },
              "& h3": { fontSize: 16, lineHeight: 1.35, margin: "18px 0 8px 0" },
              "& h1:first-of-type, & h2:first-of-type, & h3:first-of-type": {
                marginTop: 0
              },
              "& p": { margin: "8px 0", lineHeight: 1.5 },
              "& ol, & ul": { margin: "8px 0 8px 20px", padding: 0 },
              "& li": { marginBottom: "6px", lineHeight: 1.45 },
              "& table": {
                width: "100%",
                borderCollapse: "collapse",
                marginTop: 8,
                marginBottom: 16,
                fontSize: 14
              },
              "& th, & td": {
                border: "1px solid #d8dee9",
                padding: "8px 10px",
                textAlign: "left",
                verticalAlign: "top"
              },
              "& th": {
                backgroundColor: "#f5f7fb",
                fontWeight: 700
              },
              "& a": {
                color: "#1976d2",
                textDecoration: "underline"
              }
            },
            children: o ? BA(o) ? /* @__PURE__ */ a.jsx(
              Y,
              {
                dangerouslySetInnerHTML: {
                  __html: o
                }
              }
            ) : /* @__PURE__ */ a.jsx(
              LA,
              {
                components: {
                  a: ({ node: h, ...g }) => /* @__PURE__ */ a.jsx("a", { ...g, target: "_blank", rel: "noreferrer" })
                },
                children: o
              }
            ) : /* @__PURE__ */ a.jsx(
              fe,
              {
                variant: "body2",
                color: "textColor.secondary",
                sx: {
                  fontSize: Pc,
                  lineHeight: "20px",
                  m: 0
                },
                children: "Text view is not available for this cohort yet."
              }
            )
          }
        ),
        c && /* @__PURE__ */ a.jsx(Y, { sx: { px: 2.5, pb: 3 }, children: /* @__PURE__ */ a.jsxs(Y, { sx: { mt: 3 }, children: [
          /* @__PURE__ */ a.jsx(
            fe,
            {
              component: "h2",
              variant: "h2",
              sx: {
                mb: 2,
                fontSize: VA,
                lineHeight: 1.3,
                fontWeight: 700
              },
              children: "Concept Set Definitions"
            }
          ),
          u.map((h, g) => {
            const C = g === u.length - 1;
            return /* @__PURE__ */ a.jsxs(
              Y,
              {
                sx: { mb: C ? 0 : 2.5 },
                children: [
                  /* @__PURE__ */ a.jsxs(
                    fe,
                    {
                      variant: "h4",
                      sx: {
                        mt: 1,
                        mb: 1,
                        fontSize: UA,
                        lineHeight: 1.35,
                        fontWeight: 600
                      },
                      children: [
                        eb(h, g),
                        h.expressionRows.length ? "" : " - [no concepts]"
                      ]
                    }
                  ),
                  /* @__PURE__ */ a.jsx(ZA, { conceptSet: h })
                ]
              },
              h.id
            );
          })
        ] }) })
      ]
    }
  ) });
}, rb = [
  { id: "builder", label: "Design" },
  { id: "visual", label: "Visual" },
  { id: "text", label: "Text" }
], ib = ({ tab: e, active: t }) => {
  const n = t ? "#1F2A44" : "#4F4F4F", r = {
    width: 18,
    height: 18,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: { display: "block", flexShrink: 0 }
  };
  return e === "builder" ? /* @__PURE__ */ a.jsxs("svg", { ...r, "aria-hidden": "true", children: [
    /* @__PURE__ */ a.jsx(
      "rect",
      {
        x: "4",
        y: "4.5",
        width: "14",
        height: "3",
        rx: "0.7",
        stroke: n,
        strokeWidth: "2"
      }
    ),
    /* @__PURE__ */ a.jsx(
      "rect",
      {
        x: "4",
        y: "11",
        width: "5",
        height: "5",
        rx: "0.7",
        stroke: n,
        strokeWidth: "2"
      }
    ),
    /* @__PURE__ */ a.jsx(
      "path",
      {
        d: "M12 11.7H17.8M12 15.4H16",
        stroke: n,
        strokeWidth: "2",
        strokeLinecap: "round"
      }
    )
  ] }) : e === "visual" ? /* @__PURE__ */ a.jsxs("svg", { ...r, "aria-hidden": "true", children: [
    /* @__PURE__ */ a.jsx(
      "path",
      {
        d: "M11 6.4V10.2M7.4 15L10 12M14.6 15L12 12",
        stroke: n,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ a.jsx("circle", { cx: "11", cy: "5", r: "1.8", stroke: n, strokeWidth: "2" }),
    /* @__PURE__ */ a.jsx("circle", { cx: "6.2", cy: "16.2", r: "1.8", stroke: n, strokeWidth: "2" }),
    /* @__PURE__ */ a.jsx("circle", { cx: "15.8", cy: "16.2", r: "1.8", stroke: n, strokeWidth: "2" })
  ] }) : /* @__PURE__ */ a.jsxs("svg", { ...r, "aria-hidden": "true", children: [
    /* @__PURE__ */ a.jsx(
      "path",
      {
        d: "M8.2 6.7L4.5 11L8.2 15.3",
        stroke: n,
        strokeWidth: "2.2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ a.jsx(
      "path",
      {
        d: "M13.8 6.7L17.5 11L13.8 15.3",
        stroke: n,
        strokeWidth: "2.2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ a.jsx(
      "path",
      {
        d: "M12.7 5.5L9.3 16.5",
        stroke: n,
        strokeWidth: "2.2",
        strokeLinecap: "round"
      }
    )
  ] });
}, Xr = (e) => typeof e == "object" && e !== null, kc = (e) => e || {}, Mc = (e) => typeof e == "string" ? e : void 0, ob = (e) => typeof e == "string" && /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(
  e.trim()
), Hn = (e) => {
  if (typeof e == "string") {
    const t = e.trim();
    return t.length > 0 ? t : null;
  }
  return typeof e == "number" ? String(e) : null;
}, Vn = (e) => [
  e == null ? void 0 : e.id,
  e == null ? void 0 : e.uuid,
  e == null ? void 0 : e.referenceId,
  e == null ? void 0 : e.externalId
].map(Hn).filter(Boolean), ab = (e) => {
  const t = /* @__PURE__ */ new Set(), n = (r) => {
    if (!(!r || typeof r != "object")) {
      if (Array.isArray(r)) {
        r.forEach(n);
        return;
      }
      Object.entries(r).forEach(
        ([i, o]) => {
          if (i === "CodesetId" || i === "codesetId" || i === "DrugCodesetId") {
            const s = Hn(o);
            s && s !== "-1" && t.add(s);
            return;
          }
          n(o);
        }
      );
    }
  };
  return n(e), t;
}, sb = (e) => e ? Array.isArray(e) ? e.map((t) => ({
  concept: kc(t == null ? void 0 : t.concept),
  includeDescendants: (t == null ? void 0 : t.includeDescendants) ?? (t == null ? void 0 : t.descendants) ?? !1,
  includeMapped: (t == null ? void 0 : t.includeMapped) ?? (t == null ? void 0 : t.mapped) ?? !1,
  excluded: (t == null ? void 0 : t.excluded) ?? (t == null ? void 0 : t.isExcluded) ?? !1,
  hierarchy: (t == null ? void 0 : t.hierarchy) ?? !1,
  id: Mc(t == null ? void 0 : t.id)
})) : ou(
  e
).map((t) => ({
  concept: kc(t == null ? void 0 : t.concept),
  includeDescendants: (t == null ? void 0 : t.includeDescendants) ?? !1,
  includeMapped: (t == null ? void 0 : t.includeMapped) ?? !1,
  excluded: (t == null ? void 0 : t.isExcluded) ?? !1,
  hierarchy: (t == null ? void 0 : t.hierarchy) ?? !1,
  id: Mc(t == null ? void 0 : t.id)
})) : [], lb = (e) => {
  const t = Xr(e) && Xr(e.data) ? e.data : Xr(e) ? e : {};
  return {
    id: typeof t.id == "string" || typeof t.id == "number" ? t.id : void 0,
    name: typeof t.name == "string" ? t.name : void 0,
    items: t.items
  };
}, cb = (e) => {
  if (!Xr(e))
    return null;
  const t = e.ordinal;
  if (typeof t == "number" || typeof t == "string")
    return t;
  const n = Xr(e.data) ? e.data : {}, r = n.versionOrdinal;
  if (typeof r == "number" || typeof r == "string")
    return r;
  const i = n.version;
  if (typeof i == "number" || typeof i == "string")
    return i;
  const o = e.versionOrdinal;
  if (typeof o == "number" || typeof o == "string")
    return o;
  const s = e.version;
  return typeof s == "number" || typeof s == "string" ? s : null;
}, ub = ({
  subModules: e,
  typeContainer: t,
  parentId: n,
  conceptSetId: r,
  conceptSetModulePath: i,
  onClose: o,
  onConceptSetSaved: s,
  storage: l,
  initStorage: c
}) => {
  const [u, p] = J(!0);
  return Q(() => {
    const d = window.setTimeout(() => {
      p(!1);
    }, 15e3);
    return () => {
      clearTimeout(d);
    };
  }, []), /* @__PURE__ */ a.jsxs(
    Y,
    {
      sx: {
        width: "100%",
        height: "100vh",
        minHeight: "100vh",
        overflow: "hidden",
        borderRadius: 1,
        backgroundColor: "#fff",
        position: "relative"
      },
      children: [
        u && /* @__PURE__ */ a.jsx(
          Y,
          {
            sx: {
              position: "absolute",
              inset: 0,
              zIndex: 2,
              backgroundColor: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            },
            children: /* @__PURE__ */ a.jsx(Ct, { size: 56 })
          }
        ),
        /* @__PURE__ */ a.jsx(
          Y,
          {
            sx: {
              width: "100%",
              height: "100%",
              minHeight: "100%",
              overflow: "auto",
              backgroundColor: "#fff"
            },
            children: /* @__PURE__ */ a.jsx(
              e.concept,
              {
                type: "component",
                name: "concept-set-entity-embedded",
                path: i,
                title: "Concept sets",
                subModules: e,
                storage: l,
                initStorage: c,
                rootSettings: {
                  rootPath: i,
                  rootTitle: "Concept sets"
                },
                config: {
                  typeContainer: t,
                  parentId: n,
                  conceptSetId: r,
                  onCancel: o,
                  saveOnlyActions: !0,
                  onConceptSetEntityReady: () => {
                    p(!1);
                  },
                  onConceptSetEntitySaved: s
                }
              }
            )
          }
        )
      ]
    }
  );
}, Vc = (e = [], t = [], n = !1, r = !1) => {
  if (!(t != null && t.length))
    return e;
  const i = t.reduce((c, u) => {
    const p = Hn(u.externalId);
    return p && (c[p] = u), c;
  }, {}), o = /* @__PURE__ */ new Set(), s = e.map((c) => {
    const u = Hn(c == null ? void 0 : c.id), p = u ? i[u] : void 0, d = c;
    if (!p)
      return c;
    u && o.add(u);
    const f = yl(p, "currentVersionId"), h = f && p.currentVersionId ? p.currentVersionId : d.currentVersionId, g = r && !h ? p.versionId ?? d.versionId : h, C = !!g || d.currentVersionId !== void 0;
    return {
      ...c,
      referenceId: p.id,
      externalId: p.externalId,
      versionId: p.versionId ?? d.versionId,
      versionOrdinal: p.versionOrdinal ?? d.versionOrdinal,
      version: d.version,
      ...C && { currentVersionId: g },
      currentVersionOrdinal: p.currentVersionOrdinal ?? d.currentVersionOrdinal,
      terminated: !r && f ? !g : d.terminated,
      name: c.name || p.name
    };
  });
  if (!n)
    return s;
  const l = t.filter((c) => {
    const u = Hn(c.externalId);
    return u && !o.has(u);
  }).map((c) => {
    const u = yl(c, "currentVersionId"), p = u ? c.currentVersionId : void 0, d = r && !p ? c.versionId : p;
    return {
      id: c.externalId,
      name: c.name || "Archived concept set",
      expression: { items: [] },
      referenceId: c.id,
      externalId: c.externalId,
      versionId: c.versionId,
      versionOrdinal: c.versionOrdinal,
      ...(u || r) && {
        currentVersionId: d
      },
      currentVersionOrdinal: c.currentVersionOrdinal,
      terminated: !r
    };
  });
  return [...s, ...l];
}, aa = (e = []) => nf(
  e.map((t) => {
    const n = t;
    return {
      id: t.id,
      name: t.name,
      uuid: t.uuid,
      expression: t.expression,
      referenceId: n.referenceId,
      externalId: n.externalId,
      versionId: n.versionId,
      currentVersionId: n.currentVersionId,
      version: n.version,
      versionOrdinal: n.versionOrdinal,
      currentVersionOrdinal: n.currentVersionOrdinal,
      terminated: n.terminated
    };
  })
), Uc = (e, t) => JSON.stringify(e) === JSON.stringify(t), Or = Xn({
  conceptSets: [],
  updateConceptSets: () => {
  },
  refreshConceptSetReference: async () => {
  }
}), db = () => {
  var Os, vs, Ds, _s, Ns, ws, Ps;
  const { id: e } = Qc(), t = Lh(), n = au(), [r] = kh(), i = Zh(r.get("typePublish")), o = yr(), { enqueueSnackbar: s } = Nn(), [l, c] = Re.useState(""), [u, p] = J(!1), [d, f] = Re.useState({}), h = !!((Os = t.state) != null && Os.aiGenerateRequested), {
    rootSettings: g,
    path: C,
    title: T,
    config: I,
    subModules: A,
    storage: S,
    initStorage: _
  } = Le(
    Sn
  ), { showDialog: v, hideDialog: O } = Le(Wp), { openModal: j, closeModal: M } = Le(gn), { rootPath: w, rootTitle: L } = g, { parentId: P, parentTitle: k, typeContainer: z, analysisTypes: B } = I, q = z !== he.LIBRARY, N = r.get("from") === he.LIBRARY && !!r.get("typePublish"), ne = ee(() => Tm(z, P), [P]), ue = ee(() => Zr(I.typeContainer, I.parentId), [I.typeContainer, I.parentId]), te = Ba(
    (G) => {
      var se;
      return ((se = G.user.data.moduleIds) == null ? void 0 : se.includes("ai")) ?? !1;
    }
  ), {
    entity: m,
    aiGenerate: W,
    isAiCohort: H,
    summary: y,
    isVersionMode: X,
    status: V,
    aiValues: $,
    error: le,
    definition: b,
    definitionStatus: oe,
    setVersionEntity: re,
    revertEntity: ye,
    deleteEntity: Me,
    copyEntity: ot,
    getCountsSummary: Ue,
    updateDefinition: Ve,
    updateDefinitionBase: Qe,
    saveDefinition: pt,
    clearDefinition: qt,
    setDefinition: de,
    refetchEntity: ae,
    startGeneration: Fe,
    isEqual: vt,
    actions: Ye
  } = TC(ne, e, "Cohort"), { start: Tt, stop: at, status: U } = Yp(), K = uh({
    getMessages: Hf,
    fixEntity: (G) => {
      IC(G, m.expression, Ve);
    },
    fixEntityAvailability: AC
  }), pe = dh(), Ce = ee(() => z === he.LIBRARY ? pe : !!(Ye != null && Ye["update.metadata"] || Ye != null && Ye[Xs.UPDATE]), [Ye, pe, z]), [ve, He] = J(0);
  Q(() => {
    if (!e || e === "new" || z !== he.LIBRARY) {
      He(0);
      return;
    }
    Au(e).then(
      (G) => He(ef(G))
    ).catch(() => He(0));
  }, [e, z]);
  const Pt = ee(() => {
    const se = ($ == null ? void 0 : $.some(tu)) ? 1 : 0;
    return {
      ...y,
      ...z === he.LIBRARY ? { usedIn: ve } : {},
      metadata: (y.metadata || 0) + se,
      "metadata-ai": Math.max(
        (y["metadata-ai"] || 0) - se,
        0
      )
    };
  }, [$, y, z, ve]), Pe = ee(() => m != null && m.terminated ? !0 : z === he.WORKSPACE ? !1 : !(Ye != null && Ye[Xs.UPDATE]), [m == null ? void 0 : m.actions, Ye, z]), hn = !!(Ye["update.name"] || Ye["update.description"]), Xt = z === he.LIBRARY && r.get("from") !== he.LIBRARY, [Ze] = cC(b, 1e3), tn = () => {
    j(
      () => /* @__PURE__ */ a.jsx(
        xh,
        {
          propId: "cohortId",
          onClose: M,
          item: m,
          inviteMethod: qf
        }
      ),
      "Publish cohort",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: M
      }
    );
  }, Dt = (G) => {
    j(
      () => /* @__PURE__ */ a.jsx(
        A.analyses,
        {
          type: "component",
          name: "create-analysis-from-cohort",
          subModules: A,
          config: {
            onCancel: M,
            entity: m,
            analysisType: G.id,
            parentId: P,
            typeContainer: z
          }
        }
      ),
      G.name,
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: M
      }
    );
  }, _o = () => {
    j(
      () => /* @__PURE__ */ a.jsx(
        Ch,
        {
          id: m.id,
          name: b.name,
          parentId: P,
          currentContainer: z,
          subModules: A,
          jsonImportTabName: "JSON",
          createCopyMethod: BC,
          entityAtlas: Va.COHORT,
          typeEntity: "cohorts",
          defaultResolution: ze.CREATE_NEW_OBJECT,
          hideConflictResolutionControls: !0,
          validateName: async (G) => G.typeContainer === he.WORKSPACE ? ur(
            he.WORKSPACE,
            G.name
          ) : G.typeContainer === he.STUDY ? G.studyId ? ur(
            he.STUDY,
            G.name,
            String(G.studyId)
          ) : {
            isValid: !1,
            message: "Study is required."
          } : { isValid: !0 },
          onChange: () => {
            M();
          },
          exportJson: /* @__PURE__ */ a.jsx(bC, { data: b }),
          exportSql: /* @__PURE__ */ a.jsx(
            _C,
            {
              cohortId: m.id,
              cohortName: b.name,
              cohortShortcut: m.shortcut
            }
          )
        }
      ),
      "Export cohort",
      {
        closeOnClickOutside: !0,
        onClose: M
      }
    );
  }, No = () => {
    j(
      () => /* @__PURE__ */ a.jsx(
        A.users,
        {
          type: "component",
          name: "share-entity",
          subModules: A,
          config: {
            ...I,
            entity: m,
            entityType: "Cohort",
            onClose: M,
            onChange: M
          }
        }
      ),
      "Share Cohort",
      {
        closeOnClickOutside: !0,
        onClose: M,
        width: "700px"
      }
    );
  }, wo = () => {
    var se;
    const G = (se = $ == null ? void 0 : $.find(
      (be) => {
        var Oe;
        return ((Oe = be.attribute) == null ? void 0 : Oe.name) == "ai-prompt";
      }
    )) == null ? void 0 : se.value;
    j(
      () => /* @__PURE__ */ a.jsx(
        Cd,
        {
          parentId: I.parentId,
          typeContainer: I.typeContainer,
          entity: m,
          createMethod: ue,
          onCancel: M,
          prompt: G,
          attributes: $ ?? void 0,
          onGenerateStart: () => {
            Fe(), M(), s({
              message: "Cohort regenerate in progress...",
              variant: "success"
            });
          },
          onGenerateError: () => {
            ae();
          },
          afterCreate: async (be) => {
            Tt({
              subjectId: be.id
            }), ae(), await Ue();
          }
        }
      ),
      "Regenerate Cohort",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: M
      }
    );
  }, ct = ie(() => z === he.STUDY ? `study-manager/${P}/concept-sets` : "workspace/concept-sets", [P, z]), ht = ee(
    () => `/${C}/${e}/concept-sets`,
    [e, C]
  ), ft = ee(
    () => [
      "",
      "/",
      "/included",
      "/source-codes",
      "/versions",
      "/meta-attributes",
      "/ai-meta-attributes",
      "/ai-suggested",
      "/usage",
      "/statistics"
    ],
    []
  ), jt = ie(() => {
    p(!1), M(), ae();
  }, [M, ae]);
  Q(() => {
    if (!u)
      return;
    if (!t.pathname.startsWith(
      ht
    )) {
      jt();
      return;
    }
    const Oe = ((t.pathname.slice(ht.length) || "").split("/modal")[0] || "").replace(/\/+$/, "") || "/";
    ft.some(
      (De) => {
        const je = De.replace(/\/+$/, "") || "/";
        return Oe === je;
      }
    ) || jt();
  }, [
    ft,
    jt,
    ht,
    u,
    t.pathname
  ]);
  const mt = ie((G) => {
    f((se) => {
      if (!se[String(G)])
        return se;
      const be = { ...se };
      return delete be[String(G)], be;
    });
  }, []), Et = ie(() => {
    var Be;
    const G = ((Be = b == null ? void 0 : b.expression) == null ? void 0 : Be.ConceptSets) || [], se = /* @__PURE__ */ new Map();
    G.forEach((De, je) => {
      const xe = ((De == null ? void 0 : De.name) || "").trim().toLowerCase();
      if (!xe)
        return;
      const _e = se.get(xe) || [];
      _e.push(je), se.set(xe, _e);
    });
    const be = "A concept set with this name already exists. Please choose a different name.", Oe = {};
    return se.forEach((De) => {
      De.length > 1 && De.forEach((je) => {
        Oe[String(je)] = be;
      });
    }), f((De) => ({ ...De, ...Oe })), Object.keys(Oe).length > 0 ? (s({
      message: "Duplicate concept set names in this cohort. Please make names unique before saving.",
      variant: "error"
    }), !1) : !0;
  }, [(vs = b == null ? void 0 : b.expression) == null ? void 0 : vs.ConceptSets, s]), Ft = ie(
    async (G, se) => {
      var xe;
      const be = "A concept set with this name already exists. Please choose a different name.", Oe = se == null ? void 0 : se.trim();
      return Oe ? (((xe = b == null ? void 0 : b.expression) == null ? void 0 : xe.ConceptSets) || []).some((_e, Ke) => Ke === G ? !1 : ((_e == null ? void 0 : _e.name) || "").trim().toLowerCase() === Oe.toLowerCase()) ? (f((_e) => ({
        ..._e,
        [String(G)]: be
      })), s({
        message: be,
        variant: "error"
      }), !1) : (await Kx(
        z,
        Oe,
        P
      )).isValid ? (mt(G), !0) : (f((_e) => ({
        ..._e,
        [String(G)]: be
      })), s({
        message: be,
        variant: "error"
      }), !1) : !1;
    },
    [
      mt,
      (Ds = b == null ? void 0 : b.expression) == null ? void 0 : Ds.ConceptSets,
      s,
      P,
      z
    ]
  ), In = ie(
    async (G) => {
      if (Object.keys(d).length > 0) {
        s({
          message: "Please resolve concept set name errors before saving.",
          variant: "error"
        });
        return;
      }
      if ((G == null ? void 0 : G.name) !== (m == null ? void 0 : m.name) && z !== he.LIBRARY) {
        const Be = await ur(
          z,
          G.name,
          P,
          m == null ? void 0 : m.id
        );
        if (!Be.isValid) {
          c(Be.message || "");
          return;
        }
      }
      Et() && (c(""), await pt({
        name: G.name,
        description: G.description
      }));
    },
    [
      m == null ? void 0 : m.id,
      m == null ? void 0 : m.name,
      d,
      P,
      pt,
      z,
      Et
    ]
  ), st = ie(
    (G, se, be, Oe, Be, De, je, xe) => Im(
      G,
      se,
      {
        messages: be ? tf(be, ["messagesCnt", "severity", "isLoading"]) : null
      },
      Oe,
      Be,
      t,
      De,
      je,
      xe
    ),
    [e, H]
  ), nn = ee(() => {
    var G;
    return st(
      C,
      e,
      K,
      {
        conceptSets: (G = b == null ? void 0 : b.expression) == null ? void 0 : G.ConceptSets.length,
        ...Pt
      },
      Pe,
      z,
      H,
      N
    );
  }, [
    e,
    K.messagesCnt,
    K.severity,
    K.isLoading,
    b == null ? void 0 : b.expression.ConceptSets,
    Pt,
    C,
    Pe,
    z,
    H,
    N
  ]), [Bt, Jt] = Re.useState("builder"), jn = ee(
    () => ({
      data: b == null ? void 0 : b.expression.EndStrategy,
      update: (G) => Ve("EndStrategy", G),
      clear: () => qt(["EndStrategy"])
    }),
    [(_s = b == null ? void 0 : b.expression) == null ? void 0 : _s.EndStrategy]
  ), Ln = ee(
    () => {
      var G;
      return {
        data: (G = b == null ? void 0 : b.expression) == null ? void 0 : G.CensoringCriteria,
        update: (se) => Ve("CensoringCriteria", se),
        clear: () => Ve("CensoringCriteria", [])
      };
    },
    [(Ns = b == null ? void 0 : b.expression) == null ? void 0 : Ns.CensoringCriteria]
  ), rn = ee(
    () => {
      var G, se;
      return {
        dataAddition: {
          CollapseSettings: (G = b == null ? void 0 : b.expression) == null ? void 0 : G.CollapseSettings,
          CensorWindow: (se = b == null ? void 0 : b.expression) == null ? void 0 : se.CensorWindow
        },
        updateAddition: (be, Oe) => Ve(Oe, be)
      };
    },
    [
      (ws = b == null ? void 0 : b.expression) == null ? void 0 : ws.CensorWindow,
      (Ps = b == null ? void 0 : b.expression) == null ? void 0 : Ps.CollapseSettings
    ]
  ), An = ie(
    async (G) => {
      var se;
      if (!(!(G != null && G.currentVersionId) || !((se = b == null ? void 0 : b.expression) != null && se.ConceptSets)))
        try {
          const be = await Iu(
            G.currentVersionId
          ), Oe = lb(
            be
          ), Be = sb(
            Oe == null ? void 0 : Oe.items
          ), De = b.expression.ConceptSets.map((xe) => String(xe == null ? void 0 : xe.id) !== String(G == null ? void 0 : G.id) ? xe : {
            ...xe,
            name: Oe.name ?? (xe == null ? void 0 : xe.name),
            expression: {
              ...xe == null ? void 0 : xe.expression,
              items: Be
            }
          }), je = ((b == null ? void 0 : b.conceptSetRefs) || []).map(
            (xe) => {
              if (String(xe.externalId) !== String(G == null ? void 0 : G.id))
                return xe;
              const _e = cb(be) ?? xe.currentVersionOrdinal, Ke = G.currentVersionId || xe.currentVersionId;
              return {
                ...xe,
                name: Oe.name ?? xe.name,
                versionId: Ke,
                currentVersionId: Ke,
                versionOrdinal: _e ?? xe.versionOrdinal,
                currentVersionOrdinal: _e ?? xe.currentVersionOrdinal
              };
            }
          );
          de({
            ...b,
            expression: {
              ...b.expression,
              ConceptSets: De
            },
            conceptSetRefs: je
          });
        } catch {
          s({
            message: "Could not refresh concept set. Please try again.",
            variant: "error"
          });
        }
    },
    [b, de, s]
  ), fn = ee(
    () => Vc(
      qs(b == null ? void 0 : b.expression.ConceptSets),
      b == null ? void 0 : b.conceptSetRefs,
      !1,
      X
    ),
    [
      b == null ? void 0 : b.expression.ConceptSets,
      b == null ? void 0 : b.conceptSetRefs,
      X
    ]
  ), [Is, As] = Re.useState([]), vr = ee(
    () => ab(b == null ? void 0 : b.expression),
    [b == null ? void 0 : b.expression]
  );
  Q(() => {
    As([]);
  }, [e]);
  const bs = ie(
    (G) => {
      if (Uc(
        aa(G),
        aa(fn)
      ))
        return;
      const se = new Set(
        G.flatMap((je) => Vn(je))
      ), be = new Set(
        fn.flatMap(
          (je) => Vn(je)
        )
      ), Oe = fn.filter((je) => {
        const xe = Vn(je), _e = xe.some(
          (Kt) => vr.has(Kt)
        ), Ke = !xe.some(
          (Kt) => se.has(Kt)
        );
        return _e && Ke;
      }).map((je) => ({
        ...je,
        terminated: !0
      }));
      As((je) => {
        const xe = /* @__PURE__ */ new Map();
        return [...je, ...Oe].forEach(
          (_e) => {
            const Ke = Vn(_e), Kt = Ke.some(
              (Po) => vr.has(Po)
            ), yi = Ke.some(
              (Po) => se.has(Po)
            ), js = Ke[0];
            js && Kt && !yi && xe.set(js, _e);
          }
        ), Array.from(xe.values());
      });
      const Be = G.filter((je) => Vn(je).some(
        (Ke) => be.has(Ke)
      ) || !je.terminated), De = aa(Be);
      Uc(
        De,
        b == null ? void 0 : b.expression.ConceptSets
      ) || Ve("ConceptSets", De);
    },
    [
      fn,
      b == null ? void 0 : b.expression.ConceptSets,
      vr,
      Ve
    ]
  ), Dr = ee(() => {
    const G = Vc(
      qs(b == null ? void 0 : b.expression.ConceptSets),
      b == null ? void 0 : b.conceptSetRefs,
      !0,
      X
    ), se = new Set(
      G.flatMap(
        (Oe) => Vn(Oe)
      )
    ), be = Is.filter((Oe) => {
      const Be = Vn(Oe), De = Be.some(
        (xe) => vr.has(xe)
      ), je = Be.some(
        (xe) => se.has(xe)
      );
      return De && !je;
    });
    return {
      conceptSets: [...G, ...be],
      updateConceptSets: bs,
      refreshConceptSetReference: An
    };
  }, [
    Is,
    b == null ? void 0 : b.expression.ConceptSets,
    b == null ? void 0 : b.conceptSetRefs,
    X,
    vr,
    An,
    bs
  ]), Op = ie(
    (G, se) => {
      var xe;
      if (!((xe = b == null ? void 0 : b.conceptSetRefs) != null && xe.length))
        return;
      const be = G.currentVersionId ?? G.versionId, Oe = G.currentVersionOrdinal ?? G.versionOrdinal ?? G.version;
      if (!be)
        return;
      const Be = /* @__PURE__ */ new Set();
      if ([se == null ? void 0 : se.externalId, G.id].forEach((_e) => {
        const Ke = Hn(_e);
        Ke && Be.add(Ke);
      }), Be.size === 0)
        return;
      let De = !1;
      const je = ((b == null ? void 0 : b.conceptSetRefs) || []).map(
        (_e) => {
          const Ke = Hn(_e.externalId);
          if (!Ke || !Be.has(Ke))
            return _e;
          const Kt = be, yi = Oe ?? _e.currentVersionOrdinal;
          return _e.currentVersionId === Kt && _e.currentVersionOrdinal === yi ? _e : (De = !0, {
            ..._e,
            currentVersionId: Kt,
            currentVersionOrdinal: yi
          });
        }
      );
      De && de({
        ...b,
        conceptSetRefs: je
      });
    },
    [b, de]
  ), kn = ee(() => {
    var Be, De, je, xe, _e, Ke, Kt;
    const G = (b == null ? void 0 : b.expression.PrimaryCriteria.CriteriaList.length) + (((De = (Be = b == null ? void 0 : b.expression) == null ? void 0 : Be.AdditionalCriteria) == null ? void 0 : De.CriteriaList.length) || 0) + (((je = b == null ? void 0 : b.expression.AdditionalCriteria) == null ? void 0 : je.DemographicCriteriaList.length) || 0) + (((xe = b == null ? void 0 : b.expression.AdditionalCriteria) == null ? void 0 : xe.Groups.length) || 0) || 0, se = (b == null ? void 0 : b.expression.InclusionRules.length) || 0, be = (b == null ? void 0 : b.expression.CensoringCriteria.length) + 1 || 0, Oe = (((Ke = Object.keys(((_e = b == null ? void 0 : b.expression) == null ? void 0 : _e.CensorWindow) || {})) == null ? void 0 : Ke.length) || 0) + (((Kt = b == null ? void 0 : b.expression.CollapseSettings) == null ? void 0 : Kt.EraPad) > 0 ? 1 : 0);
    return {
      entryEvent: G,
      inclusion: se,
      exit: be,
      eras: Oe
    };
  }, [b]), Kn = ee(() => m != null && m.expression ? m : b, [m, b]), vp = ee(
    () => ({
      ...Kn,
      expression: {
        ...Kn == null ? void 0 : Kn.expression,
        ConceptSets: Dr.conceptSets
      }
    }),
    [Kn, Dr.conceptSets]
  ), Dp = ee(
    () => (b == null ? void 0 : b.printFriendlyExpression) || (m == null ? void 0 : m.printFriendlyExpression),
    [b == null ? void 0 : b.printFriendlyExpression, m == null ? void 0 : m.printFriendlyExpression]
  ), _p = () => {
    v(gh, {
      onSubmit: async () => {
        try {
          await Me(), o(`/${C}`);
        } catch {
        }
      },
      onClose: O,
      text: "Are you sure you want to delete this cohort?",
      confirmButtonText: "DELETE",
      variant: "error"
    });
  }, Np = ph(
    m == null ? void 0 : m.id,
    z === he.LIBRARY,
    C
  );
  Q(() => {
    V === ce.SUCCESS && Ze && K.runCheck(Ze);
  }, [Ze, V]), Q(() => {
    b != null && b.id && W && Tt({
      subjectId: b == null ? void 0 : b.id
    });
  }, [W, b == null ? void 0 : b.id]), Q(() => {
    h && (Fe(), o(
      {
        pathname: t.pathname,
        search: t.search,
        hash: t.hash
      },
      { replace: !0, state: null }
    ));
  }, [
    h,
    t.hash,
    t.pathname,
    t.search,
    o,
    Fe
  ]), Q(() => () => at(), []), Q(() => {
    let G;
    return ["DONE", "ERROR"].includes(U) && (G = setTimeout(() => {
      ae(U), at();
    }, 3e3)), () => clearTimeout(G);
  }, [U]), Q(() => {
    m && n(
      af(
        Sm(e, m == null ? void 0 : m.name, {
          path: (i == null ? void 0 : i.path) || C,
          title: (i == null ? void 0 : i.title) || T,
          rootPath: w,
          rootTitle: L,
          parentTitle: k,
          parentId: P
        })
      )
    );
  }, [C, m]), Q(() => {
    document.title = "Prometheus - " + L + " - Cohorts";
  }, [L]);
  const Rs = e !== "new", gi = Rs ? Bt : "builder", wp = gi === "visual" ? Re.Fragment : Ti;
  if (!W && V === ce.ERROR)
    return /* @__PURE__ */ a.jsx(Qt, { children: /* @__PURE__ */ a.jsx(hh, { ...le.response, path: C }) });
  if ([ce.INITIAL, ce.IN_PROGRESS].includes(V) || [ce.INITIAL].includes(oe) || W || h) {
    const G = W || h;
    return /* @__PURE__ */ a.jsx(
      Qt,
      {
        background: G && "/images/back.png",
        children: G ? /* @__PURE__ */ a.jsx(Kc, {}) : /* @__PURE__ */ a.jsx(Ct, { size: 62 })
      }
    );
  }
  return /* @__PURE__ */ a.jsxs(R, { container: !0, px: 6, flexGrow: 1, flexDirection: "column", children: [
    /* @__PURE__ */ a.jsx(fh, { children: /* @__PURE__ */ a.jsx(
      mh,
      {
        entity: (X || z !== he.LIBRARY) && b || m,
        analysisTypes: B,
        onDelete: _p,
        onArchive: Np,
        onSubmit: async (G) => {
          await In(G);
        },
        onChange: z !== he.LIBRARY ? (G) => {
          Qe({
            name: G.name,
            description: G.description
          });
        } : void 0,
        onExport: _o,
        onPublish: tn,
        onGenerate: te && H && z != he.LIBRARY ? wo : null,
        onCopy: async (G) => {
          const se = await ot(b);
          se != null && se.id && (o(`/${C}/${se.id}`, { replace: !0 }), Ue());
        },
        onClickExtraActions: (G) => {
          Dt(G);
        },
        versionPreview: X,
        onVersionRevert: ye,
        onVersionSave: async () => {
          await pt({
            name: b.originName
          });
        },
        disableSave: V !== ce.SUCCESS || oe !== ce.SUCCESS || vt,
        viewMode: Pe,
        libraryMode: hn,
        backToListPath: N ? "../../" : "",
        AdditionalActions: N && /* @__PURE__ */ a.jsx(
          A.library,
          {
            type: "component",
            name: "answer-publish-widget",
            subModules: A,
            config: {
              ...I,
              type: r.get("typePublish"),
              typeEntity: ki.COHORT,
              nameEntity: m == null ? void 0 : m.name,
              id: r.get("id"),
              isRedirect: !0,
              requestStatus: r.get("status")
            }
          }
        ),
        shareable: Xt,
        onShare: No,
        nameError: l
      }
    ) }),
    /* @__PURE__ */ a.jsxs(R, { item: !0, xs: 12, children: [
      /* @__PURE__ */ a.jsx(Xc, { tabs: nn, withRouting: !0, secondary: !0 }),
      /* @__PURE__ */ a.jsx(Fa, {})
    ] }),
    /* @__PURE__ */ a.jsx(R, { item: !0, xs: 12, py: 2, children: oe === ce.SUCCESS && /* @__PURE__ */ a.jsxs(Zc, { children: [
      /* @__PURE__ */ a.jsx(
        ln,
        {
          index: !0,
          element: /* @__PURE__ */ a.jsx(a.Fragment, { children: /* @__PURE__ */ a.jsxs(Y, { sx: { position: "relative" }, children: [
            Rs && /* @__PURE__ */ a.jsx(
              Y,
              {
                sx: {
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 0.25,
                  mb: 2,
                  p: 0.25,
                  border: "1px solid #D8DEE9",
                  borderRadius: "8px",
                  backgroundColor: "#F7F9FC",
                  boxShadow: "0 1px 2px rgba(31, 42, 68, 0.08)"
                },
                children: rb.map((G) => {
                  const se = gi === G.id;
                  return /* @__PURE__ */ a.jsxs(
                    "button",
                    {
                      type: "button",
                      onClick: () => Jt(G.id),
                      "aria-pressed": se,
                      "aria-label": G.label,
                      style: {
                        minWidth: 88,
                        height: 30,
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 6,
                        border: "1px solid",
                        borderColor: se ? "#53A3ED" : "transparent",
                        borderRadius: 6,
                        background: se ? "#FFFFFF" : "transparent",
                        color: se ? "#1F2A44" : "#56637A",
                        fontSize: 12,
                        lineHeight: "16px",
                        fontWeight: se ? 700 : 600,
                        cursor: "pointer",
                        padding: "0 10px",
                        transition: "background 120ms ease-out, border-color 120ms ease-out, color 120ms ease-out, box-shadow 120ms ease-out",
                        whiteSpace: "nowrap",
                        userSelect: "none",
                        boxShadow: se ? "0 1px 3px rgba(31, 42, 68, 0.14)" : "none"
                      },
                      children: [
                        /* @__PURE__ */ a.jsx(
                          ib,
                          {
                            tab: G.id,
                            active: se
                          }
                        ),
                        /* @__PURE__ */ a.jsx(
                          fe,
                          {
                            component: "span",
                            sx: {
                              fontSize: "12px",
                              lineHeight: "16px",
                              fontWeight: se ? 700 : 600
                            },
                            children: G.label
                          }
                        )
                      ]
                    },
                    G.id
                  );
                })
              }
            ),
            /* @__PURE__ */ a.jsx(wp, { children: oe != ce.SUCCESS || V != ce.SUCCESS ? /* @__PURE__ */ a.jsx(Jc, { children: /* @__PURE__ */ a.jsx(Ct, { size: 62 }) }) : gi === "visual" ? /* @__PURE__ */ a.jsx(Zg, { definition: Kn }) : gi === "text" ? /* @__PURE__ */ a.jsx(
              nb,
              {
                definition: vp,
                printFriendlyExpression: Dp
              }
            ) : /* @__PURE__ */ a.jsx(
              Or.Provider,
              {
                value: { ...Dr },
                children: /* @__PURE__ */ a.jsxs(R, { container: !0, spacing: 2, children: [
                  /* @__PURE__ */ a.jsx(R, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsx(
                    Rb,
                    {
                      titleText: "Cohort Entry Event",
                      counts: kn.entryEvent,
                      className: "cohort-entry-event__block",
                      viewMode: Pe,
                      primaryCriteria: b == null ? void 0 : b.expression.PrimaryCriteria,
                      additionalCriteria: b == null ? void 0 : b.expression.AdditionalCriteria,
                      qualifiedLimit: b == null ? void 0 : b.expression.QualifiedLimit,
                      update: Ve,
                      clear: qt
                    }
                  ) }),
                  (!Pe || Pe && kn.inclusion > 0) && /* @__PURE__ */ a.jsx(R, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsx(
                    Ob,
                    {
                      titleText: "Inclusion criteria",
                      counts: kn.inclusion,
                      className: "inclusion-criteria__block",
                      viewMode: Pe,
                      inclusionRules: b == null ? void 0 : b.expression.InclusionRules,
                      expressionLimit: b == null ? void 0 : b.expression.ExpressionLimit,
                      update: Ve,
                      clear: qt
                    }
                  ) }),
                  /* @__PURE__ */ a.jsx(R, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsxs(
                    nr,
                    {
                      collapsible: !0,
                      className: "cohort-exit__block",
                      title: /* @__PURE__ */ a.jsx(
                        Kr,
                        {
                          title: "Cohort Exit",
                          count: kn.exit
                        }
                      ),
                      defaultState: Pe,
                      outlined: !0,
                      elevated: !0,
                      children: [
                        /* @__PURE__ */ a.jsx(
                          kC,
                          {
                            ...jn,
                            viewMode: Pe
                          }
                        ),
                        (!Pe || Pe && kn.exit > 1) && /* @__PURE__ */ a.jsx(
                          VC,
                          {
                            ...Ln,
                            viewMode: Pe
                          }
                        )
                      ]
                    }
                  ) }),
                  (!Pe || Pe && kn.eras > 0) && /* @__PURE__ */ a.jsx(R, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsx(
                    nr,
                    {
                      collapsible: !0,
                      className: "cohort-eras__block",
                      title: /* @__PURE__ */ a.jsx(
                        Kr,
                        {
                          title: "Cohort Eras",
                          count: kn.eras
                        }
                      ),
                      defaultState: Pe,
                      outlined: !0,
                      elevated: !0,
                      children: /* @__PURE__ */ a.jsx(
                        FC,
                        {
                          ...rn,
                          viewMode: Pe
                        }
                      )
                    }
                  ) })
                ] })
              }
            ) })
          ] }) })
        }
      ),
      /* @__PURE__ */ a.jsx(
        ln,
        {
          path: "concept-sets/*",
          element: /* @__PURE__ */ a.jsx(
            A.concept,
            {
              type: "component",
              name: "concept-set-sections-widget-new",
              subModules: A,
              config: {
                ...I,
                onChange: Dr.updateConceptSets,
                conceptSets: fn,
                conceptSetNameErrors: d,
                onConceptSetNameSubmit: Ft,
                onConceptSetNameCancel: mt,
                refreshConceptSetReference: Dr.refreshConceptSetReference,
                viewMode: Pe,
                exportConceptSet: !0,
                circleMode: !0,
                hideSectionContent: !0,
                hideAddConceptSetAction: !0,
                hideCopySectionAction: !0,
                renderSectionTitleAddon: (G, se, be) => /* @__PURE__ */ a.jsx(
                  qn,
                  {
                    conceptSet: G,
                    viewMode: Pe,
                    onRefresh: be == null ? void 0 : be.onRefreshReference,
                    marginLeft: 0
                  }
                ),
                onEditSection: (G) => {
                  const se = (G == null ? void 0 : G.externalId) ?? (G == null ? void 0 : G.id), be = [
                    G == null ? void 0 : G.uuid,
                    G == null ? void 0 : G.externalId,
                    G == null ? void 0 : G.id
                  ].map(
                    (De) => typeof De == "string" ? De.trim() : typeof De == "number" ? String(De) : ""
                  ).find(ob);
                  if (!be) {
                    s({
                      message: "Concept set is not available for editing yet.",
                      variant: "error"
                    });
                    return;
                  }
                  const Oe = ct(), Be = () => {
                    jt();
                  };
                  p(!0), j(
                    () => /* @__PURE__ */ a.jsx(
                      ub,
                      {
                        subModules: A,
                        typeContainer: z,
                        parentId: P,
                        conceptSetId: String(be),
                        conceptSetModulePath: Oe,
                        onClose: Be,
                        onConceptSetSaved: (De) => {
                          Op(
                            De,
                            {
                              externalId: se
                            }
                          );
                        },
                        storage: S,
                        initStorage: _
                      }
                    ),
                    "Concept Set",
                    {
                      closeOnClickOutside: !0,
                      width: "96vw",
                      closeOnRouteChangeOutside: `/${C}/${e}/concept-sets`,
                      onClose: Be
                    }
                  );
                }
              }
            }
          )
        }
      ),
      /* @__PURE__ */ a.jsx(
        ln,
        {
          path: "messages",
          element: /* @__PURE__ */ a.jsx(Ti, { children: /* @__PURE__ */ a.jsx(nr, { outlined: !0, children: /* @__PURE__ */ a.jsx(SC, { ...K }) }) })
        }
      ),
      /* @__PURE__ */ a.jsx(
        ln,
        {
          path: "versions",
          element: q ? /* @__PURE__ */ a.jsx(Ti, { children: /* @__PURE__ */ a.jsx(
            Eh,
            {
              data: b,
              path: C,
              makeCopy: () => {
              },
              setPreviewEntity: re,
              apiMethods: Am,
              originVersionId: m.versionId
            }
          ) }) : /* @__PURE__ */ a.jsx(Ws, { to: "..", replace: !0 })
        }
      ),
      /* @__PURE__ */ a.jsx(
        ln,
        {
          path: "meta-attributes",
          element: /* @__PURE__ */ a.jsx(
            Bs,
            {
              id: m.id,
              name: m.name,
              metadataSubject: ki.COHORT,
              title: "Cohort",
              initialTypeContainer: z,
              initialParentId: P,
              initialParentName: k,
              getBaseUrl: (G, se) => {
                switch (G) {
                  case he.WORKSPACE:
                    return "/workspace/cohorts/";
                  case he.STUDY:
                    return `/studies/${se}/cohorts/`;
                  default:
                    return "/cohorts/";
                }
              },
              url: "cohortdefinition",
              canUpdate: Ce,
              configMetadataValuesApi: {
                entityFilter: "subject",
                getListValues: Xi,
                updateMetadataValue: ha,
                removeMetadataValue: rl,
                createMetadataValue: pa,
                copyMetadataValue: il
              },
              callback: () => {
                Ue();
              }
            },
            `${m.id}-metadata`
          )
        }
      ),
      /* @__PURE__ */ a.jsx(
        ln,
        {
          path: "ai-meta-attributes",
          element: /* @__PURE__ */ a.jsx(
            Bs,
            {
              id: m.id,
              name: m.name,
              aiMode: !0,
              metadataSubject: ki.COHORT,
              title: "Cohort",
              initialTypeContainer: z,
              initialParentId: P,
              initialParentName: k,
              getBaseUrl: (G, se) => {
                switch (G) {
                  case he.WORKSPACE:
                    return "/workspace/cohorts/";
                  case he.STUDY:
                    return `/studies/${se}/cohorts/`;
                  default:
                    return "/cohorts/";
                }
              },
              url: "cohortdefinition",
              canUpdate: Ce,
              configMetadataValuesApi: {
                entityFilter: "subject",
                getListValues: Xi,
                updateMetadataValue: ha,
                removeMetadataValue: rl,
                createMetadataValue: pa,
                copyMetadataValue: il
              },
              callback: () => {
                Ue();
              }
            },
            `${m.id}-aimetadata`
          )
        }
      ),
      /* @__PURE__ */ a.jsx(
        ln,
        {
          path: "usage",
          element: /* @__PURE__ */ a.jsx(Ti, { children: /* @__PURE__ */ a.jsx(nr, { outlined: !0, children: /* @__PURE__ */ a.jsx(
            $C,
            {
              id: m.id,
              typeContainer: z,
              parentId: P
            }
          ) }) })
        }
      ),
      /* @__PURE__ */ a.jsx(
        ln,
        {
          path: "statistics",
          element: N ? /* @__PURE__ */ a.jsx(Ws, { to: "..", replace: !0 }) : /* @__PURE__ */ a.jsx(GC, {})
        }
      )
    ] }) })
  ] });
}, Sn = Xn(null), pb = (e) => {
  const { path: t, title: n, name: r, rootSettings: i, initStorage: o, viewMode: s } = e, [l, c] = J(i), [u, p] = J(!0);
  return Q(() => {
    i || c({
      rootPath: t,
      rootTitle: n
    }), p(!1);
  }, []), u ? /* @__PURE__ */ a.jsx(Qt, { children: /* @__PURE__ */ a.jsx(Ct, { size: 32 }) }) : /* @__PURE__ */ a.jsx(Sn.Provider, { value: { ...e, rootSettings: l }, children: /* @__PURE__ */ a.jsxs(Zc, { children: [
    /* @__PURE__ */ a.jsx(ln, { index: !0, element: /* @__PURE__ */ a.jsx(aC, { viewMode: s }) }),
    /* @__PURE__ */ a.jsx(ln, { path: ":id/*", element: /* @__PURE__ */ a.jsx(db, {}) })
  ] }) });
}, hb = me.div`
  border-bottom: 1px solid #d6d4d4;
  padding-bottom: 16px;
`;
me.div`
  font-size: 14px;
  margin-bottom: 20px;
`;
const fb = {
  title: "Initial Event",
  addCriteriaButton: "Add initial event",
  description: "Events having any of the following criteria:",
  optionsForCriteriaButton: [
    D.CONDITION_ERA,
    D.CONDITION_OCCURRENCE,
    D.DEATH,
    D.DEVICE_EXPOSURE,
    D.DOSE_ERA,
    D.DRUG_ERA,
    D.DRUG_EXPOSURE,
    D.MEASUREMENT,
    D.OBSERVATION,
    D.OBSERVATION_PERIOD,
    D.PAYER_PLAN_PERIOD,
    D.PROCEDURE_OCCURRENCE,
    D.SPECIMEN,
    D.VISIT,
    D.VISIT_DETAILS
  ],
  textControlTextSections: {
    observationDays: {
      startText: "with continuous observation of at least",
      type: "autocomplete",
      options: Wn,
      endText: "days before"
    },
    daysAfterEvent: {
      startText: "and",
      options: Wn,
      endText: "days after event index date"
    },
    limit: {
      startText: "Limit initial events to:",
      options: fr,
      endText: "per person."
    }
  }
}, mb = it(
  (e) => {
    const {
      data: t,
      update: n,
      viewMode: r,
      parentCriteriaElement: i,
      clearParentCriteriaElement: o
    } = e, s = Le(
      Or
    ), { subModules: l, config: c } = Le(
      Sn
    ), u = ee(() => s, [s.conceptSets]), [p, d] = J(
      t ? t.ObservationWindow.PriorDays : void 0
    ), [f, h] = J(
      t ? t.ObservationWindow.PostDays : void 0
    ), [g, C] = J(
      t ? t.PrimaryCriteriaLimit.Type : Ht.FIRST
    ), [T, I] = J(
      ru(t.CriteriaList)
    ), { typeContainer: A, parentId: S } = c, {
      addCriteriaButton: _,
      title: v,
      description: O,
      optionsForCriteriaButton: j,
      textControlTextSections: M
    } = fb, { observationDays: w, daysAfterEvent: L, limit: P } = M, k = ee(() => wn(
      j,
      yn
    ), [j]), z = (B) => {
      I(B);
    };
    return Q(() => {
      const q = {
        CriteriaList: iu(T),
        ObservationWindow: {
          PriorDays: p,
          PostDays: f
        },
        PrimaryCriteriaLimit: {
          Type: g
        }
      };
      ke(t, q) || n(q);
    }, [T, p, f, g]), /* @__PURE__ */ a.jsx(hb, { className: "cohort-definition-initial-event__container", children: /* @__PURE__ */ a.jsxs(R, { container: !0, children: [
      /* @__PURE__ */ a.jsx(R, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsx(
        es,
        {
          viewMode: r,
          extend: !1,
          subModules: l,
          initialCriteries: T,
          addTextButton: _,
          optionsDropdown: k,
          updateModel: z,
          typeContainer: A,
          parentId: S,
          titleText: v,
          descriptionText: O,
          parentCriteriaElement: i,
          isParentCriteriaAction: !0,
          clearParentCriteriaElement: o,
          ...u
        }
      ) }),
      Object.keys(T).length > 0 && /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
        /* @__PURE__ */ a.jsxs(R, { item: !0, xs: 12, display: "flex", children: [
          /* @__PURE__ */ a.jsx(
            Ut,
            {
              viewMode: r,
              startText: w.startText,
              endText: w.endText,
              options: w.options,
              onChange: d,
              type: w.type,
              value: p
            }
          ),
          /* @__PURE__ */ a.jsx(
            Ut,
            {
              viewMode: r,
              startText: L.startText,
              endText: L.endText,
              options: L.options,
              onChange: h,
              type: w.type,
              value: f
            }
          )
        ] }),
        /* @__PURE__ */ a.jsx(R, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsx(
          Ut,
          {
            viewMode: r,
            startText: P.startText,
            endText: P.endText,
            options: P.options,
            onChange: C,
            value: g
          }
        ) })
      ] })
    ] }) });
  }
), Eb = {
  title: "Restrict Initial Event",
  addCriteriaButton: "Restrict Initial Event",
  textControlTextSections: {
    limit: {
      startText: "Limit initial events to:",
      options: fr,
      endText: "per person."
    }
  }
}, xb = it((e) => {
  var w;
  const {
    data: t,
    dataAddition: n,
    update: r,
    clear: i,
    updateAddition: o,
    parentCriteriaElement: s,
    clearParentCriteriaElement: l,
    viewMode: c = !1,
    actions: u
  } = e, p = Le(
    Or
  ), { subModules: d, config: f } = Le(
    Sn
  ), [h, g] = J(
    (t == null ? void 0 : t.CriteriaList.length) + (t == null ? void 0 : t.DemographicCriteriaList.length) + (t == null ? void 0 : t.Groups.length) || 0
  ), [C, T] = J(
    ((w = n == null ? void 0 : n.QualifiedLimit) == null ? void 0 : w.Type) || "All"
  ), { typeContainer: I, parentId: A } = f, { title: S, addCriteriaButton: _, textControlTextSections: v } = Eb, { limit: O } = v;
  Q(() => {
    o({
      Type: C
    });
  }, [C]);
  const j = (L) => {
    var P, k, z, B, q, N;
    L != null && L.CriteriaList && L.DemographicCriteriaList && (L != null && L.Groups) && g(
      (L == null ? void 0 : L.CriteriaList.length) + L.DemographicCriteriaList.length + (L == null ? void 0 : L.Groups.length)
    ), !ke(
      {
        ...t,
        Count: t == null ? void 0 : t.Count
      },
      L
    ) && (L == null ? void 0 : L.CriteriaList.length) + L.DemographicCriteriaList.length + (L == null ? void 0 : L.Groups.length) > 0 && r && r(L), ((P = t == null ? void 0 : t.CriteriaList) == null ? void 0 : P.length) + ((k = t == null ? void 0 : t.DemographicCriteriaList) == null ? void 0 : k.length) + ((z = t == null ? void 0 : t.Groups) == null ? void 0 : z.length) > 0 && ((B = L == null ? void 0 : L.CriteriaList) == null ? void 0 : B.length) + ((q = L.DemographicCriteriaList) == null ? void 0 : q.length) + ((N = L == null ? void 0 : L.Groups) == null ? void 0 : N.length) === 0 && i();
  }, M = (L) => {
    j(L);
  };
  return /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    /* @__PURE__ */ a.jsxs(
      R,
      {
        container: !0,
        className: "cohort-definition-restrict-initial-event__container",
        children: [
          /* @__PURE__ */ a.jsxs(R, { item: !0, xs: 12, display: "flex", alignItems: "center", children: [
            /* @__PURE__ */ a.jsx(Y, { whiteSpace: "nowrap", children: /* @__PURE__ */ a.jsx(Kr, { title: S, count: h }) }),
            u
          ] }),
          /* @__PURE__ */ a.jsx(R, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsx(
            Ar,
            {
              extend: !0,
              subModules: d,
              value: t,
              updateModel: M,
              viewMode: c,
              typeContainer: I,
              parentId: A,
              addTextButton: _,
              parentCriteriaElement: s,
              clearParentCriteriaElement: l,
              hasAction: !1,
              isParentCriteriaAction: !0,
              ...p
            }
          ) })
        ]
      }
    ),
    h > 0 && /* @__PURE__ */ a.jsx(R, { item: !0, xs: 12, mt: 1, children: /* @__PURE__ */ a.jsx(
      Ut,
      {
        viewMode: c,
        startText: O.startText,
        endText: O.endText,
        options: O.options,
        onChange: T,
        value: C
      }
    ) })
  ] });
}), Cb = {
  addCriteriaButton: "New inclusion criteria",
  optionsForCriteriaButton: [
    D.DEMOGRAPHIC,
    D.CONDITION_ERA,
    D.CONDITION_OCCURRENCE,
    D.DEATH,
    D.DEVICE_EXPOSURE,
    D.DOSE_ERA,
    D.DRUG_ERA,
    D.DRUG_EXPOSURE,
    D.LOCATION_REGION,
    D.MEASUREMENT,
    D.OBSERVATION,
    D.OBSERVATION_PERIOD,
    D.PAYER_PLAN_PERIOD,
    D.PROCEDURE_OCCURRENCE,
    D.SPECIMEN,
    D.VISIT,
    D.GROUP
  ],
  textControlTextSections: {
    limit: {
      startText: "Limit qualifying events to:",
      options: fr,
      endText: "per person."
    }
  }
}, Tp = () => /* @__PURE__ */ a.jsx(
  "svg",
  {
    width: "10",
    height: "16",
    viewBox: "0 0 10 16",
    fill: "none",
    "aria-hidden": "true",
    children: [
      [3, 4],
      [7, 4],
      [3, 8],
      [7, 8],
      [3, 12],
      [7, 12]
    ].map(([e, t]) => /* @__PURE__ */ a.jsx("circle", { cx: e, cy: t, r: "1.35", fill: "#8E97A7" }, `${e}-${t}`))
  }
), gb = ({
  setActivatorNodeRef: e,
  listeners: t,
  attributes: n
}) => /* @__PURE__ */ a.jsx(
  "div",
  {
    ref: e,
    ...n,
    ...t,
    onClick: (r) => r.stopPropagation(),
    style: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      alignSelf: "flex-start",
      minHeight: 44,
      paddingLeft: 2,
      paddingRight: 4,
      cursor: "grab",
      // Required so the pointer sensor can start a drag on touch devices.
      touchAction: "none"
    },
    title: "Drag to reorder",
    children: /* @__PURE__ */ a.jsx(Tp, {})
  }
), yb = ({ id: e, children: t }) => {
  const {
    attributes: n,
    listeners: r,
    setNodeRef: i,
    setActivatorNodeRef: o,
    transform: s,
    transition: l,
    isDragging: c
  } = ad({ id: e });
  return /* @__PURE__ */ a.jsx(
    "div",
    {
      ref: i,
      style: {
        transform: Cn.Transform.toString(s),
        transition: l,
        // While dragging, the moving copy is rendered in a DragOverlay (see
        // below); hide the original so it just leaves a placeholder gap and
        // its nested absolutely-positioned bits don't distort under the
        // sortable transform.
        opacity: c ? 0 : 1
      },
      children: t({ setActivatorNodeRef: o, listeners: r, attributes: n })
    }
  );
}, Tb = it((e) => {
  var X;
  const {
    data: t,
    dataAddition: n,
    update: r,
    updateAddition: i,
    viewMode: o,
    parentCriteriaElement: s,
    clearParentCriteriaElement: l
  } = e, [c, u] = J(
    n ? (X = n.ExpressionLimit) == null ? void 0 : X.Type : "All"
  ), { openModal: p, closeModal: d } = Le(gn), f = Le(
    Or
  ), { subModules: h, config: g } = Le(
    Sn
  ), C = ee(() => f, [f.conceptSets]), { typeContainer: T, parentId: I } = g, {
    addCriteriaButton: A,
    textControlTextSections: S,
    optionsForCriteriaButton: _
  } = Cb, { limit: v } = S;
  Q(() => {
    s && (y(s), l());
  }, [s]), ee(() => {
    const V = wn(
      _,
      yn
    );
    return [
      {
        id: zn.ADD_NEW_SUBGROUP,
        name: "Add new criteria",
        desc: ""
      },
      {
        id: zn.CHOOSE_CRITERIA,
        name: "Choose criteria from library",
        desc: "",
        endGroup: !0
      },
      ...V.map(($) => ({
        ...$,
        name: `${$.name} criteria`,
        originalName: $.name
      }))
    ];
  }, [_]);
  const O = Gc(
    t.map((V) => ({ ...V, id: Yt() }))
  ), {
    sections: j,
    addSection: M,
    copySection: w,
    updateSection: L,
    removeSection: P,
    status: k
  } = O, z = O.moveSection, B = Pu(
    wu(Co, { activationConstraint: { distance: 6 } })
  ), q = ee(
    () => j.map((V) => V.id),
    [j]
  ), [N, ne] = J(null), ue = j.findIndex(
    (V) => V.id === N
  ), te = ue >= 0 ? j[ue] : null, m = (V) => {
    const { active: $, over: le } = V;
    if (!le || $.id === le.id)
      return;
    const b = j.findIndex((re) => re.id === $.id), oe = j.findIndex((re) => re.id === le.id);
    b < 0 || oe < 0 || z(b, oe);
  };
  Q(() => {
    i && i({
      Type: c
    });
  }, [c]);
  const W = (V) => {
    p(
      () => /* @__PURE__ */ a.jsx(
        hd,
        {
          onCLose: d,
          onChange: ($) => {
            $.forEach((le) => {
              M({
                id: Yt(),
                name: le.name,
                description: le.description,
                expression: le.expression
              });
            }), d();
          }
        }
      ),
      V.name,
      {
        onClose: d,
        closeOnClickOutside: !0
      }
    );
  }, H = (V) => {
    const $ = {
      Type: "ALL",
      CriteriaList: [],
      DemographicCriteriaList: V.predefinedAttribute ? [V.predefinedAttribute] : [],
      Groups: []
    };
    return V.id === D.DEMOGRAPHIC ? ($.DemographicCriteriaList.length === 0 && $.DemographicCriteriaList.push({}), $) : V.id === D.GROUP ? ($.Groups = [{ ...$ }], $) : ($.CriteriaList.push({
      Criteria: { [V.value]: {} }
    }), $);
  }, y = (V) => {
    switch (V.id) {
      case zn.ADD_NEW_SUBGROUP:
        M({
          id: Yt(),
          name: A,
          expression: {
            Type: "ALL",
            CriteriaList: [],
            DemographicCriteriaList: [],
            Groups: []
          }
        });
        break;
      case zn.CHOOSE_CRITERIA:
        W(V);
        break;
      default:
        M({
          id: Yt(),
          name: `${A} with ${V.originalName}`,
          expression: H(V)
        });
    }
  };
  return Q(() => {
    const V = j.map(
      ($) => $.description == null ? {
        name: $.name,
        expression: $.expression
      } : {
        name: $.name,
        expression: $.expression,
        description: $.description
      }
    );
    !ke(V, t) && k === ce.SUCCESS && r(V);
  }, [j]), /* @__PURE__ */ a.jsxs(R, { container: !0, spacing: 1, className: "inclusion-criteria__block", children: [
    /* @__PURE__ */ a.jsxs(
      Ku,
      {
        sensors: B,
        collisionDetection: ju,
        onDragStart: ({ active: V }) => ne(V.id),
        onDragEnd: (V) => {
          ne(null), m(V);
        },
        onDragCancel: () => ne(null),
        children: [
          /* @__PURE__ */ a.jsx(
            id,
            {
              items: q,
              strategy: td,
              children: j.map((V, $) => /* @__PURE__ */ a.jsx(
                R,
                {
                  item: !0,
                  xs: 12,
                  className: "cohort-definition-inclusion-criteria-data",
                  children: /* @__PURE__ */ a.jsx(yb, { id: V.id, children: (le) => /* @__PURE__ */ a.jsxs(
                    Y,
                    {
                      sx: {
                        display: "flex",
                        alignItems: "flex-start"
                      },
                      children: [
                        !o && /* @__PURE__ */ a.jsx(gb, { ...le }),
                        /* @__PURE__ */ a.jsx(Y, { sx: { flex: 1, minWidth: 0 }, children: /* @__PURE__ */ a.jsx(
                          Ua,
                          {
                            index: $,
                            item: V,
                            copySection: w,
                            updateSection: L,
                            removeSection: P,
                            viewMode: o,
                            defaultState: V.defaultState,
                            children: /* @__PURE__ */ a.jsx(R, { item: !0, xs: 12, mt: o ? 0 : 1, children: /* @__PURE__ */ a.jsx(
                              Ar,
                              {
                                extend: !0,
                                subModules: h,
                                value: V.expression,
                                updateModel: (b) => {
                                  L(
                                    $,
                                    "expression",
                                    b
                                  );
                                },
                                viewMode: o,
                                typeContainer: T,
                                parentId: I,
                                groupTitleText: "",
                                isParentCriteriaAction: !1,
                                hasAction: !1,
                                ...C
                              },
                              V.id
                            ) })
                          }
                        ) })
                      ]
                    }
                  ) })
                },
                V.id
              ))
            }
          ),
          /* @__PURE__ */ a.jsx(Zu, { children: te ? /* @__PURE__ */ a.jsxs(
            Y,
            {
              sx: {
                display: "flex",
                alignItems: "center",
                gap: 1,
                px: 1.5,
                py: 1,
                background: "#fff",
                border: "1px solid #c2cbe0",
                borderRadius: "6px",
                boxShadow: "0 6px 20px rgba(23, 43, 77, 0.18)",
                cursor: "grabbing"
              },
              children: [
                /* @__PURE__ */ a.jsx(Tp, {}),
                /* @__PURE__ */ a.jsxs(
                  fe,
                  {
                    sx: { fontSize: 14, fontWeight: 600, color: "#172b4d" },
                    children: [
                      ue + 1,
                      ". ",
                      te.name
                    ]
                  }
                )
              ]
            }
          ) : null })
        ]
      }
    ),
    /* @__PURE__ */ a.jsx(R, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsx(
      Ut,
      {
        viewMode: o,
        startText: v.startText,
        endText: v.endText,
        options: v.options,
        onChange: u,
        value: c
      }
    ) })
  ] });
}), Sb = eu(
  [
    E.AGE_OCCURRENCE,
    E.GENDER,
    E.GENDER_CS,
    E.CONDITION_START_DATE,
    E.CONDITION_END_DATE,
    E.RACE,
    E.RACE_CS,
    E.ETHNICITY,
    E.ETHNICITY_CS
  ],
  lu,
  []
), Ib = wn(
  [D.LOCATION_REGION],
  yn
).map((e) => ({
  ...e,
  name: `${e.name}`,
  originalName: e.name
})), Ab = wn(
  [
    D.CONDITION_ERA,
    D.DOSE_ERA,
    D.DRUG_ERA,
    D.CONDITION_OCCURRENCE,
    D.DEATH,
    D.DEVICE_EXPOSURE,
    D.DRUG_EXPOSURE,
    D.MEASUREMENT,
    D.OBSERVATION,
    D.OBSERVATION_PERIOD,
    D.PROCEDURE_OCCURRENCE,
    D.SPECIMEN,
    D.VISIT,
    D.VISIT_DETAILS
  ],
  yn
).map((e) => ({
  ...e,
  name: `${e.name}`,
  originalName: e.name
})), bb = wn(
  [D.PAYER_PLAN_PERIOD],
  yn
).map((e) => ({
  ...e,
  name: `${e.name}`,
  originalName: e.name
})), ci = ({
  hasTemplates: e = !1,
  hideGroup: t = !1,
  isInitialEvent: n = !1,
  sx: r,
  onChange: i
}) => /* @__PURE__ */ a.jsxs(
  R,
  {
    container: !0,
    spacing: 1,
    alignItems: "baseline",
    justifyContent: "flex-end",
    lineHeight: "30px",
    py: 1,
    sx: r,
    children: [
      e && /* @__PURE__ */ a.jsx(R, { item: !0, children: /* @__PURE__ */ a.jsx(
        We,
        {
          onClick: (o) => {
            o.stopPropagation(), i({
              id: zn.CHOOSE_CRITERIA,
              name: "Choose criteria from library",
              desc: ""
            });
          },
          variant: "outlined",
          startIcon: /* @__PURE__ */ a.jsx(ge, { iconName: "add" }),
          name: "button-library",
          sx: { "&.MuiButton-outlined": { borderColor: "primary.main" } },
          children: "Templates"
        }
      ) }),
      !n && /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
        !t && /* @__PURE__ */ a.jsx(R, { item: !0, children: /* @__PURE__ */ a.jsx(
          We,
          {
            onClick: (o) => {
              o.stopPropagation(), i({
                id: D.GROUP,
                name: "Group",
                desc: "",
                originalName: "Group"
              });
            },
            variant: "outlined",
            color: "primary",
            startIcon: /* @__PURE__ */ a.jsx(ge, { iconName: "add" }),
            name: "button-group",
            sx: { "&.MuiButton-outlined": { borderColor: "primary.main" } },
            children: "Group"
          }
        ) }),
        /* @__PURE__ */ a.jsx(R, { item: !0, children: /* @__PURE__ */ a.jsx(
          vn,
          {
            variant: "contained",
            color: "info",
            options: Sb,
            onClick: (o) => {
              const s = mr[o.value], l = {
                id: o.value,
                name: o.name,
                value: fu(
                  s.type,
                  s.defaultOp
                )
              };
              i({
                id: D.DEMOGRAPHIC,
                name: "Demographics",
                desc: "",
                originalName: "Demographics",
                predefinedAttribute: {
                  [l.id]: l.value
                }
              });
            },
            name: "button-demographics",
            title: "Demographics",
            startIcon: /* @__PURE__ */ a.jsx(ge, { iconName: "add" }),
            endIcon: /* @__PURE__ */ a.jsx(ge, { fontSize: "small", iconName: "chevronFilled" }),
            closeOnSelect: !0,
            preventOverflow: !0
          }
        ) }),
        /* @__PURE__ */ a.jsx(R, { item: !0, children: /* @__PURE__ */ a.jsx(
          vn,
          {
            variant: "contained",
            color: "info",
            options: Ib,
            onClick: i,
            name: "button-health-system",
            title: "Health System",
            startIcon: /* @__PURE__ */ a.jsx(ge, { iconName: "add" }),
            endIcon: /* @__PURE__ */ a.jsx(ge, { fontSize: "small", iconName: "chevronFilled" }),
            closeOnSelect: !0,
            preventOverflow: !0
          }
        ) })
      ] }),
      /* @__PURE__ */ a.jsx(R, { item: !0, children: /* @__PURE__ */ a.jsx(
        vn,
        {
          variant: "contained",
          color: "info",
          options: Ab,
          onClick: i,
          title: "Clinical Events",
          name: "Clinical events",
          closeOnSelect: !0,
          preventOverflow: !0,
          startIcon: /* @__PURE__ */ a.jsx(ge, { iconName: "add" }),
          endIcon: /* @__PURE__ */ a.jsx(ge, { fontSize: "small", iconName: "chevronFilled" })
        }
      ) }),
      /* @__PURE__ */ a.jsx(R, { item: !0, children: /* @__PURE__ */ a.jsx(
        vn,
        {
          variant: "contained",
          color: "info",
          options: bb,
          onClick: i,
          title: "Health economics",
          name: "Health economics",
          closeOnSelect: !0,
          preventOverflow: !0,
          startIcon: /* @__PURE__ */ a.jsx(ge, { iconName: "add" }),
          endIcon: /* @__PURE__ */ a.jsx(ge, { fontSize: "small", iconName: "chevronFilled" })
        }
      ) })
    ]
  }
), Sp = (e) => {
  const { titleText: t, counts: n, viewMode: r, children: i, className: o, actions: s } = e;
  return /* @__PURE__ */ a.jsx(
    nr,
    {
      collapsible: !0,
      className: o,
      title: /* @__PURE__ */ a.jsx(Kr, { title: t, count: n }),
      actions: r ? /* @__PURE__ */ a.jsx(a.Fragment, {}) : s,
      outlined: !0,
      elevated: !0,
      children: i
    }
  );
}, Rb = (e) => {
  var g, C, T;
  const {
    primaryCriteria: t,
    additionalCriteria: n,
    qualifiedLimit: r,
    update: i,
    clear: o,
    viewMode: s,
    ...l
  } = e, [c, u] = J(), [p, d] = J(), f = ee(
    () => ({
      data: t,
      update: (I) => i("PrimaryCriteria", I),
      clear: () => i("PrimaryCriteria", Ef)
    }),
    [t]
  ), h = ee(
    () => ({
      data: n,
      dataAddition: {
        QualifiedLimit: r
      },
      update: (I) => i("AdditionalCriteria", I),
      updateAddition: (I) => i("QualifiedLimit", I),
      clear: () => o(["AdditionalCriteria", "QualifiedLimit"])
    }),
    [n, r]
  );
  return /* @__PURE__ */ a.jsx(
    Sp,
    {
      ...l,
      viewMode: s,
      actions: /* @__PURE__ */ a.jsx(
        ci,
        {
          isInitialEvent: !0,
          onChange: u
        }
      ),
      children: /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
        /* @__PURE__ */ a.jsx(
          mb,
          {
            ...f,
            viewMode: s,
            parentCriteriaElement: c,
            clearParentCriteriaElement: () => {
              u(null);
            }
          }
        ),
        (!s || s && ((g = h.data) == null ? void 0 : g.CriteriaList.length) + ((C = h.data) == null ? void 0 : C.DemographicCriteriaList.length) + ((T = h.data) == null ? void 0 : T.Groups.length) > 0) && /* @__PURE__ */ a.jsx(
          xb,
          {
            ...h,
            viewMode: s,
            parentCriteriaElement: p,
            actions: !s && /* @__PURE__ */ a.jsx(
              ci,
              {
                onChange: d
              }
            ),
            clearParentCriteriaElement: () => {
              d(null);
            }
          }
        )
      ] })
    }
  );
}, Ob = (e) => {
  const {
    inclusionRules: t,
    expressionLimit: n,
    update: r,
    clear: i,
    viewMode: o,
    ...s
  } = e, [l, c] = J(), u = ee(
    () => ({
      data: t,
      dataAddition: {
        ExpressionLimit: n
      },
      update: (p) => r("InclusionRules", p),
      updateAddition: (p) => r("ExpressionLimit", p),
      clear: () => r("InclusionRules", [])
    }),
    [t, n]
  );
  return /* @__PURE__ */ a.jsx(
    Sp,
    {
      ...s,
      viewMode: o,
      actions: /* @__PURE__ */ a.jsx(ci, { hasTemplates: !0, onChange: c }),
      children: /* @__PURE__ */ a.jsx(
        Tb,
        {
          ...u,
          viewMode: o,
          parentCriteriaElement: l,
          clearParentCriteriaElement: () => c(null)
        }
      )
    }
  );
}, vb = (e) => {
  const {
    values: t,
    addCriteriaButton: n,
    title: r,
    contextConceptSets: i,
    viewMode: o = !1,
    onChange: s,
    typeContainer: l,
    subModules: c,
    parentId: u,
    isDesignStrata: p,
    strataParams: d,
    onChangeStrataOnly: f,
    onChangeStrataBy: h,
    hiddenParentConcept: g,
    hideIgnoreObservationPeriod: C,
    hiddenIgnoreObservationPeriodValue: T,
    showRestrictToSameVisitForAllCriteria: I,
    hideOccurrence: A,
    renderSectionContentBeforeCriteria: S,
    useCohortSectionButtons: _,
    hideCriteriaGroupHeader: v,
    hideTopLevelCriteriaControls: O,
    criteriaSectionsSx: j,
    criteriaButtonsSx: M,
    parentCriteriaElement: w,
    clearParentCriteriaElement: L
  } = e, { openModal: P, closeModal: k } = Le(gn), [z, B] = J(
    d || {
      stratifiedBy: "",
      strataOnly: !1
    }
  ), {
    isStartHook: q,
    sections: N,
    addSection: ne,
    copySection: ue,
    updateSection: te,
    removeSection: m
  } = Gc(t), W = (X) => {
    switch (X.id) {
      case zn.ADD_NEW_SUBGROUP:
        ne({
          id: sa(),
          name: n,
          expression: {
            Type: "ALL",
            CriteriaList: [],
            DemographicCriteriaList: [],
            Groups: []
          }
        });
        break;
      case zn.CHOOSE_CRITERIA:
        y(X);
        break;
      default:
        ne({
          id: sa(),
          name: `${n} with ${X.originalName}`,
          expression: H(X)
        });
        break;
    }
  }, H = (X) => {
    const V = {
      Type: "ALL",
      CriteriaList: [],
      DemographicCriteriaList: X.predefinedAttribute ? [X.predefinedAttribute] : [],
      Groups: []
    };
    return X.id === D.DEMOGRAPHIC ? (V.DemographicCriteriaList.length === 0 && V.DemographicCriteriaList.push({}), V) : (V.CriteriaList.push({
      Criteria: { [X.value]: {} }
    }), V);
  }, y = (X) => {
    P(
      () => /* @__PURE__ */ a.jsx(
        hd,
        {
          onClose: k,
          onChange: (V) => {
            V.forEach(($) => {
              ne({
                name: $.name,
                description: $.description,
                expression: $.expression
              });
            }), k();
          }
        }
      ),
      X.name,
      {
        onClose: k,
        closeOnClickOutside: !0,
        width: "50vw"
      }
    );
  };
  return Q(() => {
    w && (W(w), L == null || L());
  }, [w]), Q(() => {
    q && !ke(N, t) && (N.length === 0 && B({
      stratifiedBy: "",
      strataOnly: !1
    }), s(N));
  }, [N]), Q(() => {
    z.stratifiedBy !== (d == null ? void 0 : d.stratifiedBy) && (h == null || h(z.stratifiedBy));
  }, [z.stratifiedBy]), Q(() => {
    z.strataOnly !== (d == null ? void 0 : d.strataOnly) && (f == null || f(z.strataOnly));
  }, [z.strataOnly]), /* @__PURE__ */ a.jsxs(Re.Fragment, { children: [
    !v && /* @__PURE__ */ a.jsx(Jx, { children: /* @__PURE__ */ a.jsxs(R, { container: !0, py: 1, alignItems: "center", children: [
      /* @__PURE__ */ a.jsx(R, { item: !0, xs: 5, children: /* @__PURE__ */ a.jsx(Xx, { className: "criteria-title", children: r }) }),
      /* @__PURE__ */ a.jsx(R, { item: !0, xs: 7, textAlign: "right", className: "criteria-action", children: !o && (_ ? /* @__PURE__ */ a.jsx(
        ci,
        {
          hideGroup: !0,
          onChange: (X) => {
            W(X);
          }
        }
      ) : /* @__PURE__ */ a.jsx(
        vn,
        {
          variant: "contained",
          color: "info",
          options: Jp,
          onClick: (X) => {
            W(X);
          },
          title: n,
          name: n,
          closeOnSelect: !0,
          preventOverflow: !0,
          startIcon: /* @__PURE__ */ a.jsx(
            ge,
            {
              iconName: "add",
              sx: { "&.MuiSvgIcon-root": { fontSize: 16 } }
            }
          )
        }
      )) })
    ] }) }),
    v && _ && !o && /* @__PURE__ */ a.jsx(
      ci,
      {
        hideGroup: !0,
        sx: M,
        onChange: (X) => {
          W(X);
        }
      }
    ),
    p && N.length > 0 && /* @__PURE__ */ a.jsxs(R, { container: !0, py: 1, spacing: 1, className: "criteria-content", children: [
      /* @__PURE__ */ a.jsx(R, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsx(qe, { name: "stratifiedBy", textLabel: "Stratified by", children: /* @__PURE__ */ a.jsx(
        Je,
        {
          id: "stratifiedBy",
          name: "stratifiedBy",
          type: "text",
          size: "medium",
          placeholder: "Enter stratified by",
          value: z.stratifiedBy,
          onChange: (X) => {
            B({
              ...z,
              stratifiedBy: X.target.value
            });
          },
          fullWidth: !0,
          disabled: o
        }
      ) }) }),
      /* @__PURE__ */ a.jsx(R, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsx(
        qe,
        {
          name: "strataOnly",
          textLabel: "Calculate subgroup analyses only",
          inline: !0,
          children: /* @__PURE__ */ a.jsx(
            hr,
            {
              name: "strataOnly",
              id: "strataOnly",
              onChange: () => {
                B({
                  ...z,
                  strataOnly: !z.strataOnly
                });
              },
              sx: { ml: 1 },
              checked: z.strataOnly,
              disabled: o
            }
          )
        }
      ) })
    ] }),
    /* @__PURE__ */ a.jsx(
      R,
      {
        container: !0,
        spacing: j ? 0 : 1,
        sx: j,
        children: N.map((X, V) => /* @__PURE__ */ a.jsx(R, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsxs(
          Ua,
          {
            index: V,
            item: X,
            copySection: ue,
            updateSection: te,
            removeSection: m,
            viewMode: o,
            defaultState: X.defaultState,
            children: [
              S == null ? void 0 : S({
                section: X,
                sectionId: V,
                updateSection: te
              }),
              /* @__PURE__ */ a.jsx(
                Ar,
                {
                  extend: !0,
                  subModules: c,
                  value: X.expression,
                  updateModel: ($) => {
                    te(V, "expression", $);
                  },
                  viewMode: o,
                  typeContainer: l,
                  parentId: u,
                  hiddenParentConcept: g,
                  hideIgnoreObservationPeriod: C,
                  hiddenIgnoreObservationPeriodValue: T,
                  showRestrictToSameVisitForAllCriteria: I,
                  hideOccurrence: A,
                  hideCriteriaControls: O,
                  hasAction: !1,
                  ...i
                }
              )
            ]
          }
        ) }, X.id ?? X.uuid ?? V))
      }
    ),
    Object.keys(N).length > 0 && /* @__PURE__ */ a.jsx(R, { container: !0, children: /* @__PURE__ */ a.jsx(R, { item: !0, xs: 12 }) })
  ] });
}, Db = () => {
  const e = yr(), { openModal: t, closeModal: n } = Re.useContext(gn), { enqueueSnackbar: r } = Nn(), i = (o) => {
    o.stopPropagation(), t(
      () => /* @__PURE__ */ a.jsx(
        xd,
        {
          typeContainer: he.WORKSPACE,
          createMethod: fo,
          onCancel: n,
          afterCreate: (s) => {
            r({
              message: "Cohort created successfullly",
              variant: "success"
            }), e(`/workspace/cohorts/${s.id}`), n();
          }
        }
      ),
      "Add cohort",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: n
      }
    );
  };
  return /* @__PURE__ */ a.jsx(
    yh,
    {
      title: "Cohorts",
      description: "Cohort is a set of persons who satisfy one or more inclusion and/or exclusion criteria for a duration of time.",
      iconName: "cohorts",
      onCardClick: () => e("/workspace/cohorts"),
      children: /* @__PURE__ */ a.jsx(R, { item: !0, width: 90, textAlign: "right", children: /* @__PURE__ */ a.jsx(
        We,
        {
          onClick: i,
          variant: "contained",
          startIcon: /* @__PURE__ */ a.jsx(ge, { iconName: "add" }),
          color: "info",
          name: "save",
          children: "Create"
        }
      ) })
    }
  );
};
var Gn = /* @__PURE__ */ ((e) => (e.INITIAL_EVENT = "PrimaryCriteria", e.RESTRICT_INITIAL_EVENT = "AdditionalCriteria", e.INCLUSION_CRITERIA = "InclusionRules", e.EVENT_PERSISTENCE = "EndStrategy", e.CENSORING_EVENT = "CensoringCriteria", e))(Gn || {});
const Fc = [
  {
    value: "PrimaryCriteria",
    name: "Initial Event"
  },
  {
    value: "AdditionalCriteria",
    name: "Restrict Initial Event"
  },
  {
    value: "InclusionRules",
    name: "Inclusion criteria"
  },
  {
    value: "EndStrategy",
    name: "Event persistence"
  },
  {
    value: "CensoringCriteria",
    name: "Censoring event"
  }
], _b = {
  PrimaryCriteria: [
    D.CONDITION_ERA,
    D.CONDITION_OCCURRENCE,
    D.DEATH,
    D.DEVICE_EXPOSURE,
    D.DOSE_ERA,
    D.DRUG_ERA,
    D.DRUG_EXPOSURE,
    D.MEASUREMENT,
    D.OBSERVATION,
    D.PROCEDURE_OCCURRENCE,
    D.SPECIMEN,
    D.VISIT,
    D.VISIT_DETAILS
  ],
  AdditionalCriteria: [
    D.CONDITION_ERA,
    D.CONDITION_OCCURRENCE,
    D.DEATH,
    D.DEVICE_EXPOSURE,
    D.DOSE_ERA,
    D.DRUG_ERA,
    D.DRUG_EXPOSURE,
    D.LOCATION_REGION,
    D.MEASUREMENT,
    D.OBSERVATION,
    D.PROCEDURE_OCCURRENCE,
    D.SPECIMEN,
    D.VISIT
  ],
  InclusionRules: [
    D.CONDITION_ERA,
    D.CONDITION_OCCURRENCE,
    D.DEATH,
    D.DEVICE_EXPOSURE,
    D.DOSE_ERA,
    D.DRUG_ERA,
    D.DRUG_EXPOSURE,
    D.LOCATION_REGION,
    D.MEASUREMENT,
    D.OBSERVATION,
    D.PROCEDURE_OCCURRENCE,
    D.SPECIMEN,
    D.VISIT
  ],
  CensoringCriteria: [
    D.CONDITION_ERA,
    D.CONDITION_OCCURRENCE,
    D.DEATH,
    D.DEVICE_EXPOSURE,
    D.DOSE_ERA,
    D.DRUG_ERA,
    D.DRUG_EXPOSURE,
    D.MEASUREMENT,
    D.OBSERVATION,
    D.PROCEDURE_OCCURRENCE,
    D.SPECIMEN,
    D.VISIT,
    D.VISIT_DETAILS
  ],
  EndStrategy: []
}, Nb = {
  CriteriaList: [],
  ObservationWindow: {
    PriorDays: 0,
    PostDays: 0
  },
  PrimaryCriteriaLimit: {
    Type: Ht.FIRST
  }
}, wb = {
  Type: "ALL",
  CriteriaList: [],
  DemographicCriteriaList: [],
  Groups: []
}, Ip = (e, t) => ({
  ...wb,
  CriteriaList: e.map((r) => ({
    Criteria: {
      [r]: {
        CodesetId: t
      }
    }
  }))
}), Pb = (e, t, n) => {
  const r = e.filter(
    (i) => !n.CriteriaList.find((o) => o.Criteria[i])
  );
  return {
    ...n,
    CriteriaList: [
      ...n.CriteriaList,
      ...r.map((i) => ({
        Criteria: {
          [i]: {
            CodesetId: t
          }
        }
      }))
    ]
  };
}, jb = (e, t) => ({
  ...Nb,
  CriteriaList: e.map((r) => ({
    [r]: {
      CodesetId: t
    }
  }))
}), Lb = (e, t, n) => ({
  name: e.name,
  description: e.description,
  expression: Ip(t, n)
}), kb = (e, t) => e.map((n) => ({
  [n]: {
    CodesetId: t
  }
})), Mb = (e) => ({
  CustomEra: {
    DrugCodesetId: e,
    GapDays: 0,
    Offset: 0
  }
}), Vb = (e, t, n) => {
  const r = e || {
    PrimaryCriteria: {
      CriteriaList: [],
      ObservationWindow: {
        PriorDays: 0,
        PostDays: 0
      },
      PrimaryCriteriaLimit: {
        Type: Ht.FIRST
      }
    },
    QualifiedLimit: {
      Type: Ht.FIRST
    },
    ExpressionLimit: {
      Type: Ht.FIRST
    },
    InclusionRules: [],
    CensoringCriteria: [],
    CollapseSettings: {
      CollapseType: "ERA",
      EraPad: void 0
    },
    CensorWindow: {
      StartDate: null,
      EndDate: null
    },
    ConceptSets: []
  }, i = {
    id: sa(),
    name: n.name,
    expression: {
      items: ou(n.items)
    }
  };
  switch (r.ConceptSets.push(i), t.attribute) {
    case Gn.INITIAL_EVENT:
      {
        const o = jb(
          Object.keys(t.criteries),
          i.id
        );
        r[t.attribute].CriteriaList = [
          ...r[t.attribute].CriteriaList,
          ...o.CriteriaList
        ];
      }
      break;
    case Gn.RESTRICT_INITIAL_EVENT:
      r[t.attribute] ? r[t.attribute] = Pb(
        Object.keys(t.criteries),
        i.id,
        r[t.attribute]
      ) : r[t.attribute] = Ip(
        Object.keys(t.criteries),
        i.id
      );
      break;
    case Gn.INCLUSION_CRITERIA:
      {
        const o = Lb(
          t.criteries,
          Object.keys(t.criteries).filter(
            (s) => !["name", "description"].includes(s)
          ),
          i.id
        );
        r[t.attribute].push(o);
      }
      break;
    case Gn.CENSORING_EVENT:
      {
        const o = kb(
          Object.keys(t.criteries),
          i.id
        );
        r[t.attribute] = [...r[t.attribute], ...o];
      }
      break;
    case Gn.EVENT_PERSISTENCE:
      r[t.attribute] = Mb(i.id);
      break;
  }
  return r;
}, Ub = {
  form: {
    entityId: void 0,
    title: void 0,
    section: void 0,
    attribute: void 0,
    studyId: void 0,
    typeContainer: void 0,
    createNew: !1,
    cohort: void 0,
    criteries: []
  },
  fetchStatus: ce.INITIAL,
  analysisList: [],
  status: ce.INITIAL
}, Fb = (e, t) => ui(e, (n) => {
  switch (t.type) {
    case "INIT":
      n.form = t.payload;
      break;
    case "UPDATE":
      n.form[t.payload.prop] = t.payload.value;
      break;
    case "FETCH_ANAKYSES":
      n.fetchStatus = ce.IN_PROGRESS, n.form.cohort = void 0, n.analysisList = [];
      break;
    case "FETCH_ANAKYSES_DONE":
      n.fetchStatus = ce.SUCCESS, n.analysisList = t.payload;
      break;
    case "FETCH_ANAKYSES_FAILED":
      n.fetchStatus = ce.ERROR;
      break;
    case "SAVE_PROGRESS":
      n.status = ce.IN_PROGRESS;
      break;
    case "SAVE_DONE":
      n.status = ce.SUCCESS, n.form.cohort = t.payload;
      break;
  }
}), Bb = (e, t) => {
  const [n, r] = xr(Fb, Ub), i = (c) => {
    r({
      type: "INIT",
      payload: c
    });
  }, o = ie(async () => {
    r({
      type: "SAVE_PROGRESS"
      /* SAVE_PROGRESS */
    });
    const c = Zr(
      n.form.typeContainer,
      n.form.studyId
    );
    try {
      const u = n.form.createNew ? await c({
        name: n.form.title,
        description: n.form.description,
        studyId: n.form.studyId
      }) : await qi(n.form.cohort.id), p = Vb(
        u == null ? void 0 : u.expression,
        n.form,
        t
      ), d = await ho(u.id, {
        ...u,
        expression: {
          ...p
        }
      });
      r({
        type: "SAVE_DONE",
        payload: d
      });
    } catch {
    }
  }, [n.form]), s = ie(async () => {
    const c = Ki(
      n.form.typeContainer,
      n.form.studyId
    );
    r({
      type: "FETCH_ANAKYSES"
      /* FETCH_ANALYSES */
    });
    try {
      const u = await c.fetch(0, 1e5);
      r({
        type: "FETCH_ANAKYSES_DONE",
        payload: u.content
      });
    } catch {
      r({
        type: "FETCH_ANAKYSES_FAILED"
        /* FETCH_ANALYSES_FAILED */
      });
    }
  }, [n.form.typeContainer, n.form.studyId, n.form.type]), l = (c, u) => {
    r({
      type: "UPDATE",
      payload: {
        prop: c,
        value: u
      }
    });
  };
  return Q(() => {
    i(e);
  }, []), Q(() => {
    n.form.typeContainer && s();
  }, [n.form.typeContainer, n.form.studyId, n.form.type]), {
    ...n,
    updateForm: l,
    saveCohort: o
  };
}, $b = (e) => {
  const { attribute: t, defaultValues: n, onChange: r } = e, [i, o] = J({}), [s, l] = J(!1), c = ee(() => wn(
    _b[t],
    yn
  ), [t]);
  return Q(() => {
    l(!0), setTimeout(() => {
      l(!1), o({});
    }, 400);
  }, [t]), Q(() => {
    r(i);
  }, [i]), /* @__PURE__ */ a.jsx(gr, { children: /* @__PURE__ */ a.jsxs(R, { container: !0, spacing: 2, p: 2, children: [
    t === Gn.INCLUSION_CRITERIA && /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
      /* @__PURE__ */ a.jsx(R, { item: !0, xs: 6, children: /* @__PURE__ */ a.jsx(qe, { name: "name", textLabel: "Name", required: !0, children: /* @__PURE__ */ a.jsx(
        Je,
        {
          id: "name",
          name: "name",
          type: "text",
          size: "medium",
          value: i.name,
          placeholder: "Enter name",
          onChange: (u) => o({ ...i, name: u.target.value }),
          fullWidth: !0
        }
      ) }) }),
      /* @__PURE__ */ a.jsx(R, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsx(qe, { name: "description", textLabel: "Description", children: /* @__PURE__ */ a.jsx(
        Je,
        {
          id: "description",
          name: "description",
          type: "text",
          size: "medium",
          value: i.description,
          placeholder: "Enter description",
          onChange: (u) => o({ ...i, description: u.target.value }),
          fullWidth: !0
        }
      ) }) })
    ] }),
    s ? /* @__PURE__ */ a.jsx(Qt, { children: /* @__PURE__ */ a.jsx(Ct, { size: 32 }) }) : /* @__PURE__ */ a.jsx(a.Fragment, { children: c == null ? void 0 : c.map((u) => /* @__PURE__ */ a.jsxs(R, { item: !0, xs: 6, children: [
      /* @__PURE__ */ a.jsx(
        hr,
        {
          name: u.value,
          onChange: () => {
            o({
              ...i,
              [u.value]: !i[u.value]
            });
          },
          checked: i[u.value]
        }
      ),
      /* @__PURE__ */ a.jsx(fe, { sx: { marginLeft: "10px" }, variant: "caption", children: u.name })
    ] }, u.value)) })
  ] }) });
}, Gb = (e) => {
  const { entity: t, onCancel: n, subModules: r, typeContainer: i, parentId: o } = e, s = yr(), { enqueueSnackbar: l } = Nn(), { form: c, analysisList: u, updateForm: p, saveCohort: d, status: f, fetchStatus: h } = Bb(
    {
      title: t.name,
      description: t.description,
      attribute: void 0,
      studyId: o,
      typeContainer: i,
      createNew: !1
    },
    t
  ), g = ie(async () => {
    if (c.createNew) {
      const C = await ur(
        c.typeContainer,
        c.title,
        c.studyId
      );
      if (!C.isValid) {
        l({
          message: C.message || "Warning! Name is already used by another object.",
          variant: "error"
        });
        return;
      }
    }
    await d();
  }, [c, d, l]);
  return Q(() => {
    f === ce.SUCCESS && (l({
      message: `Created cohort ${c.cohort.name} with concept set ${t.name}`,
      variant: "success"
    }), s(
      c.typeContainer === he.WORKSPACE ? `workspace/cohorts/${c.cohort.id}` : `study-manager/${c.studyId}/cohorts/${c.cohort.id}`
    ), n());
  }, [f]), c.typeContainer ? /* @__PURE__ */ a.jsx(R, { container: !0, p: 2, children: /* @__PURE__ */ a.jsx(gr, { children: /* @__PURE__ */ a.jsxs(R, { container: !0, spacing: 2, p: 2, children: [
    /* @__PURE__ */ a.jsx(R, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsx(fe, { variant: "h3", children: "Container:" }) }),
    /* @__PURE__ */ a.jsx(R, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsx(qe, { name: "typeContainer", textLabel: "Add to", required: !0, children: /* @__PURE__ */ a.jsx(
      Rt,
      {
        className: "",
        name: "typeContainer",
        disablePortal: !0,
        id: "typeContainer",
        options: Kp.filter((C) => C.value !== "ATLAS"),
        value: c.typeContainer,
        placeholder: "Select type",
        onChange: (C) => {
          p("typeContainer", C);
        },
        fullWidth: !0
      }
    ) }) }),
    c.typeContainer === he.STUDY && /* @__PURE__ */ a.jsx(R, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsx(
      r.study,
      {
        type: "component",
        name: "user-studies-list",
        subModules: r,
        config: {
          onChange: (C) => {
            C && p("studyId", C.id);
          },
          analysisMode: !0,
          studyInitialId: o
        }
      }
    ) }),
    /* @__PURE__ */ a.jsx(R, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsx(fe, { variant: "h3", children: "Cohort:" }) }),
    /* @__PURE__ */ a.jsxs(R, { item: !0, xs: 12, children: [
      /* @__PURE__ */ a.jsx(
        hr,
        {
          name: "createNew",
          onChange: () => {
            p("createNew", !c.createNew);
          },
          checked: c.createNew
        }
      ),
      /* @__PURE__ */ a.jsx(fe, { sx: { marginLeft: "5px" }, variant: "caption", children: "Create New Cohort" })
    ] }),
    c.createNew && /* @__PURE__ */ a.jsx(R, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsx(qe, { name: "title", textLabel: "Title", required: !0, children: /* @__PURE__ */ a.jsx(
      Je,
      {
        id: "title",
        name: "title",
        type: "text",
        size: "medium",
        value: c.title,
        placeholder: "Enter title",
        onChange: (C) => p("title", C.target.value),
        fullWidth: !0
      }
    ) }) }),
    !c.createNew && /* @__PURE__ */ a.jsx(R, { item: !0, xs: 12, children: [ce.INITIAL, ce.IN_PROGRESS].includes(h) ? /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
      /* @__PURE__ */ a.jsx(R, { item: !0, xs: 12, mb: 0.5, children: /* @__PURE__ */ a.jsx(zs, { height: 15, width: 50 }) }),
      /* @__PURE__ */ a.jsx(R, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsx(zs, { height: 30, width: "100%" }) })
    ] }) : /* @__PURE__ */ a.jsx(qe, { name: "cohort", textLabel: "Cohort", required: !0, children: /* @__PURE__ */ a.jsx(
      zi,
      {
        className: "",
        name: "cohort",
        id: "cohort",
        options: u,
        value: c.cohort,
        placeholder: "Select cohort...",
        fullWidth: !0,
        isOptionEqualToValue: (C, T) => {
          var I;
          return C.id === ((I = T.cohort) == null ? void 0 : I.id);
        },
        onChange: (C, T) => {
          p("cohort", T);
        },
        getOptionLabel: (C) => C.name
      }
    ) }) }),
    Fc.length > 0 && /* @__PURE__ */ a.jsx(R, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsx(
      qe,
      {
        name: "templateProp",
        textLabel: "Template attribute",
        required: !0,
        children: /* @__PURE__ */ a.jsx(
          Rt,
          {
            className: "",
            name: "templateProp",
            disablePortal: !0,
            id: "templateProp",
            options: Fc,
            value: c.attribute,
            placeholder: "Select attribute",
            onChange: (C) => {
              p("attribute", C);
            },
            fullWidth: !0
          }
        )
      }
    ) }),
    c.attribute && /* @__PURE__ */ a.jsx(
      $b,
      {
        attribute: c.attribute,
        onChange: (C) => {
          p("criteries", C);
        }
      }
    ),
    /* @__PURE__ */ a.jsx(R, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsxs(co, { children: [
      /* @__PURE__ */ a.jsx(
        We,
        {
          variant: "outlined",
          onClick: n,
          startIcon: /* @__PURE__ */ a.jsx(ge, { iconName: "deactivate" }),
          name: "cancel",
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ a.jsx(
        We,
        {
          disabled: (c.createNew ? En(c.title) : En(c.cohort)) || En(c.typeContainer) || En(c.attribute) || f === ce.IN_PROGRESS,
          onClick: g,
          variant: "contained",
          color: "success",
          startIcon: f === ce.IN_PROGRESS ? /* @__PURE__ */ a.jsx(Ct, { size: 16 }) : /* @__PURE__ */ a.jsx(ge, { iconName: "submit" }),
          name: "save",
          children: "Add"
        }
      )
    ] }) })
  ] }) }) }) : /* @__PURE__ */ a.jsx(Jc, { children: /* @__PURE__ */ a.jsx(Ct, { size: 62 }) });
}, zb = (e) => {
  var n, r;
  let t = `having ${(n = ca.find((i) => i.value === e.Type)) == null ? void 0 : n.name} ${e.Count} `;
  return e.IsDistinct && (t = `${t} distinct ${(r = ua.find((i) => i.value === e.CountColumn)) == null ? void 0 : r.name} from `), t;
}, Bc = (e) => {
  var o, s;
  const { Start: t, End: n } = e, r = e.UseEventEnd ? "ending" : "starting", i = e.UseIndexEnd ? "cohort entry end date" : "cohort entry start date";
  return !t.Days && !n.Days ? "" : `${r} between ${t.Days} days ${(o = or.find((l) => l.value === t.Coeff)) == null ? void 0 : o.name} and 
  ${n.Days} days ${(s = or.find((l) => l.value === t.Coeff)) == null ? void 0 : s.name} ${i}`;
}, Wb = (e, t, n, r) => {
  const i = Bc(e), o = t ? Bc(t) : "";
  return !i && !o ? "" : ` ${i}${i ? ", " : ""}${o}${i && o && (r || n) ? ", " : ""}${r ? "at same visit as cohort entry" : ""} ${r && n ? "and" : ""} ${n ? "allow events outside observation period" : ""}`;
}, lo = (e) => {
  var t;
  return (t = fr.find((n) => n.value === e)) == null ? void 0 : t.name;
}, Ts = (e = [], t, n = "invalid drug specified") => {
  var r;
  return t >= 0 && e.length > 0 ? `'${(r = e.find((i) => i.id === t)) == null ? void 0 : r.name}'` : n;
}, Yb = (e) => e ? `forcing drug exposure days supply to: ${e} ${e > 1 ? "days" : "day"}.` : "using days supply and exposure end date for exposure duration.", Hb = (e, t) => {
  var n;
  if (!e)
    return "The person exits the cohort at the end of continuous observation.";
  if (e.DateOffset)
    return `The cohort end date will be offset from index event's ${(n = cu.find((r) => r.value === e.DateOffset.DateField)) == null ? void 0 : n.name} plus ${e.DateOffset.Offset} days`;
  if (e.CustomEra)
    return `The cohort end date will be based on a continuous exposure to 
      ${Ts(
      t,
      e.CustomEra.DrugCodesetId
    )}:
      allowing ${e.CustomEra.GapDays} days between exposures, adding ${e.CustomEra.Offset} 
      days after exposure ends, and ${Yb(
      e.CustomEra.DaysSupplyOverride
    )}
      `;
}, qb = (e, t) => [Te.BETWEEN, Te.NOT_BETWEEN].includes(t.Op) ? `${e.viewModeTextStart || ""} ${Us[t.Op]} ${t.Value} and ${t.Extent}${e.viewModeTextEnd ? " " + e.viewModeTextEnd : ""}` : `${e.viewModeTextStart || ""} ${Us[t.Op]} ${t.Value}${e.viewModeTextEnd ? " " + e.viewModeTextEnd : ""}`, Xb = (e, t) => {
  let n = "";
  const r = t.map((o) => o.CONCEPT_NAME), i = r.length > 1 ? r.pop() : void 0;
  return n = r.join(", "), i ? n = `${e.viewModeTextStart || ""} ${n} or ${i}${e.viewModeTextEnd ? " " + e.viewModeTextEnd : ""}` : n = `${e.viewModeTextStart || ""} ${n}${e.viewModeTextEnd ? " " + e.viewModeTextEnd : ""}`, n;
}, Jb = (e, t) => [Te.BETWEEN, Te.NOT_BETWEEN].includes(t.Op) ? `${e.viewModeTextStart || ""} ${Vs[t.Op]} ${t.Value} and ${t.Extent}${e.viewModeTextEnd ? " " + e.viewModeTextEnd : ""}` : `${e.viewModeTextStart || ""} ${Vs[t.Op]} ${t.Value}${e.viewModeTextEnd ? " " + e.viewModeTextEnd : ""}`, Kb = (e, t) => `${e.viewModeTextStart || ""} ${Qp[t.Op]} ${t.Text}${e.viewModeTextEnd ? " " + e.viewModeTextEnd : ""}`, $c = (e, t) => {
  switch (e.type) {
    case F.DATE:
      return qb(e, t);
    case F.VOCABULARY:
      return Xb(e, t);
    case F.VALUE:
      return Jb(e, t);
    case F.TEXT:
      return Kb(e, t);
  }
}, Qb = (e, t, n) => {
  let r = " who are ";
  return e.type === F.BOOL ? r = ` ${e.startText} ${r}` : r = n == 0 ? `${r} ${$c(e, t)}` : `${$c(e, t)};`, r;
}, Zb = (e) => {
  const { details: t, attr: n, index: r, setConcept: i, conceptSetAttrName: o } = e;
  return Q(() => {
    t.type === F.DROPDOWN && i((s) => [...s, o]);
  }, []), t.type === F.DROPDOWN ? /* @__PURE__ */ a.jsx(a.Fragment, {}) : /* @__PURE__ */ a.jsx(
    Y,
    {
      component: "span",
      sx: { display: "inline-block", marginRight: "3px", marginLeft: "3px" },
      children: Qb(t, n, r)
    }
  );
}, Do = (e) => {
  const { criteriaList: t, conceptSets: n, demographicCriteriaList: r, groups: i } = e;
  return /* @__PURE__ */ a.jsxs("ol", { children: [
    r.length > 0 && /* @__PURE__ */ a.jsx(
      Ss,
      {
        criteriaList: r.map((o) => ({
          Demographic: o
        })),
        conceptSets: n
      }
    ),
    t.map((o, s) => {
      var I;
      const {
        Occurrence: l,
        Criteria: c,
        StartWindow: u,
        EndWindow: p,
        IgnoreObservationPeriod: d,
        RestrictVisit: f
      } = o, h = Object.keys(c)[0], g = Object.values(c)[0], C = uo[h], T = Ts(
        n,
        g.CodesetId,
        (I = C.defaultValue) == null ? void 0 : I.toLowerCase()
      );
      return /* @__PURE__ */ a.jsxs("li", { children: [
        zb(l),
        /* @__PURE__ */ a.jsx(
          Ap,
          {
            details: C,
            id: h,
            values: g,
            conceptSets: n,
            conceptSetName: T
          }
        ),
        Wb(
          u,
          p,
          d,
          f
        ),
        /* @__PURE__ */ a.jsx("span", { children: "." })
      ] }, h + s);
    }),
    i.length > 0 && i.map((o) => /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
      /* @__PURE__ */ a.jsxs("p", { children: [
        "Restrict entry events to with ",
        Dn[o.Type],
        " ",
        o.Count || "",
        " of the following criteria:"
      ] }),
      /* @__PURE__ */ a.jsx(
        Do,
        {
          criteriaList: o.CriteriaList,
          conceptSets: n,
          demographicCriteriaList: o.DemographicCriteriaList,
          groups: o.Groups
        }
      )
    ] }))
  ] });
}, eR = (e, t) => (e == null ? void 0 : e.filter((n) => t.includes(n))) || [], Ap = (e) => {
  const { id: t, values: n, details: r, conceptSetName: i, conceptSets: o } = e, [s, l] = J([]);
  return /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    r.baseTextViewMode,
    " ",
    i,
    /* @__PURE__ */ a.jsx("b", { children: s.length > 0 ? ` (including ${s.join(", ")} source concepts) ` : "" }),
    eR(
      r.attributesSort,
      Object.keys(n)
    ).map((c, u) => {
      var h;
      const p = mr[c], d = n[c], f = (h = o.find((g) => g.id === d)) == null ? void 0 : h.name;
      return p.type === F.GROUP ? /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
        /* @__PURE__ */ a.jsxs("p", { children: [
          "Restrict entry events to with ",
          Dn[d.Type],
          " ",
          d.Count || "",
          " of the following criteria:"
        ] }),
        /* @__PURE__ */ a.jsx(
          Do,
          {
            criteriaList: d.CriteriaList,
            conceptSets: o,
            demographicCriteriaList: d.DemographicCriteriaList,
            groups: d.Groups
          }
        )
      ] }) : /* @__PURE__ */ a.jsx(a.Fragment, { children: /* @__PURE__ */ a.jsx(
        Zb,
        {
          details: p,
          attr: d,
          index: u,
          setConcept: l,
          conceptSetAttrName: f
        }
      ) });
    })
  ] });
}, Ss = (e) => {
  const { criteriaList: t, conceptSets: n } = e;
  return /* @__PURE__ */ a.jsx(a.Fragment, { children: t.map((r) => {
    var c;
    const i = Object.keys(r)[0], o = Object.values(r)[0], s = uo[i], l = Ts(
      n,
      o.CodesetId,
      (c = s.defaultValue) == null ? void 0 : c.toLowerCase()
    );
    return /* @__PURE__ */ a.jsxs("li", { children: [
      /* @__PURE__ */ a.jsx(
        Ap,
        {
          details: s,
          id: i,
          values: o,
          conceptSets: n,
          conceptSetName: l
        }
      ),
      /* @__PURE__ */ a.jsx("span", { children: "." })
    ] });
  }) });
}, tR = (e, t) => {
  if (e == 0 && t == 0) return "";
  let n = "with continuous observation of";
  return e > 0 && (n = t > 0 ? `${n} ${e} days before` : `${n} ${e} days before event`), t > 0 && (n = e > 0 ? `${n} and ${t} days after event` : `${n} ${t} days after event`), n;
}, nR = (e) => {
  const { CriteriaList: t, ObservationWindow: n, PrimaryCriteriaLimit: r, conceptSets: i } = e;
  return t.length == 0 ? /* @__PURE__ */ a.jsx("section", { children: /* @__PURE__ */ a.jsxs("p", { children: [
    "Limit cohort entry events to the",
    " ",
    lo(r.Type),
    " per person"
  ] }) }) : /* @__PURE__ */ a.jsxs("section", { children: [
    /* @__PURE__ */ a.jsxs("p", { children: [
      "People",
      " ",
      tR(
        n.PriorDays,
        n.PostDays
      ),
      " ",
      "may enter the cohort when observing any of the following:"
    ] }),
    /* @__PURE__ */ a.jsx("ol", { children: /* @__PURE__ */ a.jsx(
      Ss,
      {
        criteriaList: t,
        conceptSets: i
      }
    ) }),
    /* @__PURE__ */ a.jsxs("p", { children: [
      "Limit cohort entry events to the",
      " ",
      lo(r.Type),
      " per person"
    ] })
  ] });
}, rR = (e) => {
  const {
    CriteriaList: t,
    DemographicCriteriaList: n,
    limit: r,
    conceptSets: i,
    Groups: o,
    Type: s,
    Count: l
  } = e;
  return t.length == 0 && n.length == 0 && o.length == 0 ? /* @__PURE__ */ a.jsx("section", { children: /* @__PURE__ */ a.jsxs("p", { children: [
    "Limit restrict initial events to the ",
    lo(r.Type),
    " ",
    "per person"
  ] }) }) : /* @__PURE__ */ a.jsxs("section", { children: [
    /* @__PURE__ */ a.jsxs("p", { children: [
      "Restrict entry events to with ",
      Dn[s],
      " ",
      l || "",
      " of the following criteria:"
    ] }),
    /* @__PURE__ */ a.jsx(
      Do,
      {
        criteriaList: t,
        conceptSets: i,
        demographicCriteriaList: n,
        groups: o
      }
    ),
    /* @__PURE__ */ a.jsxs("p", { children: [
      "Limit restrict initial events to the ",
      lo(r.Type),
      " per person"
    ] })
  ] });
}, iR = (e) => {
  const { inclusionRules: t, conceptSets: n } = e;
  return /* @__PURE__ */ a.jsx(a.Fragment, { children: t.map((r) => {
    const {
      name: i,
      description: o,
      expression: { CriteriaList: s, DemographicCriteriaList: l, Groups: c }
    } = r;
    return /* @__PURE__ */ a.jsxs("section", { children: [
      /* @__PURE__ */ a.jsxs("h4", { children: [
        i,
        ": ",
        o
      ] }),
      /* @__PURE__ */ a.jsx(
        Do,
        {
          criteriaList: s,
          conceptSets: n,
          demographicCriteriaList: l,
          groups: c
        }
      )
    ] });
  }) });
}, oR = (e) => {
  const { endStrategy: t, conceptSets: n, criteriaList: r } = e;
  return /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    /* @__PURE__ */ a.jsx("section", { children: Hb(t, n) }),
    /* @__PURE__ */ a.jsxs("section", { children: [
      r.length > 0 && /* @__PURE__ */ a.jsx("p", { children: "The person exits the cohort when encountering any of the following events:" }),
      /* @__PURE__ */ a.jsx("ol", { children: /* @__PURE__ */ a.jsx(
        Ss,
        {
          criteriaList: r,
          conceptSets: n
        }
      ) })
    ] })
  ] });
}, aR = (e) => /* @__PURE__ */ a.jsxs("p", { children: [
  "Entry events will be combined into cohort eras if they are within",
  " ",
  e.collapseSettings.EraPad,
  " days of each other."
] }), sR = ({ definition: e }) => {
  const { name: t, expression: n } = e;
  return /* @__PURE__ */ a.jsxs("div", { className: "cohort-view-mode", children: [
    /* @__PURE__ */ a.jsx("h1", { className: "cohort-name", children: t }),
    /* @__PURE__ */ a.jsxs("section", { className: "cohort-entry-events", children: [
      /* @__PURE__ */ a.jsx("h2", { children: "Cohort Entry Events" }),
      /* @__PURE__ */ a.jsx(
        nR,
        {
          ...n.PrimaryCriteria,
          conceptSets: n.ConceptSets
        }
      ),
      n.AdditionalCriteria && /* @__PURE__ */ a.jsx(
        rR,
        {
          ...n.AdditionalCriteria,
          conceptSets: n.ConceptSets,
          limit: n.QualifiedLimit
        }
      )
    ] }),
    n.InclusionRules.length > 0 && /* @__PURE__ */ a.jsxs("section", { className: "cohort-inclusion-criteria", children: [
      /* @__PURE__ */ a.jsx("h2", { children: "Inclusion Criteria" }),
      /* @__PURE__ */ a.jsx(
        iR,
        {
          inclusionRules: n.InclusionRules,
          conceptSets: n.ConceptSets,
          limit: n.ExpressionLimit
        }
      )
    ] }),
    /* @__PURE__ */ a.jsxs("section", { className: "cohort-exit", children: [
      /* @__PURE__ */ a.jsx("h2", { children: "Cohort Exit" }),
      /* @__PURE__ */ a.jsx(
        oR,
        {
          endStrategy: n.EndStrategy,
          criteriaList: n == null ? void 0 : n.CensoringCriteria,
          conceptSets: n.ConceptSets
        }
      )
    ] }),
    (n == null ? void 0 : n.CollapseSettings.EraPad) > 0 && /* @__PURE__ */ a.jsxs("section", { className: "cohort-eras", children: [
      /* @__PURE__ */ a.jsx("h2", { children: "Cohort Eras" }),
      /* @__PURE__ */ a.jsx(
        aR,
        {
          collapseSettings: n == null ? void 0 : n.CollapseSettings,
          censorWindow: n == null ? void 0 : n.CensorWindow
        }
      )
    ] })
  ] });
}, bp = [
  {
    id: "RACE",
    name: "Race",
    startText: "a race of",
    attr: "race",
    domainId: "Race",
    desc: "",
    value: []
  },
  {
    id: "GENDER",
    name: "Gender",
    desc: "",
    attr: "gender",
    domainId: "Gender",
    startText: "a gender of",
    value: []
  },
  {
    id: "ETHNICITY",
    name: "Ethnicity",
    desc: "",
    attr: "ethnicity",
    startText: "a ethnicity of",
    domainId: "Ethnicity",
    value: []
  },
  {
    id: "AGE",
    name: "Age",
    attr: "age",
    desc: "",
    value: {
      Value: "",
      Extent: "",
      Op: Te.GREATER_THAN
    },
    startText: "with age in years"
  },
  {
    id: "INDEX_DATE",
    name: "Date Ranges",
    attr: "dateRanges",
    desc: "",
    value: {
      Value: "",
      Extent: "",
      Op: Te.LESS_THAN
    },
    startText: "date range of"
  }
], Rp = (e) => {
  const {
    name: t,
    startText: n,
    domainId: r,
    value: i,
    updateAttribute: o,
    subModules: s,
    viewMode: l,
    id: c,
    showSelectAll: u
  } = e, p = (i == null ? void 0 : i.map((d) => d.CONCEPT_NAME).filter(Boolean).join(", ")) || "-";
  return /* @__PURE__ */ a.jsxs(R, { container: !0, alignItems: l ? "baseline" : "center", spacing: 1, children: [
    n && /* @__PURE__ */ a.jsx(R, { item: !0, minWidth: l ? 120 : 175, mr: 1, children: /* @__PURE__ */ a.jsx(fe, { variant: "body2", color: "#000000", children: n }) }),
    /* @__PURE__ */ a.jsx(
      R,
      {
        item: !0,
        flexGrow: 1,
        minWidth: 0,
        maxWidth: `calc(100% - ${n ? l ? 130 : 190 : 0}px)`,
        children: l ? /* @__PURE__ */ a.jsx(fe, { variant: "body2", fontWeight: 700, children: p }) : /* @__PURE__ */ a.jsx(
          s.vocabulary,
          {
            type: "component",
            name: "add-concepts-widget",
            subModules: s,
            config: {
              value: i,
              domainId: r,
              onAddConcepts: (d) => o(c, d),
              placeholder: "Select " + (t == null ? void 0 : t.toLowerCase()) + "...",
              showSelectAll: u
            }
          }
        )
      }
    )
  ] });
}, lR = (e = {}) => e && Object.keys(e).flatMap((t) => {
  const n = bp.find((r) => r.attr === t);
  if (n)
    return n.id === "AGE" || n.id === "INDEX_DATE" ? e[t].map((r) => ({
      ...n,
      id: Yt(),
      type: n.id,
      value: {
        Op: r.Op,
        Extent: r.Extent,
        Value: r.Value
      }
    })) : {
      ...n,
      id: Yt(),
      type: n.id,
      value: e[t].map((r) => ({
        CONCEPT_ID: r.CONCEPT_ID,
        CONCEPT_NAME: r.CONCEPT_NAME
      }))
    };
}).filter(Boolean), cR = (e) => {
  const { viewMode: t, values: n, subModules: r, onChange: i } = e, [o, s] = J(lR(n)), l = (d) => {
    s((f) => f.filter((h) => h.id !== d));
  }, c = ["RACE", "GENDER", "ETHNICITY"], u = ie(
    (d, f) => {
      const h = f.map((g) => g.type);
      return d.filter((g) => c.includes(g.id) ? !h.includes(g.id) : !0);
    },
    [o]
  );
  Q(() => {
    const d = {};
    o.forEach((f) => {
      f.type === "AGE" || f.type === "INDEX_DATE" ? (d[f.attr] || (d[f.attr] = []), d[f.attr].push({
        Op: f.value.Op,
        Extent: f.value.Extent,
        Value: f.value.Value
      })) : d[f.attr] = f.value.map((h) => ({
        CONCEPT_ID: h.CONCEPT_ID,
        CONCEPT_NAME: h.CONCEPT_NAME
      }));
    }), i(d);
  }, [o]);
  const p = (d, f) => {
    switch (d.type) {
      case "RACE":
      case "GENDER":
      case "ETHNICITY":
        return /* @__PURE__ */ a.jsx(
          Rp,
          {
            id: d.id,
            name: d.name,
            startText: d.startText,
            type: d.domainId,
            value: d.value,
            subModules: r,
            updateAttribute: (h, g) => {
              s((C) => C.map(
                (T) => T.id === h ? { ...T, value: g } : T
              ));
            },
            domainId: d.domainId,
            viewMode: t,
            showSelectAll: d.type !== "RACE"
          }
        );
      case "AGE":
      case "INDEX_DATE":
        return /* @__PURE__ */ a.jsx(a.Fragment, { children: d.type == "INDEX_DATE" ? /* @__PURE__ */ a.jsx(
          ud,
          {
            id: d.id,
            name: d.name,
            startText: d.startText,
            value: d.value,
            updateAttribute: (h, g) => {
              s(
                (C) => C.map((T) => T.id !== h ? T : { ...T, value: g })
              );
            },
            viewMode: t
          }
        ) : /* @__PURE__ */ a.jsx(
          Qa,
          {
            id: d.id,
            name: d.name,
            startText: d.startText,
            value: d.value,
            updateAttribute: (h, g) => {
              s(
                (C) => C.map((T) => T.id !== h ? T : { ...T, value: g })
              );
            },
            viewMode: t
          }
        ) });
      default:
        return /* @__PURE__ */ a.jsx(a.Fragment, {});
    }
  };
  return /* @__PURE__ */ a.jsxs(R, { container: !0, children: [
    /* @__PURE__ */ a.jsx(R, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsxs(
      R,
      {
        container: !0,
        alignItems: "center",
        justifyContent: "space-between",
        pb: 2,
        children: [
          /* @__PURE__ */ a.jsx(R, { item: !0, children: /* @__PURE__ */ a.jsx(fe, { variant: "subtitle2", children: "You can optionally provide additional attributes to explicitly check for existence of particular data. These checks will affect the final data source scoring." }) }),
          /* @__PURE__ */ a.jsx(R, { item: !0, textAlign: "right", className: "criteria-action", children: !t && /* @__PURE__ */ a.jsx(
            vn,
            {
              variant: "contained",
              color: "info",
              options: u(
                bp,
                o
              ),
              onClick: (d) => {
                s((f) => [
                  ...f,
                  {
                    ...d,
                    type: d.id,
                    id: Yt()
                  }
                ]);
              },
              title: "Add attribute",
              name: "Add attribute",
              closeOnSelect: !0,
              preventOverflow: !0,
              startIcon: /* @__PURE__ */ a.jsx(
                ge,
                {
                  iconName: "add",
                  sx: { "&.MuiSvgIcon-root": { fontSize: 16 } }
                }
              )
            }
          ) })
        ]
      }
    ) }),
    /* @__PURE__ */ a.jsx(R, { item: !0, xs: 12, children: o.map((d, f) => /* @__PURE__ */ a.jsxs(sd, { children: [
      /* @__PURE__ */ a.jsx(ld, { children: p(d) }),
      !t && /* @__PURE__ */ a.jsx(cd, { children: /* @__PURE__ */ a.jsx(
        Cr,
        {
          color: "error",
          iconName: "delete",
          onClick: () => l(d.id),
          title: "Delete",
          tooltipText: "Delete",
          name: "closeCriteriaButton",
          noExpand: !0
        }
      ) })
    ] }, d.id)) })
  ] });
}, uR = it((e) => {
  const { name: t, config: n, ...r } = e, {
    onChange: i,
    parentId: o,
    typeContainer: s,
    values: l,
    viewMode: c,
    buttonText: u,
    titleText: p,
    contextConceptSets: d,
    initialData: f,
    isSelect: h,
    returnEntityText: g,
    isDesignStrata: C,
    strataParams: T,
    onChangeStrataOnly: I,
    onChangeStrataBy: A,
    hiddenParentConcept: S,
    classNameContainer: _,
    collapsible: v,
    description: O,
    defaultState: j,
    withAlias: M,
    attrName: w,
    value: L,
    startText: P,
    domainId: k,
    standardConcept: z,
    showSelectAll: B,
    hideIgnoreObservationPeriod: q,
    hiddenIgnoreObservationPeriodValue: N,
    showRestrictToSameVisitForAllCriteria: ne,
    hideOccurrence: ue,
    renderSectionContentBeforeCriteria: te,
    useCohortSectionButtons: m,
    hideCriteriaGroupHeader: W,
    hideTopLevelCriteriaControls: H,
    criteriaSectionsSx: y,
    criteriaButtonsSx: X,
    parentCriteriaElement: V,
    clearParentCriteriaElement: $
  } = n;
  return /* @__PURE__ */ a.jsxs(Re.Fragment, { children: [
    t === "widget-cohort-import-button" && /* @__PURE__ */ a.jsx(
      bm,
      {
        ...r,
        typeContainer: s,
        parentId: o,
        onChange: i,
        initialData: f,
        multiple: h,
        returnEntityText: g,
        path: r.path,
        withAlias: M,
        containerProps: {
          titleText: p,
          buttonText: u,
          description: O,
          defaultState: j,
          collapsible: v,
          classNameContainer: _,
          viewMode: c
        }
      }
    ),
    t === "widget-criteria-group" && /* @__PURE__ */ a.jsx(
      vb,
      {
        ...r,
        onChange: i,
        typeContainer: s,
        parentId: o,
        values: l,
        viewMode: c,
        addCriteriaButton: u,
        title: p,
        contextConceptSets: d,
        isDesignStrata: C,
        strataParams: T,
        onChangeStrataOnly: I,
        onChangeStrataBy: A,
        hiddenParentConcept: S,
        hideIgnoreObservationPeriod: q,
        hiddenIgnoreObservationPeriodValue: N,
        showRestrictToSameVisitForAllCriteria: ne,
        hideOccurrence: ue,
        renderSectionContentBeforeCriteria: te,
        useCohortSectionButtons: m,
        hideCriteriaGroupHeader: W,
        hideTopLevelCriteriaControls: H,
        criteriaSectionsSx: y,
        criteriaButtonsSx: X,
        parentCriteriaElement: V,
        clearParentCriteriaElement: $
      }
    ),
    t === "widget-criteria-attributes" && /* @__PURE__ */ a.jsx(
      cR,
      {
        ...r,
        viewMode: c,
        values: l,
        onChange: i
      }
    ),
    t === "widget-attribute-value" && /* @__PURE__ */ a.jsx(
      Qa,
      {
        id: w,
        name: w,
        startText: P,
        value: L,
        updateAttribute: i,
        viewMode: c
      }
    ),
    t === "widget-attribute-vocabulary" && // <AttributeVocabulary
    //   id={attrName}
    //   name={name}
    //   startText={startText || ''}
    //   value={value}
    //   subModules={props.subModules}
    //   updateAttribute={onChange}
    //   domainId={domainId}
    //   standardConcept={standardConcept}
    //   viewMode={viewMode}
    //   extend={false}
    // />
    /* @__PURE__ */ a.jsx(
      Rp,
      {
        name: w,
        startText: P || "",
        domainId: k,
        value: L,
        updateAttribute: i,
        subModules: e.subModules,
        viewMode: c,
        id: w,
        showSelectAll: B
      }
    ),
    t === "home-widget-cohort" && /* @__PURE__ */ a.jsx(Db, {}),
    t === "create-cohort-from-concept-set" && /* @__PURE__ */ a.jsx(
      Gb,
      {
        ...e.config,
        subModules: e.subModules
      }
    ),
    t === "cohort-view-mode" && /* @__PURE__ */ a.jsx(sR, { definition: f })
  ] });
}), IR = (e) => {
  const { type: t } = e;
  return /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    !t && /* @__PURE__ */ a.jsx(pb, { ...e }),
    t === "component" && /* @__PURE__ */ a.jsx(uR, { ...e })
  ] });
};
export {
  IR as Cohort
};
//# sourceMappingURL=cohorts.js.map
